'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddressBook = function () {
  function AddressBook(id) {
    _classCallCheck(this, AddressBook);

    this.user = id;
    this.DELETE_BTN_CLASS = 'open-deleteaddress';
    this.SET_DEFHOME_BTN_CLASS = 'open-def-home';
    this.SET_DEFDELIVERY_BTN_CLASS = 'open-def-delivery';
    this.CONTAINER_CLASS = 'opsm-bordered-fluid-div';
    this.FRONTSIDE_CLASS = 'opsm-front-side';
    this.BACKSIDE_CLASS = 'opsm-back-side';

    this.getAB();

    var _this = this;
    $('.' + _this.CONTAINER_CLASS).find('.' + _this.BACKSIDE_CLASS).hide();
    $("." + _this.DELETE_BTN_CLASS).on("click", function () {
      var _thisa = $(this);
      _this.deleteAdressBook(_thisa);
    });

    $("." + _this.SET_DEFDELIVERY_BTN_CLASS).on("click", function () {
      var _thisa = $(this);
      _this.setDefaultDelivery(_thisa);
    });

    $("." + _this.SET_DEFHOME_BTN_CLASS).on("click", function () {
      var _thisa = $(this);
      _this.setDefaultHome(_thisa);
    });
  }

  _createClass(AddressBook, [{
    key: 'getAB',
    value: function getAB() {
      /*var _this2 = this;
      $.getJSON("address-book.json", { user: _this2.user }, function (data) {
          if (data.addressBook.length > 0) {
            data.addressBook.forEach(function (addressbook) {
              //console.log(addressbook);
            });
          }
      });*/
    }
  }, {
    key: 'setSaveAdressBook',
    value: function setSaveAdressBook() {}
  }, {
    key: 'setDefaultHome',
    value: function setDefaultHome(t) {
      var _this2 = this;
      var _this2id = $(t).parents('.' + _this2.CONTAINER_CLASS).attr("id");
      if ($(t).hasClass("disabled")) {
        $('.opsm-def-home').addClass("disabled");
        $(t).removeClass("disabled");
        $('#' + _this2id).addClass('opsm-bordered-active');
      } else {
        $(y).addClass("disabled");
        if ($('#' + _this2id).parents('.' + _this2.SET_DEFDELIVERY_BTN_CLASS).hasClass('disabled')) {
          $('#' + _this2id).removeClass('opsm-bordered-active');
        }
      }
    }
  }, {
    key: 'setDefaultDelivery',
    value: function setDefaultDelivery(t) {
      var _this2 = this;
      var _this2id = $(t).parents('.' + _this2.CONTAINER_CLASS).attr("id");

      if ($(t).hasClass("disabled")) {
        $('.opsm-def-delivery').addClass("disabled");
        $(t).removeClass("disabled");
        $('#' + _this2id).addClass('opsm-bordered-active');
      } else {
        $(y).addClass("disabled");
        if ($('#' + _this2id).parents('.' + _this2.SET_DEFHOME_BTN_CLASS).hasClass('disabled')) {
          $('#' + _this2id).removeClass('opsm-bordered-active');
        }
      }
    }
  }, {
    key: 'deleteAdressBook',
    value: function deleteAdressBook(t) {
      var _this2 = this;
      var _this2id = $(t).parents('.' + _this2.CONTAINER_CLASS).attr("id");
      $('#' + _this2id).find('.' + _this2.FRONTSIDE_CLASS).hide();
      $('#' + _this2id).find('.' + _this2.BACKSIDE_CLASS).fadeIn();

      $('#' + _this2id).on('click', '.cancel-remove-address', function () {
        $('#' + _this2id).find('.' + _this2.BACKSIDE_CLASS).hide();
        $('#' + _this2id).find('.' + _this2.FRONTSIDE_CLASS).fadeIn();
      });
      $('#' + _this2id).on('click', '.confirm-remove-address', function () {
        $('#' + _this2id).parent('.single-card').remove();
        /* TODO ajax call for confirm*/
      });
    }
  }]);

  return AddressBook;
}();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* implement atomic ajax calls which can be chained as promise */
var AjaxSimpleRequest = function () {
		function AjaxSimpleRequest() {
				_classCallCheck(this, AjaxSimpleRequest);
		}

		_createClass(AjaxSimpleRequest, null, [{
				key: "ajaxLoginNotMergingCart",
				value: function ajaxLoginNotMergingCart(params) {
						var reqParam = params || {};
						$.extend(reqParam, { mergeCart: "false" });
						return AjaxSimpleRequest.ajaxLogin(reqParam);
				}
		}, {
				key: "ajaxLoginMergingCart",
				value: function ajaxLoginMergingCart(params) {
						var reqParam = params || {};
						$.extend(reqParam, { mergeCart: "true" });
						return AjaxSimpleRequest.ajaxLogin(reqParam);
				}
		}, {
				key: "ajaxLogin",
				value: function ajaxLogin(params) {
						var reqParam = params || {};
						var commonParams = {
								storeId: $('#storeId').val(),
								catalogId: $('#catalogId').val(),
								langId: $('#langId').val()
								//there is not redirection with AjaxLogon
						};var ajaxParams = {
								reLogonURL: "/",
								errorViewName: "/",
								postSignInURL: "/",
								URL: "/"
						};
						$.extend(commonParams, reqParam, ajaxParams);
						return $.ajax({
								type: "POST",
								url: "/AjaxLogon",
								data: commonParams,
								async: true,
								dataType: 'json'
						});
				}
		}]);

		return AjaxSimpleRequest;
}();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApplePayManager = function () {
	function ApplePayManager(config) {
		_classCallCheck(this, ApplePayManager);

		this.log("constructor", JSON.stringify(config));
		this.merchantIdentifier = config.merchantIdentifier;
		this.currencyCode = config.currencyCode;
		this.countryCode = config.countryCode;
		this.orderNumber = config.orderNumber;
		this.storeId = config.storeId;
		this.catalogId = config.catalogId;
		this.langId = config.langId;
		this.applePayButton = config.applePayButton;
		this.applePayWrapper = config.applePayWrapper;
		this.totalAmount = config.totalAmount;
		this.billingAddressCtrl = config.billingAddressCtrl;
		this.shippingAddressCtrl = config.shippingAddressCtrl;
		this.billingAddressId = "";
		this.formOrderProcessCtrl = config.formOrderProcessCtrl;
		this.authToken = config.authToken;
		this.paymentsWithActiveCard = config.paymentsWithActiveCard;
		this.lastPiIdOrder = 0;
		this.lastPiAddParams = {};
	}
	//data builders


	_createClass(ApplePayManager, [{
		key: "getShipInstrDOM",
		value: function getShipInstrDOM() {
			var shipInstructions = '';
			if ($("#special-instructions-text").val() != null) {
				shipInstructions = $("#special-instructions-text").val();
			}

			var reWhiteSpace = new RegExp(/^\s+$/);
			if (reWhiteSpace.test(shipInstructions)) {
				shipInstructions = "";
			}

			var leaveathome = null;
			if ($('#leaveathome').is(':checked')) {
				leaveathome = "on";
			} else {
				leaveathome = "off";
			}
			var shipInstructionsData = leaveathome + "~^" + shipInstructions;
			return shipInstructionsData;
		}
	}, {
		key: "buildShipInfoCommonParam",
		value: function buildShipInfoCommonParam() {
			return {
				storeId: this.storeId,
				catalogId: this.catalogId,
				langId: this.langId,
				addressId: this.shippingAddressCtrl.val(),
				authToken: this.authToken
			};
		}
	}, {
		key: "buildShipInfoAddrParam",
		value: function buildShipInfoAddrParam() {
			return {
				requesttype: "ajax",
				orderId: ".",
				calculationUsage: "1,-2,-3,-4,-5,-6,-7",
				calculateOrder: "1",
				allocate: "***",
				backorder: "***",
				check: "*n",
				remerge: "***"
			};
		}
	}, {
		key: "buildShipInfoInstrParam",
		value: function buildShipInfoInstrParam() {
			return {
				orderId: this.orderNumber,
				URL: '/',
				shipInstructions: this.getShipInstrDOM(),
				shipModeId: $('#ship-info-mode-id').val()
			};
		}
	}, {
		key: "buildDataPiAddParams",
		value: function buildDataPiAddParams(validationURL) {
			return {
				pluginAction1: "MERCHANT_VALIDATION",
				appleUrl: validationURL,
				storeId: this.storeId,
				catalogId: this.catalogId,
				langId: this.langId,
				orderId: ".",
				requesttype: "ajax",
				payMethodId: "Applepay",
				paymentType: "APP",
				billing_address_id: this.billingAddressId,
				piAmount: this.totalAmount,
				authToken: this.authToken
			};
		}
	}, {
		key: "buildDataPiEditParams",
		value: function buildDataPiEditParams(aPayEvent) {
			var piEditParams = {
				pluginAction1: 'SAVE_AUTH_DATA',
				piId: this.lastPiIdOrder,
				pluginData1: btoa(JSON.stringify(aPayEvent.payment.token.paymentData)),
				pluginData2: aPayEvent.payment.token.paymentMethod.displayName, //Visa 0224
				pluginData3: aPayEvent.payment.token.paymentMethod.network, //Visa
				pluginData4: aPayEvent.payment.token.paymentMethod.type, //debit|credit|prepaid|store
				oemailAdd: $('#checkout-shipping-e-mail').val(),
				ccNumMasked: 'XXXXXXXXXXXX' + aPayEvent.payment.token.paymentMethod.displayName.slice(-4)
				//				cc_brand: set on server
				//				cc_nameoncard: set on server
				//				expire_year: set on server
				//				expire_month: set on server
			};
			return $.extend(this.lastPiAddParams, piEditParams);
		}
		//server actions
		/* set the addressId on items */

	}, {
		key: "shipAddressIdSet",
		value: function shipAddressIdSet() {
			var that = this;
			return $.ajax({
				context: that,
				url: "/AjaxRESTOrderShipInfoUpdate",
				data: $.extend(that.buildShipInfoCommonParam(), that.buildShipInfoAddrParam()),
				type: "POST",
				//			async: false,
				success: function success(data) {
					console.log("AjaxRESTOrderShipInfoUpdate " + data);
				}
			});
		}
		/* save shipInstructions on SHIPINFO table */

	}, {
		key: "shipInstrSet",
		value: function shipInstrSet() {
			var that = this;
			var data = $.extend(that.buildShipInfoCommonParam(), that.buildShipInfoInstrParam());
			return $.ajax({
				context: that,
				url: "/AjaxShipInfoUpdate",
				data: data,
				type: "POST",
				//			async: false,
				success: function success(data) {
					console.log("AjaxShipInfoUpdate " + data);
				}
			});
		}
	}, {
		key: "piAdd",
		value: function piAdd(validationURL) {
			var that = this;
			this.lastPiAddParams = this.buildDataPiAddParams(validationURL);
			return $.ajax({
				context: that,
				url: "/AjaxRESTOrderPIAdd",
				data: that.lastPiAddParams,
				type: "POST",
				success: function success(data) {
					that.log("AjaxRESTOrderPIAdd");
				}
			});
		}
	}, {
		key: "piEdit",
		value: function piEdit(paymentAuthorizedEv) {
			var that = this;
			return $.ajax({
				context: that,
				url: "/AjaxRESTOrderPIUpdate",
				data: that.buildDataPiEditParams(paymentAuthorizedEv),
				type: "POST",
				success: function success(data) {
					that.log("AjaxRESTOrderPIUpdate data ", data);
				}
			});
		}
	}, {
		key: "piDeletePreviousAndFetchCart",
		value: function piDeletePreviousAndFetchCart(piAddData, status, xhr) {
			var that = this;
			console.log("piDeletePrevious");
			console.log(this);
			console.log(this.manager);
			var response = JSON.parse(piAddData);
			var lastPiIdItem = 0;
			lastPiIdItem = that.getLastPIFromResponse(response);
			this.lastPiIdOrder = lastPiIdItem;
			this.log("AjaxRESTOrderPIAdd lastPiIdItem ", lastPiIdItem);

			if (lastPiIdItem != 0 && response && Array.isArray(response.paymentInstruction)) {
				for (var i = 0; i < response.paymentInstruction.length; i++) {
					var piIdItem = parseInt(response.paymentInstruction[i].piId);
					if (piIdItem != lastPiIdItem) {
						this.log("AjaxRESTOrderPIDelete ", piIdItem);
						var dataPiDelete = {
							piId: piIdItem,
							authToken: this.authToken
						};
						$.ajax({
							url: "/AjaxRESTOrderPIDelete",
							data: dataPiDelete,
							type: "POST",
							async: false,
							success: function success(data) {
								that.log("AjaxRESTOrderPIDelete data ", data);
							}
						});
					}
				}
			}
			//return a success promise
			return that.fetchCartDetails();
		}
	}, {
		key: "orderPrepare",
		value: function orderPrepare(respData, status, xhr) {
			var that = this;
			return $.ajax({
				context: that,
				url: "/AjaxRESTOrderPrepare",
				data: {
					storeId: that.storeId,
					catalogId: that.catalogId,
					langId: that.langId,
					requesttype: "ajax",
					authToken: that.authToken
				},
				type: "POST",
				success: function success(data) {
					var response = JSON.parse(data);
					if (response) {}
					that.log("AjaxRESTOrderPrepare data ", data);
				}
			});
		}
	}, {
		key: "fetchCartDetails",
		value: function fetchCartDetails() {
			var that = this;
			return $.ajax({
				context: that,
				url: "/AjaxRESTCartDetails",
				data: {
					storeId: that.storeId,
					requesttype: "ajax",
					authToken: that.authToken
				},
				type: "POST"
			});
		}
	}, {
		key: "activateApplePayButton",
		value: function activateApplePayButton() {
			var _this = this;
			_this.log("activateApplePayButton");
			if (window.ApplePaySession) {
				if (_this.paymentsWithActiveCard) {
					var promise = ApplePaySession.canMakePaymentsWithActiveCard(_this.merchantIdentifier);
					promise.then(function (canMakePayments) {
						if (canMakePayments) {
							_this.showApplePayWrapper();
						} else {
							_this.removeApplePayWrapper();
						}
					});
				} else {
					if (ApplePaySession.canMakePayments()) {
						_this.showApplePayWrapper();
					} else {
						_this.removeApplePayWrapper();
					}
				}
			} else {
				_this.removeApplePayWrapper();
			}
		}
	}, {
		key: "removeApplePayWrapper",
		value: function removeApplePayWrapper() {
			var _this = this;
			_this.log("removeApplePayWrapper");
			_this.applePayWrapper.innerHTML = "";
		}
	}, {
		key: "showApplePayWrapper",
		value: function showApplePayWrapper() {
			var _this = this;
			_this.log("showApplePayWrapper");
			_this.setButtonListeners();
			_this.applePayWrapper.classList.remove('d-none');
		}
	}, {
		key: "setButtonListeners",
		value: function setButtonListeners() {
			var _this = this;
			_this.log("setButtonListeners");
			_this.applePayButton.addEventListener('click', function () {

				_this.log("applePayButton-click");
				_this.billingAddressId = _this.billingAddressCtrl.val() || _this.shippingAddressCtrl.val();
				_this.log("billingAddressId", _this.billingAddressId);

				//first call is for setting the addressId on items
				//second call is for saving shipInstructions on SHIPINFO table
				//			this.shipAddressIdSet();
				//			this.shipInstrSet();
				_this.shipAddressIdSet().then(_this.shipInstrSet);

				var configApplePay = {
					currencyCode: _this.currencyCode,
					countryCode: _this.countryCode,
					applicationData: btoa("Order Number " + _this.orderNumber),
					total: { "amount": _this.totalAmount, "label": "OPSM", "type": "final" },
					supportedNetworks: ["visa", "masterCard", "amex"],
					merchantCapabilities: ["supports3DS", "supportsCredit", "supportsDebit"],
					requiredBillingContactFields: ["email", "name", "phone", "postalAddress"],
					shippingMethods: [],
					supportsCouponCode: false
				};
				_this.startApplePaySession(configApplePay);
			});
		}
	}, {
		key: "getLastPIFromResponse",
		value: function getLastPIFromResponse(response) {
			var lastPiIdItem = 0;
			if (response && Array.isArray(response.paymentInstruction) && response.paymentInstruction.length > 0) {
				for (var i = 0; i < response.paymentInstruction.length; i++) {
					var piIdItem = parseInt(response.paymentInstruction[i].piId);
					if (piIdItem > lastPiIdItem) {
						lastPiIdItem = parseInt(piIdItem);
					}
				}
			}
			return lastPiIdItem;
		}
	}, {
		key: "startApplePaySession",
		value: function startApplePaySession(configApplePay) {
			var _this = this;
			_this.log("startApplePaySession ", JSON.stringify(configApplePay));
			try {
				var applePaySession = new ApplePaySession(1, configApplePay);
				applePaySession.manager = _this;
				applePaySession.onvalidatemerchant = _this.onvalidatemerchant;
				applePaySession.onshippingcontactselected = _this.onshippingcontactselected;
				applePaySession.onshippingmethodselected = _this.onshippingmethodselected;
				applePaySession.onpaymentauthorized = _this.onpaymentauthorized;
				applePaySession.oncancel = _this.oncancel;
				applePaySession.begin();
			} catch (err) {
				_this.log("startApplePaySession error ", err);
			}
		}

		//ApplePaySession callbacks

	}, {
		key: "onvalidatemerchant",
		value: function onvalidatemerchant(event) {
			var _this = this;
			var _manager = this.manager;
			var completeMerchVal = function completeMerchVal(respData, status, xhr) {
				var response = JSON.parse(respData);
				if (response.paymentInstruction && response.paymentInstruction.length > 0) {
					_manager.lastPiIdOrder = response.paymentInstruction[0].piId || 0;
					var protocolDataItems = response.paymentInstruction[0].protocolData;
					var merchantSessionObject_size = 0;
					var protocolData = {};
					protocolDataItems.forEach(function (protocol) {
						if (protocol.name.startsWith("MerchantSessionObject_size")) {
							merchantSessionObject_size = protocol.value;
						} else if (protocol.name.startsWith("MerchantSessionObject_")) {
							var idx = parseInt(protocol.name.substring(1 + protocol.name.lastIndexOf("_")));
							protocolData[idx] = protocol.value;
						}
					});

					_manager.log("merchantSessionObject_size=", merchantSessionObject_size);

					if (Object.keys(protocolData).length > 0) {
						var opaqueMerchantSession = "";
						for (var i = 0; i < Object.keys(protocolData).length; i++) {
							opaqueMerchantSession += protocolData[i];
						}
						_manager.log("opaqueMerchantSession=", opaqueMerchantSession);
						var opaqueMerchantSessionObj = JSON.parse(opaqueMerchantSession);
						try {
							_this.completeMerchantValidation(opaqueMerchantSessionObj);
						} catch (e) {
							_manager.log("completeMerchantValidation ERROR ", e);
						}
					}
				}
			};
			_manager.log("onvalidatemerchant " + event.validationURL);
			_manager.piAdd(event.validationURL).then(_manager.piDeletePreviousAndFetchCart).then(completeMerchVal);
		}
	}, {
		key: "onshippingcontactselected",
		value: function onshippingcontactselected(event) {
			var _manager = this.manager;
			_manager.log("onshippingcontactselected ", event);
		}
	}, {
		key: "onshippingmethodselected",
		value: function onshippingmethodselected(event) {
			var _manager = this.manager;
			_manager.log("onshippingmethodselected ", event);
		}
	}, {
		key: "onpaymentauthorized",
		value: function onpaymentauthorized(event) {
			var _this = this;
			var _manager = this.manager;
			var submitOrder = function submitOrder() {
				try {
					callAnalyticsForClick('prop2,prop24', '', '', '', '', '', '', '', '', '', 'o', 'Cart|PlaceOrder', window.analyticsFramework.data.pageName);
				} catch (err) {
					_manager.log("callAnalyticsForClick error ", err);
				}

				try {
					_manager.log("SubmitOrderProcess ");
					_manager.formOrderProcessCtrl.submit();
				} catch (e) {
					_manager.log("onpaymentauthorized ERROR ", e);
				}
			};
			var completePmt = function completePmt() {
				_this.completePayment(ApplePaySession.STATUS_SUCCESS);
				submitOrder();
			};

			_manager.log("lastPiIdOrder: " + _manager.lastPiIdOrder);
			if (parseInt(_manager.lastPiIdOrder) > 0) {
				//			_manager.piEdit(event).then(_manager.orderPrepare).then([completePmt, submitOrder]);
				_manager.piEdit(event).then(_manager.orderPrepare).then(completePmt);
			}

			/*
   		$.ajax({
   		url: "/AjaxRESTOrderSubmit",
   		data: dataPi,
   		type: "POST",
   		async: false,
   		success: function (data) {
   			var response = JSON.parse(data);
   			if (response) {
   				_this.completePayment(ApplePaySession.STATUS_SUCCESS);
   				var orderId = response.orderId;
   				var email = 'opsm@omnys.com';
   				var customerName = event.payment.billingContact.givenName;
   				console.log("Redirect to TYP");
   				console.log(`/OrderConfirmationView?TYPFrom=checkout&oemail=${email}&ocxname=${customerName}&catalogId=${_this.catalogId}&langId=${_this.langId}&storeId=${_this.storeId}&orderId=${orderId}`);
   			}
   			_manager.log("AjaxRESTOrderSubmit data ", data);
   		}
   	});
   
   */
		}
	}, {
		key: "oncancel",
		value: function oncancel(event) {
			var _manager = this.manager;
			_manager.log("oncancel ", event);
		}
	}, {
		key: "log",
		value: function log(msg, obj) {
			//if (localStorage.getItem("DEBUG")) {
			console.log("ApplePayManager-" + msg, obj);
			//}
		}
	}]);

	return ApplePayManager;
}();
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * If api key is wrong, auth issue can be managed by global function window.gm_authFailure
 * if api key has hostname block issue, gm_authFailure callback is called by Gmap api
 * if api key is ok, but not enabled for some service, some event is triggered when 
 * .getPlace() method of Place api is called
 * we can handle on UI / OK button click 
 * 
 * */
var AutoCompleteGoogleMapsPlace = function () {
	function AutoCompleteGoogleMapsPlace($inputEl, componentForm, componentFormSfx, types, componentRestrictions, placeChangedCallback, apiErrorCallback) {
		_classCallCheck(this, AutoCompleteGoogleMapsPlace);

		this.$inputEl = $inputEl;
		//use setter after new AutoCompleteGoogleMapsPlace() to enable
		this.flagInputSelectedOnChoose = false;

		if (typeof this.$inputEl === 'undefined' || this.$inputEl == null || !$inputEl.is('input')) {
			console.log('Gmap: element is not an input type');
			//			this.functionCall(apiErrorCallback);
			$(document).trigger('gmapApi:detached' + this.componentFormSfx);
			return;
		}
		this.autocomplete = null;

		this.inputEl = $inputEl[0];

		//If the following global function is defined it will be called when the GoogleMap authentication fails. 
		window.gm_authFailure = window.gm_authFailure || this.unloadOnAuthHandler;

		//the following is the default mapping to Place.Autocomplete response object
		var _componentForm = {
			subpremise: 'short_name',
			street_number: 'short_name',
			route: 'long_name',
			locality: 'long_name', /* City */
			colloquial_area: 'long_name', //for city in some cases
			administrative_area_level_1: 'short_name', /*suburb*/
			country: 'short_name',
			postal_code: 'short_name'
		};
		var _componentRestrictions = {
			'country': []
		};
		var _types = ['address']; //return results with full address

		//use defaults if not passed
		this.componentForm = componentForm || _componentForm;
		this.types = types || _types;
		this.componentRestrictions = componentRestrictions || _componentRestrictions;
		this.placeChangedCallback = placeChangedCallback;
		this.apiErrorCallback = apiErrorCallback;
		this.googleMapsApiKey = opsm.core.getGoogleMapsApiKey();

		this.componentFormSfx = componentFormSfx || '';
		//handlers need to be loaded before and anyway
		this.initHandleErrors();

		//handle disable api for insert in manual mode
		$(document).on('gmapApi:detach' + this.componentFormSfx, { _this: this }, this.unloadOnEvent);

		this.loadApiVar = null;
		this.loadGoogleApis();
	}

	_createClass(AutoCompleteGoogleMapsPlace, [{
		key: 'setCompRestrictions',
		value: function setCompRestrictions(restrictions) {
			if (this.autocomplete === null || typeof this.autocomplete === 'undefined') {
				//will apply on input first click
				this.componentRestrictions = restrictions;
			} else {
				this.autocomplete.setComponentRestrictions(restrictions);
			}
		}
	}, {
		key: 'loadGoogleApis',
		value: function loadGoogleApis(retries) {
			if (typeof retries === 'undefined' || retries === null) {
				retries = 0;
			}

			var _this = this;
			if (window.gapisloading && retries < 200) {
				if (_this.loadApiVar) clearTimeout(_this.loadApiVar);
				_this.loadApiVar = setTimeout(function () {
					_this.loadGoogleApis(++retries);
				}, 50);
			} else if (typeof google !== 'undefined' && google !== null && typeof google.maps !== 'undefined' && google.maps !== null && typeof google.maps.places !== 'undefined' && google.maps.places !== null) {
				_this.$inputEl.one('focus', { _this: _this }, _this.initOnInputEvent);
			} else if (this.googleMapsApiKey != 'undefined' && (typeof google === 'undefined' || google === null)) {
				window.gapisloading = true;
				$.getScript('https://maps.googleapis.com/maps/api/js?key=' + this.googleMapsApiKey + '&libraries=places&sensor=false&language=en&region=' + opsm.core.getCountryCode()).done(function (script, status) {
					window.gapisloading = false;
					_this.$inputEl.one('focus', { _this: _this }, _this.initOnInputEvent);
				}).fail(function (jqxhr, settings, exception) {
					window.gapisloading = false;
					console.log("Unable to load G-map api");
					$(document).trigger('gmapApi:detached');
				});
			}
		}
	}, {
		key: 'initOnInputEvent',
		value: function initOnInputEvent(e) {
			e.data._this.initAutocomplete();
			//todo move in css?? 
			e.data._this.initRemoveGStyles();
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(e) {
			var classSfx = e.data._this.componentFormSfx;
			//could help with validators
			if (e.data._this.flagInputSelectedOnChoose) {
				$(this).data('selected', 'false');
			}
			for (var component in e.data._this.componentForm) {
				if ($('.' + component + classSfx)[0] !== $(this)[0]) {
					opsm.utils.setContent($('.' + component + classSfx), '');
					$('.' + component + classSfx).prop('disabled', false);
				}
			}
			$(this).trigger('gmapApi:placeEdited');
		}
	}, {
		key: 'doFlagInputSelectedOnChoose',
		value: function doFlagInputSelectedOnChoose(b) {
			if ((typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== _typeof(true) || b === null) {
				return;
			}
			this.flagInputSelectedOnChoose = b;
		}
	}, {
		key: 'functionCall',
		value: function functionCall(maybefunction) {
			if (typeof maybefunction == "function") {
				maybefunction.call();
			}
		}

		//this is the callback function called by google apis on auth errors

	}, {
		key: 'unloadOnAuthHandler',
		value: function unloadOnAuthHandler(e) {
			//no need to unbind on auth error; notify or call callback function
			$(document).trigger('gmapApi:detached');
		}

		//trick : this is used to intercept valid api key, but not enabled for service
		// here click event on input has been triggered

	}, {
		key: 'unloadOnEvent',
		value: function unloadOnEvent(event, isGlobalReason) {
			console.log("Unloading Gmap handlers on event");
			if (typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.event !== 'undefined') {
				event.data._this.restoreOriginalListener(event.data._this.inputEl);
				google.maps.event.clearInstanceListeners(event.data._this.inputEl);
				//			this.unloadOnAuthHandler();
				if (isGlobalReason) {
					$(document).trigger('gmapApi:detached');
				}
			}
		}
	}, {
		key: 'unloadOnEventGlobally',
		value: function unloadOnEventGlobally(event) {
			event.data._this.unloadOnEvent(event, true);
		}

		//hide G logo and hyperlink from address suggestions UI

	}, {
		key: 'initRemoveGStyles',
		value: function initRemoveGStyles() {
			$('<style>.pac-logo:after {display: none !important;}</style>').appendTo($('head'));
		}

		/*
   * if api key is ok, but not enabled for some service, some event is triggered 
   * when .getPlace() method of Place api is called;
   * a container is shown up to alert
   * we can handle on OK button click 
   * */

	}, {
		key: 'initHandleErrors',
		value: function initHandleErrors() {
			var _this = this;
			$(document).on('gmapApi:detached gmapApi:detach' + _this.componentFormSfx, function (e) {
				_this.clear();
				_this.functionCall(_this.apiErrorCallback);
			});
			$(document).on('DOMNodeInserted', function (e) {
				if ($('.pac-container .dismissButton').length) {
					//				$('.dismissButton').one('click', {funct: _this.apiErrorCallback},  _this.functionCallHandler);
					$('.dismissButton').one('click', { _this: _this }, _this.unloadOnEventGlobally);
					//				_this.$inputEl.one('focusout',
				}
			});
		}
	}, {
		key: 'clear',
		value: function clear() {
			var _this = this;
			//		this.$inputEl.off('change');
			//		$(document).off('gmapApi:detached', _this.apiErrorCallback);
			this.$inputEl.off('change', _this.onInputChange);
			this.$inputEl.off('focus', _this.initOnInputEvent);
			//		$(document).off('DOMNodeInserted', function(e){
		}
	}, {
		key: 'initAutocomplete',
		value: function initAutocomplete() {
			var _this = this;
			var classSfx = _this.componentFormSfx;
			if (_this.autocomplete !== null && typeof _this.autocomplete !== 'undefined') {
				return;
			}

			this.selectFirstOnEnterOrFocusOut(this.inputEl);
			this.$inputEl.on('change', { _this: _this }, _this.onInputChange);

			_this.autocomplete = new google.maps.places.Autocomplete(this.inputEl);
			_this.autocomplete.setTypes(this.types);
			_this.autocomplete.setComponentRestrictions(this.componentRestrictions);
			_this.autocomplete.setFields(['address_component']);
			_this.autocomplete.addListener('place_changed', function () {
				var result = _this.autocomplete.getPlace();
				/* OPSMD-4013 street number not fully returned by place api */
				var selectedPrediction = '';
				try {
					selectedPrediction = _this.autocomplete.gm_accessors_.place.ue.formattedPrediction;
				} catch (e) {
					console.log('initAutocomplete: selectedPrediction fetching error');
				}
				/* END OPSMD-4013 */
				if (typeof result.address_components != 'undefined') {
					//clear fields
					for (var component in _this.componentForm) {
						opsm.utils.setContent($('.' + component + classSfx), '');
						$('.' + component + classSfx).prop('disabled', false);
					}

					if (typeof _this.placeChangedCallback === 'function') {
						_this.placeChangedCallback(result, _this.componentFormSfx, selectedPrediction);
					} else {
						_this.googlePlaceAutocompleteClick(result);
					}

					//could help with validators
					if (_this.flagInputSelectedOnChoose) {
						_this.$inputEl.data('selected', 'true');
						//				_this.$inputEl.trigger('blur');
					}
					_this.$inputEl.trigger('gmapApi:placeSelected');
				}
			});
		}

		//this method auto handles autocomplete based on componentForm and classes on dom elements

	}, {
		key: 'googlePlaceAutocompleteClick',
		value: function googlePlaceAutocompleteClick(place) {
			var componentForm = this.componentForm;
			var classSfx = _this.componentFormSfx;
			var colloquial_area_for_city = '';
			//administrative_area_level_2 ???
			for (var i = 0; i < place.address_components.length; i++) {
				var addressType = place.address_components[i].types[0];
				if (componentForm[addressType]) {
					var val = place.address_components[i][componentForm[addressType]];
					if (addressType === 'colloquial_area') {
						colloquial_area_for_city = val;
					}
					opsm.utils.setContent($('.' + addressType + classSfx), val);
				}
			}
			if (opsm.utils.getContent($('.locality' + classSfx)) === '') {
				opsm.utils.setContent($('.locality' + classSfx), colloquial_area_for_city);
			}
		}
	}, {
		key: 'restoreOriginalListener',
		value: function restoreOriginalListener(input) {
			if (input.removeEventListener) {
				if (this.wrappedKeydownListener) input.removeEventListener('keydown', this.wrappedKeydownListener);
				//			if(this.wrappedBlurListener) input.removeEventListener('keydown', this.wrappedBlurListener);
			} else if (input.detachEvent) {
				if (this.wrappedKeydownListener) input.detachEvent('keydown', this.wrappedKeydownListener);
				//			if(this.wrappedBlurListener) input.detachEvent('keydown', this.wrappedBlurListener);
			}
			if (input.addEventListener) {
				if (this.originalAddEventListener) input.addEventListener = this.originalAddEventListener;
			} else if (input.attachEvent) {
				if (this.originalAddEventListener) input.attachEvent = this.originalAddEventListener;
			}
		}
	}, {
		key: 'selectFirstOnEnterOrFocusOut',
		value: function selectFirstOnEnterOrFocusOut(input) {
			var _this = this;
			// store the original event binding function
			var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;
			_this.originalAddEventListener = _addEventListener;

			/* Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
    * and then trigger the original listener.
    * Also can attach a blur listener to original listener
    */
			function addEventListenerWrapper(type, listener) {
				if (type == "keydown") {
					var orig_listener = listener;
					var blurListener = function blurListener(event) {
						var suggestion_selected = $(".pac-item-selected").length > 0;
						if (!suggestion_selected) {
							var simulated_downarrow = $.Event("keydown", { keyCode: 40, which: 40 });
							// var simulated_uparrow = $.Event("keyup", {keyCode: 13, which: 13});
							var simulated_downenter = $.Event("keydown", { keyCode: 13, which: 13 });
							orig_listener.apply(input, [simulated_downarrow]);
							orig_listener.apply(input, [simulated_downenter]);
						}
					};
					_this.wrappedBlurListener = blurListener;
					listener = function listener(event) {
						//_addEventListener.apply(input, ['blur', blurListener]); // add blur listener
						var suggestion_selected = $(".pac-item-selected").length > 0;
						if (event.which == 13 && !suggestion_selected) {
							var simulated_downarrow = $.Event("keydown", { keyCode: 40, which: 40 });
							orig_listener.apply(input, [simulated_downarrow]);
						}
						orig_listener.apply(input, [event]);
					};
					_this.wrappedKeydownListener = listener;
				}
				// add the modified listener
				_addEventListener.apply(input, [type, listener]);
			}

			if (input.addEventListener) {
				input.addEventListener = addEventListenerWrapper;
			} else if (input.attachEvent) {
				input.attachEvent = addEventListenerWrapper;
			}
		}
	}]);

	return AutoCompleteGoogleMapsPlace;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AutoCompleteGoogleMaps = function () {
  function AutoCompleteGoogleMaps(callbackFunc) {
    var _this = this;

    _classCallCheck(this, AutoCompleteGoogleMaps);

    this.elmInput = $('#field-booking');
    var autocomplete = true;
    if (this.elmInput.length && typeof google === 'undefined') {
      $.getScript('//maps.googleapis.com/maps/api/js?sensor=false&key=' + opsm.core.getGoogleMapsApiKey() + '&language=en&region=' + opsm.core.getCountryCode() + '&libraries=places').done(function (script, status) {
        if (typeof callbackFunc == "function") {
          callbackFunc.call();
        }
      });
    }
    this.elmInput.on('click', function () {
      if (autocomplete) {
        _this.handleAutocomplete();
        autocomplete = false;
      }
    });
  }

  _createClass(AutoCompleteGoogleMaps, [{
    key: 'handleAutocomplete',
    value: function handleAutocomplete() {
      var input = document.getElementById('field-booking');
      var autocomplete = new google.maps.places.Autocomplete(input, {
        types: ['geocode'],
        componentRestrictions: {
          'country': 'au'
        }
      });

      autocomplete.addListener('place_changed', function () {
        var result = autocomplete.getPlace();
        if (typeof result.address_components != 'undefined') {
          googlePlaceAutocompleteClick(result);
        }
      });

      function googlePlaceAutocompleteClick(place) {
        console.log(place);
      }
    }
  }]);

  return AutoCompleteGoogleMaps;
}();
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * If api key is wrong, auth issue can be managed by global function window.gm_authFailure
 * if api key has hostname block issue, gm_authFailure callback is called by Gmap api
 * if api key is ok, but not enabled for some service, some event is triggered when 
 * .getPlace() method of Place api is called
 * we can handle on UI / OK button click 
 * 
 * */
var AutocompleteAddressGmaps = function () {
	function AutocompleteAddressGmaps($inputEl, componentForm, componentFormSfx, types, componentRestrictions, placeChangedCallback, apiErrorCallback) {
		_classCallCheck(this, AutocompleteAddressGmaps);

		this.$inputEl = $inputEl;
		this.flagInputSelectedOnChoose = false;

		if (typeof this.$inputEl === 'undefined' || this.$inputEl == null || !$inputEl.is('input')) {
			console.log('Gmap: element is not an input type');
			$(document).trigger('gmapApi:detached' + this.componentFormSfx);
			return;
		}
		this.autocomplete = null;

		this.inputEl = $inputEl[0];
		this.$formId = this.$inputEl.parents("form");

		//If the following global function is defined it will be called when the GoogleMap authentication fails. 
		window.gm_authFailure = window.gm_authFailure || this.unloadOnAuthHandler;

		//the following is the default mapping to Place.Autocomplete response object
		var _componentForm = {
			subpremise: 'short_name',
			street_number: 'short_name',
			route: 'long_name',
			locality: 'long_name', /* City */
			colloquial_area: 'long_name', //for city in some cases
			administrative_area_level_1: 'short_name', /*suburb*/
			country: 'short_name',
			postal_code: 'short_name'
		};
		var _componentRestrictions = {
			'country': opsm.core.getCountryCode()
		};
		var _types = ['address']; //return results with full address

		//use defaults if not passed
		this.componentForm = componentForm || _componentForm;
		this.types = types || _types;
		this.componentRestrictions = componentRestrictions || _componentRestrictions;
		this.placeChangedCallback = placeChangedCallback || this.placeChangedCallbackDefault;
		this.apiErrorCallback = apiErrorCallback || this.apiErrorCallbackDefault;
		this.googleMapsApiKey = opsm.core.getGoogleMapsApiKey();

		this.componentFormSfx = componentFormSfx || '';
		//handlers need to be loaded before and anyway
		this.initHandleErrors();

		//handle disable api for insert in manual mode
		$(document).on('gmapApi:detach' + this.componentFormSfx, { _this: this }, this.unloadOnEvent);

		this.loadApiVar = null;
		this.loadGoogleApis();
	}

	_createClass(AutocompleteAddressGmaps, [{
		key: 'setCompRestrictions',
		value: function setCompRestrictions(restrictions) {
			if (this.autocomplete === null || typeof this.autocomplete === 'undefined') {
				//will apply on input first click
				this.componentRestrictions = restrictions;
			} else {
				this.autocomplete.setComponentRestrictions(restrictions);
			}
		}
	}, {
		key: 'loadGoogleApis',
		value: function loadGoogleApis(retries) {
			if (typeof retries === 'undefined' || retries === null) {
				retries = 0;
			}

			var _this = this;
			if (window.gapisloading && retries < 200) {
				if (_this.loadApiVar) clearTimeout(_this.loadApiVar);
				_this.loadApiVar = setTimeout(function () {
					_this.loadGoogleApis(++retries);
				}, 50);
			} else if (typeof google !== 'undefined' && google !== null && typeof google.maps !== 'undefined' && google.maps !== null && typeof google.maps.places !== 'undefined' && google.maps.places !== null) {
				_this.$inputEl.one('focus', { _this: _this }, _this.initOnInputEvent);
			} else if (this.googleMapsApiKey != 'undefined' && (typeof google === 'undefined' || google === null)) {
				window.gapisloading = true;
				$.getScript('https://maps.googleapis.com/maps/api/js?key=' + this.googleMapsApiKey + '&libraries=places&sensor=false&language=en&region=' + opsm.core.getCountryCode()).done(function (script, status) {
					window.gapisloading = false;
					_this.$inputEl.one('focus', { _this: _this }, _this.initOnInputEvent);
				}).fail(function (jqxhr, settings, exception) {
					window.gapisloading = false;
					console.log("Unable to load G-map api");
					$(document).trigger('gmapApi:detached');
				});
			}
		}
	}, {
		key: 'initOnInputEvent',
		value: function initOnInputEvent(e) {
			e.data._this.initAutocomplete();
			//todo move in css?? 
			$(".ui-autocomplete").css({ "z-index": "1101" });
			e.data._this.initRemoveGStyles();
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(e) {
			var _this = this;
			var classSfx = e.data._this.componentFormSfx;
			var inputEl = e.data._this.inputEl;
			//could help with validators
			if (e.data._this.flagInputSelectedOnChoose) {
				$(this).data('selected', 'false');
			}
			for (var component in e.data._this.componentForm) {
				if ($('.' + component + classSfx)[0] !== $(this)[0]) {
					opsm.utils.setContent(e.data._this.$formId.find('.' + component + classSfx), '');
					e.data._this.$formId.find('.' + component + classSfx).prop('disabled', false);
				}
			}
			$(this).trigger('gmapApi:placeEdited');
		}
	}, {
		key: 'doFlagInputSelectedOnChoose',
		value: function doFlagInputSelectedOnChoose(b) {
			if ((typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== _typeof(true) || b === null) {
				return;
			}
			this.flagInputSelectedOnChoose = b;
		}
	}, {
		key: 'functionCall',
		value: function functionCall(maybefunction) {
			if (typeof maybefunction == "function") {
				maybefunction.call();
			}
		}

		//this is the callback function called by google apis on auth errors

	}, {
		key: 'unloadOnAuthHandler',
		value: function unloadOnAuthHandler(e) {
			//no need to unbind on auth error; notify or call callback function
			$(document).trigger('gmapApi:detached');
		}

		//trick : this is used to intercept valid api key, but not enabled for service
		// here click event on input has been triggered

	}, {
		key: 'unloadOnEvent',
		value: function unloadOnEvent(event, isGlobalReason) {
			console.log("Unloading Gmap handlers on event");
			if (typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.event !== 'undefined') {
				event.data._this.restoreOriginalListener(event.data._this.inputEl);
				google.maps.event.clearInstanceListeners(event.data._this.inputEl);
				//			this.unloadOnAuthHandler();
				if (isGlobalReason) {
					$(document).trigger('gmapApi:detached');
				}
			}
		}
	}, {
		key: 'unloadOnEventGlobally',
		value: function unloadOnEventGlobally(event) {
			event.data._this.unloadOnEvent(event, true);
		}

		//hide G logo and hyperlink from address suggestions UI

	}, {
		key: 'initRemoveGStyles',
		value: function initRemoveGStyles() {
			$('<style>.pac-logo:after {display: none !important;}</style>').appendTo($('head'));
		}

		/*
   * if api key is ok, but not enabled for some service, some event is triggered 
   * when .getPlace() method of Place api is called;
   * a container is shown up to alert
   * we can handle on OK button click 
   * */

	}, {
		key: 'initHandleErrors',
		value: function initHandleErrors() {
			var _this = this;
			$(document).on('gmapApi:detached gmapApi:detach' + _this.componentFormSfx, function (e) {
				_this.clear();
				_this.functionCall(_this.apiErrorCallback);
			});
			$(document).on('DOMNodeInserted', function (e) {
				if ($('.pac-container .dismissButton').length) {
					//				$('.dismissButton').one('click', {funct: _this.apiErrorCallback},  _this.functionCallHandler);
					$('.dismissButton').one('click', { _this: _this }, _this.unloadOnEventGlobally);
					//				_this.$inputEl.one('focusout',
				}
			});
		}
	}, {
		key: 'clear',
		value: function clear() {
			var _this = this;
			//		this.$inputEl.off('change');
			//		$(document).off('gmapApi:detached', _this.apiErrorCallback);
			this.$inputEl.off('change', _this.onInputChange);
			this.$inputEl.off('focus', _this.initOnInputEvent);
			//		$(document).off('DOMNodeInserted', function(e){
		}
	}, {
		key: 'initAutocomplete',
		value: function initAutocomplete() {
			var _this = this;
			var classSfx = _this.componentFormSfx;
			var formId = _this.$formId;
			if (_this.autocomplete !== null && typeof _this.autocomplete !== 'undefined') {
				return;
			}

			this.selectFirstOnEnterOrFocusOut(this.inputEl);
			this.$inputEl.on('change', { _this: _this }, _this.onInputChange);

			_this.autocomplete = new google.maps.places.Autocomplete(this.inputEl);
			_this.autocomplete.setTypes(this.types);
			_this.autocomplete.setComponentRestrictions(this.componentRestrictions);
			_this.autocomplete.setFields(['address_component']);
			$(formId).off('gmapApi:placeEdited gmapApi:placeSelected', _this.inputEl, _this.onStreetAddressNotif);
			$(formId).on('gmapApi:placeEdited gmapApi:placeSelected', _this.inputEl, _this.onStreetAddressNotif);
			_this.autocomplete.addListener('place_changed', function () {
				var result = _this.autocomplete.getPlace();
				/* OPSMD-4013 street number not fully returned by place api */
				var selectedPrediction = '';
				try {
					selectedPrediction = _this.autocomplete.gm_accessors_.place.ue.formattedPrediction;
				} catch (e) {
					console.log('initAutocomplete: selectedPrediction fetching error');
				}
				/* END OPSMD-4013 */
				if (typeof result.address_components != 'undefined') {
					//clear fields
					for (var component in _this.componentForm) {
						opsm.utils.setContent(_this.$formId.find('.' + component + classSfx), '');
						_this.$formId.find('.' + component + classSfx).prop('disabled', false);
					}

					if (typeof _this.placeChangedCallback === 'function') {
						_this.placeChangedCallback(result, _this.componentFormSfx, selectedPrediction);
					} else {
						_this.googlePlaceAutocompleteClick(result);
					}

					//could help with validators
					if (_this.flagInputSelectedOnChoose) {
						_this.$inputEl.data('selected', 'true');
						//				_this.$inputEl.trigger('blur');
					}
					_this.$inputEl.trigger('gmapApi:placeSelected');
				}
			});
		}

		//this method auto handles autocomplete based on componentForm and classes on dom elements

	}, {
		key: 'googlePlaceAutocompleteClick',
		value: function googlePlaceAutocompleteClick(place) {
			var _this = this;
			var componentForm = _this.componentForm;
			var classSfx = _this.componentFormSfx;
			var colloquial_area_for_city = '';
			//administrative_area_level_2 ???
			for (var i = 0; i < place.address_components.length; i++) {
				var addressType = place.address_components[i].types[0];
				if (componentForm[addressType]) {
					var val = place.address_components[i][componentForm[addressType]];
					if (addressType === 'colloquial_area') {
						colloquial_area_for_city = val;
					}
					opsm.utils.setContent(_this.$formId.find('.' + addressType + classSfx), val);
				}
			}
			if (opsm.utils.getContent(_this.$formId.find('.locality' + classSfx)) === '') {
				opsm.utils.setContent(_this.$formId.find('.locality' + classSfx), colloquial_area_for_city);
			}
		}
	}, {
		key: 'restoreOriginalListener',
		value: function restoreOriginalListener(input) {
			if (input.removeEventListener) {
				if (this.wrappedKeydownListener) input.removeEventListener('keydown', this.wrappedKeydownListener);
				//			if(this.wrappedBlurListener) input.removeEventListener('keydown', this.wrappedBlurListener);
			} else if (input.detachEvent) {
				if (this.wrappedKeydownListener) input.detachEvent('keydown', this.wrappedKeydownListener);
				//			if(this.wrappedBlurListener) input.detachEvent('keydown', this.wrappedBlurListener);
			}
			if (input.addEventListener) {
				if (this.originalAddEventListener) input.addEventListener = this.originalAddEventListener;
			} else if (input.attachEvent) {
				if (this.originalAddEventListener) input.attachEvent = this.originalAddEventListener;
			}
		}
	}, {
		key: 'selectFirstOnEnterOrFocusOut',
		value: function selectFirstOnEnterOrFocusOut(input) {
			var _this = this;
			// store the original event binding function
			var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;
			_this.originalAddEventListener = _addEventListener;

			/* Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
    * and then trigger the original listener.
    * Also can attach a blur listener to original listener
    */
			function addEventListenerWrapper(type, listener) {
				if (type == "keydown") {
					var orig_listener = listener;
					var blurListener = function blurListener(event) {
						var suggestion_selected = $(".pac-item-selected").length > 0;
						if (!suggestion_selected) {
							var simulated_downarrow = $.Event("keydown", { keyCode: 40, which: 40 });
							// var simulated_uparrow = $.Event("keyup", {keyCode: 13, which: 13});
							var simulated_downenter = $.Event("keydown", { keyCode: 13, which: 13 });
							orig_listener.apply(input, [simulated_downarrow]);
							orig_listener.apply(input, [simulated_downenter]);
						}
					};
					_this.wrappedBlurListener = blurListener;
					listener = function listener(event) {
						//_addEventListener.apply(input, ['blur', blurListener]); // add blur listener
						var suggestion_selected = $(".pac-item-selected").length > 0;
						if (event.which == 13 && !suggestion_selected) {
							var simulated_downarrow = $.Event("keydown", { keyCode: 40, which: 40 });
							orig_listener.apply(input, [simulated_downarrow]);
						}
						orig_listener.apply(input, [event]);
					};
					_this.wrappedKeydownListener = listener;
				}
				// add the modified listener
				_addEventListener.apply(input, [type, listener]);
			}

			if (input.addEventListener) {
				input.addEventListener = addEventListenerWrapper;
			} else if (input.attachEvent) {
				input.attachEvent = addEventListenerWrapper;
			}
		}
	}, {
		key: 'apiErrorCallbackDefault',
		value: function apiErrorCallbackDefault() {
			// Given the impacted form we're able to get all the address related input & ids, based on a standard structure of selectors
			var _this = this;
			var suburb = _this.$formId.find("[contenteditable]");
			var state = _this.$formId.find("[name=*'state']");
			var postcode = _this.$formId.find("[name*='postcode']");
			var statePostcodeWrapper = state.closest("div[id]");
			var suburbId = suburb.attr("id");
			var stateId = state.attr("id");
			var postcodebId = postcode.attr("id");
			var statePostcodeWrapperId = statePostcodeWrapper.attr("id");
			console.log("gApiErrorCallback called for " + _this.$inputEl);
			//detach google.maps listeners
			if (typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.event !== 'undefined') {
				google.maps.event.clearInstanceListeners(_this.$inputEl);
			}
			//detach listenters on streetaddr input
			_this.$inputEl.parents("[class*='wrapper']").off('gmapApi:placeEdited gmapApi:placeSelected', _this.$inputEl.attr("id"), onStreetAddressNotif);

			suburb.attr('contenteditable', '').css("background-color", _this.$inputEl.css("background-color"));
			//init old validation on suburb
			var addressValidationsUrl = $('#addressValidationResults').val();
			window.autoCompleteSuburbShipping = new OPSMAutoCompleteSuburb(suburbId, stateId, postcodebId, statePostcodeWrapperId, addressValidationsUrl, opsm.core.getCountryCode());
			if (suburb.length) {
				if (suburb.parent().length) {
					suburb.parent().show();
				} else {
					suburb.show();
				}
			}
			statePostcodeWrapper.show();
		}
	}, {
		key: 'placeChangedCallbackDefault',
		value: function placeChangedCallbackDefault(place, addrTypeSfx, selectedPrediction) {
			var _this = this;
			addrTypeSfx = addrTypeSfx || '';
			var componentForm = this.componentForm;
			var colloquial_area_for_city = '';
			//administrative_area_level_2 ???
			var street_number = '';
			var subpremise = '';
			for (var i = 0; i < place.address_components.length; i++) {
				var addressType = place.address_components[i].types[0];
				if (componentForm[addressType]) {
					var val = place.address_components[i][componentForm[addressType]];

					if (addressType === 'colloquial_area') {
						colloquial_area_for_city = val;
					}

					if (addressType === 'subpremise') {
						subpremise = val;
					}

					if (addressType === 'street_number') {
						street_number = val;
					}

					if ($('.' + addressType + addrTypeSfx).length) {
						opsm.utils.setContent(_this.$formId.find('.' + addressType + addrTypeSfx), val);
					}
				}
				//different countries may have different mappings
				if (addressType === 'administrative_area_level_2') {
					var aaLev2 = place.address_components[i]['short_name'];
				}
				if (addressType === 'administrative_area_level_3') {
					var aaLev3 = place.address_components[i]['short_name'];
				}
				if (opsm.core.getCountryCode() === 'nz' && addressType === 'sublocality_level_1') {
					var subLocLev1 = place.address_components[i]['short_name'];
				}
			}
			if (opsm.core.getCountryCode() === 'nz') {
				subLocLev1 = subLocLev1 || false;
				if (subLocLev1) {
					opsm.utils.setContent(_this.$formId.find('.locality' + addrTypeSfx), subLocLev1);
				}
			}

			if (opsm.utils.getContent(_this.$formId.find('.locality' + addrTypeSfx)) === '') {
				opsm.utils.setContent(_this.$formId.find('.locality' + addrTypeSfx), colloquial_area_for_city);
			}
			if (street_number.length) {

				if (subpremise.length) {
					street_number = subpremise + "/" + street_number;
				}

				opsm.utils.setContent(_this.$formId.find('.route' + addrTypeSfx), street_number + ', ' + opsm.utils.getContent(_this.$formId.find('.route' + addrTypeSfx)));
			}

			//different countries may have different mappings
			if (addrTypeSfx == '-billing' && $('[id*="billing-country"').val() && $('[id*="billing-country"').val() !== 'AU' && $('[id*="billing-country"').val() !== 'NZ') {
				//	    		if(opsm.utils.getContent($('.administrative_area_level_1'+addrTypeSfx)) === ''){
				opsm.utils.setContent(_this.$formId.find('.administrative_area_level_1' + addrTypeSfx), aaLev3 && aaLev3 !== opsm.utils.getContent(_this.$formId.find('.locality' + addrTypeSfx)) ? aaLev3 : null || aaLev2 && aaLev2 !== opsm.utils.getContent(_this.$formId.find('.locality' + addrTypeSfx)) ? aaLev2 : null || opsm.utils.getContent(_this.$formId.find('.administrative_area_level_1' + addrTypeSfx)) ? opsm.utils.getContent(_this.$formId.find('.administrative_area_level_1' + addrTypeSfx)) : opsm.utils.getContent(_this.$formId.find('.locality' + addrTypeSfx)));
				//	    		}
			}
			opsm.utils.changeGmapPlaceApiResults($('.administrative_area_level_1' + addrTypeSfx), 'administrative_area_level_1');

			/* OPSMD-4013 street number not fully returned by place api */
			if (selectedPrediction) {
				try {
					var selectedAddrParts = selectedPrediction.split(',');
					if (selectedAddrParts.length > 1) {
						for (var part = 0; part < selectedAddrParts.length; part++) {
							if (part > 0 && selectedAddrParts[part].indexOf(opsm.utils.getContent(_this.$formId.find('.locality' + addrTypeSfx)).trim()) !== -1) {
								/* the street number + street address is all before this part */
								opsm.utils.setContent(_this.$formId.find('.route' + addrTypeSfx), selectedAddrParts.slice(0, part).join(',').trim());
								break;
							}
						}
					}
				} catch (e) {
					console.log('placeChangedCallback: selectedPrediction parsing error');
				}
			}
		}
	}, {
		key: 'onStreetAddressNotif',
		value: function onStreetAddressNotif(e) {
			var inputEl = $(e.target);
			var formId = $(e.currentTarget);
			inputEl.valid();

			/* OPSMD-3715 trigger event to handle validation at opsm.checkout.attachevents()*/
			inputEl.trigger('paste');
			var suburb = formId.find('.locality');
			var state = formId.find('.administrative_area_level_1');
			var postcode = formId.find('.postal_code');
			// var errorInput = suburb.parent().parent().find(".error");
			var suburbMirrorInput = suburb;
			if (formId.find('.add-suggest-mirr').length) {
				suburbMirrorInput = formId.find('.add-suggest-mirr');
			}
			if (suburb.length) {
				suburb.attr('contenteditable', ''); //needed to activate validation on it
				if (formId.data("validator")) {
					formId.data("validator").checkForm();
				}
				if (opsm.utils.getContent(suburb).trim().length) {
					suburb.parent().addClass("not-empty");
					if (opsm.utils.getContent(state).trim().length && opsm.utils.getContent(postcode).trim().length) {
						$(suburbMirrorInput).data('selected', 'true').valid();
					} else {
						$(suburbMirrorInput).data('selected', 'false').valid();
						// opsm.utils.setContent($(errorInput), 'The selected address is incomplete');
					}
				} else {
					suburb.parent().removeClass("not-empty");
					suburbMirrorInput.data('selected', 'false').valid();
					// opsm.utils.setContent($(errorInput), 'The selected address is incomplete');
				}
			}
			inputEl.blur();
			suburb.blur();
			suburb.removeAttr("contenteditable");
		}
	}]);

	return AutocompleteAddressGmaps;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AutoCompleteSuburb = function () {
  function AutoCompleteSuburb(suburbId, stateId, postcodeId, containerId, googleMapsApiKey, countryCode, placeChangedCallback) {
    _classCallCheck(this, AutoCompleteSuburb);

    var _this = this;

    this.suburbId = suburbId;
    this.elmInput = $('#' + this.suburbId);

    this.stateId = stateId;
    this.postcodeId = postcodeId;
    this.containerId = containerId;
    this.placeChangedCallback = placeChangedCallback;
    this.countryCode = countryCode;
    this.googleMapsApiKey = googleMapsApiKey;

    if (this.elmInput.length === 0) {
      return;
    }

    $("#" + this.containerId).hide();
    var autocomplete = true;
    if (this.elmInput.length && typeof google === 'undefined') {
      $.getScript('//maps.googleapis.com/maps/api/js?sensor=false&key=' + this.googleMapsApiKey + '&language=en&region=' + this.countryCode + '&libraries=places') /*.done(function (script, status) {
                                                                                                                                                                   if (typeof callbackFunc == "function") {
                                                                                                                                                                   callbackFunc.call();
                                                                                                                                                                   }
                                                                                                                                                                   })*/;
    }
    this.elmInput.on('click', function () {
      if (autocomplete) {
        _this.handleAutocomplete();
        autocomplete = false;
      }
    });
  }

  _createClass(AutoCompleteSuburb, [{
    key: 'handleAutocomplete',
    value: function handleAutocomplete() {
      var _this2 = this;
      var input = document.getElementById(_this2.suburbId);
      var autocomplete = new google.maps.places.Autocomplete(input, {
        types: ['geocode'],
        componentRestrictions: {
          'country': _this2.countryCode
        }
      });

      autocomplete.addListener('place_changed', function () {
        var result = autocomplete.getPlace();
        if (typeof result.address_components != 'undefined') {
          if (typeof _this2.placeChangedCallback === 'function') _this2.placeChangedCallback(result);else googlePlaceAutocompleteClick(result);
        }
      });

      function googlePlaceAutocompleteClick(place) {
        $("#" + _this2.stateId).val(place.address_components[2].short_name).trigger('input');
        $("#" + _this2.postcodeId).val(place.address_components[4].long_name).trigger('input');
        $("#" + _this2.containerId).show();
      }
    }
  }]);

  return AutoCompleteSuburb;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OPSMAutoCompleteSuburb = function () {
  function OPSMAutoCompleteSuburb(suburbId, stateId, postcodeId, containerId, urlToCall, countryCode, minTermLength) {
    _classCallCheck(this, OPSMAutoCompleteSuburb);

    var _this = this;

    this.suburbId = suburbId;
    this.elmInput = $('#' + this.suburbId);
    if (this.elmInput.length === 0) {
      return;
    }

    this.stateId = stateId;
    this.postcodeId = postcodeId;
    this.containerId = containerId;
    this.urlToCall = urlToCall;
    this.countryCode = countryCode;

    this.minTermLength = 3;
    if (typeof minTermLength != 'undefined') this.minTermLength = minTermLength;

    $("#" + this.containerId).hide();

    this._addressSuggestionList = new Array();

    //wrapping calling to internal method to allow scoping of variable _this
    this.elmInput.autocomplete({

      //fetch the address data
      source: function source(request, response) {
        _this.getAddressData(request, response);
      },

      // This function is executed when a suggestion is selected
      select: function select(event, ui) {
        return _this.setSelectedValue(event, ui);
      },
      // This function is executed when the users focuses on a item with the mouse
      // or keyboard
      focus: function focus(event, ui) {
        //return _this.setSelectedValue(event, ui);
      },

      open: function open() {
        $(".ui-autocomplete:visible").css({ top: "+=1", left: "+=20", width: "-=40" });
        $(".ui-autocomplete").css({ "max-height": "14.5em", "overflow-y": "auto" });
      }

    }).on('input', function (e) {
      if ('true' === _this.elmInput.data('selected')) {
        var isCorrectValueSelected = _this.checkActualValue();
        if (!isCorrectValueSelected) {
          _this.elmInput.removeData('selected'); //"invalidating" input
          $("#" + _this.stateId).val('').trigger('input');
          $("#" + _this.postcodeId).val('').trigger('input');
          $("#" + _this.containerId).hide();
        }
      }
    }).data("uiAutocomplete")._renderItem = function (ul, item) {
      return _this.renderAddressValue(ul, item);
    };
  }

  _createClass(OPSMAutoCompleteSuburb, [{
    key: 'getAddressData',
    value: function getAddressData(request, response) {
      var _this2 = this;

      var term = request.term;
      if (term && term.length < _this2.minTermLength) return;

      function getBaseUrlToCall() {
        if (_this2.urlToCall.indexOf('?') >= 0) return _this2.urlToCall;
        return _this2.urlToCall + '?';
      }

      var addressValidationResults = getBaseUrlToCall() + '&term=' + term;

      var manageRemoteResults = function manageRemoteResults(data) {
        if (data && data.length && data.length >= 1) {
          var endsWith = ', city';
          var endsWithRegEx = new RegExp(endsWith + '$');
          for (var i = 0; i < data.length; i++) {
            var row = data[i];
            var value = row.value;
            if (value && endsWithRegEx.test(value)) {
              value = value.substring(0, value.length - endsWith.length);
              row.value = value; //replacing value after stripping tail ', city'  - see OPSMD-2614 by Shane
            }
          }
        }
        return data;
      };

      //Get the ajax url

      $.ajax({
        type: "POST",
        url: addressValidationResults,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function success(data) {
          manageRemoteResults(data);
          response(data);
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          //manageRemoteResults(data);
          response(textStatus + ' - ' + errorThrown.message);
          //hide the ul completely
          $('.ui-autocomplete').hide();
        }
      });
    }

    /* sets the selected  to the text box*/

  }, {
    key: 'setSelectedValue',
    value: function setSelectedValue(event, ui) {
      // Sets the text of the input textbox to the title of the object referenced
      // by the selected list item
      var _this4 = this;
      //$(_this4).val(ui.item.value);

      //update  city,state  and address
      var addressParts = ui.item.value.split(",");
      if (addressParts != undefined && addressParts.length >= 3) {
        var suburb = $.trim(addressParts[0]);
        var state = $.trim(addressParts[1]);
        var postcode = $.trim(addressParts[2]);

        //.valid() : triggering validation for single element
        opsm.utils.setContent(_this4.elmInput, suburb).data('selected', 'true').valid(); //don't trigger 'input' event (to avoid loop)
        /* OPSMD-3715 trigger event to handle validation at opsm.checkout.attachevents()*/
        _this4.elmInput.trigger('paste');
        $("#" + _this4.stateId).val(state).trigger('input').valid();
        $("#" + _this4.postcodeId).val(postcode).trigger('input').valid();
        $("#" + _this4.containerId).show().closest('form'); //showing container
      }
      return false;
    }

    /* render the address list with all values.
     * WARN state should be not rendered for NZ ??? */

  }, {
    key: 'renderAddressValue',
    value: function renderAddressValue(ul, item) {
      // ul is the unordered suggestion list
      // item is a object in the data object that was send to the response function
      // after the JSON request
      // We append a custom formatted list item to the suggestion list
      // The search term is bolded out

      var _this5 = this;
      var result = ul;
      if (item != undefined && item.term != undefined) {
        ul.show();
        var termPosn = item.value.indexOf(item.term);
        var countryCode = _this5.countryCode;
        var itemDisplayString = "";
        //Splitting the address to remove the city from the display string
        if (termPosn != -1) {
          var split = item.value.split(",");
          /*itemDisplayString = "<a>" + item.value.substring(0,termPosn) + "<b>" + item.term + "</b>" 
          + item.value.substring(termPosn + item.term.length ) + "</a>";*/

          itemDisplayString = "<a>" + item.value.substring(0, termPosn) + "<b>" + item.term + "</b>";
          itemDisplayString = itemDisplayString + item.value.substring(termPosn + item.term.length) + "</a>";
          if (countryCode == 'AU') {
            var itemDisplayStringSplit = itemDisplayString.split(",");
            itemDisplayString = itemDisplayStringSplit[0] + "," + itemDisplayStringSplit[1] + "," + itemDisplayStringSplit[2];
            item.value = split[0] + "," + split[1] + "," + split[2];
          }
          if (countryCode == 'NZ') {
            var itemDisplayStringSplit = itemDisplayString.split(",");
            itemDisplayString = itemDisplayStringSplit[0] + "," + itemDisplayStringSplit[1] + "," + itemDisplayStringSplit[2];
            item.value = split[0] + "," + split[1] + "," + split[2];
          }
        }

        //Store the last suggestion list for validation
        _this5._addressSuggestionList.push(item.value);
        result = $("<li></li>").data("ui-autocomplete-item", item).append(itemDisplayString).appendTo(ul);
      }
      return result;
    }
  }, {
    key: 'checkActualValue',
    value: function checkActualValue() {
      var _this6 = this;
      var actualValue = $("#" + _this6.suburbId).val();
      for (var arr in _this6._addressSuggestionList) {
        if (arr.value === actualValue) return true;
      }
      return false;
    }
  }]);

  return OPSMAutoCompleteSuburb;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaetStepTwo = function () {
    function BaetStepTwo() {
        _classCallCheck(this, BaetStepTwo);
    }

    _createClass(BaetStepTwo, [{
        key: 'tabSlider',

        // constructor() {
        //     this.tabSliderNavCls = '.baet-step-2--slider-nav';
        //     this.tabSliderNavEle = $(this.tabSliderNavCls);
        //     this.appointmentCls = '.baet-step-2--appointments';
        //     this.appointmentEle = $(this.appointmentCls);
        //     this.apmtContentCls = '.baet-step-2--appointment-content';
        //     this.apmtContentEle = $(this.apmtContentCls);
        //
        //     setTimeout(function(){window.eyeTestStep2.tabSlider()}, 5000)
        //     this.collapseTime();
        //
        //     let timeOut;
        //     $(window).resize(()=> {
        //         clearTimeout(timeOut);
        //         timeOut = setTimeout( ()=> {
        //             this.collapseTime()
        //             this.applyClickOnSlider();
        //         }, 300);
        //     });
        // }

        /*
         * Days Slider
         */
        value: function tabSlider() {
            var self = this;
            if (!this.tabSliderNavEle.data('slick')) {
                this.tabSliderNavEle.not('.slick-initialized').slick({
                    arrows: true,
                    speed: 300,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    variableWidth: true,
                    infinite: false,
                    responsive: [{
                        breakpoint: 1140,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4
                        }
                    }, {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    }, {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }]
                });

                this.initAppointment();
            }

            this.applyClickOnSlider();
            this.updateAvailable();
        }

        /*
         * Enable/Disable Collapse for the Appointment block
         */

    }, {
        key: 'collapseTime',
        value: function collapseTime() {
            if (Utils.isTabletAndAbove()) {
                this.appointmentEle.find('.baet-step-2--card-title').attr('data-toggle', '');
                this.appointmentEle.find('.baet-step-2--card-sign').attr('data-toggle', '');
            } else {
                this.appointmentEle.find('.baet-step-2--card-title').attr('data-toggle', 'collapse');
                this.appointmentEle.find('.baet-step-2--card-sign').attr('data-toggle', 'collapse');
            }
        }

        /*
         * Init Appointment
         */

    }, {
        key: 'initAppointment',
        value: function initAppointment() {
            var dataFile = '';

            dataFile = $('div[data-item=baet-step-2--slider-nav-item-0]').data('sync');
            $('div[data-item=baet-step-2--slider-nav-item-0]').addClass('slide-selected');
            if (dataFile) this.loadAppointment(dataFile);
        }

        /*
         * Load Appointment
         */

    }, {
        key: 'loadAppointment',
        value: function loadAppointment(dataFile) {
            var _this = this;

            var self = this;

            self.apmtContentEle.html("");
            $.getJSON(dataFile, function (data) {
                if (data.length > 0) {
                    data.forEach(function (appointment, index) {
                        var apptItem = Utils.showAppointment(appointment, index);
                        apptItem.animateCss('fadeIn');
                        _this.apmtContentEle.append(apptItem);
                    });
                    _this.activeHour();
                    _this.activeNextBtn();
                } else {
                    self.loadMessage();
                }
            });
        }

        /*
         * Update Available label on the slider
         */

    }, {
        key: 'updateAvailable',
        value: function updateAvailable() {
            var navItem = $('.baet-step-2--slider-nav-item');
            var dataFile = '';
            var countItem = void 0;

            navItem.each(function () {
                dataFile = $(this).data('sync');
                var statusEle = $(this).find('.article-eye-test--day-status');

                if (dataFile) $.getJSON(dataFile, function (data) {
                    countItem = 0;
                    if (data.length > 0) {
                        data.forEach(function (appointment) {
                            countItem += appointment.items.length;
                        });
                    }
                    statusEle.html('(' + countItem + ' available)');
                });
            });
        }

        /*
         * Load Message
         */

    }, {
        key: 'loadMessage',
        value: function loadMessage() {
            var message = $('<p class="baet-step-2--message">There are no available appointments on this day</p>');
            $('.baet-step-2--next-btn').attr('disabled', 'disabled');
            this.apmtContentEle.html(message);
            this.apmtContentEle.animateCss('fadeIn');
        }

        /*
         * Enable/Disable Next Button
         */

    }, {
        key: 'activeNextBtn',
        value: function activeNextBtn() {
            var hourItem = this.apmtContentEle.find('.article-card--item');
            var cardItem = void 0;

            hourItem.on('click', function (e) {
                cardItem = $(e.target).parents('.baet-step-2--card-item');

                if (!cardItem.hasClass('baet-step-2--card-booked')) {
                    if (cardItem.hasClass('baet-step-2--card-selected')) {
                        cardItem.removeClass('baet-step-2--card-selected');
                        $('.baet-step-2--next-btn').attr('disabled', 'disabled');
                    } else {
                        $('.baet-step-2--card-item').removeClass('baet-step-2--card-selected');
                        cardItem.addClass('baet-step-2--card-selected');
                        $('.baet-step-2--next-btn').removeAttr('disabled');
                    }
                }
            });
        }

        /*
         * Selected a hour by default
         * Active collapse item to the item that is booked.
         */

    }, {
        key: 'activeHour',
        value: function activeHour() {
            var cardItem = $('.baet-step-2--card-item');
            var booked = false;

            cardItem.each(function (index) {
                if ($(this).hasClass('baet-step-2--card-booked')) {
                    booked = true;

                    $('.baet-step-2--card').find('a[data-toggle="collapse"]').attr('aria-expanded', 'false').addClass('collapsed');
                    $('.baet-step-2--card').find('.collapse').removeClass('show');
                    $(this).parents('.baet-step-2--card').find('a[data-toggle="collapse"]').attr('aria-expanded', 'true').removeClass('collapsed');
                    $(this).parents('.baet-step-2--card').find('.collapse').addClass('show');

                    $('.baet-step-2--card-item').eq(parseInt(index) + 1).addClass('baet-step-2--card-selected');
                    $('.baet-step-2--next-btn').removeAttr('disabled');
                }
            });
            if (!booked && cardItem.length > 0) {
                $('.baet-step-2--card-item').eq(0).addClass('baet-step-2--card-selected');
                $('.baet-step-2--next-btn').removeAttr('disabled');
            }
        }

        /*
         * Load Appointment when clicked on the slide
         */

    }, {
        key: 'applyClickOnSlider',
        value: function applyClickOnSlider() {
            var _this2 = this;

            var slide = this.tabSliderNavEle.find('.slick-slide');

            slide.on('click', function (e) {
                var dataFile = '';
                var currentItem = $(e.currentTarget).find('.baet-step-2--slider-nav-item');

                if (!currentItem.hasClass('slide-selected')) {
                    $('.baet-step-2--slider-nav-item').removeClass('slide-selected');
                    currentItem.addClass('slide-selected');
                    dataFile = currentItem.data('sync');
                    if (dataFile) {
                        _this2.apmtContentEle.html("");
                        _this2.loadAppointment(dataFile);
                    }
                }
            });
        }
    }, {
        key: 'mobileStep2Baet',
        value: function mobileStep2Baet() {
            var currentSlide = Math.floor($(".booking-calendar section.selected").index() / 7) + 1;
            if ($(window).width() < 992) {
                $('.booking-calendar .inner').slick({
                    arrows: true,
                    speed: 300,
                    variableWidth: true,
                    slidesToScroll: 1,
                    infinite: false,
                    mobileFirst: true,
                    initialSlide: currentSlide,
                    responsive: [{
                        breakpoint: 1242,
                        settings: "unslick"
                    }, {
                        breakpoint: 576,
                        settings: {
                            variableWidth: true,
                            slidesToScroll: 2
                        }
                    }, {
                        breakpoint: 750,
                        settings: {
                            variableWidth: true,
                            slidesToScroll: 3
                        }
                    }]
                });
                $('.hourAppointment').addClass("collapse");
                $(".calendar-ok p").addClass("collapsed");
                $(".calendar-ok p:first-of-type").removeClass("collapsed");
                $('.hourAppointment:first-of-type').collapse('toggle');
                $(".calendar-ok p").click(function () {
                    $(this).toggleClass("collapsed");
                    $(this).next('.hourAppointment').collapse('toggle');
                    if (!$(this).next('.hourAppointment')) {
                        $('.hourAppointment').collapse('hide');
                    }
                });
            }
        }
    }]);

    return BaetStepTwo;
}();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CharCounter = function CharCounter(inputSelector, callback, initialSize) {
  _classCallCheck(this, CharCounter);

  var _this = this;

  this.inputSelector = inputSelector;
  this.callback = callback;
  this.initialSize = initialSize;

  this.$input = $(this.inputSelector);

  if (this.$input.length === 0 || !this.callback || typeof this.callback !== 'function') {
    return;
  }

  if (!this.initialSize) this.initialSize = 30;

  this.$input.on('input', function (e) {
    var remaining = checkTextAreaMaxLength(_this.initialSize, this, e);
    _this.callback(remaining);
  });

  function checkTextAreaMaxLength(initialSize, textBox, e) {
    var maxLength = initialSize;
    if (!opsm.utils.checkSpecialKeys(e)) {
      if (textBox.value.length > maxLength - 1) textBox.value = textBox.value.substring(0, maxLength);
    }
    var remaining = maxLength - textBox.value.length;
    return remaining;
  }
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Checkout = function () {
	function Checkout() {
		_classCallCheck(this, Checkout);

		var _this = this;

		this.isRxCheckout = typeof cartHasItemsRX != 'undefined' && (cartHasItemsRX === true || cartHasItemsRX === "true") || $('#isRxOrder').val() === "true";
		this.form = $('#checkout-form');
		if (!this.form.length) {
			return;
		}

		function useAsBillingAddress() {
			return $('#additional-address').is(':checked');
		}

		function userIsGuest() {
			return isGuestUser === 'true';
		}

		function isRecurringOrder() {
			return $("#isRecurringOrderItem").val() == "true";
		}

		var validator = {
			debug: opsm.utils.debugForm(),
			onfocusout: function onfocusout(element) {
				$(element).valid();
			},
			//        ignore:  "#addressSuggest_state,#addressSuggest_postcode,#billingAddress_state,#billingAddress_postcode,:hidden",
			//ignore:  "#addressSuggest_state,#addressSuggest_postcode,:hidden",
			rules: {
				debug: opsm.utils.debugForm(),
				'firstname': { required: true, minlength: 2 },
				'lastname': { required: true, minlength: 2 },
				'e-mail': {
					required: true,
					email: true,
					remoteEmail2: true
				},
				'phone': {
					required: true,
					digits: true,
					pattern: $("#checkout-shipping-phone").attr('pattern')
				},
				'street-address_1': { required: true, minlength: 3 },
				'addressSuggest-bet': { required: true, minlength: 3, suburb_state_postcode: true },
				'label-address': { required: function required(element) {
						return !userIsGuest();
					}, minlength: 3 },
				'logonPassword': {
					required: isRecurringOrder,
					pwdPolicyCompliant: true },
				'logonPasswordVerify': {
					equalTo: "#save-details-password"
				},
				'firstname-billing': {
					required: {
						depends: function depends(element) {
							return !useAsBillingAddress();
						}
					},
					minlength: 3
				},
				'lastname-billing': {
					required: {
						depends: function depends(element) {
							return !useAsBillingAddress();
						}
					},
					minlength: 2
				},
				'street-address_1-billing': {
					required: {
						depends: function depends(element) {
							return !useAsBillingAddress();
						}
					},
					minlength: 3
				},
				'billingAddressSuggestDiv': {
					required: {
						depends: function depends(element) {
							return !useAsBillingAddress();
						}
					},
					minlength: 3,
					suburb_state_postcode: true
				},
				'checkout-billing-country': {
					required: {
						depends: function depends(element) {
							return !useAsBillingAddress();
						}
					}
				},
				'label-address-billing': { required: function required(element) {
						return !userIsGuest() && !useAsBillingAddress();
					}, minlength: 3 }
			},
			messages: {
				'firstname': {
					required: $("#checkout-shipping-first-name").data("errors").required
				},
				'lastname': {
					required: $("#checkout-shipping-last-name").data("errors").required
				},
				'e-mail': {
					required: userIsGuest() && $("#checkout-shipping-e-mail").length >= 1 ? $("#checkout-shipping-e-mail").data("errors").required : '',
					email: userIsGuest() && $("#checkout-shipping-e-mail").length >= 1 ? $("#checkout-shipping-e-mail").data("errors").email : '',
					remoteEmail2: userIsGuest() && $("#checkout-shipping-e-mail").length >= 1 ? $("#checkout-shipping-e-mail").data("errors").remoteEmail2 : ''
				},
				'phone': {
					required: $("#checkout-shipping-phone").length >= 1 ? $("#checkout-shipping-phone").data("errors").required : '',
					digits: "#checkout-shipping-phone".length >= 1 ? $("#checkout-shipping-phone").data("errors").digits : '',
					pattern: "#checkout-shipping-phone".length >= 1 ? $("#checkout-shipping-phone").data("errors").pattern : ''
				},
				'street-address_1': {
					required: $("#checkout-shipping-street-address_1").data("errors").required
				},
				'addressSuggest-bet': {
					required: $("#addressSuggest-bet").data("errors").required
				},
				'label-address': {
					required: !userIsGuest() && $("#checkout-shipping-label-address").length >= 1 ? $("#checkout-shipping-label-address").data("errors").required : ''
				},
				/*
     *  'logonPassword': {
    * 	minlength: $("#save-details-password").data("errors").minlength
     * },
     * 'logonPasswordVerify': {
    * 	equalTo: $("#save-details-confirm-password").data("errors").equalTo
     * },
     */
				'firstname-billing': {
					required: $("#checkout-billing-first-name").data("errors").required
				},
				'lastname-billing': {
					required: $("#checkout-billing-last-name").data("errors").required
				},
				'street-address_1-billing': {
					required: $("#checkout-billing-street-address_1").data("errors").required
				},
				'billingAddressSuggest': {
					required: $("#billingAddressSuggest").data("errors").required
				},
				'label-address-billing': {
					required: !userIsGuest() && $("#checkout-billing-label-address").length >= 1 ? $("#checkout-billing-label-address").data("errors").required : ''
				}
			},
			errorPlacement: function errorPlacement(error, element) {
				error.addClass('invalid-feedback');
				error.appendTo(element.closest('.form-group'));
			},
			highlight: function highlight(element, errorClass, validClass) {
				$(element).closest('.form-group').addClass(errorClass).removeClass(validClass);
				if ($(element).is('#save-details-password')) {
					$('#pwd-policy-error').removeClass('d-none');
				}
				//            $('#checkout-order-billing-shipping-cta').removeClass('button--primary--red').addClass('button--primary--dark');
			},
			unhighlight: function unhighlight(element, errorClass, validClass) {
				$(element).closest('.form-group').removeClass(errorClass).addClass(validClass);
				if ($(element).is('#save-details-password')) {
					$('#pwd-policy-error').addClass('d-none');
				}
			},
			submitHandler: function submitHandler(form) {
				return false;
			},
			focusInvalid: false,
			invalidHandler: function invalidHandler(form, validator) {

				if (!validator.numberOfInvalids()) return;

				$('html, body').animate({
					scrollTop: $(validator.errorList[0].element).offset().top
				}, 1000);
			}
		};

		/* OPSMD-5798 fields restrictions for RX */
		if (this.isRxCheckout) {
			var rxcustomRules = {
				'firstname': { required: true, minlength: 2, maxlength: 34 },
				'lastname': { required: true, minlength: 2, maxlength: 34 },
				'street-address_1': { required: true, minlength: 3, maxlength: 34 },

				'firstname-billing': {
					required: {
						depends: function depends(element) {
							return !useAsBillingAddress();
						}
					},
					minlength: 3, maxlength: 34
				},
				'lastname-billing': {
					required: {
						depends: function depends(element) {
							return !useAsBillingAddress();
						}
					},
					minlength: 2, maxlength: 34
				},
				'street-address_1-billing': {
					required: {
						depends: function depends(element) {
							return !useAsBillingAddress();
						}
					},
					minlength: 3
				}
			};
			$.extend(validator.rules, rxcustomRules);
		}

		validator = this.form.validate(validator);
		this.validator = validator;

		this.checkoutSpecialDeliveryInstructionsCharCounter = new CharCounter('#special-instructions-text', function () {
			//using anonymous function immediately executed, to cache the reference to the charCounter element
			var $charCounter = $('#special-instructions-text').parent().find(".char-counter");
			return function (remaining) {
				$charCounter.html(remaining);
			};
		}(), $('#special-instructions-text').data('length') ? parseInt($('#special-instructions-text').data('length')) : 30);
		this.enableSelectForValidation();
		this.handleLazyValid();
		var date = new Date();
		var minDate = date.getMonth() + "-" + date.getFullYear();
		$('#expiry-date-input').datepicker({
			format: "mm/yyyy",
			startView: 2,
			minViewMode: 1,
			autoclose: true,
			startDate: '+1d',
			container: 'div#expire-date-only-new'
		});
		$("#expire-date-only-new .material-input").on("change", materialInputEmptyCheck);
	}

	//OPSMD-2636


	_createClass(Checkout, [{
		key: 'checkElementValid',
		value: function checkElementValid($elementId) {
			var isValid = true;
			if ($('#' + $elementId + ':visible').length) {
				isValid = this.validator.check('#' + $elementId);
				//fixes validation when div is not 'contenteditable'
				if ($('div#' + $elementId).length && typeof $('div#' + $elementId).attr('contenteditable') === 'undefined') {
					$('div#' + $elementId).attr('contenteditable', '');
					this.validator.checkForm();
					isValid = this.validator.check('#' + $elementId);
					$('div#' + $elementId).removeAttr('contenteditable');
				}
			}
			return isValid;
		}

		//this don't work if div is not focusable (as for gmap autocomplete impl)

	}, {
		key: 'handleLazyValid',
		value: function handleLazyValid() {
			var _this = this;
			$(document).ready(function () {
				/*
     * $.validator is lazy, use this to activate validation if needed
    */
				if (_this.form.length) {
					//handle issue on validating div: onfocusout not working lazily
					$(_this.form).one('focus', 'div#addressSuggest-bet:visible', function (e) {
						_this.validator.checkForm();
					});
					$(_this.form).one('focus', 'div#billingAddressSuggest:visible', function (e) {
						_this.validator.checkForm();
					});
				}
			});
		}
	}, {
		key: 'enableSelectForValidation',
		value: function enableSelectForValidation() {
			this.form.find('.delivery-address-wrapper .hybrid-select select').css({
				"display": "block",
				"visibility": "hidden"
			});
		}

		/**
   * the following handles clicks on labels for custom radio input
   * some radio are for different payment methods (CC|PPAL|AFTPay)
   * some radio are for user saved cards
   */

	}], [{
		key: 'paymentToggleBody',
		value: function paymentToggleBody(el) {
			if ($(el).siblings('input.custom-control-input').is(':checked') && !$(el).parent().next('.card-body').is(':hidden')) {
				$(el).parent().next('.card-body').hide();
			} else {
				$("#payment-selection .card-wrapper .custom-radio .custom-control-input").prop('checked', false);
				$("#payment-selection .card-wrapper .card-body").hide();

				$(el).siblings('.custom-control-input').prop('checked', true);
				//custom class to mark the custom-radio as selected
				$(el).closest('.custom-radio').addClass('js-selected');
				$(el).parent().next('.card-body').show();
				$(el).siblings('input.custom-control-input').trigger('change');
				//trigger a custom event for 
				$(el).closest('.custom-radio').trigger('opsm:change');
			}
		}
	}]);

	return Checkout;
}();
'use strict';

/**
 * For content/styleguide page only
 */
;(function ($) {
    $(function () {
        var slideshowSingle = $('.opsm-slideshow--slide[data-slide-type="single"]');
        slideshowSingle.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
        });

        var slideshowMyArea = $('.opsm-slideshow--slide[data-slide-type="myArea"]');
        slideshowMyArea.slick({
            dots: false,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1
                }
            }]
        });

        var slideshowGrid = $('.opsm-slideshow--slide[data-slide-type="grid"]');
        slideshowGrid.slick({
            dots: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }]
        });

        $('#sample-form').validate({
            ignore: [], // becausel <SELECT> is customized to be hidden, show we must set ignore to be empty array
            rules: {
                'field-1a': 'required',
                'field-1b': 'required',
                'field-1c': 'required',
                'field-1d': 'required',
                'field-2a': 'required',
                'field-2b': 'required',
                'drop-1a': 'required',
                'drop-1b': 'required',
                'drop-1c': 'required',
                'drop-1d': 'required',
                'drop-1e': 'required',
                'drop-1f': 'required',
                'drop-2a': 'required',
                'drop-2b': 'required',
                'textarea': 'required'
            },
            messages: {
                'field-1a': 'Required field',
                'field-1b': 'Required field',
                'field-1c': 'Required field',
                'field-1d': 'Required field',
                'field-2a': 'Required field',
                'field-2b': 'Required field',
                'drop-1a': 'Required field',
                'drop-1b': 'Required field',
                'drop-1c': 'Required field',
                'drop-1d': 'Required field',
                'drop-1e': 'Required field',
                'drop-1f': 'Required field',
                'drop-2a': 'Required field',
                'drop-2b': 'Required field',
                'textarea': 'Required field'
            },
            errorPlacement: function errorPlacement(error, element) {
                error.addClass('invalid-feedback');
                error.appendTo(element.closest('.form-group'));
            },
            highlight: function highlight(element, errorClass, validClass) {
                $(element).closest('.form-group').addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function unhighlight(element, errorClass, validClass) {
                $(element).closest('.form-group').removeClass(errorClass).addClass(validClass);
            },
            submitHandler: function submitHandler(form) {
                alert('submitted!');
                return false;
            }
        });
    });
})(jQuery);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.opsmData = window.opsmData || {};
window.opsmData.userData = window.opsmData.userData || {};

var CreditCard = function () {
  function CreditCard(id) {
    _classCallCheck(this, CreditCard);

    var _this = this;
    this.savedCCsezlection = $('#credit-card-options');
    this.paymType = $('#payment-selection');
    this.user = id;
    this.DELETE_BTN_CLASS = 'open-deletecard';
    this.SET_DEFHOME_BTN_CLASS = 'opsm-def-card';
    this.CONTAINER_CLASS = 'opsm-bordered-fluid-div';
    this.FRONTSIDE_CLASS = 'opsm-front-side';
    this.BACKSIDE_CLASS = 'opsm-back-side';
    this.NEW_CARD_VALUE = '0';
    this.NEW_CARD_TITLE = 'Add new card';

    this.initSavedCards();

    this.paymType.on('change', 'input.js-payment-type', function (ev) {
      var value = $(this).data('cc-nr');
      _this.savedCCsezlection.val(value).change();
      _this.setSavedCreditCard();
    });

    //this.getAllCC();

    $('.' + _this.CONTAINER_CLASS + '.opsm-bordered-active').find('.' + _this.DELETE_BTN_CLASS).hide();
    $('.' + _this.CONTAINER_CLASS).find('.' + _this.BACKSIDE_CLASS).hide();

    $('.' + _this.CONTAINER_CLASS).on("click", "." + _this.DELETE_BTN_CLASS, function () {
      _this.deleteAdressBook(this);
    });

    $('.' + _this.CONTAINER_CLASS).on("click", "." + _this.SET_DEFHOME_BTN_CLASS, function (e) {
      var _thisa = $(this);
      var data = window.opsmData.userData;
      //$.getJSON("credit-card.json", function (data) {
      if (data.creditCard && data.creditCard.length > 0) {
        var _thisaid = _thisa.parents('.' + _this.CONTAINER_CLASS).attr("id");
        data.creditCard.forEach(function (card) {
          if (card.id === _thisaid) {
            if (card.valid) {
              _this.setCardDefault(card.id);
            }
          }
        });
      }
    });
    //});
    if (!$('#payment-selection input.js-payment-type:checked').length) {
      $('#payment-selection .card-wrapper').first().find('.custom-radio label.custom-control-label').trigger('click');
    }
  }

  _createClass(CreditCard, [{
    key: 'getAllCC',
    value: function getAllCC(func) {
      if (func) {
        var _this2 = this;
        var data = window.opsmData.userData;
        //$.getJSON("credit-card.json", { user: _this2.user }, function (data) {
        if (data.creditCard && data.creditCard.length > 0) {
          data.creditCard.forEach(function (credicard) {
            //console.log(credicard);
            func(creditcard);
          });
        }
        //});
      }
    }
  }, {
    key: 'deleteAdressBook',
    value: function deleteAdressBook(t) {
      var _this2 = this;
      var _this2id = $(t).parents('.' + _this2.CONTAINER_CLASS).attr("id");
      $('#' + _this2id).find('.' + _this2.FRONTSIDE_CLASS).hide();
      $('#' + _this2id).find('.' + _this2.BACKSIDE_CLASS).fadeIn();

      $('#' + _this2id).on('click', '.cancel-remove-address', function () {
        $('#' + _this2id).find('.' + _this2.BACKSIDE_CLASS).hide();
        $('#' + _this2id).find('.' + _this2.FRONTSIDE_CLASS).fadeIn();
      });

      $('#' + _this2id).on('click', '.confirm-remove-address', function () {
        $('#' + _this2id).parent('.col-lg-4').remove();
        /* TODO ajax call for confirm*/
      });
    }
  }, {
    key: 'setCardDefault',
    value: function setCardDefault(id) {
      var _this2 = this;
      var _this2id = id;
      $('.' + _this2.SET_DEFHOME_BTN_CLASS).addClass('disabled');
      $("#" + _this2id).find('.' + _this2.SET_DEFHOME_BTN_CLASS).removeClass('disabled');
      $('.' + _this2.CONTAINER_CLASS).removeClass("opsm-bordered-active");
      $('#' + _this2id).addClass("opsm-bordered-active");
      $('.' + _this2.CONTAINER_CLASS).find('.' + _this2.DELETE_BTN_CLASS).show();
      $('#' + _this2id).find('.' + _this2.DELETE_BTN_CLASS).hide();
      /* TODO ajax call for confirm*/
    }

    /*
     * inject each 
     */

  }, {
    key: 'initSavedCards',
    value: function initSavedCards() {
      var _this2 = this;
      var data = window.opsmData.userData;
      var template = $('.js-saved-card-wrapper.js-template');
      if (data.creditCard && data.creditCard.length > 0) {
        data.creditCard.forEach(function (card, idx) {
          if (card.valid) {
            var row = template.clone();
            $(row).removeClass('d-none').removeClass('js-template');
            $(row).find('.js-card-type').text(card.type);
            $(row).find('.js-card-nr').text(card.ending);
            $(row).find('input.js-payment-type').attr('data-cc-nr', card.id).attr('id', card.id);
            $(row).find('.custom-control-label').attr('for', card.id);

            var img = $(row).find('img.payment-logo');
            img.attr('src', img.attr('js-src').replace('[CARDNAME]', card.cardLogo));
            img.attr('alt', card.altImg);

            $(row).insertBefore('.js-new-card-wrapper');
            $('.js-new-card-wrapper').addClass('d-none');
            $('#logged-new-address-collapse').insertBefore('.js-new-card-wrapper');
          }
        });
      } else {
        // OPSMD-9305
        $("#logged-new-address-collapse").remove();
      }
      template.remove();
    }
  }, {
    key: 'setSavedCreditCard',
    value: function setSavedCreditCard() {
      var _this2 = this;
      var selActually = _this2.savedCCsezlection.val();
      var data = window.opsmData.userData;
      $('#card-name').val('').prop('readonly', false);;
      //$.getJSON("credit-card.json", function (data) {
      if (data.creditCard && data.creditCard.length > 0) {
        data.creditCard.forEach(function (card) {
          if (card.id === selActually) {
            //_this2.dateOnlynew.hide();
            $('#card-name').val(card.name).prop('readonly', true);
          }
        });
      }
      //});
    }
  }, {
    key: 'getExpiryDate',
    value: function getExpiryDate(card) {
      return card.expiryMonth + '/' + card.expiryYear;
    }
  }]);

  return CreditCard;
}();
'use strict';

/**
 * add date separator while fillingin the input
 */

(function ($) {
	var separatorCh = "/";
	var plhld = String('[placeholder="MM/YYYY"]');
	var elSelector = 'input.datetimepicker-input' + plhld;

	//use for custom ids
	/*
 	let dateInputsIds = ["#start-date", "#expiry-date", "#prescription-doe"];
 	
 	for(var i=0; i<dateInputsIds.length; i++) {
 		dateInputsIds[i] += plhld;
 	}
 	elSelector += ',' + dateInputsIds.join(',');
 */

	$(document).ready(function () {
		if ($(elSelector).length) {
			$(document).on('keyup', elSelector, formatDateInput);
		}
	});

	var formatDateInput = function formatDateInput(e) {
		var onlyNum = $(this).val().replace(/[^0-9.]/g, '');
		if (onlyNum.length > 6) {
			onlyNum = onlyNum.substring(0, 6);
		}
		if (onlyNum.length > 2) {
			$(this).val(onlyNum.substring(0, 2) + separatorCh + onlyNum.substring(2));
		} else if (onlyNum.length === 2) {
			if (e.keyCode !== 8) {
				$(this).val(onlyNum + separatorCh);
			} else {
				$(this).val(onlyNum);
			}
		} else {
			$(this).val(onlyNum);
		}
		$(this).change();
	};
})(jQuery);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.opsmData = window.opsmData || {};
window.opsmData.userData = window.opsmData.userData || {};

var DeliveryAddress = function () {
	function DeliveryAddress(selectId, savedAddressId, myaccountAreaId, newAddressFieldSelector, newAddressLabel, userDataProperty) {
		_classCallCheck(this, DeliveryAddress);

		var _this = this;
		this.selectAddress = $('#' + selectId); //$('#logged-address');
		this.savedAddress = $('#' + savedAddressId); //$('#saved-address');
		this.newAddressFields = $(newAddressFieldSelector); //.only-new-address-shipping

		this.myaccount = $('#' + myaccountAreaId).length; //$('#myaccount-area').length;
		this.newAddressLabel = newAddressLabel; //New address
		this.userDataProperty = userDataProperty; //deliveryAddress

		this.newAddressValue = '0';

		if (this.selectAddress.length === 0) {
			return;
		}

		this.getAllAddress();

		this.setSavedAddress();

		this.selectAddress.on('change', function () {
			_this.evaluateAddress();
		});
	}

	_createClass(DeliveryAddress, [{
		key: 'getAllAddress',
		value: function getAllAddress() {
			var _this = this;
			var data = window.opsmData.userData;
			_this.selectAddress.empty();
			if (data[_this.userDataProperty].length > 0) {
				data[_this.userDataProperty].forEach(function (address) {
					//console.log("address "+JSON.stringify(address));
					_this.selectAddress.append($('<option></option>').val(address.id).html(address.labelshort));
				});
			}

			if (_this.myaccount === 0) {
				/* OPSMD-9229 hide new address option for R user with no saved addr */
				if (data[_this.userDataProperty].length < 1) {
					var addrGroup = _this.selectAddress.closest('.opsm-form-group');
					addrGroup.siblings('.js-not-emoty-addr').addClass('d-none');
					addrGroup.addClass('d-none');
				}
				/* END OPSMD-9229 */
				_this.selectAddress.append($('<option></option>').val(_this.newAddressValue).html(_this.newAddressLabel));
			}
			_this.selectAddress.hybridSelect();
			_this.setSavedAddress();
		}
	}, {
		key: 'setSavedAddress',
		value: function setSavedAddress() {
			var _this = this;
			var selActually = _this.selectAddress.val();
			var data = window.opsmData.userData;
			if (data[_this.userDataProperty].length > 0) {
				data[_this.userDataProperty].forEach(function (address) {
					if (selActually == address.id) {
						var inner_html = "<p><span id='ship-to-name' class='d-block'>" + address.name + "</span>" + "<span id='ship-to-address' class='d-none font-weight-bold'>" + address.streetAddress + "</span>" + "<span class='d-block font-weight-bold'>" + address.labelshort + "</span>" + "<span id='ship-to-city-state-zip' class='d-block'>" + address.labellong + "</span>"; // +
						//"<span class='d-block'>"+ address.email + "</span>" +
						//"<span class='d-block'>"+ address.phone + "</span></p>" ;
						$(_this.savedAddress).html(inner_html);
					}
				});
			} else {
				_this.evaluateAddress(); //to allow showing inputs for new address addition
			}
		}
	}, {
		key: 'evaluateAddress',
		value: function evaluateAddress() {

			function showElement($el) {
				$el /*.show()*/.removeClass('d-none');
			}

			function hideElement($el) {
				$el /*.hide()*/.addClass('d-none');
			}

			var _this = this;
			var sel = _this.selectAddress.val();
			if (sel == _this.newAddressValue) {
				hideElement(_this.savedAddress);
				showElement(_this.newAddressFields);
			} else {
				hideElement(_this.newAddressFields);
				showElement(_this.savedAddress);
				_this.setSavedAddress();
			}
		}
	}]);

	return DeliveryAddress;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EyeTestBooking = function () {
    function EyeTestBooking() {
        var _this = this;

        _classCallCheck(this, EyeTestBooking);

        this.form = $('#book-eye-test-booking-form');
        if (!this.form.length) {
            return;
        }

        // this.form.find('#dob').datetimepicker({
        //     format: 'DD/MM/YYYY'
        // });

        this.form.find('#dob').inputmask('99/99/9999', { "placeholder": "DD/MM/YYYY" });

        var chbCreateAcc = this.form.find('#create-account');

        chbCreateAcc.on('change', function () {
            _this.form.find('#password, #password-2').val('');
        });

        this.form.validate({
            ignore: [],
            rules: {
                title: {
                    required: true
                },
                'first-name': {
                    required: true
                },
                'last-name': {
                    required: true
                },
                'dob': {
                    required: true,
                    DateFormat: true
                },
                'email': {
                    required: true,
                    email: true
                },
                'mobile': {
                    required: true,
                    // digits: true,
                    MobilePhoneAU: true
                },
                'password': {
                    required: '#create-account:checked'
                },
                'password-2': {
                    required: '#create-account:checked',
                    equalTo: '#password'
                }
            },
            messages: {
                title: {
                    required: 'Required field'
                },
                'first-name': {
                    required: 'Required field'
                },
                'last-name': {
                    required: 'Required field'
                },
                'dob': {
                    required: 'Required field'
                },
                'email': {
                    required: 'Required field',
                    email: 'Email is not valid'
                },
                'mobile': {
                    required: 'Required field',
                    digits: 'Invalid phone number'
                },
                'password': {
                    required: 'Required field'
                },
                'password-2': {
                    required: 'Required field',
                    equalTo: 'Confirm password does not match'
                }
            },
            errorPlacement: function errorPlacement(error, element) {
                error.addClass('invalid-feedback');
                error.appendTo(element.closest('.form-group'));
            },
            highlight: function highlight(element, errorClass, validClass) {
                $(element).closest('.form-group').addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function unhighlight(element, errorClass, validClass) {
                $(element).closest('.form-group').removeClass(errorClass).addClass(validClass);
            }
        });
    }

    _createClass(EyeTestBooking, null, [{
        key: 'getAptBook',
        value: function getAptBook(url, params, _success, _error) {
            var url = url || '/AjaxGetBookAnEyeTestDataQuery',
                params = params || {};
            return $.ajax({
                dataType: 'json',
                url: url,
                data: params,
                success: function success(result, textStatus, jqXHR) {
                    if (typeof _success === 'function') {
                        _success(result);
                    }
                },
                error: function error(xhr, textStatus, thrownError) {
                    if (typeof _error === 'function') {
                        _error(xhr, textStatus, thrownError);
                    }
                }
            });
        }
    }]);

    return EyeTestBooking;
}();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REMOVE = 'REMOVE';
var REMOVE_HIDE = 'REMOVE_HIDE';
var WIDTH_CHIPS_TOTAL = 50;
var CLASS_LINE_HORIZONTAL = 'line-horizontal';
var selectedFilter = [];
var lastAccordion = null;
//const MOBILE_CHIP_BREAKPOINT = '(max-width: 992px)';
/**
 * facet values labels
 */
var facetValues = {

  //products
  OPTICAL: 'Frames',
  SUN: 'Sunglasses',
  FS: 'Sphere',
  F: 'Multi Focal',
  FT: 'Toric',

  //gender
  UNISEX: 'Unisex',
  MALE: 'Men',
  FEMALE: 'Women',
  CHILD: 'Kids',

  //lens technology
  DEMO_LENS: 'Demo'

  // SC: commented for OPSMD-7598
  //fit
  //STD: 'Standard',
  //L: 'Large',
  //S: 'Small'
};

var Filter = function () {
  function Filter() {
    var _this = this;

    _classCallCheck(this, Filter);

    this._loadingTimeout = null;
    /* ----------------------------------------------------
     * VUE CAROUSEL MANAGEMENT - START
     * Handles store/restore states during PLP updates
     * ---------------------------------------------------- */
    this.$carousel = null;
    this._pendingFilterRequests = 0;
    this._handleTilesSettled = function (e) {
      _this._pendingFilterRequests = Math.max(0, _this._pendingFilterRequests - 1);
      if (_this._pendingFilterRequests === 0) {
        console.debug("_handleTilesSettled removing 2 event listener");
        document.removeEventListener('plp:tilesReplaced', _this._handleTilesSettled);
        document.removeEventListener('plp:tilesUpdateErr', _this._handleTilesSettled);
        _this.restoreVueCarousel();
        _this.endLoading();
      }
    };
    /* ----------------------------------------------------
     * VUE CAROUSEL MANAGEMENT - END
     * ---------------------------------------------------- */

    /**
     * on scrolling, adjust top of filter sidebar,
     * because the header is displayed on scrolling up
     * and hidden on scrolling down.
     */
    var filterStickyTop = $(".filter--sticky-section").offset().top;
    $(window).scroll(function () {
      // if (!Utils.isSmallDesktopAndAbove()) {
      //   return;
      // }

      // if (!$('html').is('.csspositionsticky')) {
      //   return;
      // }

      var scrollTop = $(window).scrollTop();
      // const productListingTop = $('.products-listing').position().top;

      /*
       * As per the new CR, main menu should be sticky.
       * So changing the top position of sidebar filters to the height of sticky header.
       */
      // const headerStickyHeight = $('.header').is('.sticky-ing') ? $('#opsm-header-sticky').height() : 0;
      // const headerStickyHeight = $('.header').height();
      var isStickyHeaderHidden = $('#opsm-header-sticky').is('.temp-hidden');

      if (scrollTop >= filterStickyTop) {
        $(".filter--sticky-section").addClass('sticky');
      } else {
        $(".filter--sticky-section").removeClass('sticky');
      }
      if (!isStickyHeaderHidden) {
        $(".filter--sticky-section").addClass('header-visible');
      } else {
        $(".filter--sticky-section").removeClass('header-visible');
      }
    });
    this.init();

    var that = this;
    // var observer = new MutationObserver(function(e) {
    // 	that.endLoading();
    // });
    // observer.observe(this.productsListing[0], {characterData: true, childList: true, subtree: true});

    /**
     * remove selected filter handler
     */
    this.filters.on('click', '.filters--result-item .filters--result-item-remove', function (event) {
      _this.resetPriceFacet();
      _this.removeFiltersPills(event, _this);
      _this.executeFilter();
    });

    this.selectedFiltersContainerGrid.on('click', '.filters--result-item .filters--result-item-remove', function (event) {
      _this.resetPriceFacet();
      _this.removeFiltersPills(event, _this);
      _this.executeFilter();
    });

    /**
     * Step1 checkbox filter handler: check / uncheck
     */
    this.filters.on('change', 'input[data-filter]', function (event, params) {
      var input = $(event.target);
      var filter = input.data('filter');
      if (filter === 'brand' || filter === 'gender' || filter === 'discountpercentage' || filter === 'type' || filter === 'frequency') {
        $('#' + input.attr('id') + '-dropdown').prop('checked', input.is(':checked'));
      } else if (filter === 'metagen') {
        $('#' + input.attr('id') + '-dropdown').prop('checked', input.is(':checked'));
        // optionally render selected the view All option
        var baseInputs = $('input[data-filter="metagen"]').not('[id$="-dropdown"]');
        var allChecked = baseInputs.length > 0 && baseInputs.filter(':checked').length === baseInputs.length;
        $('input#filter-metagen-all, input#filter-metagen-all-dropdown').prop('checked', allChecked);
      }
    });

    this.filters.on('click', 'input[data-filter]', function (event, params) {
      // on check / uncheck checkbox filter
      var input = $(event.target);
      var value = input.val();
      var filter = input.data('filter');
      var text = input.siblings('label.custom-control-label').find(".filters--checkbox-text").text();

      if (input.is(':checked')) {
        lastAccordion = $(input).parent().parent().parent();
        _this.addFilter(filter, value, text);
      } else {
        _this.removeFilter(filter, value);
      }

      if (filter === 'brand' || filter === 'gender' || filter === 'discountpercentage' || filter === 'type' || filter === 'frequency') {
        $('#' + input.attr('id') + '-dropdown').prop('checked', input.is(':checked'));
      }
      _this.applyFiltersCta();
    });

    this.filters.on('click', 'input#filter-metagen-all', function (event) {
      var isChecked = $(event.target).is(':checked');
      $('input#filter-metagen-all, input#filter-metagen-all-dropdown').prop('checked', isChecked);

      $('input[data-filter="metagen"]').not('[id$="-dropdown"]').each(function (i, el) {
        _this.setMetagenCheckbox($(el), isChecked);
      });

      _this.applyFiltersCta();
    });

    this.metaGenDropdown.on('click', '.filters--chip .custom-control-label', function (event) {
      // const isMobileChipUI = window.matchMedia(MOBILE_CHIP_BREAKPOINT).matches;
      // if (!isMobileChipUI) {
      //   // Desktop: default behaviour see  'input[data-filter]' click handler
      //   return;
      // }

      var $label = $(event.currentTarget);
      var $chip = $label.closest('.filters--chip');
      var $input = $chip.find('input[data-filter="metagen"]');
      var $remove = $chip.find('.filters--chip-remove');

      // X remove is visible if: mobile chip UI ACTIVE and filter selected
      if (!$remove.is(':visible')) {
        // Desktop: default behaviour see  'input[data-filter]' click handler
        return;
      }

      var isRemoveX = $(event.target).closest('.filters--chip-remove').length > 0;
      event.preventDefault();

      if (isRemoveX) {
        if ($input.is(':checked')) {
          _this.setMetagenCheckbox($input, false);
          _this.applyFiltersCta();
        }
      } else {
        // click sul resto del chip: seleziona solo se non già checked
        if (!$input.is(':checked')) {
          _this.setMetagenCheckbox($input, true);
          _this.applyFiltersCta();
        }
        // no action if already selected
      }
    });

    this.brandDropdown.on('click', 'input[data-filter]', function (event, params) {
      var input = $(event.target);
      _this.dropdownMenuClick(input);
    });

    this.genderDropdown.on('click', 'input[data-filter]', function (event, params) {
      var input = $(event.target);
      _this.dropdownMenuClick(input);
    });

    this.metaGenDropdown.on('click', 'input[data-filter]', function (event, params) {
      var input = $(event.target);
      _this.dropdownMenuClick(input);
    });

    this.metaGenDropdown.on('click', 'input#filter-metagen-all-dropdown', function (event) {
      var isChecked = $(event.target).is(':checked');
      $('input#filter-metagen-all, input#filter-metagen-all-dropdown').prop('checked', isChecked);

      _this.metaGenDropdown.find('input[data-filter="metagen"]').each(function (i, el) {
        _this.setMetagenCheckbox($(el), isChecked);
      });

      _this.applyFiltersCta(); // UNA sola chiamata, dopo l'intero batch
    });

    this.metaNeedDropdown.on('click', 'input[data-filter]', function (event, params) {
      var input = $(event.target);
      _this.dropdownMenuClick(input);
    });

    this.priceDropdown.on('click', 'input[data-filter]', function (event, params) {
      var input = $(event.target);
      _this.dropdownMenuClick(input);
    });

    this.typeDropdown.on('click', 'input[data-filter]', function (event, params) {
      var input = $(event.target);
      _this.dropdownMenuClick(input);
    });

    this.frequencyDropdown.on('click', 'input[data-filter]', function (event, params) {
      var input = $(event.target);
      _this.dropdownMenuClick(input);
    });
    /**
     * Reset buttons handlers:
     * for mobile do not trigger execute if filter
     * are being deselected but had never been applied,
     * those flagged with 'pending-sel' class
     */
    this.filters.on('click', '.filters--btn-reset', function (event) {
      _this.clearAllFilters();
    });

    this.selectedFiltersContainerGrid.on('click', '.filters--btn-reset', function (event) {
      _this.clearAllFilters();
    });

    this.filters.on('click mouseenter touchstart', '.filters--result-item-total', function () {
      _this.styleInlineFilter(_this.selectedFiltersContainer);
      _this.scopeHoverFilter = true;
      _this.renderTemplateSeleted();
    });

    this.filters.on('mouseleave', '.filters--selected-filters', function () {
      _this.closeResultMoreItem();
    });

    this.filters.on('touchend', '.card.filters--box:not(:first), .filters--header', function () {
      _this.closeResultMoreItem();
    });

    this.filters.on('touchend', '.filters--content.accordion', function (e) {
      if (e.target !== _this.filtersContent[0]) return;
      _this.closeResultMoreItem();
    });

    /*Step2*/
    this.filters.on("change", ".filters--custom-checkbox input", function (ev, extraParam) {
      _this.executeChange(ev, extraParam);
      _this.lastFacetId = $(ev.target).attr("id");
    });

    $(document).on('input', '#filters--slider-handle--01', function () {
      var newMin = document.getElementById('filters--slider-handle--01').value;
      _this.priceRangeSlider.slider("values", 0, newMin);
      $('#filters--slider-handle--01-dropdown').val(newMin);
    });

    $(document).on('input', '#filters--slider-handle--02', function () {
      var newMax = document.getElementById('filters--slider-handle--02').value;
      _this.priceRangeSlider.slider("values", 1, newMax);
      $('#filters--slider-handle--02-dropdown').val(newMax);
    });
    $("#filters").on("hide.bs.modal", function () {
      $(".filters--content .collapse").collapse("hide");
    });
  }

  _createClass(Filter, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      this.btnOpenFilters = $('#product-filter-toggle');
      this.filters = $('#filters');
      this.filtersOverlay = this.filters.find('.filters--overlay');
      this.filtersInner = this.filters.find('.filters--inner');
      this.btnCloseFilters = this.filters.find('.filters--back-btn, .filters--close-btn');
      this.btnApplyFilters = this.filters.find('#btn-apply-filters');
      this.spanNoFilter = this.filters.find('.filters--no-result-item');
      this.selectedFiltersContainer = $('.filters--selected-filters');
      this.selectedFiltersContainerGrid = $('.filters--selected-filters-grid');
      this.filtersContent = this.filters.find('.filters--content');
      this.selectedFiltersNumberText = $('#filter-filtering-items');
      this.productsListing = $("#products-listing-list");
      this.filterSliderMin = $('.filters--slider-handle--01 .filters--slider-handle-text');
      this.filterSliderMax = $('.filters--slider-handle--02 .filters--slider-handle-text');
      this.brandDropdown = $('#filter-box-brand-dropdown');
      this.genderDropdown = $('#filter-box-gender-dropdown');
      this.metaGenDropdown = $('#filter-box-metagen-dropdown');
      this.metaNeedDropdown = $('#filter-box-metaneed-dropdown');
      this.priceDropdown = $('#filter-box-price-dropdown');
      this.typeDropdown = $('#filter-box-type-dropdown');
      this.frequencyDropdown = $('#filter-box-frequency-dropdown');
      this.isOpenDashbutton = $(".filters--box .card-body-wrapper").hasClass("show");
      this.scopeHoverFilter = false;
      this.hideElementFilter = {};
      this.showElementFilter = {};
      var priceRange_min = $('#filter-box-price .filter-price-min').val();
      if (!priceRange_min) priceRange_min = 20;else priceRange_min = parseInt(priceRange_min);
      var priceRange_max = $('#filter-box-price .filter-price-max').val();
      if (!priceRange_max) priceRange_max = 990;else priceRange_max = parseInt(priceRange_max);
      this.priceRange = {
        min: priceRange_min,
        max: priceRange_max
      };
      if (this.lastFacetId !== "") {
        // open last filter clicked
        $("#" + this.lastFacetId).closest(".card.filters--box").find(".filters--btn-toggle").click();
      }
      this.lastFacetId = "";

      if (!Modernizr.csspositionsticky) {
        /**
         * IE and some other old browser don't support css position: sticky
         * so we use affix plugin from old bootstrap (v3). This is a good plugin,
         * better than other polyfillc
         */
        this.filters.affix({
          offset: {
            top: function top() {
              if ($('.prod-pg-header').length > 0) {
                return this.top = $('.header').outerHeight() + $('.prod-pg-header').outerHeight();
              } else if ($('.search--result-head').length > 0 && $('.search--result-subhead').length > 0) {
                return this.top = $('.header').outerHeight() + $('.search--result-head').outerHeight() + $('.search--result-subhead').outerHeight();
              }
            },
            bottom: function bottom() {
              return this.bottom = $('.footer').outerHeight();
            }
          }
        }).on('affixed.bs.affix', function () {
          var wrapper = $('.filters--ie-wrapper');
          _this2.filters.css({
            'width': wrapper.width(),
            'left': wrapper.offset().left + 15 // 15 is padding
          });
        }).on('affixed-top.bs.affix, affixed-bottom.bs.affix', function () {
          var wrapper = $('.filters--ie-wrapper');
          _this2.filters.css({
            'width': '',
            'left': ''
          });
        }).parent().addClass('filters--ie-wrapper');
      }
      /**
       * init price range slider,
       * only when slider exists in filter
       */
      this.priceRangeSlider = $('.filters--slider-range');
      this.priceRangeSliderHandler = [this.priceRangeSlider.parent().find('.filters--slider-handle--01 .filters--slider-handle-text'), this.priceRangeSlider.parent().find('.filters--slider-handle--02 .filters--slider-handle-text')];

      if (this.priceRangeSlider.length) {
        this.priceRangeSlider.slider({
          range: true,
          min: this.priceRange.min,
          max: this.priceRange.max,
          step: 1,
          values: [this.priceRange.min, this.priceRange.max],
          create: function create() {
            _this2.priceRangeSliderHandler[0].val(_this2.priceRangeSlider.slider('values')[0]);
            _this2.priceRangeSliderHandler[1].val(_this2.priceRangeSlider.slider('values')[1]);
          },
          slide: function slide(event, ui) {
            _this2.sliderSlideEvent(event, ui);
          },
          stop: function stop(event, ui) {
            _this2.executeChange();
          }
        });
        resizeInput(".filters--slider-handle-text");
      }
      /**
       * handle filter sidebar on mobile: open, close...
       */
      this.btnOpenFilters.on('click', function () {
        _this2.openFiltersSidebar();
      });

      this.btnCloseFilters.on('click', function () {
        _this2.closeFiltersSidebar();
      });

      this.btnApplyFilters.on('click', function () {
        _this2.applyFiltersCta(true);
      });

      this.filtersOverlay.on('click', function () {
        _this2.closeFiltersSidebar();
      });

      this.filterSliderMin.on('change', function () {
        var min = _this2.filterSliderMin.val().replace("$", "");
        _this2.priceRangeSlider.slider("values", 0, min);
        var filt = new Filter();
        filt.sliderSlideEvent(event, null, true);
        filt.executeChange();
      });

      this.filterSliderMax.on('change', function () {
        var max = _this2.filterSliderMax.val().replace("$", "");
        _this2.priceRangeSlider.slider("values", 1, max);
        var filt = new Filter();
        filt.sliderSlideEvent(event, null, true);
        filt.executeChange();
      });

      // run some methods on initialize
      this.loadFilters();
      this.renderSeletedFilters({});
      this.toggleButtonReset();
      var that = this;
      setTimeout(function () {
        that.clearUnselectedCheckbox();
        that.countCategoryChecked();
        $("#" + lastAccordion.attr('id')).collapse('show');
      }, 100);
    }
  }, {
    key: 'changeSiblingOptionsVisib',
    value: function changeSiblingOptionsVisib($input, action) {
      if (typeof $input !== 'undefined' && typeof action !== 'undefined' && $input.length) {
        if (action == 'hide') {
          $input.closest('.filters--custom-checkbox').not('.multivalue').siblings().hide();
        } else if (action == 'show') {
          $input.closest('.filters--custom-checkbox').siblings().show();
        }
      }
    }
  }, {
    key: 'dropdownMenuClick',
    value: function dropdownMenuClick(input) {
      var ctaId = input.attr('id');
      ctaId = ctaId.replace('-dropdown', '');
      $("#" + ctaId).trigger('click');
    }
  }, {
    key: 'applyFiltersCta',
    value: function applyFiltersCta() {
      var isCta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (isCta) {
        this.closeFiltersSidebar();
      } else {
        this.executeFilter();
      }
      $(".filters--selected-filters-grid").removeClass("hide");
      $(".filters--selected-filters-grid").addClass("show");
    }
  }, {
    key: 'resetPriceFacet',
    value: function resetPriceFacet() {
      var urlParams = new URLSearchParams(window.location.search);
      var param = Array.from(urlParams.keys());
      var that = this;
      var check = false;
      var i = 0;
      while (i < param.length && check === false) {
        if (urlParams.get(param[i]).substring(0, 5) === 'price') {
          that.removeFilter('price');
          check = true;
        }
        i++;
      }
    }
  }, {
    key: 'clearAllFilters',
    value: function clearAllFilters() {
      var btn = $(event.target);
      var box = btn.closest('.filters--box');
      var applyBox = btn.closest('.filters--apply-btn');
      //const plpBox = $('.filters--selected-filters-grid');

      if (box.is('.filters--box--top')) {
        // reset all
        box.parent().find('input[data-filter].pending-sel').prop('checked', false).trigger('change');

        this.loadPriceFacet(this.priceRange.min, this.priceRange.max);
        if (box.parent().find('input[data-filter]:checked').not('.pending-sel').length) {
          box.parent().find('input[data-filter]:checked').not('pending-sel').prop('checked', false).trigger('change', ["Reset"]);
          this.executeChange();
          //plpBox.addClass("hide");
        }
      } else if (applyBox.length > 0) {
        // reset all
        applyBox.siblings('.filters--content').find('input[data-filter].pending-sel').prop('checked', false).trigger('change');

        this.loadPriceFacet(this.priceRange.min, this.priceRange.max);
        if (applyBox.siblings('.filters--content').find('input[data-filter]:checked').not('.pending-sel').length) {
          applyBox.siblings('.filters--content').find('input[data-filter]:checked').not('pending-sel').prop('checked', false).trigger('change', ["Reset"]);
          this.executeChange();
          //plpBox.addClass("hide");
        }
      } else {
        // reset each box
        if (box.find('.filters--slider-range').length) {
          this.loadPriceFacet(this.priceRange.min, this.priceRange.max);
          this.executeChange();
        } else {
          box.find('input[data-filter].pending-sel').prop('checked', false).trigger('change');

          if (box.find('input[data-filter]:checked').not('.pending-sel').length) {
            box.find('input[data-filter]:checked').not('pending-sel').prop('checked', false).trigger('change', ["Reset"]);
            this.executeChange();
            //plpBox.addClass("hide");
          }
        }
      }

      for (var i = 0; i < selectedFilter.length; i++) {
        this.removeFilter(selectedFilter[i].filter, selectedFilter[i].value);
      }
      selectedFilter = [];

      this.executeChange();
      this.clearUnselectedCheckbox();
      this.selectedFiltersNumberText.text('');
    }
  }, {
    key: 'sliderSlideEvent',
    value: function sliderSlideEvent(event, ui) {
      var inputField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      lastAccordion = $("#filter-box-price");
      if (inputField) {
        var min = $('.filters--slider-handle--01 .filters--slider-handle-text').val().replace("$", "");
        var max = $('.filters--slider-handle--02 .filters--slider-handle-text').val().replace("$", "");
        this.priceRangeSlider.slider("values", 0, min);
        this.priceRangeSlider.slider("values", 1, max);
      } else {
        var min = ui.values[0];
        var max = ui.values[1];
      }
      // // Done in toggleButtonReset
      this.priceRangeSliderHandler[0].val(min);
      this.priceRangeSliderHandler[1].val(max);

      var value = min + ',' + max;
      var text = '$' + min + '-$' + max;

      // if price match [min, min] or [max, max] => remove this price filter
      if (min === max && min === this.priceRange.min || min === max && min === this.priceRange.max || min === this.priceRange.min && max === this.priceRange.max) {
        this.removeFilter('price');
      } else {
        this.addPriceFilter(value, text);
      }

      this.renderSeletedFilters({});
      this.toggleButtonReset();
    }
  }, {
    key: 'closeResultMoreItem',
    value: function closeResultMoreItem() {
      if (this.scopeHoverFilter) {
        this.applyFilters({});
        this.scopeHoverFilter = false;
      }
    }
  }, {
    key: 'openFiltersSidebar',


    /**
     * open filter sidebar on mobile
     */
    value: function openFiltersSidebar() {
      // this.filters.addClass('show');
      // this.filtersInner.animateCss('slideInLeft');
      // var styles = {
      //   overflow : "hidden",
      //   position: "fixed"
      // };
      // $("body").css( styles );
      // $("html").css( styles );
      this.filters.modal('show');
    }

    /**
     * close filter sidebar on mobile
     */

  }, {
    key: 'closeFiltersSidebar',
    value: function closeFiltersSidebar() {
      // this.filtersInner.animateCss('slideOutLeft', () => {
      //   this.filters.removeClass('show');

      //   this.filters.find('.collapse').collapse('hide');
      // });
      // this.closeResultMoreItem();
      // $("body").removeAttr("style");
      // $("html").removeAttr("style");
      this.filters.modal('hide');
    }

    /**
     * add filter item
     * @param {*} filter filter name, i.e: brand
     * @param {*} value filter value, i.e: ray-ban
     * @param {*} text filter text, i.e: Ray-Ban
     */

  }, {
    key: 'addFilter',
    value: function addFilter(filter, value, text) {
      text = text.replaceAll("&amp;", "&");
      selectedFilter.push({
        filter: filter,
        value: value,
        text: text
      });
    }
  }, {
    key: 'loadFilters',
    value: function loadFilters() {
      var urlParams = new URLSearchParams(window.location.search);
      var that = this;

      urlParams.forEach(function (param) {
        var tmpFilterObj = $("input[value='" + param + "']");
        var tmpFilter = tmpFilterObj.attr("data-filter");
        if (tmpFilter != "price" && tmpFilter != null && tmpFilter != undefined) {
          if (tmpFilter != "metagen" && tmpFilter != "framecolor" && tmpFilter != "frameshape" && tmpFilter != "faceshape" && tmpFilter != "lenscolor") {
            if (tmpFilter === "material" || tmpFilter === "geofit" || tmpFilter === "lenstech" || tmpFilter === "frameFitting" || tmpFilter === "prescription") {
              var tmpText = $("input[value='" + param + "']").siblings().children().children().html();
            } else {
              var tmpText = $("input[value='" + param + "']").siblings().children().html();
            }
          } else {
            var tmpText = $("input[value='" + param + "']").siblings().children().eq(1).html();
          }
          that.addFilter(tmpFilter, param, tmpText);
        }
      });
      this.renderSeletedFilters({});
      // Manage scrolling/sliding interaction with selected filters bar
      var filterResultsActualWidth = $(".filters--selected-filters-grid .filters--selected-filters")[0].scrollWidth;
      var filterResultsLayoutWidth = $(".filters--selected-filters-grid .filters--selected-filters").width() + 5;
      if (filterResultsActualWidth >= filterResultsLayoutWidth) {
        $(".filters--btn-reset").addClass("overflow-btn");
        $(".filters--selected-filters-arrow").removeClass("d-none");
        // Manage slide on click of selected filters bar
        if (!$(".filters--selected-filters-arrow").hasClass("initialized")) {
          $(".filters--selected-filters-arrow").on("click", function () {
            var scrollAmount = $('.filters--selected-filters-grid .filters--selected-filters').scrollLeft();
            $(".filters--selected-filters-arrow").addClass("initialized");
            $('.filters--selected-filters-grid .filters--selected-filters').animate({
              scrollLeft: scrollAmount += 100,
              duration: 1000
            }, 500);
          });
        }
      } else {
        $(".filters--btn-reset").removeClass("overflow-btn");
        $(".filters--selected-filters-arrow").addClass("d-none");
      }
    }
  }, {
    key: 'countCategoryChecked',
    value: function countCategoryChecked() {
      var list = ["brand", "gender", "polarized", "lenstech", "frameSizeDisplay", "frameFitting", "geofit", "material", "frameshape", "framecolor", "lenscolor", "faceshape", "rim", "prescription"];

      list.forEach(function (item) {
        var counter = 0;
        var filterBoxSelector = "#filter-box-" + item;
        var filterCounterSelector = "#" + item + "-filter-count";
        $(filterBoxSelector).find(':checkbox').each(function () {
          if ($(this).is(':checked')) {
            counter++;
          }
        });
        var counterStr = counter > 0 ? "(" + counter + ")" : "";
        $(filterCounterSelector).html(counterStr);
      });
    }
  }, {
    key: 'addPriceFilter',
    value: function addPriceFilter(value, text) {
      var filter = selectedFilter.filter(function (item) {
        return item.filter === 'price';
      });
      if (filter.length) {
        filter[0].value = value;
        filter[0].text = text;
      } else {
        this.addFilter('price', value, text);
      }
    }

    /**
     * Find a filter by filter name and value
     * @param {*} filter filter name i.e: brand
     * @param {*} value (optional) filter value i.e: ray-ban
     */

  }, {
    key: 'findFilter',
    value: function findFilter(filter, value) {
      var filterItem = selectedFilter.filter(function (item) {
        return item.filter === filter && (typeof value !== 'undefined' && item.value === value || typeof value === 'undefined');
      });
      return filterItem;
    }

    /**
     * remove filter item
     * @param {*} filter filter name, i.e: brand
     * @param {*} value filter value, i.e: ray-ban
     */

  }, {
    key: 'removeFilter',
    value: function removeFilter(filter, value) {
      var filterItems = this.findFilter(filter, value);
      if (filterItems.length) {
        selectedFilter = selectedFilter.filter(function (item) {
          return filterItems.indexOf(item) < 0;
        });
      }
    }

    /**
     * render selected filters
     */

  }, {
    key: 'renderSeletedFilters',
    value: function renderSeletedFilters(_ref) {
      var _ref$event = _ref.event,
          event = _ref$event === undefined ? '' : _ref$event,
          _ref$callApply = _ref.callApply,
          callApply = _ref$callApply === undefined ? true : _ref$callApply;

      this.renderTemplateSeleted();
      if (callApply === true) {
        this.applyFilters(event);
      }
    }
  }, {
    key: 'renderTemplateSeleted',
    value: function renderTemplateSeleted() {
      if (selectedFilter.length) {
        var htmlString = '';
        this.selectedFiltersContainer.empty().addClass("show");
        this.selectedFiltersContainer.removeClass("hide");
        this.selectedFiltersNumberText.text('');
        this.spanNoFilter.addClass('d-none');
        this.clearDuplicates();
        this.toggleButtonReset();

        selectedFilter.forEach(function (item) {
          var text = item.text,
              filter = item.filter,
              value = item.value;

          value = value.replaceAll('"', "&quot;");
          htmlString += '<div class="badge badge-pill filters--result-item" data-filter="' + filter + '" data-value="' + value + '">';
          if (filter === "framecolor" || filter === "lenscolor") {
            htmlString += '<span class="catalogue-color catalogue-color--frames--' + text + '"></span>';
          }
          if (filter === "frameshape" || filter === "faceshape" || filter === "frametype") {
            var tmpText = text.replace(" ", '-').toLowerCase();
            htmlString += '<img class="filters--checkbox-icon" src="/wcsstore/OPSMStorefrontAssetStore/images/' + filter + '/frame-' + tmpText + '.svg" alt="' + text + '" onerror="this.style.display=' + "'none'" + '">';
          }
          if (filter === "metagen") {
            var tmpGen = value.substring(value.indexOf('&quot;') + 6, value.lastIndexOf('&quot;')).replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
            htmlString += '<img class="filters--checkbox-icon" src="/wcsstore/OPSMStorefrontAssetStore/images/icons/metagen/' + tmpGen + '.png" width="24" height="24" alt="" onerror="this.style.display=' + "'none'" + '">';
          }
          htmlString += '<span>' + text + '</span>' + '<a class="filters--result-item-remove pointer" tabindex="0"><span class="icon-close-fat" data-analytics_available_call="0"></span></a>' + '</div>';
        });
        this.selectedFiltersContainer.html(htmlString);
        this.selectedFiltersNumberText.text('(' + selectedFilter.length + ')');
        this.selectedFiltersContainerGrid.removeClass("hide");
        this.selectedFiltersContainerGrid.addClass("show");
      } else {
        this.spanNoFilter.removeClass('d-none');
        this.selectedFiltersContainer.removeClass("show");
        this.selectedFiltersContainer.addClass("hide");
        this.selectedFiltersContainerGrid.addClass("hide");
        this.selectedFiltersContainerGrid.removeClass("show");
        this.selectedFiltersNumberText.text('');
        $("input[data-filter]:checked").each(function () {
          $(this).prop('checked', false);
        });
        $(".filters--btn-reset").removeClass("overflow-btn");
        $(".filters--selected-filters-arrow").addClass("d-none");
      }
    }
  }, {
    key: 'clearUnselectedCheckbox',
    value: function clearUnselectedCheckbox() {
      if (selectedFilter.length === 0) {
        $("input[data-filter]:checked").each(function () {
          $(this).prop('checked', false);
        });
      }
    }
    /**
     * @Description: apply filter
     */

  }, {
    key: 'applyFilters',
    value: function applyFilters(event) {
      var _this3 = this;

      var selectedFiltersContainer = this.selectedFiltersContainer,
          shortFilterResult = this.shortFilterResult,
          scopeHoverFilter = this.scopeHoverFilter,
          visibleFilterResult = this.visibleFilterResult,
          styleInlineFilter = this.styleInlineFilter;

      var totalWidthChips = 0;
      var flagTotal = false;
      var lengthElementHide = 0;
      var divWidthFilter = selectedFiltersContainer.width();
      var childrenFilters = selectedFiltersContainer.children();
      var conditionEventRemove = event === REMOVE;
      var conditionEventRemoveHide = event === REMOVE_HIDE;
      if (conditionEventRemove || conditionEventRemoveHide) {
        this.hideElementFilter = {};
        this.showElementFilter = {};
      }
      childrenFilters.each(function (index, item) {
        var offsetWidth = item.offsetWidth;

        totalWidthChips += offsetWidth;
        if (totalWidthChips + WIDTH_CHIPS_TOTAL >= divWidthFilter) {
          lengthElementHide += 1;
          flagTotal = true;
          _this3.hideElementFilter[index] = item;
          /*        selectedFiltersContainer.addClass(CLASS_LINE_HORIZONTAL);*/
        } else {
          styleInlineFilter(selectedFiltersContainer);
          _this3.showElementFilter[index] = item;
        }
      });
      var self = this;
      // if (scopeHoverFilter && conditionEventRemove) {
      //   visibleFilterResult(selectedFiltersContainer, self);
      // } else if (flagTotal) {
      //   shortFilterResult(lengthElementHide, self);
      // }
    }
  }, {
    key: 'shortFilterResult',
    value: function shortFilterResult(length, self) {
      var selectedFiltersContainer = self.selectedFiltersContainer,
          showElementFilter = self.showElementFilter;

      selectedFiltersContainer.empty();
      var templateTotalFilter = '\n         <div class="badge badge-pill filters--result-item filters--result-item-total">\n            <span>+' + length + '</span>\n         </div>\n      ';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(showElementFilter)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref2 = _step.value;

          var _ref3 = _slicedToArray(_ref2, 2);

          var itemElement = _ref3[1];

          selectedFiltersContainer.append(itemElement);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      selectedFiltersContainer.append(templateTotalFilter);
    }
  }, {
    key: 'visibleFilterResult',
    value: function visibleFilterResult(selectedFiltersContainer, self) {
      var styleInlineFilter = self.styleInlineFilter;

      styleInlineFilter(selectedFiltersContainer);
    }
  }, {
    key: 'styleInlineFilter',
    value: function styleInlineFilter(selectedFiltersContainer) {
      selectedFiltersContainer.hasClass(CLASS_LINE_HORIZONTAL) ? selectedFiltersContainer.removeClass(CLASS_LINE_HORIZONTAL) : '';
    }

    // togle reset buttons visibility and update price facet

  }, {
    key: 'toggleButtonReset',
    value: function toggleButtonReset() {
      // this.filters.find('.filters--box:not(.filters--box--top)').each((index, box) => {
      // const btnReset = $(box).find('.filters--btn-reset');

      // if ($(box).find('.filters--slider-range').length) {
      //   // if this is price range slider
      //   const currentPriceRange = this.priceRangeSlider.slider('values');
      //   if (currentPriceRange && (
      //     (currentPriceRange[0] === this.priceRange.min && currentPriceRange[1] === this.priceRange.min) ||
      //     (currentPriceRange[0] === this.priceRange.max && currentPriceRange[1] === this.priceRange.max) ||
      //     (currentPriceRange[0] === this.priceRange.min && currentPriceRange[1] === this.priceRange.max)
      //   )) {
      //     // slider at default value [min, min]
      //     btnReset.addClass('d-none');
      //   } else {
      //     btnReset.removeClass('d-none');
      //   }
      // } else {
      //   // checkboxes list
      //   const checkedCheckboxes = $(box).find('input[data-filter]:checked');
      //   if (checkedCheckboxes.length) {
      //     btnReset.removeClass('d-none');
      //   } else {
      //     btnReset.addClass('d-none');
      //   }
      // }
      // });
      var btnReset = $('.filters--btn-reset');
      btnReset.toggleClass('d-none', selectedFilter.length === 0);
    }
  }, {
    key: 'loadPriceFacet',
    value: function loadPriceFacet(minPrice, maxPrice) {
      var minMax = $(".filters--slider-range").slider("values");
      if (minMax.length === 0 || minMax[0] === minPrice && minMax[1] === maxPrice) {
        return;
      }
      var priceValues = minPrice + "," + maxPrice,
          priceText = "$" + minPrice + "-$" + maxPrice;
      $(".filters--slider-range").slider("values", ["" + minPrice, "" + maxPrice]);
      this.priceRangeSliderHandler[0].val(minPrice);
      this.priceRangeSliderHandler[1].val(maxPrice);
      this.addPriceFilter(priceValues, priceText);
      this.toggleButtonReset();
      var renderOptions = { callApply: false };
      if (minPrice === maxPrice && minPrice === this.priceRange.min || minPrice === maxPrice && minPrice === this.priceRange.max || minPrice === this.priceRange.min && maxPrice === this.priceRange.max) {
        renderOptions.event = REMOVE;
      }
      this.renderSeletedFilters(renderOptions);
      resizeInput(".filters--slider-handle-text");
    }
  }, {
    key: 'executeFilter',
    value: function executeFilter() {
      var tempparams = [];
      var params = [];
      //    var noProductsAndPrice = false;
      /* refactor */
      this.startLoading();
      this.clearDuplicates();
      for (var index = 0; index < selectedFilter.length; index++) {
        var filter = selectedFilter[index];
        if (filter.filter === "price") {
          var minMax = filter.value.split(",");
          var currency = $("#price-facet-currency").val();
          if (typeof currency !== "undefined" && currency !== null) {
            tempparams.push("facet=" + encodeURIComponent('price_' + currency + ':({' + minMax[0] + ' ' + minMax[1] + '} "' + minMax[1] + '")'));
          }
        } else {
          tempparams.push("facet=" + encodeURIComponent(filter.value));
        }
      }
      //   if (!noProductsAndPrice) {
      params = tempparams;
      //   } else {
      //	   //recover from ReloadFacetCookie
      //      var reloadFacetCookie = $.cookie("ReloadFacetCookie").split("#");
      //      var paramsForReloadFacetCookie = [];
      //      if(reloadFacetCookie.length > 1) {
      //        var facetsInCookie = reloadFacetCookie[1].split(",");
      //        for(var i = 0; i < facetsInCookie.length; i++) {
      //          if (facetsInCookie[i].indexOf("price_") === -1) {
      //    	    if (facetsInCookie[i].indexOf("orderBy") === -1 || facetsInCookie[i].indexOf("pageSize") === -1)
      //            paramsForReloadFacetCookie.push(facetsInCookie[i]);
      //          }
      //        }
      //      }
      //      params = paramsForReloadFacetCookie;
      //   }
      // $(".filters .filters--content .filters--box .filters--custom-checkbox input:checked").each(
      //   function(){
      //     params.push("facet=" + encodeURIComponent($(this).val()));
      //   }
      // );
      if (typeof opsm !== "undefined" && opsm !== null && typeof opsm.catalog !== "undefined" && opsm.catalog !== null && typeof opsm.catalog.loadpanels !== "undefined" && opsm.catalog.loadpanels !== null) {
        $('#pageSizecookie').val("pageSize=" + 18);

        /* ----------------------------------------------------
        * VUE CAROUSEL MANAGEMENT - START
        * ---------------------------------------------------- */
        if (!this.$carousel || this.$carousel.length === 0) {
          if ($('.product-listing--carousel').length > 0) this.$carousel = $('.product-listing--carousel').detach();
        }

        this._pendingFilterRequests++;
        console.debug("execute filter with pending request " + this._pendingFilterRequests);
        if (this._pendingFilterRequests === 1) {
          console.debug("execute filter registering 2 listeners");
          // 1 shared listener among whole request burst
          // registered on the 1st and active untill the counter is 0
          document.addEventListener('plp:tilesReplaced', this._handleTilesSettled);
          document.addEventListener('plp:tilesUpdateErr', this._handleTilesSettled);
        }

        opsm.catalog.loadpanels($("#basePageURL").val(), params.join(","), true, "GET", false, false, undefined, function () {
          opsm.filters.init();
        });
        if (params != undefined) {
          params = params.join(",").replace(/,/g, '&');
          var facetURL = window.location.href.split('?')[0] + '?' + params;
          history.pushState("facet", document.title, facetURL);
        }
        //$('#pageSizecookie').val("pageSize=" + addPageSize);
        var respagesizeorderBy = $('#pagesizeorderBy').val();
        var rescookiepagesize = $('#pageSizecookie').val();
        //      opsm.catalog.updateReloadFacetCookie(params.join(",")+","+respagesizeorderBy+","+rescookiepagesize);
      }
    }
  }, {
    key: 'executeChange',
    value: function executeChange(ev, extraParam) {
      if (typeof extraParam !== "undefined" && extraParam === "Init") {
        return;
      }
      if (typeof extraParam !== "undefined" && extraParam === "Reset") {
        return;
        //		if($("#btn-apply-filters").is(":visible")
        //				&& typeof ev !== "undefined") {
        //			if (!$(ev.target).hasClass('existing-on-load') &&
        //					$(ev.target).hasClass('pending-sel')){
        //				$(ev.target).removeClass('pending-sel');
        //				return;
        //			}
        //		} else {
        //			return;
        //		}
      } else /*mobile behavoiour*/
        if ($("#btn-apply-filters").is(":visible") && typeof ev !== "undefined") {
          /*OPSMD-8269*/
          if ($(ev.target).is(':checked')) {
            return;
          } else if (!$(ev.target).hasClass('existing-on-load') && $(ev.target).hasClass('pending-sel')) {
            $(ev.target).removeClass('pending-sel');
            return;
          }
        }
      this.executeFilter();
    }
  }, {
    key: 'removeFiltersPills',
    value: function removeFiltersPills(e, that) {
      var item = $(e.target).closest('.filters--result-item');
      var filter = item.data('filter');
      var value = item.data('value');
      if (filter !== 'price') {
        // if it's not price range slider => it's checkbox => uncheck
        that.filters.find('input[data-filter="' + filter + '"][value=\'' + value + '\']').prop('checked', false).trigger("change");
        that.removeFilter(filter, value);
        that.renderSeletedFilters({ event: REMOVE });
        that.toggleButtonReset();
      } else {
        that.loadPriceFacet(that.priceRange.min, that.priceRange.max);
        that.removeFilter('price');
        that.executeFilter();
      }
    }
  }, {
    key: 'searchFilterBrand',
    value: function searchFilterBrand(e) {
      var searchString = $(e.target).val().toLowerCase();
      $(e.target).parents('.collapse').find(".custom-checkbox").each(function () {
        var currentBrandFilter = $(this).find('.filters--checkbox-text').text();
        if (currentBrandFilter.indexOf(searchString) > -1) {
          $(this).removeClass("d-none");
        } else {
          $(this).addClass("d-none");
        }
      });
    }
  }, {
    key: 'searchFilterMetaGen',
    value: function searchFilterMetaGen(e) {
      var searchString = $(e.target).val().toLowerCase();
      $(e.target).parents('.collapse').find(".custom-checkbox").each(function () {
        var currentGenFilter = $(this).find('.filters--checkbox-text').text();
        if (currentGenFilter.indexOf(searchString) > -1) {
          $(this).removeClass("d-none");
        } else {
          $(this).addClass("d-none");
        }
      });
    }
  }, {
    key: 'clearDuplicates',
    value: function clearDuplicates() {
      if (selectedFilter.length > 1) {
        selectedFilter = selectedFilter.filter(function (obj, index) {
          return index === selectedFilter.findIndex(function (o) {
            return obj.text === o.text && obj.filter === o.filter && obj.value === o.value;
          });
        });
      }
    }
  }, {
    key: 'startLoading',
    value: function startLoading(e) {
      var _this4 = this;

      if (this._loadingTimeout) {
        clearTimeout(this._loadingTimeout);
      }

      this._loadingTimeout = setTimeout(function () {
        _this4.endLoading();
      }, 5000);
      $("body").addClass("skeleton");
      $("html").animate({
        scrollTop: 0,
        duration: 2000
      }, 500);
    }
  }, {
    key: 'endLoading',
    value: function endLoading(e) {
      if (this._loadingTimeout) {
        clearTimeout(this._loadingTimeout);
        this._loadingTimeout = null;
      }
      $("body").removeClass("skeleton");
    }
  }, {
    key: 'openDashbuttons',
    value: function openDashbuttons(el) {
      var targetCollapse = $(el).data("target");
      opsm.filters.isOpenDashbutton = $(targetCollapse).hasClass('show');
      if (!opsm.filters.isOpenDashbutton) {
        $(targetCollapse).collapse("show");
        document.addEventListener("click", opsm.filters.closeDashbuttons);
      } else {
        $(targetCollapse).collapse("hide");
        opsm.filters.isOpenDashbutton = false;
        document.removeEventListener("click", opsm.filters.closeDashbuttons);
      }
    }
  }, {
    key: 'closeDashbuttons',
    value: function closeDashbuttons(event) {
      opsm.filters.isOpenDashbutton = $(".filters--box .card-body-wrapper").hasClass('show');
      var clickover = $(event.target).parents(".card-body-wrapper").length >= 1;
      if (opsm.filters.isOpenDashbutton === true && !clickover) {
        $(".filters--box .card-body-wrapper").collapse("hide");
        opsm.filters.isOpenDashbutton = false;
        document.removeEventListener("click", opsm.filters.closeDashbuttons);
      }
    }
  }, {
    key: 'setMetagenCheckbox',
    value: function setMetagenCheckbox(baseInput, checked) {
      var id = baseInput.attr('id').replace('-dropdown', '');
      var $base = $('#' + id);
      var $dropdown = $('#' + id + '-dropdown');
      var value = $base.val();
      var text = $base.siblings('label.custom-control-label').find('.filters--checkbox-text').text();

      $base.prop('checked', checked);
      $dropdown.prop('checked', checked);

      if (checked) {
        lastAccordion = $base.parent().parent().parent();
        this.addFilter('metagen', value, text);
      } else {
        this.removeFilter('metagen', value);
      }
    }
  }, {
    key: 'restoreVueCarousel',
    value: function restoreVueCarousel() {
      console.debug("restoreVueCarousel has carousel ", this.$carousel && this.$carousel.length > 0);
      var $carouselPlaceholder = this.productsListing.find('.product-listing--carousel');
      if (this.$carousel && this.$carousel.length > 0 && $carouselPlaceholder.length > 0) {
        $carouselPlaceholder.replaceWith(this.$carousel);
        this.$carousel = null;
      }
    }
  }], [{
    key: 'facetValueLabel',
    value: function facetValueLabel(facetValue) {
      switch (facetValue.toUpperCase().replace(/\s+/g, '_')) {
        case Utils.string_of_enum(facetValues, facetValues.OPTICAL):
          return facetValues.OPTICAL;
        case Utils.string_of_enum(facetValues, facetValues.SUN):
          return facetValues.SUN;
        case Utils.string_of_enum(facetValues, facetValues.FS):
          return facetValues.FS;
        case Utils.string_of_enum(facetValues, facetValues.F):
          return facetValues.F;
        case Utils.string_of_enum(facetValues, facetValues.FT):
          return facetValues.FT;
        case Utils.string_of_enum(facetValues, facetValues.UNISEX):
          return facetValues.UNISEX;
        case Utils.string_of_enum(facetValues, facetValues.MALE):
          return facetValues.MALE;
        case Utils.string_of_enum(facetValues, facetValues.FEMALE):
          return facetValues.FEMALE;
        case Utils.string_of_enum(facetValues, facetValues.CHILD):
          return facetValues.CHILD;
        case Utils.string_of_enum(facetValues, facetValues.DEMO_LENS):
          return facetValues.DEMO_LENS;
        case Utils.string_of_enum(facetValues, facetValues.STD):
          return facetValues.STD;
        case Utils.string_of_enum(facetValues, facetValues.L):
          return facetValues.L;
        case Utils.string_of_enum(facetValues, facetValues.S):
          return facetValues.S;
      }
      return facetValue;
    }
  }]);

  return Filter;
}();

;(function ($) {
  $(document).ready(function () {
    if ($('#filters').length) {
      opsm.filters = new Filter();
    }
  });
})(jQuery);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StickFooterBanner = function () {
    function StickFooterBanner() {
        var _this = this;

        _classCallCheck(this, StickFooterBanner);

        this.element = $('#footer-sticky-banner');
        this.closeBtn = this.element.find('.footer--sticky-banner-close-btn');

        if (typeof getCookie !== "undefined" && getCookie('extra10') === 'extra10') {
            this.hide();
        }
        this.closeBtn.on('click', function () {
            if (typeof setCookie !== "undefined") {
                setCookie('extra10', 'extra10', 1000);
            }
            _this.hide();
        });
    }

    _createClass(StickFooterBanner, [{
        key: 'show',
        value: function show() {
            this.element.show().animateCss('slideInUp');
        }
    }, {
        key: 'hide',
        value: function hide() {
            var _this2 = this;

            this.element.animateCss('slideOutDown', function () {
                _this2.element.hide(0);
            });
        }
    }]);

    return StickFooterBanner;
}();

var FormSubscription = function FormSubscription() {
    _classCallCheck(this, FormSubscription);

    this.form = document.querySelector('#form-subscription');

    if (this.form) {
        this.form.addEventListener('submit', function (event) {
            if (_this3.form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
            }

            this.form.classList.add('was-validated');
        });
    }
};
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OPSMHeader = function () {
  function OPSMHeader() {
    var _this = this;

    _classCallCheck(this, OPSMHeader);

    this.basePath = window.location.origin;
    //	  this.basePath = window.location.origin + "/webapp/wcs/stores/servlet"; // DEV
    $.ajax({
      url: this.basePath + '/AjaxUserFavouriteListItems',
      dataType: 'json',
      success: function success(interestItemsLists) {
        var itemsStr = "";
        var itemsCount = 0;
        var items = [];
        if (interestItemsLists.length) {
          if (interestItemsLists[0].items.length) {
            itemsStr = interestItemsLists[0].items.join('_');
            itemsCount = interestItemsLists[0].items.length;
            items = interestItemsLists[0].items;
          }
        }
        $(document).ready(function () {
          $('#wishlist-total-count').val(itemsCount);
          $('#added-products-favourites').attr('rel', itemsStr);

          // handle header star
          $('#btn-favourite .header--cms-badge').html(itemsCount).trigger("change");

          // handle PDP star
          items.forEach(function (v, i, arr) {
            $('button.product--favourite[rel="' + v + '"]').addClass("product--favourite--yes").find('span.icon-heart-outline').addClass("icon-heart");
            $('button.product--favourite[rel="' + v + '"]').addClass("product--favourite--yes").find('span.icon-heart-outline').removeClass("icon-heart-outline");
          });
        });
      },
      error: function error(xhr, ajaxOptions, thrownError) {
        console.log(xhr.responseText);
      }
    });

    $.ajax({
      url: this.basePath + '/AjaxCustomerHeaderInfos',
      dataType: 'json',
      // beforeSend: function(jqXHR, settings) {
      //     document.dispatchEvent(new CustomEvent('CustomerHeaderInfosStart'));
      // },
      success: function success(customerHeaderInfos) {
        document.dispatchEvent(new CustomEvent('CustomerHeaderInfosLoaded', { detail: customerHeaderInfos }));
        try {
          if (customerHeaderInfos.length) {
            $(document).ready(function () {
              var userType = customerHeaderInfos[2];
              if (userType === 'G') {
                $('.header--g-user').removeClass('d-none');
                $('.header--r-user').addClass('d-none');
                $('.js-gr-ddm-reorder-cta').attr('href', $('input#js-gr-header--g-user').val());
                $('.header--r-user ').not('.reorder-button').removeClass('d-flex');
                $('.sidemenu--g-user').removeClass('d-none');
                $('.sidemenu--r-user').addClass('d-none');
                isLoggedInUser = 'false';
              } else if (userType === 'R') {
                $('.sidemenu--g-user').addClass('d-none');
                $('.sidemenu--r-user').removeClass('d-none');
                $('.js-gr-ddm-reorder-cta').attr('href', $('input#js-gr-header--r-user').val());
                $('.header--g-user').addClass('d-none');
                $('.header--r-user').not('.reorder-button').addClass('d-flex');
                $('.header--r-user').removeClass('d-none');
                // RDDM update: now we have just a slightly different icon, we don't show the user first name anymore
                // $('.header--cms-item.btn-link > .header--brand-account.hidden-mobile').text(customerHeaderInfos[0]);
                // $('.header--cms-item.btn-link > .header--brand-account--rounded.visible-mobile').text(customerHeaderInfos[1]);
                isLoggedInUser = 'true';
              }
            });
          }
        } catch (err) {
          console.log(err);
        }
      },
      error: function error(xhr, ajaxOptions, thrownError) {
        document.dispatchEvent(new CustomEvent('CustomerHeaderInfosError'));
        console.log(xhr.responseText);
      }
    });

    /** Notibar */
    this.header = $('.header');
    this.saleBanner = $('div#sale-off-banner');
    this.notibarCloseBtn = $('#header-notibar-close');
    this.notibarCloseBtn.on('click', function () {
      _this.saleBanner.animateCss('fadeOutUp', function () {
        _this.saleBanner.remove();
        _this.header.addClass('header--no-notibar');
      });
    });

    /**
     * Stick the header: using CSS solution
     */
    this.header = $('.header');
    this.headersticky = $('#opsm-header-sticky');
    this.preHeader = $("#pre-header-strip");
    this.navbarLeft = this.header.find('#header-mega-navbar-left');
    this.underline = this.navbarLeft.find('.header--mega-navbar-underline');
    this.headerWrapper = this.header.find('.header-wrapper');

    /**
    * As per the new CR, make the main menu sticky.
    * So, disabling the menu toggle animation.
    * handle window scroll
    * following CR, the header should not be sticky, no sudden appearing.
    * everything written above has been reverted for ticket OPSMD-4780
    */
    var previousWindowScrollTop = $(window).scrollTop();
    var deltaScroll = 0;
    $(window).on('scroll', function () {
      var currentScrollTop = $(window).scrollTop();

      if (currentScrollTop > previousWindowScrollTop && currentScrollTop > _this.header.height()) {
        deltaScroll = currentScrollTop - previousWindowScrollTop;
        // if(deltaScroll > 50) {
        if (!_this.megaMenuContainer.is('.show')) {
          _this.headerWrapper.addClass('temp-hidden');
          _this.headerWrapper.attr({
            'data-aos': 'fade-up'
          });
          _this.saleBanner.addClass('temp-hidden');
          // this.saleBanner.attr({
          //   'data-aos': 'fade-up'
          // });
          _this.headersticky.addClass('temp-hidden');
          // this.headersticky.attr({
          //   'data-aos': 'fade-up'
          // });
          _this.preHeader.addClass('temp-hidden');
          // this.preHeader.attr({
          //   'data-aos': 'fade-up'
          // });
        }
      } else {
        deltaScroll = previousWindowScrollTop - currentScrollTop;
        if (deltaScroll > 50 || currentScrollTop <= _this.header.height() + 40) {
          if (!_this.megaMenuContainer.is('.show')) {
            _this.headerWrapper.removeClass('temp-hidden');
            _this.headerWrapper.attr({
              'data-aos': 'fade-down'
            });
            _this.saleBanner.removeClass('temp-hidden');
            // this.saleBanner.attr({
            //   'data-aos': 'fade-down'
            // });
            _this.headersticky.removeClass('temp-hidden');
            //  this.headersticky.attr({
            //   'data-aos': 'fade-down'
            // });
            _this.preHeader.removeClass('temp-hidden');
            // this.preHeader.attr({
            //   'data-aos': 'fade-down'
            // });
          } else {
            _this.headerWrapper.removeAttr('data-aos');
            //  this.headersticky.removeAttr('data-aos');
            //  this.saleBanner.removeAttr('data-aos');
            //  this.preHeader.removeAttr('data-aos');
          }
        }
      }
      previousWindowScrollTop = currentScrollTop;

      if (currentScrollTop > _this.header.height() / _this.header.height()) {
        _this.header.addClass('sticky-ing');
      } else {
        _this.header.removeClass('sticky-ing');
      }

      //remove the blank at the top of page when scrolling up (because of the fade-up animation)
      if (currentScrollTop <= _this.header.height() && _this.header.not('.sticky-ing')) {
        // remove AOS fade-down event to prevent conflict with megamenu event
        if (_this.headersticky.is('[data-aos]')) {
          _this.headersticky.removeAttr('data-aos');
        }
        if (_this.saleBanner.is('[data-aos]')) {
          _this.saleBanner.removeAttr('data-aos');
        }
      }

      //remove sticky if mega menu is showing
      //  if(this.megaMenuContainer.is('.show') && this.header.is('.sticky-ing')) {
      //    this.header.removeClass('sticky-ing');
      //  }

      //   adjust the megamenu top position after scrolling
      _this.adjustMegaTopPos();
    });

    /**
     * Handle the user menu behaviour
     * if the user menu exists as a dropdown,
     * then adjust the position of dropdown everytime it appears
     */
    this.btnLogin = $('#btn-login .hidden-mobile');
    if (this.btnLogin.length) {
      this.userMenu = this.btnLogin.siblings('.dropdown-menu');
      this.btnLogin.dropdown({
        offset: function offset(data) {
          var btnWidth = _this.btnLogin.outerWidth();
          var menuWidth = _this.userMenu.width();
          var offsetLeft = parseInt((menuWidth - btnWidth) / 2, 10);
          var popper = data.popper;
          popper.left = -offsetLeft;
          if (Utils.isSmallDesktopAndAbove()) {
            popper.top = 30;
          }
          return data;
        }
      });

      var timeoutHoveringOut = false;
      var touched = false;
      this.btnLogin.on('mouseenter', function () {
        if (touched) {
          touched = false;
          return;
        }

        if (timeoutHoveringOut) {
          clearTimeout(timeoutHoveringOut);
          timeoutHoveringOut = false;
        }

        if (_this.userMenu.is(':hidden')) {
          _this.btnLogin.dropdown('toggle');
        }
      }).on('mouseleave', function () {
        timeoutHoveringOut = setTimeout(function () {
          _this.userMenu.trigger('mouseleave');
        }, 200);
      }).on('touchstart', function () {
        touched = true;
      });

      this.userMenu.on('mouseenter', function () {
        if (timeoutHoveringOut) {
          clearTimeout(timeoutHoveringOut);
          timeoutHoveringOut = false;
        }
      }).on('mouseleave', function () {
        if (_this.userMenu.is(':visible')) {
          _this.btnLogin.dropdown('toggle');
        }
      });
    }

    /**
     * Handle the mega contents: show / hide / switch
     * Some nav links (BEAT and LOCATIONS) could not have megaMenus associated:
     * handled at show/hide method level
     */
    this.megaMenuLink = $('.header--mega-navbar-item-link');
    this.megaMenus = $('.header--mega-navbar-contents');
    this.megaMenuContainer = $('.header--mega-navbar-contents-container');
    this.megaMenuWrapper = $('.header--mega-navbar-contents--wrapper');
    this.megaMenuItem = $('.header--mega-navbar-item');
    var megamenuOutTimeout = false;
    this.mobileMenuToggle = $('#btn-toggle-sidemenu');

    var showHeaderMenu = function showHeaderMenu(event) {
      if (megamenuOutTimeout) {
        clearTimeout(megamenuOutTimeout);
        megamenuOutTimeout = false;
      }
      var link = $(event.target);
      var targetId = link.data('target');

      if (targetId == undefined) {
        return;
      }
      if (link.hasClass('hover')) {
        _this.closeMegaMenu();
      }
      if (targetId) {
        if (_this.megaMenus.filter(targetId).is(':hidden')) {
          _this.openMegaMenu(targetId);
        }
      }

      _this.megaMenuLink.filter('.hover').removeClass('hover');
      link.addClass('hover');

      _this.adjustMegaTopPos();
      event.preventDefault();
    };

    var hideHeaderMenu = function hideHeaderMenu(event) {
      var mousePageY = event.pageY;
      var currentShowingMenu = _this.megaMenus.filter('.show');
      //handle event for targets which do not have megaMenus to show
      if (!currentShowingMenu.length) {
        return;
      }
      var timeout = 150;
      if (mousePageY > currentShowingMenu.position().top + currentShowingMenu.height()) {
        timeout = 0;
      }
      megamenuOutTimeout = setTimeout(function () {
        _this.closeMegaMenu();
      }, timeout);
    };

    // click to open
    //this.megaMenuLink.on('click.mega',showHeaderMenu);
    this.megaMenuLink.off('click').on('click.mega', showHeaderMenu);

    //this.megaMenus.on('click.mega',showHeaderMenu );

    // click to close
    // this.megaMenuLink.on('click.mega.close', () => {
    //   if (this.megaMenus.filter('.show').length === 0) {
    //     this.megaMenuLink.filter('.hover').removeClass('hover');
    //   }
    // });

    //this.megaMenuLink.on('mouseleave.mega',hideHeaderMenu );


    //this.megaMenus.on('mouseleave.mega', hideHeaderMenu);


    /* this.header.find('#header-brand').on('click.mega.close', () => {
       this.closeMegaMenu();
     });*/
    $('body').on('click.mega.close', function (e) {
      var currentVisibleMenu = _this.megaMenus.filter('.show:not(.animated)');
      if (currentVisibleMenu.length) {
        if (e.pageY > currentVisibleMenu.offset().top + currentVisibleMenu.height()) {
          _this.closeMegaMenu();
        }
      }
    });

    $('.header--mega-navbar-category-content a[data-toggle="tab"]').on('show.bs.tab', function (e) {
      var element = $(e.target);
      var promo = element.data('promo');
      var cat = element.data('promo-cat');
      $('[data-promo-target="' + promo + '"]').find('a[href="#' + cat + '-' + promo + '-promo"]').tab('show');
    });

    /**
     * underline effect when hovering menu item
     */

    var timeoutMouseLeaveNavLeft = false;
    this.navbarLeft.on('click.mega.underline', '.header--mega-navbar-item', function (event) {
      var link = $(event.target);
      var offset = link.position();

      _this.underline.addClass('show').css({
        left: offset.left,
        width: link.outerWidth()
      });
    });

    this.navbarLeft.on('mouseenter', '.header--mega-navbar-item', function (event) {
      if ($('.header--mega-navbar-item-link.hover').length > 0) {
        return;
      } else {
        var link = $(event.target);
        var offset = link.position();
        _this.underline.addClass('show').css({
          left: offset.left,
          width: link.outerWidth()
        });
      }
    });

    this.navbarLeft.on('mouseleave', function () {
      timeoutMouseLeaveNavLeft = setTimeout(function () {
        if (_this.megaMenus.filter('.show').length === 0) {
          _this.underline.removeClass('show');
        }
      }, 500);
    });

    this.megaMenuContainer.on('mouseleave', function () {
      if (timeoutMouseLeaveNavLeft) {
        clearTimeout(timeoutMouseLeaveNavLeft);
      }
    });
  }

  /**
   * adjust top of megamenu
   */


  _createClass(OPSMHeader, [{
    key: 'adjustMegaTopPos',
    value: function adjustMegaTopPos() {
      if (!this.megaMenuContainer.is(':visible')) {
        return;
      }

      var top = 0;
      var currentScrollTop = $(window).scrollTop();

      if (this.header.is('.sticky-ing')) {
        top = this.headersticky.height() + 1;
      } else {
        top = this.header.height() + 1;
      }

      this.megaMenuContainer.css('top', top);
    }

    /**
     * Open megamenu
     * @param {string} id
     */

  }, {
    key: 'openMegaMenu',
    value: function openMegaMenu(id) {
      var _this2 = this;

      // if no mega visible
      var currentVisibleMega = this.megaMenus.filter(':visible');
      var targetMega = this.megaMenus.filter(id);
      $("html, body").css("overflow-y", "hidden");

      if (currentVisibleMega.length === 0) {
        // mark the container as show and animating
        this.megaMenuContainer.addClass('show animating');
        this.adjustMegaTopPos();

        targetMega.animateCss('slideInDown', function () {
          // end all effect
          targetMega.addClass('show');
          _this2.megaMenuContainer.removeClass('animating');
        });
      } else {
        // there is already a mega menu visible
        currentVisibleMega.removeClass('fadeIn').animateCss('fadeOut', function () {
          currentVisibleMega.removeClass('show');
        });

        targetMega.animateCss('fadeIn', function () {
          targetMega.addClass('show');
        });
      }
    }

    /**
     * Close megamenu
     */

  }, {
    key: 'closeMegaMenu',
    value: function closeMegaMenu() {
      var _this3 = this;

      var visibleMenu = this.megaMenus.filter(':visible');
      this.megaMenuContainer.addClass('animating out');
      $("html, body").removeAttr("style");
      visibleMenu.animateCss('slideOutUp', function () {
        _this3.megaMenuContainer.removeClass('show animating out');
        _this3.megaMenus.removeClass('animated slideInDown slideOutUp fadeIn fadeOut show');
      });
      this.megaMenuLink.removeClass('hover');

      this.underline.removeClass('show');
    }
  }], [{
    key: 'getFavList',
    value: function getFavList() {
      return ($('#added-products-favourites').attr('rel') || '').split('_').filter(function (el) {
        return el != '';
      });
    }
  }, {
    key: 'isPendingFavReq',
    value: function isPendingFavReq() {
      return $('#pending-products-favourites').attr('rel') || false;
    }
  }, {
    key: 'setPendingFavReq',
    value: function setPendingFavReq(isPending) {
      $('#pending-products-favourites').attr('rel', isPending);
    }
  }, {
    key: 'updateFavBadge',
    value: function updateFavBadge(increment, catentryId) {
      var increment = increment || 0;
      var catentryId = catentryId || '';
      increment = parseInt(increment);
      //Increase the your favourites count by 1 and show the heart icon accordingly.
      var count = $('#wishlist-total-count').val();
      if (!count || count === '') count = '0';
      $('#wishlist-total-count').val(parseInt(count) + increment);

      var favouritesLn = parseInt($('#wishlist-total-count').val());
      if (favouritesLn > 0) {
        $('#btn-favourite .header--cms-badge').text(favouritesLn).removeClass('d-none');
      } else {
        $('#btn-favourite .header--cms-badge').text('0').addClass('d-none');
      }
      //	  $('#btn-favourite .header--cms-badge').trigger("change");

      if ($('#added-products-favourites').length) {
        var alreadyInFavs = ($('#added-products-favourites').attr('rel') || '').split('_');
        if (increment > 0) {
          alreadyInFavs.push(catentryId + "");
        } else if (increment < 0) {
          alreadyInFavs = alreadyInFavs.filter(function (value, index, arr) {
            return value != catentryId;
          });
        }
        $('#added-products-favourites').attr('rel', alreadyInFavs.join("_"));
      }
    }
  }, {
    key: 'favItemListServerResp',
    value: function favItemListServerResp(resp) {
      var resp = resp || {};
      var totalItems = parseInt(resp.itemsCount || '0');
      if (resp.actualFavItems || false) {
        window.favItemsData = resp.actualFavItems;
        //		  for (const [catentryId, favData] of resp) {
        //			  
        //		  }
      }
      $('#wishlist-total-count').val(totalItems);
      if (totalItems > 0) {
        $('#btn-favourite .header--cms-badge').text(totalItems).removeClass('d-none');
      } else {
        $('#btn-favourite .header--cms-badge').text('0').addClass('d-none');
      }
      //	  $('#btn-favourite .header--cms-badge').trigger("change");
    }
  }]);

  return OPSMHeader;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HomeCarousel = function () {
  function HomeCarousel() {
    var _this = this;

    _classCallCheck(this, HomeCarousel);

    /**
     * Main carousel
     */
    this.carouselMain = $('.carousel');
    this.carouselNav = $('.carousel-nav');
    this.popularProducts = $('.popular-products--inner');
    this.complementProducts = $('.complement-products--inner');
    this.underline = this.carouselNav.find('.carousel-nav--underline');
    this.carouselMain.slick({
      infinite: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      responsive: [{
        breakpoint: 768,
        settings: {
          autoplay: false,
          dots: true
        }
      }]
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      _this.handleUnderline(nextSlide);
      _this.handleNav(nextSlide);
    });

    this.navItem = $('.carousel-nav .carousel-nav--item');

    this.navItem.on('click', function (e) {
      _this.navItem.removeClass('active');
      var item = $(e.target);
      _this.navItem.find(item).addClass('active');
      _this.carouselMain.slick('slickGoTo', _this.navItem.index(item));
      _this.handleUnderline(_this.navItem.index(item));
      _this.handleNav(_this.navItem.index(item));
    });

    var timeOut = void 0;
    $(window).resize(function () {
      clearTimeout(timeOut);
      timeOut = setTimeout(function () {
        var index = _this.carouselMain.slick('slickCurrentSlide');
        _this.handleUnderline(index);
        _this.handleNav(index);
      }, 100);
    });

    this.handleUnderline(0);
    this.handleNav(0);

    /**
     * Popular Product slider
     */
    var slidesToShow = 4;
    if ($("#popular-product-carousel-count").length > 0) {
      try {
        slidesToShow = parseInt($("#popular-product-carousel-count").val());
      } catch (e) {}
    }

    if (!$(".pg-product-detail").length > 0) {
      this.popularProducts.slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        refresh: true,
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 2.1,
            arrows: false,
            dots: true
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.1,
            arrows: false,
            dots: true
          }
        }]
      });
    }

    this.complementProducts.slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  }

  _createClass(HomeCarousel, [{
    key: 'handleNav',
    value: function handleNav(index) {
      this.navItem.removeClass('active').eq(index).addClass('active');
    }
  }, {
    key: 'handleUnderline',
    value: function handleUnderline(index) {
      var item = this.navItem.eq(index);
      if (item.length) {
        this.underline.css({
          left: item.offset().left,
          width: item.outerWidth(),
          opacity: 1
        });
      }
    }
  }]);

  return HomeCarousel;
}();
"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Home = function () {
    function Home() {
        _classCallCheck(this, Home);

        this.brandsWeLoveSliderMobileCls = 'brands-we-love--slider-sm';
        this.brandsWeLoveSliderTabletCls = 'brands-we-love--slider-md';
        this.brandsWeLoveSlider = $('.' + this.brandsWeLoveSliderMobileCls);

        this.brandSlider();
        this.aos();
    }

    /*
    * Brands Slider
    */


    _createClass(Home, [{
        key: 'brandSlider',
        value: function brandSlider() {
            if (!this.brandsWeLoveSlider.data('slick')) {
                this.brandsWeLoveSlider.not('.slick-initialized').slick({
                    arrows: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: false,
                    variableWidth: true
                });
            }
        }

        /*
         * Animate On Scroll Library
         */

    }, {
        key: 'aos',
        value: function aos() {
            AOS.init({
                duration: 1000,
                disable: 'phone'
            });
        }
    }]);

    return Home;
}();
'use strict';

/**
 * OPSM Image src checker
 */
(function ($) {

	var defaultOptions = {
		parentSlideClass: 'slide-inner-wrapper',
		slickSlideClass: 'slick-slide',
		slickInitializedClass: 'slick-initialized'
	};

	function errorImageRemove($_err_img, options) {
		var options = options || {};
		options = $.extend(defaultOptions, options);

		if ($_err_img.closest('.' + options.slickSlideClass).length) {
			var $targetSlide = $_err_img.closest('.' + options.slickSlideClass);
			var $mainSlickInit = $targetSlide.closest('.' + options.slickInitializedClass);
			if ($mainSlickInit.length) {
				$mainSlickInit.slick('slickRemove', $targetSlide.data('slick-index'));
			} else {
				//slick not initialized (destroyed, unslick)

			}
		} else {
			var parentSlideClass = options.parentSlideClass || '';
			if (parentSlideClass.length) {
				$_err_img.closest(parentSlideClass).remove();
			} else {
				$_err_img.remove();
			}
		}
	}
	;
	var pluginRemove = 'imgRemove';
	$.fn[pluginRemove] = function (options) {
		var options = options || {};
		options = $.extend(defaultOptions, options);
		return this.each(function (options) {
			if (this.tagName.toLowerCase() != 'img') return;

			errorImageRemove($(this), options);
		});
	};

	var pluginName = 'checkErrImg';
	$.fn[pluginName] = function (options) {

		var options = options || defaultOptions;
		options = $.extend(defaultOptions, options);
		return this.each(function (options) {
			if (this.tagName.toLowerCase() != 'img') return;

			// store current img
			var $_orig = $(this);
			var url = $_orig.attr('src') || '';
			$.ajax({
				url: url,
				type: "GET",
				statusCode: {
					200: function _(xhr, textStatus, err) {
						$_orig.removeClass('src-err-rem');
					},
					404: function _(xhr, textStatus, err) {
						errorImageRemove($_orig, options);
					}
				},
				error: function error(xhr, textStatus, err) {
					errorImageRemove($_orig, options);
				}
			});
		});
	};
})(jQuery);

$(function () {
	$(document).ready(function () {
		$('img.src-err-rem').one('load', function (e) {
			$(this).checkErrImg();
		});
		$('img.src-err-rem').one('error', function (e) {
			$(this).imgRemove();
		});
		//required for browsers not firing onload event (Firefox)
		setTimeout(function () {
			$('img.src-err-rem').each(function () {
				$(this).attr('src', $(this).attr('src'));
			});
		}, 200);
	});
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ManualInput = function () {
	function ManualInput() {
		_classCallCheck(this, ManualInput);
	}

	_createClass(ManualInput, null, [{
		key: 'suffix',

		//best practice to use frame Ids for ROX
		value: function suffix(_productId, _orderItemId) {
			//TBD if required
			var productId = 'number' === typeof _productId ? '' + _productId : 'string' === typeof _productId ? _productId.trim() : '0';
			var orderItemId = 'number' === typeof _orderItemId ? '' + _orderItemId : 'string' === typeof _orderItemId ? _orderItemId.trim() : '0';
			return '_' + productId + '_' + orderItemId;
		}
	}, {
		key: 'saveExtendedPrescription',
		value: function saveExtendedPrescription(_prescriptionObject, _suffix) {
			var suffix = _suffix || '';
			sessionStorage.setItem("RXPanelSaveLensSelectionExt" + suffix, JSON.stringify(_prescriptionObject));
		}
	}, {
		key: 'loadExtendedPrescription',
		value: function loadExtendedPrescription(_suffix) {
			var suffix = _suffix || '';
			return JSON.parse(sessionStorage.getItem("RXPanelSaveLensSelectionExt" + suffix));
		}
	}, {
		key: 'clearExtendedPrescription',
		value: function clearExtendedPrescription(_suffix) {
			var suffix = _suffix || '';
			sessionStorage.removeItem("RXPanelSaveLensSelectionExt" + suffix);
		}
	}, {
		key: 'isoDateTimeStrToDateStr',
		value: function isoDateTimeStrToDateStr(dateTimeStr) {
			try {
				return new Date(dateTimeStr).toISOString().split('T')[0];
			} catch (e) {
				console.error("ManualInput - isoDateTimeStrToDateStr ", dateTimeStr, e);
				return '';
			}
		}
	}, {
		key: 'trimNumValueTo',
		value: function trimNumValueTo(_numVal, _def) {
			try {
				return isNaN(parseFloat(_numVal)) ? _def : ('' + _numVal).trim();
			} catch (e) {
				console.error("ManualInput - trimNumValueTo ", _numVal, e);
				return _def;
			}
		}
	}, {
		key: 'trimNumValueOneDecimalTo',
		value: function trimNumValueOneDecimalTo(_numVal, _def) {
			try {
				return isNaN(parseFloat(_numVal)) ? _def : '' + parseFloat(_numVal).toFixed(1);
			} catch (e) {
				console.error("ManualInput - trimNumValueOneDecimalTo ", _numVal, e);
				return _def;
			}
		}
	}, {
		key: 'trimNumValueTwoDecimalTo',
		value: function trimNumValueTwoDecimalTo(_numVal, _def) {
			try {
				return isNaN(parseFloat(_numVal)) ? _def : '' + parseFloat(_numVal).toFixed(2);
			} catch (e) {
				console.error("ManualInput - trimNumValueOneDecimalTo ", _numVal, e);
				return _def;
			}
		}
	}, {
		key: 'trimStringValueTo',
		value: function trimStringValueTo(_strVal, _def) {
			try {
				return 'string' === typeof _strVal ? _strVal.trim() : _def;
			} catch (e) {
				console.error("ManualInput - trimStringValueTo ", _strVal, e);
				return _def;
			}
		}
	}, {
		key: 'resolvePD',
		value: function resolvePD(_prescrMI) {
			var prescrMI = _prescrMI || {};
			var resolvedPD = {
				visionType: 'READING' == prescrMI.rxType ? 'NEAR' : 'DISTANCE' == prescrMI.rxType ? 'DISTANCE' : 'PROGRESSIVE' == prescrMI.rxType ? 'NEARDISTANCE' : '',
				//				leftPupDistFar: '',
				//				leftPupDistNear: '',
				//				rightPupDistFar: '',
				//				rightPupDistNear: '',
				leftPupDist: '',
				rightPupDist: '',
				bothPD: ''
			};
			var leftPD = ManualInput.trimNumValueOneDecimalTo((prescrMI.PD || {}).OS, ''),
			    rightPD = ManualInput.trimNumValueOneDecimalTo((prescrMI.PD || {}).OD, '');
			if ('' == leftPD && '' != rightPD) {
				resolvedPD.bothPD = ManualInput.trimNumValueOneDecimalTo(rightPD, '');
			} else {
				//			if('NEAR' == resolvedPD.visionType){
				//				resolvedPD.leftPupDistNear = leftPD;
				//				resolvedPD.rightPupDistNear = rightPD;
				//			} else if('DISTANCE' == resolvedPD.visionType){
				//				resolvedPD.leftPupDistFar = leftPD;
				//				resolvedPD.rightPupDistFar = rightPD;
				//			}  else if('NEARDISTANCE' == resolvedPD.visionType){
				//			}
				resolvedPD.leftPupDist = leftPD;
				resolvedPD.rightPupDist = rightPD;
			}
			return resolvedPD;
		}
	}, {
		key: 'resolvePrism',
		value: function resolvePrism(_prescrMI) {
			var prescrMI = _prescrMI || {};
			/*
   if(prescrMI.PRISM_ENABLED){
   	
   } else {
   	
   }
   */
			var resolvedPrism = {
				leftUDPrism: ManualInput.trimNumValueTwoDecimalTo((prescrMI.VPRISM || {}).OS, ''),
				leftUDPdir: ManualInput.trimStringValueTo(ManualInput.parsePrismDir((prescrMI.VBASEDIR || {}).OS), ''),
				rightUDPrism: ManualInput.trimNumValueTwoDecimalTo((prescrMI.VPRISM || {}).OD, ''),
				rightUDPdir: ManualInput.trimStringValueTo(ManualInput.parsePrismDir((prescrMI.VBASEDIR || {}).OD), ''),

				leftIOPrism: ManualInput.trimNumValueTwoDecimalTo((prescrMI.HPRISM || {}).OS, ''),
				leftIOPdir: ManualInput.trimStringValueTo(ManualInput.parsePrismDir((prescrMI.HBASEDIR || {}).OS), ''),
				rightIOPrism: ManualInput.trimNumValueTwoDecimalTo((prescrMI.HPRISM || {}).OD, ''),
				rightIOPdir: ManualInput.trimStringValueTo(ManualInput.parsePrismDir((prescrMI.HBASEDIR || {}).OD), '')

			};
			resolvedPrism.leftUDPrismFMT = ManualInput.trimStringValueTo(resolvedPrism.leftUDPrism, '-') + ' ' + ManualInput.trimStringValueTo(ManualInput.parsePrismDirFMT(resolvedPrism.leftUDPdir), '');
			resolvedPrism.rightUDPrismFMT = ManualInput.trimStringValueTo(resolvedPrism.rightUDPrism, '-') + ' ' + ManualInput.trimStringValueTo(ManualInput.parsePrismDirFMT(resolvedPrism.rightUDPdir), '');
			resolvedPrism.leftIOPrismFMT = ManualInput.trimStringValueTo(resolvedPrism.leftIOPrism, '-') + ' ' + ManualInput.trimStringValueTo(ManualInput.parsePrismDirFMT(resolvedPrism.leftIOPdir), '');
			resolvedPrism.rightIOPrismFMT = ManualInput.trimStringValueTo(resolvedPrism.rightIOPrism, '-') + ' ' + ManualInput.trimStringValueTo(ManualInput.parsePrismDirFMT(resolvedPrism.rightIOPdir), '');
			if (!isNaN(parseFloat(resolvedPrism.leftUDPrism)) && '' == resolvedPrism.leftUDPdir || isNaN(parseFloat(resolvedPrism.leftUDPrism)) && '' != resolvedPrism.leftUDPdir) {
				console.error("ManualInput - resolvePrism - error: leftUDPrism / leftUDPdir ", resolvedPrism.leftUDPrism, resolvedPrism.leftUDPdir);
			}
			if (!isNaN(parseFloat(resolvedPrism.rightUDPrism)) && '' == resolvedPrism.rightUDPdir || isNaN(parseFloat(resolvedPrism.rightUDPrism)) && '' != resolvedPrism.rightUDPdir) {
				console.error("ManualInput - resolvePrism - error: rightUDPrism / rightUDPdir ", resolvedPrism.rightUDPrism, resolvedPrism.rightUDPdir);
			}
			if (!isNaN(parseFloat(resolvedPrism.leftIOPrism)) && '' == resolvedPrism.leftIOPdir || isNaN(parseFloat(resolvedPrism.leftIOPrism)) && '' != resolvedPrism.leftIOPdir) {
				console.error("ManualInput - resolvePrism - error: leftIOPrism / leftIOPdir ", resolvedPrism.leftIOPrism, resolvedPrism.leftIOPdir);
			}
			if (!isNaN(parseFloat(resolvedPrism.rightIOPrism)) && '' == resolvedPrism.rightIOPdir || isNaN(parseFloat(resolvedPrism.rightIOPrism)) && '' != resolvedPrism.rightIOPdir) {
				console.error("ManualInput - resolvePrism - error: rightIOPrism / rightIOPdir ", resolvedPrism.rightIOPrism, resolvedPrism.rightIOPdir);
			}
			return resolvedPrism;
		}
	}, {
		key: 'parsePrismDir',
		value: function parsePrismDir(_dirString) {
			var mapper = {
				IN: 'BI',
				OUT: 'BO',
				UP: 'BU',
				DOWN: 'BD',
				UKN: ''
			};
			return mapper['string' == typeof _dirString ? _dirString.toUpperCase() : 'UKN'];
		}
	}, {
		key: 'parsePrismDirFMT',
		value: function parsePrismDirFMT(_dirString) {
			var mapper = {
				IN: 'BI(in)',
				OUT: 'BO(out)',
				UP: 'BU(up)',
				DOWN: 'BD(down)',
				BI: 'BI(in)',
				BO: 'BO(out)',
				BU: 'BU(up)',
				BD: 'BD(down)',
				UKN: ''
			};
			return mapper['string' == typeof _dirString ? _dirString.toUpperCase() : 'UKN'];
		}
	}, {
		key: 'toCheckoutPrescr',
		value: function toCheckoutPrescr(_OidLens, _prescrMI) {
			var OidLens = _OidLens || '';
			var prescrMI = _prescrMI || {};
			var resolvedPD = ManualInput.resolvePD(prescrMI);
			var resolvedPrism = ManualInput.resolvePrism(prescrMI);
			var prescr = {
				locked: '0',
				lensproductId: OidLens,
				verified: prescrMI.verified || "1",
				issueDate: ManualInput.isoDateTimeStrToDateStr(prescrMI.issueDate),

				leftSph: ManualInput.trimNumValueTo((prescrMI.SPH || {}).OS, ''),
				rightSph: ManualInput.trimNumValueTo((prescrMI.SPH || {}).OD, ''),
				leftCyl: ManualInput.trimNumValueTo((prescrMI.CYL || {}).OS, ''),
				rightCyl: ManualInput.trimNumValueTo((prescrMI.CYL || {}).OD, ''),
				leftAxis: ManualInput.trimNumValueTo((prescrMI.AX || {}).OS, ''),
				rightAxis: ManualInput.trimNumValueTo((prescrMI.AX || {}).OD, ''),
				leftAdd: ManualInput.trimNumValueTo((prescrMI.ADD || {}).OS, ''),
				rightAdd: ManualInput.trimNumValueTo((prescrMI.ADD || {}).OD, ''),

				leftSegH: '',
				leftOCH: '',
				rightSegH: '',
				rightOCH: '',

				visionType: 'READING' == prescrMI.rxType ? 'NEAR' : 'DISTANCE' == prescrMI.rxType ? 'DISTANCE' : 'PROGRESSIVE' == prescrMI.rxType ? 'NEARDISTANCE' : '',
				//				leftPupDistNear: resolvedPD.leftPupDistNear,
				//				rightPupDistNear: resolvedPD.rightPupDistNear,
				//				leftPupDistFar: resolvedPD.leftPupDistFar,
				//				rightPupDistFar: resolvedPD.rightPupDistFar,
				bothPD: resolvedPD.bothPD,
				leftPupDist: resolvedPD.leftPupDist,
				rightPupDist: resolvedPD.rightPupDist,

				leftUDPrism: resolvedPrism.leftUDPrism,
				leftUDPdir: resolvedPrism.leftUDPdir,
				rightUDPrism: resolvedPrism.rightUDPrism,
				rightUDPdir: resolvedPrism.rightUDPdir,

				leftIOPrism: resolvedPrism.leftIOPrism,
				leftIOPdir: resolvedPrism.leftIOPdir,
				rightIOPrism: resolvedPrism.rightIOPrism,
				rightIOPdir: resolvedPrism.rightIOPdir,

				leftUDPrismFMT: resolvedPrism.leftUDPrismFMT,
				rightUDPrismFMT: resolvedPrism.rightUDPrismFMT,
				leftIOPrismFMT: resolvedPrism.leftIOPrismFMT,
				rightIOPrismFMT: resolvedPrism.rightIOPrismFMT

				//				sapPresRefId: "",
				//				statePrescription: "MC_OK",
				//				filename: "",
				//				expiryDate: "2022-01-01",
				//				fileNameUI: "",
				//				fileSize: ""
			};
			return prescr;
		}
	}, {
		key: 'saveReviewObject',
		value: function saveReviewObject(_reviewObject, _suffix) {
			var reviewObject = _reviewObject || {};
			var suffix = _suffix || '';
			sessionStorage.setItem("RXPanelReviewObject" + suffix, JSON.stringify(reviewObject));
		}
	}, {
		key: 'loadReviewObject',
		value: function loadReviewObject(_suffix) {
			var suffix = _suffix || '';
			return JSON.parse(sessionStorage.getItem("RXPanelReviewObject" + suffix));
		}
	}, {
		key: 'saveRXCartState',
		value: function saveRXCartState(_cartStateObject, _suffix) {
			var cartState = _cartStateObject || {};
			var suffix = _suffix || '';
			sessionStorage.setItem("RXPanelCartState" + suffix, JSON.stringify(cartState));
		}
	}, {
		key: 'loadRXCartState',
		value: function loadRXCartState(_suffix) {
			var suffix = _suffix || '';
			var savedState = sessionStorage.getItem("RXPanelCartState" + suffix);
			if (!savedState) {
				return null;
			}
			try {
				return JSON.parse(savedState);
			} catch (e) {
				console.error("Error during JSON parsing from sessionStorage:", e);
				return null;
			}
		}
	}]);

	return ManualInput;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MapStoreLocator = function () {
  function MapStoreLocator(isNotAutoInit, favoriteMap) {
    var _this2 = this;

    _classCallCheck(this, MapStoreLocator);

    this.elmMap = $('#map');

    if (this.elmMap.length === 0) {
      return;
    }

    this.searchStore = $('#searchStore-find');
    this.btnShowMore = $('#btn-show-more');
    this.storeList = $('.select-store--list-inner');
    this.spinner = $('#load-more-product-spinner');
    this.showMoreWrap = $('.select-store--showmore');
    this.mapWrap = $('.select-store--maps');
    this.mapSticky = $('.select-store--maps--sticky');
    this.btnSelectMap = $('#select-map');
    this.btnBackListMap = $('#back-list-view');
    this.mapInstance = {};
    this.listMarket = [];
    this.storeItem = $('.select-store--item');
    this.btnUseMyLocation = $('#use-my-location');
    this.dataStore = [];
    this.newDataStore = [];

    if (!favoriteMap) {
      this.btnUseMyLocation.on('click', function () {
        _this2.btnUseMyLocation.find('.loading').removeClass('d-none');
        if (navigator.geolocation) {
          try {
            navigator.geolocation.getCurrentPosition(_this2.showPosition.bind(_this2));
          } catch (ex) {
            _this2.useGoogleApiToGetLocation();
          }
        } else {
          _this2.useGoogleApiToGetLocation();
        }
      });
    }
    if (!isNotAutoInit) {
      this.init();
    }
    if (!favoriteMap) {
      this.searchStore.on('submit', function (e) {
        var val = $('#field-booking').val();
        e.preventDefault();
        _this2.handleSearchStore(val);
      });

      this.btnShowMore.on('click', function () {
        _this2.btnShowMore.addClass('d-none');
        _this2.spinner.removeClass('d-none');

        _this2.showMoreStore(function () {
          _this2.btnShowMore.removeClass('d-none');
          _this2.spinner.addClass('d-none');
        });
      });
    } else {
      this.handleFavoriteStore();
    }
    this.btnSelectMap.on('click', function () {
      _this2.mapSticky.addClass('open');
      _this2.storeList.addClass('openMobile');
      $('html').addClass('openMaps');
    });
    this.btnBackListMap.on('click', function () {
      _this2.mapSticky.removeClass('open');
      _this2.storeList.removeClass('openMobile');
      $('html').removeClass('openMaps');
    });
    if (!Modernizr.csspositionsticky) {

      $('.select-store--maps').parent().addClass('filters--ie-wrapper');

      $('.select-store--maps').affix({
        offset: {
          top: function top() {
            return this.top = $('.filters--ie-wrapper').offset().top;
          },
          bottom: function bottom() {
            return this.bottom = $('.footer').outerHeight();
          }
        }
      }).on('affixed.bs.affix', function () {
        var wrapper = $('.filters--ie-wrapper');
        $('.select-store--maps').css({
          'width': wrapper.width(),
          'left': wrapper.offset().left,
          'top': $('.header').outerHeight()
        });
      }).on('affixed-top.bs.affix, affixed-bottom.bs.affix', function () {
        $('.select-store--maps').css({
          'left': '',
          'top': ''
        });
      });
    }

    $(window).scroll(function () {
      if (!Utils.isSmallDesktopAndAbove()) {
        return;
      }

      if (!$('html').is('.csspositionsticky')) {
        return;
      }

      var scrollTop = $(window).scrollTop();
      if ($("body").hasClass("pg-book-eye-test")) {
        var storeContent = $('.select-store').position().top;
      } else {
        var storeContent = $('.select-store--content').position().top;
      }
      var headerStickyHeight = $('.header').is('.sticky-ing') ? $('#opsm-header-sticky').height() : 0;
      var isStickyHeaderHidden = $('#opsm-header-sticky').is('.temp-hidden');
      if (scrollTop >= storeContent - headerStickyHeight && !isStickyHeaderHidden) {
        _this2.mapSticky.css('top', headerStickyHeight);
      } else {
        _this2.mapSticky.css('top', '');
      }
    });
  }

  /**
   * alternative way to get location using google api
   */


  _createClass(MapStoreLocator, [{
    key: 'useGoogleApiToGetLocation',
    value: function useGoogleApiToGetLocation() {
      var _this3 = this;

      $.ajax({
        url: '//www.googleapis.com/geolocation/v1/geolocate?key=' + opsm.core.getGoogleMapsApiKey(),
        type: 'post',
        success: function success(data) {
          if (data.location) {
            var position = {
              coords: {
                latitude: data.location.lat,
                longitude: data.location.lng
              }
            };

            _this3.showPosition(position);
          }
        },
        complete: function complete() {
          _this3.btnUseMyLocation.find('.loading').addClass('d-none');
        }
      });
    }
  }, {
    key: 'showPosition',
    value: function showPosition(position) {
      this.btnUseMyLocation.find('.loading').addClass('d-none');
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;
      var url = '//maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lng + '&sensor=true';

      $.getJSON(url, function (data) {
        if (data.results.length) {
          var address = data.results[0].formatted_address;
          document.getElementById("field-booking").value = address;
          $('#searchStore').submit();
        } else {
          alert('Sorry! We could not locate your position.');
        }
      });
    }

    //this should be used only on select of preferred store

  }, {
    key: 'setMarkerColor',
    value: function setMarkerColor(lat, lng, index) {
      var _this4 = this;

      if (this.listMarket.length > 0) {
        this.listMarket.forEach(function (marker, idx) {
          if (idx == index) {
            _this4.listMarket[idx].setOptions({
              position: new google.maps.LatLng(lat, lng),
              map: _this4.mapInstance,
              icon: {
                url: imageDirectoryPath + 'images/icons/marker_selected.svg',
                labelOrigin: new google.maps.Point(16, 19)
              }
            });
            _this4.mapInstance.panTo(new google.maps.LatLng(lat, lng));
          } else {
            _this4.listMarket[idx].setOptions({
              icon: {
                url: imageDirectoryPath + 'images/icons/marker_default.svg',
                labelOrigin: new google.maps.Point(13, 14)
              }
            });
          }
        });
      }
    }
  }, {
    key: 'handleSearchStore',
    value: function handleSearchStore(val) {
      var _this5 = this;

      this.storeList.empty();
      this.showMoreWrap.addClass('d-none');
      this.newDataStore = [];
      var favoriteStore = [];
      this.removeMarkers();
      if (val.length) {
        $.getJSON('favorite-store.json', function (data) {
          favoriteStore = data;
        });
        $.getJSON('search-store.json', function (data) {
          _this5.dataStore = data;
          var dataShow = data.slice(0, 4);
          dataShow.forEach(function (store, index) {
            var favoriteChk = false;
            favoriteStore.forEach(function (fav, index) {
              if (store.id === fav.id) {
                favoriteChk = true;
              }
            });
            var storeItem = Utils.showStore(store, index, favoriteChk);
            storeItem.animateCss('fadeIn');
            _this5.storeList.append(storeItem);
            _this5.initMarker(store, index);
          });
          if (data.length > 0) {
            _this5.mapWrap.removeClass('d-none');
          } else {
            _this5.mapWrap.addClass('d-none');
          }
          if (data.length >= 4) {
            _this5.showMoreWrap.removeClass('d-none');
          } else {
            _this5.showMoreWrap.addClass('d-none');
          }
          _this5.handleClickStore();
        });
      } else {
        this.storeList.empty();
        this.showMoreWrap.addClass('d-none');
        this.mapWrap.addClass('d-none');
      }
    }
  }, {
    key: 'handleFavoriteStoreAjax',
    value: function handleFavoriteStoreAjax() {
      var _this = this;
      this.storeList.empty();
      this.showMoreWrap.addClass('d-none');
      this.newDataStore = [];
      var favoriteStore = [];
      this.removeMarkers();

      //update to avoid ajax call to non existing resaource
      if (window.getFavStoreAjaxURL) {
        $.getJSON('favorite-store.json', function (data) {
          _this.dataStore = data;
          if (data.length > 0) {
            data.forEach(function (store, index) {
              //console.log(store);
              var storeItem = Utils.showStoreFavorite(store, index);
              storeItem.animateCss('fadeIn');
              _this.storeList.append(storeItem);
              _this.initMarker(store, index);
            });
            if (data.length > 0) {
              _this.mapWrap.removeClass('d-none');
            } else {
              _this.mapWrap.addClass('d-none');
            }
            if (data.length >= 4) {
              _this.showMoreWrap.removeClass('d-none');
            } else {
              _this.showMoreWrap.addClass('d-none');
            }
            _this.handleClickStore();
          } else {
            $('.select-store--list').remove();
            $('.select-store--maps').remove();
          }
        });
      }
    }
  }, {
    key: 'handleFavoriteStore',
    value: function handleFavoriteStore() {
      var _this = this;
      this.storeList.empty();
      this.showMoreWrap.addClass('d-none');
      this.newDataStore = [];
      var favoriteStore = [];
      this.removeMarkers();

      var data = window.favStoreList ? window.favStoreList : [];
      _this.dataStore = data;
      if (data.length > 0) {
        data.forEach(function (store, index) {
          //console.log(store);
          var storeItem = Utils.showStoreFavorite(store, index);
          storeItem.animateCss('fadeIn');
          _this.storeList.append(storeItem);
          _this.initMarker(store, index);
        });
        if (data.length > 0) {
          _this.mapWrap.removeClass('d-none');
        } else {
          _this.mapWrap.addClass('d-none');
        }
        if (data.length >= 4) {
          _this.showMoreWrap.removeClass('d-none');
        } else {
          _this.showMoreWrap.addClass('d-none');
        }
        _this.handleClickStore();
        _this.mapInstance.panTo(new google.maps.LatLng(data[0].lat, data[0].lng));
      } else {
        $('.select-store--list').remove();
        $('.select-store--maps').remove();
      }
    }
  }, {
    key: 'handleClickStore',
    value: function handleClickStore() {
      var that = this;
      $('.select-store--item').click(function (e) {
        var thisJq = $(this);
        //these actions should be done on set preferred success
        //$('.select-store--item').removeClass('select-store--item--selected');
        //thisJq.addClass("select-store--item--selected");
        var idx = thisJq.data('index');
        var lngCur = thisJq.data('lng');
        var latCur = thisJq.data('lat');
        //that.setMarkerColor(latCur,lngCur, idx);
        that.mapInstance.panTo(new google.maps.LatLng(latCur, lngCur));
      });
    }
  }, {
    key: 'initMarker',
    value: function initMarker(store, index) {
      var _this6 = this;

      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(store.lat, store.lng),
        map: this.mapInstance,
        // label: {
        //   text: `${store.id}`,
        //   color: '#fff',
        //   fontFamily: 'ProximaNova-Bold',
        //   fontSize: '14'
        // },
        title: '' + store.nameStreet,
        icon: {
          url: imageDirectoryPath + 'images/icons/marker_default.svg',
          labelOrigin: new google.maps.Point(13, 14)
        },
        url: '' + store.url,
        id: '' + index
      });
      this.listMarket.push(marker);
      marker.addListener('click', function () {
        //this.setMarkerColor(store.lat, store.lng, marker.id);
        _this6.mapInstance.panTo(new google.maps.LatLng(store.lat, store.lng));
        //$('.select-store--item').removeClass('select-store--item--selected');
        //      if(this.newDataStore.length>0){
        //        this.newDataStore.forEach((store, idx)=>{
        //          if(idx == index){
        //            $('.select-store--item').eq(idx).addClass('select-store--item--selected');
        //          }
        //        })
        //      }
      });
    }
  }, {
    key: 'showMoreStore',
    value: function showMoreStore(callback) {
      var _this7 = this;

      var favoriteStore = [];
      $.getJSON('favorite-store.json', function (data) {
        favoriteStore = data;
      });
      var currentStore = this.newDataStore.length;
      var newStoreMore = this.dataStore.slice(currentStore, currentStore + 4);
      if (this.newDataStore.length === this.dataStore.length) {
        this.showMoreWrap.addClass('d-none');
      }
      if (newStoreMore.length) {
        newStoreMore.forEach(function (store, index) {
          var favoriteChk = false;
          favoriteStore.forEach(function (fav, index) {
            if (store.id == fav.id) {
              favoriteChk = true;
            }
          });
          var storeItem = Utils.showStore(store, currentStore + index, favoriteChk);
          storeItem.animateCss('fadeIn');
          _this7.storeList.append(storeItem);
          _this7.initMarker(store, currentStore + index);
          if (typeof callback === 'function') {
            callback.call();
          }
        });
        this.handleClickStore();
      }
    }
  }, {
    key: 'removeMarkers',
    value: function removeMarkers() {
      for (var i = 0; i < this.listMarket.length; i++) {
        this.listMarket[i].setMap(null);
      }
      this.listMarket = [];
    }
  }, {
    key: 'init',
    value: function init() {
      var mapOptions = {
        zoom: 14,
        center: new google.maps.LatLng(-33.868820, 151.209296),
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        styles: [{
          "featureType": "road",
          "elementType": "labels",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "poi",
          "elementType": "labels",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "transit",
          "elementType": "labels.text",
          "stylers": [{
            "visibility": "off"
          }]
        }]
      };
      var mapElement = document.getElementById('map');
      this.mapInstance = new google.maps.Map(mapElement, mapOptions);
    }
  }]);

  return MapStoreLocator;
}();

var AutoCompleteGoogleMapsOmnys = function () {
  function AutoCompleteGoogleMapsOmnys(callbackFunc) {
    var _this8 = this;

    _classCallCheck(this, AutoCompleteGoogleMapsOmnys);

    this.elmInput = $('#field-booking');
    var autocomplete = true;
    if (this.elmInput.length && typeof google === 'undefined') {
      $.getScript('//maps.googleapis.com/maps/api/js?sensor=false&key=' + opsm.core.getGoogleMapsApiKey() + '&language=en&region=' + opsm.core.getCountryCode() + '&libraries=places').done(function (script, status) {
        if (typeof callbackFunc == "function") {
          callbackFunc.call();
        }
      });
    }
    this.elmInput.on('click', function () {
      if (autocomplete) {
        _this8.handleAutocomplete();
        autocomplete = false;
      }
    });
  }

  _createClass(AutoCompleteGoogleMapsOmnys, [{
    key: 'handleAutocomplete',
    value: function handleAutocomplete() {
      var input = document.getElementById('field-booking');
      var autocomplete = new google.maps.places.Autocomplete(input, {
        types: ['geocode'],
        componentRestrictions: {
          'country': 'au'
        }
      });

      autocomplete.addListener('place_changed', function () {
        var result = autocomplete.getPlace();
        if (typeof result.address_components != 'undefined') {
          googlePlaceAutocompleteClick(result);
        }
      });

      function googlePlaceAutocompleteClick(place) {
        //console.log(place)
      }
    }
  }]);

  return AutoCompleteGoogleMapsOmnys;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MapStore = function () {
  function MapStore(isNotAutoInit) {
    var _this = this;

    _classCallCheck(this, MapStore);

    this.elmMap = $('#map');

    if (this.elmMap.length === 0) {
      return;
    }

    this.searchStore = $('#searchStore');
    this.btnShowMore = $('#btn-show-more');
    this.storeList = $('.select-store--list-inner');
    this.spinner = $('#load-more-product-spinner');
    this.showMoreWrap = $('.select-store--showmore');
    this.mapWrap = $('.select-store--maps');
    this.mapSticky = $('.select-store--maps--sticky');
    this.btnSelectMap = $('#select-map');
    this.btnBackListMap = $('#back-list-view');
    this.mapInstance = {};
    this.listMarket = [];
    this.storeItem = $('.select-store--item');
    this.btnUseMyLocation = $('#use-my-location');
    this.dataStore = [];
    this.newDataStore = [];

    this.btnUseMyLocation.on('click', function () {
      _this.btnUseMyLocation.find('.loading').removeClass('d-none');
      if (navigator.geolocation) {
        try {
          navigator.geolocation.getCurrentPosition(_this.showPosition.bind(_this));
        } catch (ex) {
          console.log(ex);
          _this.useGoogleApiToGetLocation();
        }
      } else {
        _this.useGoogleApiToGetLocation();
      }
    });
    if (!isNotAutoInit) {
      this.init();
    }
    this.searchStore.on('submit', function (e) {
      var val = $('#field-booking').val();
      e.preventDefault();
      _this.handleSearchStore(val);
    });

    this.btnShowMore.on('click', function () {
      _this.btnShowMore.addClass('d-none');
      _this.spinner.removeClass('d-none');

      _this.showMoreStore(function () {
        _this.btnShowMore.removeClass('d-none');
        _this.spinner.addClass('d-none');
      });
    });
    this.btnSelectMap.on('click', function () {
      _this.mapSticky.addClass('open');
      _this.storeList.addClass('openMobile');
      $('html').addClass('openMaps');
    });
    this.btnBackListMap.on('click', function () {
      _this.mapSticky.removeClass('open');
      _this.storeList.removeClass('openMobile');
      $('html').removeClass('openMaps');
    });
    if (!Modernizr.csspositionsticky) {

      $('.select-store--maps').parent().addClass('filters--ie-wrapper');

      $('.select-store--maps').affix({
        offset: {
          top: function top() {
            return this.top = $('.filters--ie-wrapper').offset().top;
          },
          bottom: function bottom() {
            return this.bottom = $('.footer').outerHeight();
          }
        }
      }).on('affixed.bs.affix', function () {
        var wrapper = $('.filters--ie-wrapper');
        $('.select-store--maps').css({
          'width': wrapper.width(),
          'left': wrapper.offset().left,
          'top': $('.header').outerHeight()
        });
      }).on('affixed-top.bs.affix, affixed-bottom.bs.affix', function () {
        $('.select-store--maps').css({
          'left': '',
          'top': ''
        });
      });
    }

    $(window).scroll(function () {
      if (!Utils.isSmallDesktopAndAbove()) {
        return;
      }

      if (!$('html').is('.csspositionsticky')) {
        return;
      }

      var scrollTop = $(window).scrollTop();
      if ($("body").hasClass("pg-book-eye-test")) {
        var storeContent = $('.select-store').position().top;
      } else {
        var storeContent = $('.select-store--content').position().top;
      }
      var headerStickyHeight = $('.header').is('.sticky-ing') ? $('#opsm-header-sticky').height() : 0;
      var isStickyHeaderHidden = $('#opsm-header-sticky').is('.temp-hidden');
      if (scrollTop >= storeContent - headerStickyHeight && !isStickyHeaderHidden) {
        _this.mapSticky.css('top', headerStickyHeight);
      } else {
        _this.mapSticky.css('top', '');
      }
    });
  }

  /**
   * alternative way to get location using google api
   */


  _createClass(MapStore, [{
    key: 'useGoogleApiToGetLocation',
    value: function useGoogleApiToGetLocation() {
      var _this2 = this;

      $.ajax({
        url: '//www.googleapis.com/geolocation/v1/geolocate?key=' + opsm.core.getGoogleMapsApiKey(),
        type: 'post',
        success: function success(data) {
          if (data.location) {
            var position = {
              coords: {
                latitude: data.location.lat,
                longitude: data.location.lng
              }
            };

            _this2.showPosition(position);
          }
        },
        complete: function complete() {
          _this2.btnUseMyLocation.find('.loading').addClass('d-none');
        }
      });
    }
  }, {
    key: 'showPosition',
    value: function showPosition(position) {
      this.btnUseMyLocation.find('.loading').addClass('d-none');
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;
      var url = '//maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lng + '&sensor=true';

      $.getJSON(url, function (data) {
        if (data.results.length) {
          var address = data.results[0].formatted_address;
          document.getElementById("field-booking").value = address;
          $('#searchStore').submit();
        } else {
          alert('Sorry! We could not locate your position.');
        }
      });
    }
  }, {
    key: 'setMarkerColor',
    value: function setMarkerColor(lat, lng, index) {
      var _this3 = this;

      if (this.listMarket.length > 0) {
        this.listMarket.forEach(function (marker, idx) {
          if (idx == index) {
            _this3.listMarket[idx].setOptions({
              position: new google.maps.LatLng(lat, lng),
              map: _this3.mapInstance,
              icon: 'images/icons/marker_selected.svg'
            });
            _this3.mapInstance.panTo(new google.maps.LatLng(lat, lng));
          } else {
            _this3.listMarket[idx].setOptions({
              icon: 'images/icons/marker_default.svg'
            });
          }
        });
      }
    }
  }, {
    key: 'handleSearchStore',
    value: function handleSearchStore(val) {
      var _this4 = this;

      this.storeList.empty();
      this.showMoreWrap.addClass('d-none');
      this.newDataStore = [];
      this.removeMarkers();
      if (val.length) {
        $.getJSON('search-store.json', function (data) {
          var _newDataStore;

          _this4.dataStore = data;
          var dataShow = data.slice(0, 4);
          (_newDataStore = _this4.newDataStore).push.apply(_newDataStore, _toConsumableArray(dataShow));
          dataShow.forEach(function (store, index) {
            var storeItem = Utils.showStore(store, index);
            storeItem.animateCss('fadeIn');
            _this4.storeList.append(storeItem);
            _this4.initMarker(store, index);
          });
          if (data.length > 0) {
            _this4.mapWrap.removeClass('d-none');
          } else {
            _this4.mapWrap.addClass('d-none');
          }
          if (data.length >= 4) {
            _this4.showMoreWrap.removeClass('d-none');
          } else {
            _this4.showMoreWrap.addClass('d-none');
          }
          _this4.handleClickStore();
        });
      } else {
        this.storeList.empty();
        this.showMoreWrap.addClass('d-none');
        this.mapWrap.addClass('d-none');
      }
    }
  }, {
    key: 'handleClickStore',
    value: function handleClickStore() {
      var that = this;
      $('.select-store--item').click(function (e) {
        var thisJq = $(this);
        $('.select-store--item').removeClass('select-store--item--selected');
        thisJq.addClass("select-store--item--selected");
        var idx = thisJq.data('index');
        var lngCur = thisJq.data('lng');
        var latCur = thisJq.data('lat');
        that.setMarkerColor(latCur, lngCur, idx);
        // close infobox
        if (that.prev_infowindow) {
          that.prev_infowindow.close();
        }
      });
    }
  }, {
    key: 'initMarker',
    value: function initMarker(store, index) {
      var _this5 = this;

      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(store.lat, store.lng),
        map: this.mapInstance,
        // label: {
        //   text: `${store.id}`,
        //   color: '#fff',
        //   fontFamily: 'ProximaNova-Bold',
        //   fontSize: '14'
        // },
        title: '' + store.nameStreet,
        icon: 'images/icons/marker_default.svg',
        url: '' + store.url,
        id: '' + index
      });
      this.listMarket.push(marker);
      var infowindow = new google.maps.InfoWindow({
        maxWidth: 200
      });
      this.prev_infowindow = null;
      marker.addListener('click', function () {
        var templateInfo = '\n      <div class="info-window">\n        <h5>' + marker.title + '</h5>\n        <div class="address">\n          <p>' + store.address + ', Tel: ' + store.tel + '</p>\n          <a href="' + marker.url + '">Select store</a>\n        </div>\n      </div>';
        if (_this5.prev_infowindow) {
          _this5.prev_infowindow.close();
        }
        _this5.setMarkerColor(store.lat, store.lng, marker.id);
        infowindow.setContent(templateInfo);
        infowindow.open(marker.get('map'), marker);
        _this5.prev_infowindow = infowindow;
        _this5.mapInstance.panTo(new google.maps.LatLng(store.lat, store.lng));
        $('.select-store--item').removeClass('select-store--item--selected');
        if (_this5.newDataStore.length > 0) {
          _this5.newDataStore.forEach(function (store, idx) {
            if (idx == index) {
              $('.select-store--item').eq(idx).addClass('select-store--item--selected');
            }
          });
        }
      });
      this.mapInstance.addListener('click', function () {
        infowindow.close();
      });
    }
  }, {
    key: 'showMoreStore',
    value: function showMoreStore(callback) {
      var _newDataStore2,
          _this6 = this;

      var currentStore = this.newDataStore.length;
      var newStoreMore = this.dataStore.slice(currentStore, currentStore + 4);
      (_newDataStore2 = this.newDataStore).push.apply(_newDataStore2, _toConsumableArray(newStoreMore));
      if (this.newDataStore.length === this.dataStore.length) {
        this.showMoreWrap.addClass('d-none');
      }
      if (newStoreMore.length) {
        newStoreMore.forEach(function (store, index) {
          var storeItem = Utils.showStore(store, currentStore + index);
          storeItem.animateCss('fadeIn');
          _this6.storeList.append(storeItem);
          _this6.initMarker(store, currentStore + index);
          if (typeof callback === 'function') {
            callback.call();
          }
        });
        this.handleClickStore();
      }
    }
  }, {
    key: 'removeMarkers',
    value: function removeMarkers() {
      for (var i = 0; i < this.listMarket.length; i++) {
        this.listMarket[i].setMap(null);
      }
      this.listMarket = [];
    }
  }, {
    key: 'init',
    value: function init() {
      var mapOptions = {
        zoom: 14,
        center: new google.maps.LatLng(-33.868820, 151.209296),
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        styles: [{
          "featureType": "road",
          "elementType": "labels",
          "stylers": [{ "visibility": "off" }]
        }, {
          "featureType": "poi",
          "elementType": "labels",
          "stylers": [{ "visibility": "off" }]
        }, {
          "featureType": "transit",
          "elementType": "labels.text",
          "stylers": [{ "visibility": "off" }]
        }]
      };
      var mapElement = document.getElementById('map');
      if (mapElement) {
        this.mapInstance = new google.maps.Map(mapElement, mapOptions);
      }
    }
  }]);

  return MapStore;
}();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Medipass = function () {
	function Medipass(initUrl) {
		_classCallCheck(this, Medipass);

		this.initUrl = initUrl || "OPSMInitiateMedipass";
	}

	_createClass(Medipass, [{
		key: "createPaymentSession",
		value: function createPaymentSession(data) {
			return this.callServer(this.initUrl, data);
		}
	}, {
		key: "callServer",
		value: function callServer(url, data, dataType) {
			return $.ajax({
				type: "POST",
				dataType: dataType || "json",
				url: url,
				data: data || {}
			});
		}
		/* handling errors also in http success response*/

	}], [{
		key: "successCreateSessionHandler",
		value: function successCreateSessionHandler(responseData, status, xhr) {
			if (responseData.paymentRequestUrl && responseData.paymentRequestUrl.length) {
				return $.Deferred().resolve(responseData, status, xhr);
			} else {
				console.error(responseData.errorKeyMedipass, responseData.errorMessageKey, responseData.errorMessageParam, responseData.exceptionData, responseData.errorMessage);
				var showMsg = Medipass.MessageMapping(responseData.errorKeyMedipass || "" + responseData.errorCode + responseData.errorMessageKey); // || exceptionData.errorKeyMedipass
				return $.Deferred().reject(responseData, status, xhr, showMsg);
			}
		}
	}, {
		key: "MessageMapping",
		value: function MessageMapping(key) {
			var _key = key || "DEFAULT";
			var defMsg = "An error occurred with Tyro Health. Please try again later, or change payment method.";
			var invalidCart = "We can only process health fund rebates for prescription eyewear and contact lenses. Please amend your cart if you wish to claim on your health fund at checkout.";
			var invalidPrescription = "We can only process health fund rebates with a valid prescription.";
			var _msmMap = {
				DEFAULT: defMsg,
				_PAYMENT_FORB_ERR_INVALID_CART: invalidCart,
				_PAYMENT_FORB_ERR_NOT_OK_CP_PRESCR: invalidPrescription,
				_PAYMENT_FORB_ERR_PAY_METH_DIS: defMsg
			};
			return _msmMap[key] || defMsg;
		}
	}]);

	return Medipass;
}();
'use strict';

/**
 * Init Parallax blocks
 */
;(function ($) {
    $(function () {
        /**
         * Fix Parallax when document height change
         */
        $('[data-parallax]').paroller();
        var currentDocumentHeight = $(document).height();
        setInterval(function () {
            if ($(document).height() !== currentDocumentHeight) {
                $(window).triggerHandler('resize');
                currentDocumentHeight = $(document).height();
            }
        }, 1000);
    });
})(jQuery);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentMethod = function () {
	function PaymentMethod() {
		_classCallCheck(this, PaymentMethod);

		var _this = this;
		this.paymethod = $('#payment-method-options');
		this.paymethodWrap = $('#payment-method-wrapper');

		if (this.paymethod.length === 0) {
			return;
		}

		this.paymethodWrap.hide();
		this.getField();
		this.paymethod.on('change', function () {
			_this.paymethodWrap.hide();
			_this.getField();
		});
	}

	_createClass(PaymentMethod, [{
		key: 'getCC',
		value: function getCC() {}
	}, {
		key: 'getField',
		value: function getField() {
			var selActually = $('[name="payment-method-options"]').val();
			var _this2 = this;

			var params = {};
			$.ajax({
				type: "POST",
				url: "WalletProcess",
				async: false,
				data: {},
				dataType: 'json',
				success: function success(responseData) {
					var payments = responseData.paymentMethods;
					if (payments.length > 0) {
						payments.forEach(function (payment) {

							var providerName = "Payment";
							switch (payment.paymentTypeEnum.value) {
								case "001":
									providerName = "visa";
									break;
								case "002":
									providerName = "mc";
									break;
								case "003":
									providerName = "amex";
									break;
								case "004":
									providerName = "paypal";
									break;
							}

							$('#cc_brand').val(payment.paymentTypeEnum.value);

							var id = payment.sno + ":" + providerName + ":" + payment.subscriptionId;

							if (id.startsWith(selActually)) {
								if (providerName === "paypal") {
									$('#card-name').html(payment.cardName);
								} else {
									var dateSplit = payment.expiryDate.split(" ");
									$('#card-name').html(payment.cardName);
									$('#billing-expires').html(dateSplit[1] + " " + dateSplit[5]);
								}
							}
						});

						_this2.paymethodWrap.show();
					}
				}
			});
		}
	}, {
		key: 'getExpiryDate',
		value: function getExpiryDate(card) {
			return card.expiryMonth + '/' + card.expiryYear;
		}
	}]);

	return PaymentMethod;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import { ZoomNode, ZOOM_MIN, ZOOM_MAX } from "./zoom";
//var currentMobileSpritespin;

var PDP = function () {
    function PDP(reload) {
        var _this2 = this;

        _classCallCheck(this, PDP);

        if (!$('.pg-product-detail').length) {
            return;
        }
        this.upc = $('#analyticsPDPUpc').val() || "";
        this.isReload = reload || false;
        this.hasInventoryCheck = $('#hasInventoryCheck').val();
        this.isContactLensBrand = $('#isContactLensBrand').val();
        this.btnAddToCart = $('.product--add-to-cart-btn');
        this.formCheckAvailability = $('.product--form-check-availability');
        this.listAvailabilityStatus = $('.product--availability-list');
        var productSliderMainClass = '.product--slider-main';
        this.productSliderMain = $(productSliderMainClass);
        this.productSliderNav = $('.product--slider-nav');
        //        this.spriteSpinProduct = $('#spritespin-product');
        //        this.spriteSpinProductTablet = $('#spritespin-product-tb');
        //        this.spriteSpinProductMobile = $('#spritespin-product-mb');
        //        currentMobileSpritespin = this.spriteSpinProductMobile;
        var spriteSpinCoverClass = '.product--slider-main-cover';
        var sliderDesktopCoverClass = '.product--slider-main-cover--dt';
        this.sliderDesktopCover = $(sliderDesktopCoverClass);
        this.sliderMobileCover = $('.product--slider-main-cover--mb');
        this.reviewShortcut = $('.product--info-area ƒl.product--rating-stars');
        this.complimentSlider = $('#pdp-product-compliment');
        this.lightboxSlideshow = $('#lightbox-slideshow');
        this.colorSelectors = $('.product--thumbnail-color-selectors');
        this.subscribeBox = $('.product--contact-subs-box');
        this.colorSlider = $(".product--thumbnail-colors ul");
        this.colorWrapper = $(".product--thumbnail-colors");

        this.zn = null;
        this.containerEl = document.getElementById("modal-zoom");
        this.zoomInBtn = document.getElementById("zoom-in");
        this.zoomOutBtn = document.getElementById("zoom-out");

        this.zoomTransition = "transform 0.4s ease-out";
        this.zoomed = false;
        this.scale = 1.0;

        this.defaultSpriteSpinOptions = {
            responsive: true,
            animate: false,
            frameTime: 80,
            sense: 1,
            senseLane: 1
        };

        this.formCheckAvailability.validate({
            rules: {
                postcode: {
                    required: true,
                    digits: true
                }
            },
            errorPlacement: function errorPlacement(error, element) {
                error.addClass('invalid-feedback');
                error.insertAfter(element.parent());
            },
            highlight: function highlight(element, errorClass, validClass) {
                $(element).parent().addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function unhighlight(element, errorClass, validClass) {
                $(element).parent().removeClass(errorClass).addClass(validClass);
            },
            submitHandler: function submitHandler() {
                var postCode = _this2.formCheckAvailability.find('#postcode').val();

                $.getJSON('product-availability.json', function (data) {
                    var html = '';
                    var _clickCollect$availab = {
                        clickCollect: 'Click & Collect available at ',
                        availableAt: 'Available at ',
                        NA: 'Not available at ',
                        outOfStock: 'This product is not available near you, please contact customer care on 1800 626 300 for AU or search another post code'
                    },
                        clickCollect = _clickCollect$availab.clickCollect,
                        availableAt = _clickCollect$availab.availableAt,
                        NA = _clickCollect$availab.NA,
                        outOfStock = _clickCollect$availab.outOfStock;

                    var resultAvailableAt = '';
                    var resultClickCollect = '';
                    var resultNA = '';

                    function getStore() {
                        for (var i = 0; i < data.length; i++) {
                            var storeName = '<a href="#"><strong>' + data[i].store + '</strong></a>';
                            if (data[i].available) {
                                if (data[i].clickAndCollect) {
                                    resultClickCollect = clickCollect + ' ' + storeName;
                                } else {
                                    resultAvailableAt = availableAt + ' ' + storeName;
                                }
                            } else {
                                resultNA = NA + ' ' + storeName;
                            }
                        }
                        return '<div><span class="icon icon-check"></span>' + resultAvailableAt + '</div>\n                        <div><span class="icon icon-check"></span>' + resultClickCollect + '</div>\n                        <div><span class="icon icon-cross"></span>' + resultNA + '</div>';
                    }

                    if (data.length != 0 && postCode != 2000) {
                        html = getStore();
                    } else {
                        html = '<div><span class="icon icon-cross"></span>' + outOfStock + '</div>';
                    }
                    _this2.listAvailabilityStatus.empty().html(html);
                });
            }
        });

        if (this.hasInventoryCheck && opsm && opsm.InventoryCheckManager && "function" === typeof opsm.InventoryCheckManager.getCustomInventoryAsync) {

            opsm.InventoryCheckManager.getCustomInventoryAsync($('#analyticsPDPUpc').val()).then(function (result, txtStatus) {
                _this2.hidePdpSkeleton();
                _this2.fetchCustInvSuccess(result, txtStatus);
                _this2.createProductImagesSlider();
            }).catch(function (xhr, txtStatus, error) {
                _this2.hidePdpSkeleton();
                PDP.fetchCustInvErr(xhr, txtStatus, error);
                _this2.createProductImagesSlider();
            });

            $('#fit-size-select button').not('.isCurrent').each(function () {
                var upc = $(this).data('upc') || "";
                upc = "" + upc;
                var that = this;
                if (upc.length) {
                    opsm.InventoryCheckManager.getCustomInventoryAsync(upc).then(PDP.fetchCustInvSuccessSize);
                    //.catch(PDP.fetchCustInvErr);
                }
            });
        } else {
            PDP.fetchCustInvErr(null, "error", "Missing inventory manager - opsm.InventoryCheckManager.getCustomInventoryAsync not defined");
        }

        if (this.isContactLensBrand == "true") {
            analyticsFramework.module.pdp.asyncAddCustomInventory(this.upc, 1, 1);
        }

        /* Fallback hide skeleton */
        setTimeout(function () {
            _this2.hidePdpSkeleton();
            _this2.createProductImagesSlider();
        }, 3000);

        /**
         * on mobile, auto fadeout the cover after 3 seconds
         */

        setTimeout(function () {
            _this2.sliderMobileCover.fadeOut();
        }, 3000);

        if ($(window).width() > 768 && this.colorSlider.find('li').length > 6) {
            this.colorSlider.not('.slick-initialized').slick({
                dots: false,
                infinite: false,
                slidesToShow: 6,
                slidesToScroll: 1

            });
        } else if ($(window).width() <= 768 && this.colorSlider.find('li').length > 5) {
            //WAS
            /*
            this.colorSlider.not('.slick-initialized').slick({
            	dots: false,
            	infinite: false,
            	slidesToShow: 5,
            	slidesToScroll: 1,
            }); */

            this.colorWrapper.addClass("fluid-slider");
            this.colorWrapper.prepend('<button type="button" class="arrow-prev" style="display: none;"></button>');
            this.colorWrapper.append('<button type="button" class="arrow-next"></button>');
            var sliderWidth = $(".product--thumbnail-color-selectors")[0].scrollWidth;
            this.colorSelectors.on("scroll", function () {
                var currentScrollLeft = $(".product--thumbnail-color-selectors").scrollLeft();
                var deltaScroll = sliderWidth - currentScrollLeft;
                if (deltaScroll == $(".product--thumbnail-color-selectors").width()) {
                    $(".fluid-slider .arrow-next").hide();
                } else {
                    $(".fluid-slider .arrow-next").show();
                }
                if (currentScrollLeft > 60) {
                    $(".fluid-slider .arrow-prev").show();
                } else {
                    $(".fluid-slider .arrow-prev").hide();
                }
            });

            $('.arrow-next').on("click", function () {
                var closest;
                var currentScrollLeft = $(".product--thumbnail-color-selectors").scrollLeft() + 8;
                $('.product--thumbnail-color-selector').each(function () {
                    var slideOffset = $(this)[0].offsetLeft;
                    if (slideOffset > currentScrollLeft) {
                        if (closest == null || Math.abs(slideOffset - currentScrollLeft) < Math.abs(closest - currentScrollLeft)) {
                            closest = slideOffset;
                        }
                    }
                });
                $(".product--thumbnail-color-selectors").animate({
                    scrollLeft: closest
                }, 100);
            });

            $('.arrow-prev').on("click", function () {
                var closest;
                var currentScrollLeft = $(".product--thumbnail-color-selectors").scrollLeft() - 8;
                $('.product--thumbnail-color-selector').each(function () {
                    var slideOffset = $(this)[0].offsetLeft;
                    if (slideOffset < currentScrollLeft) {
                        if (closest == null || Math.abs(slideOffset - currentScrollLeft) < Math.abs(closest - currentScrollLeft)) {
                            closest = slideOffset;
                        }
                    }
                });
                $(".product--thumbnail-color-selectors").animate({
                    scrollLeft: closest
                }, 100);
            });
        }

        if ($(".contact-lenses").length > 0) {
            // OPSMD-14113
            // if ($(window).width() >= 768) {
            //     $(".contact-lenses .product--sidebar-col").niceScroll({
            //         autohidemode: "hidden",
            //         cursorwidth: "0px",
            //         railoffset: {
            //             top: 0,
            //             left: -16
            //         }
            //     });
            // } else {
            //     $("#product--sidebar-col").getNiceScroll().remove()
            // }

            //            $("#prescr-sel-pdp, #add-to-cart-pdp").on('click', function () {
            //
            //                $([document.documentElement, document.body]).animate({
            //                    scrollTop: $(".product--prescription").offset().top
            //                }, 200);
            //
            //                $('.product--sidebar-col').getNiceScroll().doScrollPos(0, $('.product--prescription').position().top);
            //            });

            $("#full-image-container").addClass("fixed-header").css("width", $("#full-image-body").width() + "px");
            $(".breadcrumbtrail").addClass("fixed-header fixed-animation");
            $(window).on("scroll", function () {
                var currentBotPos = $(window).scrollTop() + $(window).height();
                var sidebarBotPos = $("#product--sidebar-col").offset().top + $("#product--sidebar-col").outerHeight();
                if (currentBotPos <= sidebarBotPos) {
                    if ($(".header--sticky").hasClass("temp-hidden")) {
                        $(".breadcrumbtrail").addClass("fixed-animation");
                        $("#full-image-container").addClass("fixed-0").removeClass("fixed-header absolute-top");
                        $(".breadcrumbtrail").removeAttr("style").addClass("fixed-0").removeClass("fixed-header absolute-top");
                    } else {
                        $("#full-image-container").removeClass("fixed-0 absolute-top").addClass("fixed-header");
                        $(".breadcrumbtrail").removeAttr("style").removeClass("fixed-0 absolute-top").addClass("fixed-header");
                    }
                } else {
                    var topPosSlide;
                    if ($(".header--sticky").hasClass("temp-hidden")) {
                        topPosSlide = $(".contact-lenses .product--slider-main").offset().top - 153;
                    } else {
                        topPosSlide = $(".contact-lenses .product--slider-main").offset().top;
                    }
                    $("#full-image-container").removeClass("fixed-0 fixed-header").addClass("absolute-top");
                    $(".breadcrumbtrail").css("top", topPosSlide + "px").removeClass("fixed-0 fixed-header fixed-animation").addClass("absolute-top");
                }
            });
        }

        if ($(".equivalent-widget").length > 0) {
            $("#full-image-body").addClass('equivalent');
            if ($(window).width() <= 768 && $(".single-equivalent").length > 1) {
                $(".equivalent-widget").not('.slick-initialized').slick({
                    dots: false,
                    infinite: false,
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                    arrows: false
                });
            }
            if ($(window).width() > 768) {
                if ($(".single-equivalent").length > 2) {
                    $(".equivalent-widget").not('.slick-initialized').slick({
                        dots: false,
                        infinite: false,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false
                    });
                } else if ($(".single-equivalent").length == 1) {
                    $(".equivalent-widget").addClass('col-12-grid');
                } else {
                    $(".equivalent-widget").removeClass('col-12-grid');
                }
            }
        }

        /**
         * on click header rating stars, scroll to review sections
         */
        this.reviewShortcut.on('click', function () {
            $('#collapseReviews').collapse('show');
            $('html, body').animate({
                scrollTop: $('.product--details-info').position().top
            });
        });

        /**
         * compliment products slider
         */
        this.complimentSlider.not('.slick-initialized').slick({
            dots: false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }]
        });

        /**
         * trigger to open lightbox gallery on tablet
         */
        $('[data-open-lightbox]').on('click', function () {
            if (Utils.isTablet()) {
                _this2.lightboxSlideshow.modal('show');
            }
        });

        // setup CSS variable for attributes layout
        if ($(".attribute-wrapper").length > 0) {
            $(".attribute-wrapper").attr('style', '--attrCount:' + Math.floor($(".attribute-wrapper")[0].childElementCount / 2));
        }
        /**
         * on lightbox showing up, refresh the sprite spin,
         * because sprite spin cannot init if it's hidden
         */
        /*
        this.lightboxSlideshow.on('shown.bs.modal', () => {
            this.lightboxSlideshow.find('.product--slider-main, .product--slider-nav').slick('setPosition');
            this.lightboxSlideshow.find('.product--slider-nav')
                .slick('slickSetOption', 'slidesToShow', 5, true);
             if (this.spriteSpinProductTablet.length) {
                this.spriteSpinProductTablet.css({
                        'padding-top': (this.spriteSpinProduct.data('height') / this.spriteSpinProduct.data('width') * 100) + '%'
                    })
                    .spritespin(jQuery.extend({
                        source: this.spriteSpinProduct.data('images').split(',')
                    }, this.defaultSpriteSpinOptions));
            }
        });
        */

        /* OPSMD-7652 - Fix accordion reposition on mibile: now when the user toggles the accordion cards in mobile view, 
        there will be an animation in which the active card will be scrolled right below the sticky header 
        NB: this fix will affect the PDP info-accordion only */
        if ($(window).width() <= 768) {
            $('#info-accordion .collapse').on('show.bs.collapse', function (e) {
                var $card = $(this).closest('.card');
                var $open = $($(this).data('parent')).find('.collapse.show');

                var additionalOffset = 0;

                if ($card.prevAll().filter($open.closest('.card')).length !== 0) {
                    additionalOffset = $open.height();
                }
                $('html,body').animate({
                    scrollTop: $card.offset().top - additionalOffset - 150
                }, 200);
            });
        }

        /**
         * change product colors
         */
        this.colorSelectors.on('click', 'a', function (e) {
            /*
               const a = $(e.target).closest('a');
               const li = a.parent();
               const color = a.data('color');
                li.addClass('active').siblings().removeClass('active');
                $.getJSON('pdp-111-' + color + '.json', (data) => {
                   this.updateProductOnColor(data);
               });
               */
        });

        /**
         * inserted in prescription.js
         *
        this.subscribeBox.on('change', 'input[type="checkbox"]', (e) => {
            $('.product--after-pay').toggleClass('d-none', e.target.checked);
        });*/

        /**
         * Landscape detection
         */
        $(window).on('orientationchange', function () {
            var degree = window.orientation;
            var mobileBreakpoint = 576;
            var windowHeight = $(window).outerHeight();
            var screenHeight = screen.width < screen.height ? screen.width : screen.height;
            var height = windowHeight < screenHeight ? windowHeight : screenHeight;

            if (degree === 90 || degree === -90) {
                if (height < mobileBreakpoint) {
                    $('html').addClass('opsm-landscape');
                    setTimeout(function () {
                        $(".product--slider-mobile .product--slider-main-cover--dt").fadeOut();
                    }, 2000);
                }
            } else {
                $('html').removeClass('opsm-landscape');
            }
        });

        /*
         * Adjust top of sticky area when scrolling
         */
        this.adjustTopSticky();
        PDP.handleShopButtons();
        attachAjaxLoadEvent(this);
        if (this.isContactLensBrand) {
            this.setupPrescriptionObserver();
        }
    }

    _createClass(PDP, [{
        key: 'hidePdpSkeleton',
        value: function hidePdpSkeleton() {
            $('.product--info-area .sk-visible').removeClass('sk-visible').addClass('sk-invisible');
            $('.product--info-area .content-invisible').removeClass('content-invisible').addClass('content-visible');
        }
    }, {
        key: 'setupPrescriptionObserver',
        value: function setupPrescriptionObserver() {
            var _this3 = this;

            var $prescriptionDiv = $('.product--prescription');
            if ($prescriptionDiv.length === 0) return;

            if (!$prescriptionDiv.hasClass('loader')) {
                this.hidePdpSkeleton();
                this.createProductImagesSlider();
                return;
            }

            var prescriptionElement = $prescriptionDiv[0];

            var prescriptionObserver = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        var $target = $(mutation.target);
                        if (!$target.hasClass('loader')) {
                            prescriptionObserver.disconnect();
                            _this3.hidePdpSkeleton();
                            _this3.createProductImagesSlider();
                        }
                    }
                });
            });

            prescriptionObserver.observe(prescriptionElement, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }, {
        key: 'reload',
        value: function reload() {
            var reload = true;
            this.constructor(reload);
        }

        /**
         * update product detail page on selecting color
         * @param {object} data color of product data
         */

    }, {
        key: 'updateProductOnColor',
        value: function updateProductOnColor(data) {
            // update image source
            $('[data-pdp-update="image"]').attr('src', data.image);

            $('[data-pdp-update="color"]').html(data.color);

            // update price
            $('[data-pdp-update="sprites"]').data('images', data.sprites.join(',')).spritespin(jQuery.extend({
                source: data.sprites
            }, this.defaultSpriteSpinOptions));

            // update price
            $('[data-pdp-update="price"]').html(data.price);

            // update size
            var sizeOptiosHtml = '';
            for (var i = 0; i < data.size.length; i++) {
                sizeOptiosHtml += '<option value="' + data.size[i] + '">' + data.size[i] + '</option>';
            }
            $('[data-pdp-update="size"]').html(sizeOptiosHtml).hybridSelect('buildDropdownMenu');
        }

        /*
         * Adjust top of sticky area when scrolling
         */

    }, {
        key: 'adjustTopSticky',
        value: function adjustTopSticky() {
            var sideBar = $('.product--info-right');
            var infoArea = $('.product--info-area');
            var header = $('.header');
            var opsmHeaderSticky = $('#opsm-header-sticky');
            var productPrescription = $('.product--prescription');

            // if (!Modernizr.csspositionsticky) {
            //     sideBar.affix({
            //         offset: {
            //             top: function () {
            //                 const infoAreaOffsetTop = infoArea.offset().top;
            //                 return (this.top = infoAreaOffsetTop);
            //             },
            //             bottom: function () {
            //                 const infoAreaOffsetBottom = sideBar.parent().offset().top + sideBar.parent().outerHeight();
            //                 const bottom = $(document).height() - infoAreaOffsetBottom;
            //                 return (this.bottom = bottom);
            //             }
            //         }
            //     }).on('affixed.bs.affix', () => {
            //         sideBar.css({
            //             width: sideBar.parent().width() - 30
            //         });
            //     }).on('affixed-top.bs.affix, affixed-bottom.bs.affix', () => {
            //         sideBar.css({
            //             width: ''
            //         });
            //     });
            // }

            $(window).scroll(function () {
                if (!Utils.isTabletAndAbove()) {
                    return;
                }

                /**
                 * As per the new CR, main menu is sticky, so assigning header height to
                 * sidebar top position value.
                 */
                // const headerStickyHeight = header.is('.sticky-ing') ? opsmHeaderSticky.height() : 0;
                var headerStickyHeight = opsmHeaderSticky.height();
                var isStickyHeaderHidden = opsmHeaderSticky.is('.temp-hidden');

                // if (!Modernizr.csspositionsticky) {
                //     // legacy browser
                //     if (sideBar.is('.affix') && !isStickyHeaderHidden) {
                //         sideBar.css('top', headerStickyHeight);
                //     } else {
                //         sideBar.css('top', '');
                //     }
                // } else {
                //     // modern browser
                //     const scrollTop = $(window).scrollTop();
                //     const contentInfo = infoArea.position().top;

                //     if (scrollTop >= (contentInfo - headerStickyHeight) && !isStickyHeaderHidden) {
                //         sideBar.css('top', headerStickyHeight);
                //     } else {
                //         sideBar.css('top', '');
                //     }
                // }
            });
        }

        /*
         * handle shop buttons when scrolling
         */

    }, {
        key: 'fetchCustInvSuccess',
        value: function fetchCustInvSuccess(data, txtStatus) {
            if (data.errorCode || data.errorMessage) {
                console.warn("AjaxCatalogEntryInventory", data.errorMessage, data.errorCode);
                PDP.showCtaOnStock($('#available-wrapper'));
                $('#analyticsPDPAvailable').val("Available");
                $('#analyticsOOSOptions').val("");
                /*
                if(data.results && data.results.length && !this.isRealod) {
                	var result = data.results[0];
                	analyticsFramework.asyncAddCustomInventory(this.partNumber,
                			"A",
                			"111");
                }
                */
            } else if (data.hasOwnProperty("quantity") || data.hasOwnProperty("active")) {
                console.log("AjaxCatalogEntryInventory", "Result", data);
                var result = data;

                if (result.quantity > 0) {
                    //is available product
                    PDP.showCtaOnStock($('#available-wrapper'));
                    PDP.showHideBackInStockBadge(result.backInStock);
                    $('#analyticsPDPAvailable').val("Available");
                    $('#analyticsOOSOptions').val("");
                } else if (result.active === 1) {
                    PDP.showCtaOnStock($('#oos-wrapper'));
                    $('#analyticsPDPAvailable').val("Out-of-stock");
                    $('#analyticsOOSOptions').val("FindStore");
                } else if (result.active === 0) {
                    PDP.showCtaOnStock($('#disco-wrapper'));
                    $('#analyticsPDPAvailable').val("Not-for-sale");
                    $('#analyticsOOSOptions').val("FindStore");
                } else {
                    PDP.showCtaOnStock($('#available-wrapper'));
                    PDP.showHideBackInStockBadge(result.backInStock);
                    $('#analyticsPDPAvailable').val("Available");
                    $('#analyticsOOSOptions').val("");
                }
                //add inventory informations analytics
                if (!(this.isReload || pdp.isReload || window.pdp.isReload)) {
                    analyticsFramework.module.pdp.asyncAddCustomInventory(result.partNumber, result.active, result.quantity);
                } else {
                    analyticsFramework.module.pdp.asyncPDPProductUpdate(result.partNumber, result.active, result.quantity);
                }
            }
            PDP.handleShopButtons();
        }
    }, {
        key: 'activateZoom',
        value: function activateZoom(isZoomed) {
            if (!isZoomed) {
                this.scale = 1.0;
                var img = this.containerEl.querySelector(".slick-current img");
                this.zn = new ZoomNode(img);
            }
            return !isZoomed;
        }
    }, {
        key: 'onItemChange',
        value: function onItemChange(item, index) {
            // Destroy previous zoom and make a new one
            if (this.zn) {
                this.zn.destroy();
                this.scale = 1.0;
                this.updateZoomButtons();
                var img = item.querySelector("img");
                this.zn = new ZoomNode(img);
                this.zoomed = true;
            }
        }
    }, {
        key: 'initZoom',
        value: function initZoom() {
            var _this = this;
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
            $('#modal-zoom').modal();
            Utils.blockPageScroll(true);
            if (!$("#slide-zoom").hasClass("slick-initialized")) {
                $("#slide-zoom").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    adaptiveHeight: true,
                    infinite: true,
                    swipeToSlide: true,
                    vertical: true,
                    verticalSwiping: true,
                    dots: true,
                    responsive: [{
                        breakpoint: 768,
                        settings: {

                            swipe: false,

                            adaptiveHeight: false,
                            vertical: false,
                            verticalSwiping: false,

                            variableWidth: true,
                            customPaging: function customPaging(slick, index) {
                                var targetImage = slick.$slides.eq(index).find('img').attr('src');
                                return '<div><img crossorigin="anonymous" src=" ' + targetImage + '?impolicy=OP_PDP_thumb "/></div>'; // OPSMD-14622
                            }
                        }
                    }]

                }).on('afterChange', function (event, slick, currentSlide) {
                    var galleryItems = document.querySelector("#slide-zoom");
                    var currSlideEl = galleryItems.querySelector("div.slick-slide[data-slick-index='" + currentSlide + "']");
                    if ($(window).width() > 768) {
                        slick.setOption('touchThreshold', 5);
                        slick.setOption('swipe', true);
                        slick.setOption('swipeToSlide', true);
                    }
                    _this.onItemChange(currSlideEl);
                }).on('wheel', Utils.onSliderWheel);
            }
            $("#slide-zoom").slick('refresh');
            var mainIndex = $("#slide-main").slick('slickCurrentSlide');
            $("#slide-zoom").slick('slickGoTo', mainIndex, true);

            this.activateZoom(this.zoomed);

            // Bind each image to zoom activation 

            // galleryItems.querySelectorAll('.slick-slide img').forEach((el) => {
            //     el.addEventListener("click", function (event) {
            //         // Don't activate again
            //         if (!zoomed) {
            //             zoomed = activateZoom(zoomed);
            //         }
            //     })
            // });

            // if (this.zoomInBtn) {
            //     var _this = this;
            //     this.zoomInBtn.addEventListener("click", function (event) {
            //         _this.scale += 1.0;
            //         _this.updateZoomButtons();
            //         _this.zn.zoom(_this.scale, _this.zoomTransition);
            //     });
            // }

            // if (this.zoomOutBtn) {
            //     var _this = this;
            //     this.zoomOutBtn.addEventListener("click", function (event) {
            //         //DEBUG && log("zoomOutBtn")
            //         _this.scale -= 1.0;
            //         _this.updateZoomButtons();
            //         _this.zn.zoom(_this.scale, _this.zoomTransition);
            //     });
            // }

            // Helpers 
        }
    }, {
        key: 'zoomInFunction',
        value: function zoomInFunction() {
            var _this = this;
            _this.scale += 0.5;
            if (_this.scale > ZOOM_MAX) {
                _this.scale = ZOOM_MAX;
            }
            _this.updateZoomButtons();
            _this.zn.zoom(_this.scale, _this.zoomTransition);
        }
    }, {
        key: 'zoomOutFunction',
        value: function zoomOutFunction() {
            var _this = this;
            _this.scale -= 0.5;
            if (_this.scale < ZOOM_MIN) {
                _this.scale = ZOOM_MIN;
            }
            _this.updateZoomButtons();
            _this.zn.zoom(_this.scale, _this.zoomTransition);
        }
    }, {
        key: 'updateButton',
        value: function updateButton(button, value) {
            var _this = this;
            console.log(_this.scale);
            if (_this.scale == value) {
                button.setAttribute("disabled", "");
            } else {
                button.removeAttribute("disabled");
            }
        }
    }, {
        key: 'updateZoomButtons',
        value: function updateZoomButtons() {
            this.updateButton(this.zoomInBtn, ZOOM_MAX);
            this.updateButton(this.zoomOutBtn, ZOOM_MIN);
        }
    }, {
        key: 'destroyZoom',
        value: function destroyZoom() {
            if (this.zn) {
                this.zn.destroy();
                this.scale = 1.0;
                this.updateZoomButtons();
            }
            Utils.blockPageScroll(false);
            $("#slide-zoom").slick('unslick');
            $('#modal-zoom').modal('hide');
        }
    }, {
        key: 'createProductImagesSlider',
        value: function createProductImagesSlider() {
            var partnumber = $('#image_partn').val() || $('[data-analytics-sku]').data('analytics-sku');
            var productSliderMainClass = ".product--slider-main";
            $(productSliderMainClass).each(function (i, slide) {
                var isMobile = Utils.isMobile();
                var isCL = $(".contact-lenses").length > 0;
                var checkVertical = !isMobile && !isCL;
                var checkArrows = !isMobile;
                $(slide).data('slider-length', $(slide).children().length);
                $(slide).not('.slick-initialized').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: checkArrows,
                    adaptiveHeight: true,
                    // asNavFor: '.product--slider-nav',
                    infinite: false,
                    swipe: isMobile,
                    swipeToSlide: true,
                    draggable: false,
                    vertical: checkVertical,
                    verticalSwiping: checkVertical,
                    dots: true
                }).on('afterChange', function (event, slick, currentSlide) {
                    console.log(slick);
                    $(event.target).data('current-slide', currentSlide);
                    // Search for playing video
                    var videos = slick.$slides.find('.video-js');
                    videos.each(function (i, vid) {
                        var videoPlayer = videojs(vid);
                        videoPlayer.pause();
                    });
                    var currSlide = $(slick.$slides[currentSlide]);
                    // if (currSlide.find('.video-js').length) {
                    //     const video = currSlide.find('.video-js')[0];
                    //     const videoPlayer = videojs(video);
                    //     videoPlayer.play();
                    // }
                    /**
                     * after changing slide, revert slick options
                     */
                    slick.setOption('touchThreshold', 5);
                    slick.setOption('swipe', true);
                    slick.setOption('swipeToSlide', true);
                    $(".product--slider-nav").find(".slick-slide[data-index=" + currentSlide + "]");
                    $(".product--slider-nav").find(".slick-slide[data-slick-index=" + currentSlide + "]").addClass("selected");
                });
            });

            /**
             * product thumbnail slider
             */
            $('.product--slider-nav').on('init', function (event, slick) {
                slick.$slides.filter('[data-slick-index="0"]').addClass('selected');
            });

            $('.product--slider-nav').not('.slick-initialized').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                // asNavFor: '.product--slider-main',
                focusOnSelect: false,
                infinite: true
            });
            $('.product--slider-nav').on('click', '.thumb', function () {
                var index = $(this).data('index');
                var slideId = $(this).closest('[data-main-slide]').data('main-slide');
                var slide = $(slideId);
                slide.slick('slickGoTo', index);
                $(this).closest('.slick-slide').addClass('selected').siblings().removeClass('selected');
            });

            if ($(".pdp-video-wrapper").length) {
                opsm.utils.initCustomVideo(".pdp-video-wrapper");
            }
        }
    }], [{
        key: 'handleShopButtons',
        value: function handleShopButtons() {
            if ($(".add-to-cart-btn--sticky-bar:visible").length > 0 && $("body.giftcard").length == 0) {
                var stickybarInitialHeight = $(".add-to-cart-btn--sticky-bar").outerHeight();
                var addToCartBtnTopPos = $(".add-to-cart-btn--sticky-bar").offset().top;
                var addToCartBtnBotPos = addToCartBtnTopPos + stickybarInitialHeight;
                var footerTopPos = $(".footer").offset().top;
                var headerTotalHeight = $(".header-wrapper").outerHeight();

                $(window).on('scroll', function () {

                    // addToCartBtnBotPos = $(".add-to-cart-btn--wrapper").offset().top + stickybarInitialHeight;
                    $(".product--info-area").css("padding-bottom", stickybarInitialHeight + "px");

                    if ($(".header--sticky").hasClass("temp-hidden")) {
                        var currentTopPos = $(window).scrollTop();
                    } else {
                        var currentTopPos = $(window).scrollTop() + headerTotalHeight;
                    }
                    var currentBotPos = $(window).scrollTop() + $(window).height();
                    footerTopPos = $(".footer").offset().top;
                    if (currentTopPos >= addToCartBtnBotPos) {

                        if (currentBotPos >= footerTopPos) {

                            if ($(".add-to-cart-btn--sticky-bar").hasClass("sticky") || $(".add-to-cart-btn--sticky-bar").hasClass("sticky-ing")) {
                                if ($(".add-to-cart-btn--sticky-bar").parent().hasClass("add-to-cart-btn--wrapper")) {
                                    $(".add-to-cart-btn--sticky-bar").prependTo(".product--info-area");
                                }
                                if (!$(".product--info-area").hasClass("position-relative")) {
                                    $(".product--info-area").addClass("position-relative");
                                }
                                $(".add-to-cart-btn--sticky-bar").removeClass("sticky");
                                $(".add-to-cart-btn--sticky-bar").removeClass("sticky-ing");
                                if (!$(".add-to-cart-btn--sticky-bar").hasClass("absolute")) {
                                    $(".add-to-cart-btn--sticky-bar").addClass("absolute");
                                }
                            }
                        } else {
                            if ($(".add-to-cart-btn--sticky-bar").parent().hasClass("add-to-cart-btn--wrapper")) {
                                $(".add-to-cart-btn--sticky-bar").prependTo(".product--info-area");
                            }
                            if (!$(".add-to-cart-btn--sticky-bar").hasClass("sticky-ing")) {
                                $(".add-to-cart-btn--sticky-bar").addClass("sticky-ing");
                            }
                            if (!$(".add-to-cart-btn--sticky-bar").hasClass("sticky")) {
                                if ($(".add-to-cart-btn--sticky-bar").hasClass("absolute")) {
                                    $(".add-to-cart-btn--sticky-bar").addClass("sticky");
                                    $(".add-to-cart-btn--sticky-bar").removeClass("absolute");
                                } else {
                                    setTimeout(function () {
                                        $(".add-to-cart-btn--sticky-bar").addClass("sticky");
                                    }, 0);
                                }
                            }
                            // if (!$(".add-to-cart-btn--wrapper").hasClass("fixed-height")) {
                            $(".add-to-cart-btn--wrapper").css("height", stickybarInitialHeight + "px");
                            // }
                        }
                    } else {
                        if ($(".add-to-cart-btn--sticky-bar").hasClass("sticky") || $(".add-to-cart-btn--sticky-bar").hasClass("sticky-ing")) {
                            $(".add-to-cart-btn--sticky-bar").removeClass("sticky");
                            if ($(".add-to-cart-btn--sticky-bar").hasClass("sticky-ing")) {
                                setTimeout(function () {
                                    $(".add-to-cart-btn--sticky-bar").removeClass("sticky-ing");
                                    $(".add-to-cart-btn--sticky-bar").prependTo(".add-to-cart-btn--wrapper");
                                }, 100);
                            }
                        }
                        // if ($(".add-to-cart-btn--wrapper").hasClass("fixed-height")) {
                        // $(".add-to-cart-btn--wrapper").removeAttr("style");
                        // }
                    }
                });
            }
            //handling for virtual mirror in virtual-mirror-manager.js
        }
    }, {
        key: 'showCtaOnStock',
        value: function showCtaOnStock($element) {
            if ($element && $($element).length) {
                var handledElements = $('#oos-wrapper, #disco-wrapper, #available-wrapper');
                handledElements.addClass('d-none');
                $element.removeClass('d-none');
                handledElements.not($element).remove();
            }
        }
    }, {
        key: 'showHideBackInStockBadge',
        value: function showHideBackInStockBadge(isShow) {
            $('.pdp-badge-list .back-stock-badge').toggleClass('d-none', !isShow);
        }
    }, {
        key: 'fetchCustInvSuccessSize',
        value: function fetchCustInvSuccessSize(data, txtStatus) {
            if (data.errorCode || data.errorMessage) {
                console.warn("AjaxCatalogEntryInventory", data.errorMessage, data.errorCode);
            } else if (data.hasOwnProperty("partNumber") && (data.hasOwnProperty("quantity") || data.hasOwnProperty("active"))) {
                var result = data;

                if (result.quantity > 0) {
                    //is available product
                } else if (result.active === 1) {
                    //is OOS
                    $('#fit-size-select button[data-upc="' + data.partNumber + '"]').addClass('js-gr-oos');
                } else if (result.active === 0) {
                    //is DISCO
                    $('#fit-size-select button[data-upc="' + data.partNumber + '"]').addClass('js-gr-oos');
                }
            }
        }
    }, {
        key: 'fetchCustInvErr',
        value: function fetchCustInvErr(xhr, txtStatus, err) {
            console.warn("AjaxCatalogEntryInventory", err);
            PDP.showCtaOnStock($('#available-wrapper'));
            $('#analyticsPDPAvailable').val("Available");
            PDP.handleShopButtons();
        }
    }]);

    return PDP;
}();

function ajaxPageLoad(href, options) {
    function hashCode(str) {
        var hash = 0,
            i,
            chr;
        for (i = 0; i < str.length; i++) {
            chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
    var _options = {
        elements: [],
        preserveChildElements: [],
        texts: [],
        attributes: {},
        changeHistory: true,
        onLoad: function onLoad() {}
    };
    _options = $.extend(_options, options);
    $.ajax({
        cache: true,
        url: href,
        type: 'GET',
        dataType: 'html',
        beforeSend: function beforeSend() {
            window.pdpAjaxReqStarted = true;
        },
        success: function success(data) {

            var $NewPage = $(data),
                $Page = $('body');
            //browser history and page title
            if (_options.changeHistory) {
                var titleText = $NewPage.filter('title').text();
                history.replaceState(hashCode(href), titleText, href);
                document.title = titleText;
            }
            //elements
            for (var index in _options.elements) {
                var originSelector = _options.elements[index];
                var $replacement = $(originSelector, $NewPage);
                var $current = $(originSelector, $Page);
                //check if contains a protected element
                var protectedElementsSel = [];
                for (var idx in _options.preserveChildElements) {
                    var preserveSelector = _options.preserveChildElements[idx];
                    if ($current.children(preserveSelector).length) {
                        protectedElementsSel.push(preserveSelector);
                        if ($replacement.children(preserveSelector).length) {
                            $replacement.children(preserveSelector).replaceWith($current.children(preserveSelector).clone());
                        } else {
                            //TODO should be added somehow in same position
                        }
                    }
                }
                if (protectedElementsSel.length) {
                    var toUpdateChild = $current.children();
                    var toReplaceChild = $replacement.children();
                    protectedElementsSel.forEach(function (val, i, arr) {
                        toUpdateChild = toUpdateChild.not(val);
                        toReplaceChild = toReplaceChild.not(val);
                    });
                    $(toUpdateChild).each(function (idx, orig) {
                        $(this).remove();
                    });
                    $(toReplaceChild).each(function (idx, orig) {
                        $current.append($(this));
                    });
                } else if ($replacement.length) {
                    $(originSelector, $Page).replaceWith($replacement);
                } else {
                    $current.remove();
                }
            }

            if (typeof _options['onLoad'] == 'function') _options['onLoad']();
        }
    });
}

function ajaxPageLoad_caller(href) {
    window.pdpAjaxReqStacked = href || '';

    if (!(window.pdpAjaxReqStarted || false)) {
        $(document).trigger('pdp:ajax-before-reload');
        var elementL = ['[data-slot-id="2"]', '[data-slot-id="3"]', '[data-slot-id="4"]', '#accordion', '#pdp-info-container'];
        ajaxPageLoad(href, {
            // last elements are needed to load correctly analytics product
            elements: elementL,
            preserveChildElements: ['#virtual-mirror-wrapper', '#modal-vm-policy', '#modal-vm-snap'],
            texts: [],
            attributes: {},
            changeHistory: true,
            onLoad: function onLoad() {
                // reload all features
                if (typeof currentMobileSpritespin !== "undefined" && currentMobileSpritespin !== null && currentMobileSpritespin.length > 0) {
                    currentMobileSpritespin.spritespin("destroy");
                }
                $('[data-toggle="hybridSelect"]').hybridSelect();
                /* 
                 * check generic initialization performed at 
                 * //OPSMStorefrontAssetStore/assets-src/js/opsm-theplayhouse.js
                */
                window.pdp.reload();
                window.sizingAndFit = new SizingAndFit();
                window.pdpAjaxReqStarted = false;
                window.pdpAjaxReqStacked = window.pdpAjaxReqStacked.replace(href, '');
                $(document).trigger('pdp:ajax-reloaded');

                $(document).ready(function () {
                    analyticsFramework.module.pdp.setPDPParams(true);
                });
            }
        });
    }
}

function attachAjaxLoadEvent(that) {
    //listener to hadle ajax page reload stack on complete
    $(document).off('pdp:ajax-reloaded.pdpCore').on('pdp:ajax-reloaded.pdpCore', function () {
        $('#virtual-mirror-wrapper').trigger('pdp:vm:ajax-reloaded');
        setTimeout(function () {
            $(".slick-initialized").slick("reinit");
        }, 500);
        if (window.pdpAjaxReqStacked && window.pdpAjaxReqStacked.length && !(window.pdpAjaxReqStarted || false)) {
            ajaxPageLoad_caller(window.pdpAjaxReqStacked);
            window.pdpAjaxReqStacked = '';
        } else {
            //if all calls are completed, remove loaders
            that.colorSelectors.find('.js-gr-loading').removeClass('js-gr-loading');
        }
    });

    /*
     * listeners for ajax page reload triggers
     */
    //swatch buttons thumbs
    $("[data-slot-id='4'] .ajaxReload li:not('.isCurrent') a").on('click', function (e) {
        if (!$(this).hasClass('dropdown-item')) {
            $(this).closest('li').closest('ul').find('li').removeClass('js-gr-loading');
            $(this).closest('li').addClass('js-gr-loading');

            ajaxPageLoad_caller(this.href);
        }
        e.preventDefault();
    });
    //size selector and GiftCard upc selector
    $("[data-slot-id='4'] .ajaxReload #fit-size-select button").not('.isCurrent').click(function (e) {
        ajaxPageLoad_caller($(this).data("url"));
        e.preventDefault();
    });
    //reload for moco selectors inside VirtualMirror (mobile)
    $("[data-slot-id='3']").on('afterChange', '.ajaxReload#virtual-mirror-variants', function (event, slick, currentSlide) {
        var $slide = $(slick.$slides.get(currentSlide));
        var slideUpc = $slide.find('.variant-slide').data('upc');
        var slideUrl = $slide.find('.variant-slide').data('url');
        var pdpUpc = $('#image_partn').val() || $('#analyticsPDPUpc').val() || $('[data-analytics-upc]').data('analytics-upc');
        //do not reload when same upc
        if (slideUpc != pdpUpc) {
            ajaxPageLoad_caller(slideUrl);
            event.preventDefault();
        }
    });
}
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PLP = function () {
    function PLP() {
        var _this = this;

        _classCallCheck(this, PLP);

        if ($('#products-listing-list').length === 0) {
            return;
        }
        this.productListingList = $('#products-listing-list');
        this.sortFilterEle = $('.sort-filter-mb');
        this.headerSticky = $('.header--sticky');
        this.placeholder = $('.sort-filter-mb--pos-placeholder');
        this.btnLoadMore = $('#btn-show-more');
        this.spinner = $('#load-more-product-spinner');

        var scrollTop = $(window).scrollTop();
        var direction = 'down';

        $(window).scroll(function () {
            if ($(window).scrollTop() > scrollTop) {
                direction = 'down';
            } else {
                direction = 'up';
            }

            scrollTop = $(window).scrollTop();

            if (direction === 'down') {
                _this.destroyFixPos();
            } else {
                if (scrollTop < _this.placeholder.offset().top - _this.headerSticky.height()) {
                    _this.destroyFixPos();
                } else {
                    _this.initFixPos();
                }
            }
        });

        $(window).on("resize", function () {
            if (Utils.isMobile()) {
                $('.vto-toggle').prependTo($(".grid-view-wrapper"));
            } else {
                $('.vto-toggle').prependTo($(".sorting-wrapper"));
            }
        });

        if (Utils.isMobile()) {
            $('.vto-toggle').prependTo($(".grid-view-wrapper"));
        } else {
            $('.vto-toggle').prependTo($(".sorting-wrapper"));
        }

        $(".product--colors--slider").each(function () {
            $(this).slick({
                dots: false,
                arrows: true
            });
        });
        $(".product--colors--slider").on('afterChange', function (event) {
            var activeSlide = $(event.target).find('.slick-active');
            // console.log($(activeSlide).find('.product--color-item'));
            Product.changeProductColor(activeSlide);
        });

        $("#grid-view-chk").on("click", function () {
            $('.products-listing--list').toggleClass('list-view');
            $('.product--colors--slider').each(function () {
                $(this)[0].slick.refresh();
            });
        });
        // this.btnLoadMore.on('click', () => {
        //     this.btnLoadMore.addClass('d-none');
        //     this.spinner.removeClass('d-none');
        //
        //     this.loadProducts(() => {
        //         this.btnLoadMore.removeClass('d-none');
        //         this.spinner.addClass('d-none');
        //     });
        // });
    }

    // loadProducts(callback) {
    //     $.getJSON('productListing.json', (data) => {
    //         /**
    //          * @todo: this is fake loading more products
    //          */
    //         data.forEach(prod => {
    //             const product = Utils.showProduct(prod);
    //             product.animateCss('fadeIn');
    //             this.productListingList.append(product);
    //         });
    //
    //         const numberText = $('.products-listing--showing-product-number');
    //         const current = parseInt(numberText.text(), 10);
    //         numberText.text(current + data.length);
    //
    //         if (typeof callback === 'function') {
    //             callback.call();
    //         }
    //     });
    // }

    _createClass(PLP, [{
        key: 'initFixPos',
        value: function initFixPos() {
            this.sortFilterEle.addClass('sticky');
        }
    }, {
        key: 'destroyFixPos',
        value: function destroyFixPos() {
            this.sortFilterEle.removeClass('sticky');
        }
    }]);

    return PLP;
}();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PrescriptionLeadTime = function () {
  function PrescriptionLeadTime() {
    _classCallCheck(this, PrescriptionLeadTime);

    this.leadTimeReq = 0;
    this.delayForMultipleChange = 100;
    if ($(".main-container .product--info-area.contact-lenses").length) {
      var _this = this;
      $(document).on("change", ".prescription-table select:not(#right-boxes,#left-boxes)", function (e) {
        var name = $(this).attr("name");
        var eye = name.indexOf("right") !== -1 ? "right" : "left";
        if (0 != _this.leadTimeReq) {
          clearTimeout(_this.leadTimeReq);
        }
        _this.leadTimeReq = setTimeout(function () {
          if (_this.allPrescriptionFieldsSelected(eye)) {
            _this.checkInput(eye);
          }
        }, _this.delayForMultipleChange);
      });
    }
  }

  _createClass(PrescriptionLeadTime, [{
    key: "showMessage",
    value: function showMessage(msg) {
      $("#cl-combination-error-leadtime-message").html(msg);
      $(".cl-combination-error-leadtime").show();
    }
  }, {
    key: "clearMessage",
    value: function clearMessage() {
      $("#cl-combination-error-leadtime-message").html("");
      $(".cl-combination-error-leadtime").hide();
    }
  }, {
    key: "allPrescriptionFieldsSelected",
    value: function allPrescriptionFieldsSelected(type) {
      var eyeSelector = "select#" + type;
      //	  let prescription = $('.product--prescription');
      var prescription = $('.prescription-table');
      //	  let boxes = prescription.find(eyeSelector + '-boxes');
      //	  let power = prescription.find(eyeSelector + '-power');
      //	  let bc = prescription.find(eyeSelector + '-bc');
      //	  let dia = prescription.find(eyeSelector + '-dia');
      //	  let cyl = prescription.find(eyeSelector + '-cyl');
      //	  let axis = prescription.find(eyeSelector + '-axis');
      //	  let add = prescription.find(eyeSelector + '-add');
      //	  let color = prescription.find(eyeSelector + '-color');
      var availableSelect = prescription.find(eyeSelector + '-power,' + eyeSelector + '-bc,' + eyeSelector + '-dia,' + eyeSelector + '-cyl,' + eyeSelector + '-axis,' + eyeSelector + '-add,' + eyeSelector + '-color');
      var returnValue = true;
      availableSelect.each(function () {
        if (!$(this).val()) {
          returnValue = false;
        }
      });
      //	  return availableSelect.length >0 && returnValue;
      return returnValue;
    }
  }, {
    key: "checkInput",
    value: function checkInput(type) {
      var _this = this;
      var _lensEye = "select#" + type;
      var _notSelectableLensEye = "input#" + type;
      var _boxes = $(_lensEye + "-boxes").val();
      var boxes = parseInt(_boxes);
      if (isNaN(boxes) || boxes < 1) {
        _this.clearMessage();
        return false; //first step: check quantity
      }

      var power = $(_lensEye + "-power").val() || $(_notSelectableLensEye + "-power").val();
      var bc = $(_lensEye + "-bc").val() || $(_notSelectableLensEye + "-bc").val();
      var dia = $(_lensEye + "-dia").val() || $(_notSelectableLensEye + "-dia").val();
      var cyl = $(_lensEye + "-cyl").val() || $(_notSelectableLensEye + "-cyl").val();
      var axis = $(_lensEye + "-axis").val() || $(_notSelectableLensEye + "-axis").val();
      var add = $(_lensEye + "-add").val() || $(_notSelectableLensEye + "-add").val();
      var color = $(_lensEye + "-color").val() || $(_notSelectableLensEye + "-color").val();

      var ajaxGetData = {
        productId: $("#parentCatentryIdforLens").val(),
        storeId: WCParamJS.storeId,
        langId: WCParamJS.langId
      };

      var checkLeadTime = true;
      if (typeof power !== "undefined") {
        ajaxGetData["spherePower"] = power;
        if (power === null) checkLeadTime = false;
      }
      if (typeof bc !== "undefined") {
        ajaxGetData["baseCurve"] = bc;
        if (bc === null) checkLeadTime = false;
      }
      if (typeof dia !== "undefined") {
        ajaxGetData["diameter"] = dia;
        if (dia === null) checkLeadTime = false;
      }
      if (typeof cyl !== "undefined") {
        ajaxGetData["cylinder"] = cyl;
        if (cyl === null) checkLeadTime = false;
      }
      if (typeof axis !== "undefined") {
        ajaxGetData["axis"] = axis;
        if (axis === null) checkLeadTime = false;
      }
      if (typeof add !== "undefined") {
        ajaxGetData["addPower"] = add;
        if (add === null) checkLeadTime = false;
      }
      if (typeof color !== "undefined") {
        ajaxGetData["tintColor"] = color;
        if (color === null) checkLeadTime = false;
      }

      if (checkLeadTime) {
        _this.clearMessage();
        $.ajax({
          url: "/AjaxPrescriptionLeadTime",
          data: ajaxGetData,
          cache: true,
          success: function success(results) {
            var isValid = results["isLeadtime"];
            if (results !== null && isValid === true) {
              var message = "Sorry, this product has a longer lead time than usual. <span class='font-weight-bold'>" + results["message"] + ".</span>";
              _this.showMessage(message);
            } else {
              _this.clearMessage();
            }
          },
          error: function error() {
            _this.clearMessage();
          }
        });
      } else {
        _this.clearMessage();
      }
    }
  }]);

  return PrescriptionLeadTime;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* Helper Value For Application */
var boxesLeftTxt = void 0;
var powerLeftTxt = void 0;
var bcLeftTxt = void 0;
var diaLeftTxt = void 0;
var cylLeftTxt = void 0;
var axisLeftTxt = void 0;
var addLeftTxt = void 0;
var colorLeftTxt = void 0;
var boxesRightTxt = void 0;
var powerRightTxt = void 0;
var bcRightTxt = void 0;
var diaRightTxt = void 0;
var cylRightTxt = void 0;
var axisRightTxt = void 0;
var addRightTxt = void 0;
var colorRightTxt = void 0;
var notSelectedValue = void 0;

if (typeof isAddPrescrPage !== "undefined" && isAddPrescrPage === true) {
  boxesLeftTxt = 'notdefined';
  powerLeftTxt = 'cl-os-sphere';
  bcLeftTxt = 'cl-os-bc';
  diaLeftTxt = 'cl-os-dia';
  cylLeftTxt = 'cl-os-cyl';
  axisLeftTxt = 'cl-os-axis';
  addLeftTxt = 'cl-os-add';
  colorLeftTxt = 'cl-os-color';
  boxesRightTxt = 'notdefined';
  powerRightTxt = 'cl-od-sphere';
  bcRightTxt = 'cl-od-bc';
  diaRightTxt = 'cl-od-dia';
  cylRightTxt = 'cl-od-cyl';
  axisRightTxt = 'cl-od-axis';
  addRightTxt = 'cl-od-add';
  colorRightTxt = 'cl-od-color';
  notSelectedValue = '0';
} else {
  boxesLeftTxt = 'left-boxes';
  powerLeftTxt = 'left-power';
  bcLeftTxt = 'left-bc';
  diaLeftTxt = 'left-dia';
  cylLeftTxt = 'left-cyl';
  axisLeftTxt = 'left-axis';
  addLeftTxt = 'left-add';
  colorLeftTxt = 'left-color';
  boxesRightTxt = 'right-boxes';
  powerRightTxt = 'right-power';
  bcRightTxt = 'right-bc';
  diaRightTxt = 'right-dia';
  cylRightTxt = 'right-cyl';
  axisRightTxt = 'right-axis';
  addRightTxt = 'right-add';
  colorRightTxt = 'right-color';
  notSelectedValue = null;
}
var issueDateTxt = 'start-date';
var expiryDateTxt = 'expiry-date';
var BOXES = 'boxes';
var POWER = 'power';
var BC = 'baseCurve';
var DIA = 'dia';
var CYL = 'cyl';
var AXIS = 'axis';
var ADD = 'add';
var COLOR = 'color';

var classShowList = 'dropdown--prescription-show';
var classShowBtn = 'dropdown--prescription-showBtn';
var state = 1;
var firstLoadPage = false;
var newPrescription = false;
var dataPrescriptions = null;

/* Func Check Object Empty */
var isEmpty = function isEmpty(data) {
  for (var key in data) {
    if (data.hasOwnProperty(key)) return false;
  }
  return true;
};

/* Func Render DOM And Set Value For Each Box */
var renderVal = function renderVal(element, value) {
  if (value !== "") {
    if (element.is("select")) {
      var _el = element.find('option[value="' + value + '"]');
      /* fix to handle select 10.00 value 10 or select 10 value 10.00*/
      if (!_el.length && opsm.utils.isInt(value)) {
        _el = element.find('option[value="' + parseFloat(value).toFixed(2) + '"]').length ? element.find('option[value="' + parseFloat(value).toFixed(2) + '"]') : element.find('option[value="' + parseFloat(value).toFixed() + '"]');
      }
      /* fix to handle different trailing zeroes*/
      if (!_el.length && !isNaN(value)) {
        var nValue = parseFloat(value);
        element.find('option').each(function () {
          if (!isNaN($(this).attr('value')) && parseFloat($(this).attr('value')) == nValue) {
            _el = $(this);
          }
        });
      }
      if (_el.length) {
        _el.prop("selected", true);
      }
    }
    element.trigger('change');
  }
};

/* USAGE: notPassed = checkval(e.v) => return false if match*/
var checkVal = function checkVal(element, value) {
  if (value !== "") {
    if (element.is("select")) {

      var _result = element.find('option[value="' + value + '"]').length === 0;
      /* fix to handle select 10.00 value 10 select 10 value 10.00 */
      if (_result === true && opsm.utils.isInt(value)) {
        _result = element.find('option[value="' + parseFloat(value).toFixed(2) + '"]').length === 0 && element.find('option[value="' + parseFloat(value).toFixed() + '"]').length === 0;
      }
      /* fix to handle different trailing zeroes*/
      if (_result === true && !isNaN(value)) {
        var nValue = parseFloat(value);
        element.find('option').each(function () {
          if (!isNaN($(this).attr('value'))) {
            _result = (parseFloat($(this).attr('value')) == nValue ? false : true) && _result;
          }
        });
      }
      return _result;
    } else if (element.is("input")) {
      var result = element.val() !== value;
      /* fix to handle different trailing zeroes*/
      if (result === true && !isNaN(value) && !isNaN(element.val())) {
        result = parseFloat(value) != parseFloat(element.val());
      }
      return result;
    } else {
      return true;
    }
  }
  //if value is not set in saved prescription, then accept
  return false;
};

var checkApplyData = function checkApplyData(data, self) {
  //TODO check that product partnumber match
  var boxesLeft = self.boxesLeft,
      powerLeft = self.powerLeft,
      bcLeft = self.bcLeft,
      diaLeft = self.diaLeft,
      cylLeft = self.cylLeft,
      axisLeft = self.axisLeft,
      addLeft = self.addLeft,
      colorLeft = self.colorLeft,
      boxesRight = self.boxesRight,
      powerRight = self.powerRight,
      bcRight = self.bcRight,
      diaRight = self.diaRight,
      cylRight = self.cylRight,
      axisRight = self.axisRight,
      addRight = self.addRight,
      colorRight = self.colorRight;

  for (var item in data) {
    var notPassed = false;

    /* OPSMD-3702 Apply saved prescr on PDP */
    /* Fix for IE not supporting Symbol.iterator internally called when data[item] is not an array*/
    if (item == BOXES || item == POWER || item == BC || item == DIA || item == CYL || item == AXIS || item == ADD || item == COLOR) {
      var _data$item = _slicedToArray(data[item], 2),
          left = _data$item[0],
          right = _data$item[1];

      switch (item) {
        case 'expiryDate':
          break;
        case 'expired':
          break;
        case BOXES:
          notPassed = checkVal(boxesLeft, left);
          if (!notPassed) {
            notPassed = checkVal(boxesRight, right);
          }
          break;
        case POWER:
          notPassed = checkVal(powerLeft, left);
          if (!notPassed) {
            notPassed = checkVal(powerRight, right);
          }
          break;
        case BC:
          notPassed = checkVal(bcLeft, left);
          if (!notPassed) {
            notPassed = checkVal(bcRight, right);
          }
          break;
        case DIA:
          notPassed = checkVal(diaLeft, left);
          if (!notPassed) {
            notPassed = checkVal(diaRight, right);
          }
          break;
        case CYL:
          notPassed = checkVal(cylLeft, left);
          if (!notPassed) {
            notPassed = checkVal(cylRight, right);
          }
          break;
        case AXIS:
          notPassed = checkVal(axisLeft, left);
          if (!notPassed) {
            notPassed = checkVal(axisRight, right);
          }
          break;
        case ADD:
          notPassed = checkVal(addLeft, left);
          if (!notPassed) {
            notPassed = checkVal(addRight, right);
          }
          break;
        case COLOR:
          //	    	OPSMD-16015 
          //	    	notPassed = checkVal(colorLeft, left);
          //	        if (! notPassed) {
          //	          notPassed = checkVal(colorRight, right);
          //	        }
          break;
      }
    }
    if (notPassed) {
      return false;
    }
  }
  return true;
};

var applyData = function applyData(data, self) {
  var boxesLeft = self.boxesLeft,
      powerLeft = self.powerLeft,
      bcLeft = self.bcLeft,
      diaLeft = self.diaLeft,
      cylLeft = self.cylLeft,
      axisLeft = self.axisLeft,
      addLeft = self.addLeft,
      colorLeft = self.colorLeft,
      boxesRight = self.boxesRight,
      powerRight = self.powerRight,
      bcRight = self.bcRight,
      diaRight = self.diaRight,
      cylRight = self.cylRight,
      axisRight = self.axisRight,
      addRight = self.addRight,
      colorRight = self.colorRight,
      issueDate = self.issueDate,
      expiryDate = self.expiryDate;

  for (var item in data) {
    /* OPSMD-3702 Apply saved prescr on PDP */
    /* Fix for IE not supporting Symbol.iterator internally called when data[item] is not an array*/
    if (item == BOXES || item == POWER || item == BC || item == DIA || item == CYL || item == AXIS || item == ADD || item == COLOR) {
      var _data$item2 = _slicedToArray(data[item], 2),
          left = _data$item2[0],
          right = _data$item2[1];

      switch (item) {
        case BOXES:
          renderVal(boxesLeft, left);
          renderVal(boxesRight, right);
          break;
        case POWER:
          renderVal(powerLeft, left);
          renderVal(powerRight, right);
          break;
        case BC:
          renderVal(bcLeft, left);
          renderVal(bcRight, right);
          break;
        case DIA:
          renderVal(diaLeft, left);
          renderVal(diaRight, right);
          break;
        case CYL:
          renderVal(cylLeft, left);
          renderVal(cylRight, right);
          break;
        case AXIS:
          renderVal(axisLeft, left);
          renderVal(axisRight, right);
          break;
        case ADD:
          renderVal(addLeft, left);
          renderVal(addRight, right);
          break;
        case COLOR:
          renderVal(colorLeft, left);
          renderVal(colorRight, right);
          break;
      }
    }
  }
  issueDate.val(data.issueDate);
  expiryDate.val(data.expiryDate);
};

var renderInsertNewPrescription = function renderInsertNewPrescription() {
  var _window = window,
      prescriptionS3B = _window.prescriptionS3B;
  var powerLeft = prescriptionS3B.powerLeft,
      cylLeft = prescriptionS3B.cylLeft,
      axisLeft = prescriptionS3B.axisLeft,
      powerRight = prescriptionS3B.powerRight,
      cylRight = prescriptionS3B.cylRight,
      axisRight = prescriptionS3B.axisRight;

  var boxLeftRight = [powerLeft, cylLeft, axisLeft, powerRight, cylRight, axisRight];

  $("#same-on-both").prop('checked', false).attr("disabled", null);
  $("#prescription-step-1 select option").prop("selected", false).removeAttr("selected");
  $("#prescription-step-1 select").val("-").change();
  $("#prescription-step-1 .required").removeClass("error");
  /* Disable Button When Apply User Data */
  boxLeftRight.forEach(function (box) {
    var btn = $(box.siblings('button'));
    box.attr('disabled', false);
    btn.attr('disabled', false);
    btn.removeClass('prescription-btn-disabled');
    $(btn.children('.icon')).css('display', 'block');
  });
  $("#start-date").attr('disabled', false);
  $("#start-date").removeClass('prescription-disabled');
  $("#start-date").val('');
  $("#expiry-date").attr('disabled', false);
  $("#expiry-date").removeClass('prescription-disabled');
  $("#expiry-date").val('');
  $(prescriptionS3B.boxesLeft).val("1").change();
  $(prescriptionS3B.boxesRight).val("1").change();
};

/* PDP CL user select prescription, DOM onclick triggered */
var selectPrescriptionPDP = function selectPrescriptionPDP(_this) {
  //element passed with f call (eg DOM)
  if (_this === "undefined") {
    _this = undefined;
  }
  if (typeof $(_this).attr("disabled") !== "undefined" && $(_this).attr("disabled") !== false) return;

  $('#prescription-added-msg').hide();
  $("#prescription-not-valid-msg").hide();

  $('.prescription-list').find('.single-prescription.selected').removeClass('selected');
  $(_this).addClass('selected');

  //    const checkboxEyes = prescription.find('input[name="same-on-both-s3b"]');
  //    checkboxEyes.each((_, boxEyes) => {
  //      if (boxEyes.checked) {
  //        boxEyes.checked = false;
  //        nonCheckedEyes(arrBoxRight);
  //      }
  //    });
  var idItems = $(_this).find('input[name="presNumber"]').val();
  handleData(dataPrescriptions, idItems);
};

/* Func Mock User Data Follow Id Prescription */
var handleData = function handleData(listPrescription, idItems) {
  var flagDefault = false;
  var itemCurrent = null;
  firstLoadPage = false;
  state = 2;
  listPrescription.forEach(function (itemPrescription) {
    idItems === itemPrescription.id ? itemCurrent = itemPrescription : '';
  });
  $("#prescription-not-valid-msg").hide();
  var _window2 = window,
      prescriptionS3B = _window2.prescriptionS3B;
  //const { powerLeft, cylLeft, axisLeft, powerRight, cylRight, axisRight } = prescriptionS3B;

  var boxesLeft = prescriptionS3B.boxesLeft,
      boxesRight = prescriptionS3B.boxesRight,
      powerLeft = prescriptionS3B.powerLeft,
      cylLeft = prescriptionS3B.cylLeft,
      axisLeft = prescriptionS3B.axisLeft,
      addLeft = prescriptionS3B.addLeft,
      bcLeft = prescriptionS3B.bcLeft,
      diaLeft = prescriptionS3B.diaLeft,
      powerRight = prescriptionS3B.powerRight,
      cylRight = prescriptionS3B.cylRight,
      axisRight = prescriptionS3B.axisRight,
      addRight = prescriptionS3B.addRight,
      bcRight = prescriptionS3B.bcRight,
      diaRight = prescriptionS3B.diaRight;

  if (isEmpty(itemCurrent)) {
    renderInsertNewPrescription();
  } else {
    /* OPSMD-7360
     * reset boxes for 1 eye case
     */
    renderInsertNewPrescription();
    /* END OPSMD-7360*/

    //const boxLeftRight = [powerLeft, cylLeft, axisLeft, powerRight, cylRight, axisRight];
    var boxLeftRight = [powerLeft, cylLeft, axisLeft, addLeft, bcLeft, diaLeft, powerRight, cylRight, axisRight, addRight, bcRight, diaRight];
    var boxQtyLeftRight = [boxesLeft, boxesRight];
    var check = checkApplyData(itemCurrent, prescriptionS3B);
    if (check) {
      applyData(itemCurrent, prescriptionS3B);
      /* Disable Button When Apply User Data */
      boxLeftRight.forEach(function (box) {
        var btn = $(box.siblings('button'));
        box.attr('disabled', true);
        btn.attr('disabled', true);
        btn.addClass('prescription-btn-disabled');
        $(btn.children('.icon')).css('display', 'none');
      });
      /* disable qty for eye without prescr*/
      if (!boxQtyLeftRight.every(function (box) {
        return box.val() == '0';
      })) {
        boxQtyLeftRight.forEach(function (box) {
          if (box.val() == '0') {
            var btn = $(box.siblings('button'));
            box.attr('disabled', true);
            btn.attr('disabled', true);
            btn.addClass('prescription-btn-disabled');
            $(btn.children('.icon')).css('display', 'none');
          }
        });
      }

      $("#start-date").attr("disabled", "disabled");
      $("#start-date").addClass("prescription-disabled");
      $("#expiry-date").attr("disabled", "disabled");
      $("#expiry-date").addClass("prescription-disabled");
      $("#same-on-both").prop('checked', false).attr("disabled", "disabled");
      $('#prescription-added-msg').show();
    } else {
      $("#prescription-not-valid-msg").show();
    }
  }
  window.prescription.updateBtnCartValue();
};

/* Func Initial Validation For Each Field */
var inititalValidateField = function inititalValidateField() {
  //  /*All Element Need Set Data In Box Left*/
  //  const boxesLeft  = $(`#${boxesLeftTxt}`);
  //  const powerLeft  = $(`#${powerLeftTxt}`);
  //  const cylLeft  = $(`#${cylLeftTxt}`);
  //  const axisLeft  = $(`#${axisLeftTxt}`);
  //  const addLeft  = $(`#${addLeftTxt}`);
  //  const colorLeft  = $(`#${colorLeftTxt}`);
  //  /*All Element Need Set Data In Box Right*/
  //  const boxesRight = $(`#${boxesRightTxt}`);
  //  const powerRight  = $(`#${powerRightTxt}`);
  //  const cylRight  = $(`#${cylRightTxt}`);
  //  const axisRight  = $(`#${axisRightTxt}`);
  //  const addRight  = $(`#${addRightTxt}`);
  //  const colorRight  = $(`#${colorRightTxt}`);
  //  
  //  const boxLeftRight = [boxesLeft, powerLeft, cylLeft, axisLeft, boxesRight, powerRight, cylRight, axisRight];
  //  boxLeftRight.forEach(box => {
  //    /* Func Catch Select Change Value And Apply Validation */
  //    $(box).change(function() {
  //      startValidate($(this));
  //    });
  //    $(box.siblings()[0]).click(function () {
  //      !state ? newPrescription = true : state = 1;
  //    });
  //  });
};

/* Func Create Dom Validate For Field Box */
var startValidate = function startValidate(el) {
  /* Create DOM Error For Every Box */
  var val = el.val();
  var id = el.attr('id');
  var idError = id + '-error';
  var elError = document.createElement("label");
  elError.className = "error invalid-feedback";
  elError.id = idError;
  elError.htmlFor = id;
  var parentElTop = $(el).closest('.form-group.required.opsm-form-group');
  var parentElMid = parentElTop.find('.dropdown.form-control');

  var _el$siblings = el.siblings('#' + idError),
      length = _el$siblings.length;

  length === 0 ? parentElMid.append(elError) : '';

  /* Handle Remove Error */
  var removeError = function removeError() {
    $(parentElMid).find('.error.invalid-feedback').text('');
    elError.style.display = 'none';
    parentElTop.removeClass('error').addClass('valid');
  };

  /* Check Value Each Field And Catch Validate */
  if (val === '-') {
    $(parentElMid).find('.error.invalid-feedback').text('Required field');
    elError.style.display = 'block';
    parentElTop.addClass('error');
  } else {
    removeError();
  }

  /* Page Reload First Or Chose Data To Set Value For Each Box And Non-Validation */
  length === 0 ? firstLoadPage = true : '';
  length === 0 || !state && !newPrescription ? removeError() : '';
};

var PrescriptionS3B = function () {
  function PrescriptionS3B() {
    _classCallCheck(this, PrescriptionS3B);

    this.userPrescription = $('.prescription-list');
    this.skipUnmatchedPresc = this.userPrescription.hasClass("js-fn-skip-unmatch-pres");
    this.prescription = $('.product--prescription');
    this.isFavPage = false;
    if (typeof isFavoritePage !== "undefined" && isFavoritePage === true) {
      this.isFavPage = true;
      this.prescription = $('.product--modal-prescription');
    }
    this.isAddPage = false;
    if (typeof isAddPrescrPage !== "undefined" && isAddPrescrPage === true) {
      this.isAddPage = true;
      this.prescription = $('.rx_form_cl .my-account-prescriptions-add-eyes');
    }

    //        
    //        /* All Element Need Set Data In Box Left */
    this.boxesLeft = this.prescription.find('#' + boxesLeftTxt);
    this.powerLeft = this.prescription.find('#' + powerLeftTxt);
    this.bcLeft = this.prescription.find('#' + bcLeftTxt);
    this.diaLeft = this.prescription.find('#' + diaLeftTxt);
    this.cylLeft = this.prescription.find('#' + cylLeftTxt);
    this.axisLeft = this.prescription.find('#' + axisLeftTxt);
    this.addLeft = this.prescription.find('#' + addLeftTxt);
    this.colorLeft = this.prescription.find('#' + colorLeftTxt);
    //        
    //        /* All Element Need Set Data In Box Right */
    this.boxesRight = this.prescription.find('#' + boxesRightTxt);
    this.powerRight = this.prescription.find('#' + powerRightTxt);
    this.bcRight = this.prescription.find('#' + bcRightTxt);
    this.diaRight = this.prescription.find('#' + diaRightTxt);
    this.cylRight = this.prescription.find('#' + cylRightTxt);
    this.axisRight = this.prescription.find('#' + axisRightTxt);
    this.addRight = this.prescription.find('#' + addRightTxt);
    this.colorRight = this.prescription.find('#' + colorRightTxt);

    this.issueDate = this.prescription.find('#' + issueDateTxt);
    this.expiryDate = this.prescription.find('#' + expiryDateTxt);

    this.scrollToError();

    /*Handle user prescription selection */
    /* not for pdp-redesign*/
    this.prescription.on('click', '.product--prescription-slider-item', function (e) {
      //          const { boxesRight, powerRight, bcRight, diaRight, cylRight, axisRight, nonCheckedEyes, prescription } = window.prescriptionS3B;
      //          const arrBoxRight = [boxesRight, powerRight, bcRight, diaRight, cylRight, axisRight];
      if (typeof $(this).parent().attr("disabled") !== "undefined" && $(this).parent().attr("disabled") !== false) return;
      var className = 'product--prescription-slider-item-selected';
      $('body').find('.' + className).removeClass(className);
      $(this).addClass(className);
      //          const checkboxEyes = prescription.find('input[name="same-on-both-s3b"]');
      //          checkboxEyes.each((_, boxEyes) => {
      //            if (boxEyes.checked) {
      //              boxEyes.checked = false;
      //              nonCheckedEyes(arrBoxRight);
      //            }
      //          });
      var idItems = $(e.target).closest('.product--prescription-slider-nav-item').find('.product--prescription-slider-item-title').attr('data-prescription-id');
      handleData(dataPrescriptions, idItems);
    });

    /*Handle user prescription selection */
    /* for pdp-redesign : selectPrescriptionPDP() DOM onclick*/

    /*Function Change Value Same Prescription With Checkbox*/
    //        this.prescription.on('change', 'input[name="same-on-both-s3b"]', function() {
    //            const { boxesLeft, powerLeft, bcLeft, diaLeft, cylLeft, axisLeft, boxesRight, powerRight, bcRight, diaRight, cylRight, axisRight, nonCheckedEyes } = window.prescriptionS3B;
    //            const arrBoxLeft = [boxesLeft, powerLeft, bcLeft, diaLeft, cylLeft, axisLeft];
    //            const arrBoxRight = [boxesRight, powerRight, bcRight, diaRight, cylRight, axisRight];
    //            const valEyes = $(this).is(":checked");
    //            if (valEyes) {
    //              arrBoxRight.forEach((box, index) => {
    //                renderVal(box, arrBoxLeft[index].val());
    //                box.attr('disabled', true);
    //                $(box.siblings()[0]).attr('disabled', true);
    //              });
    //            } else {
    //              nonCheckedEyes(arrBoxRight);
    //            }
    //        });

    /* Used in CL Modal from favourite page
     * Function Click Dropdown And Change Data Dropdown Component*/
    this.prescription.on('click', '.dropdown--component', function () {
      if (typeof $(this).attr("disabled") !== "undefined" && $(this).attr("disabled") !== false) return;
      var txtEmply = 'Enter new prescription';
      var classShowList = 'dropdown--prescription-show';
      var classShowBtn = 'dropdown--prescription-showBtn';
      var btnElement = $('.dropdown--prescription-btn');
      var prescriptionElement = $('.dropdown--prescription-list');
      var dropdown = $(this).find('.dropdown--component-title');
      var idItems = $(dropdown).attr('data-prescription-id');
      var txtItems = $(dropdown).text();
      btnElement.removeClass(classShowBtn);
      btnElement.text(idItems && idItems.length > 0 ? txtItems : txtEmply);
      prescriptionElement.removeClass(classShowList);

      handleData(dataPrescriptions, idItems);
    });

    /*Validate Prescription Form*/
    //        inititalValidateField();

    /*Check User Login And Initialize Data For ExistingPrescription*/
    //        if (window.sessionStorage.getItem('login')) {
    this.initialLoad();
    //            $('.product--prescription-login').remove();
    //        } else {
    //            $('.product--prescription-existing').hide();
    //        }
  }

  /* AddClass And RemoveClass On Dropdown Prescription Mobile */


  _createClass(PrescriptionS3B, [{
    key: 'handleClass',
    value: function handleClass(btnDropdownPrescription, listDropdownComponent) {
      if ($(listDropdownComponent).hasClass(classShowList)) {
        $(btnDropdownPrescription).removeClass(classShowBtn);
        listDropdownComponent.removeClass(classShowList);
      } else {
        $(btnDropdownPrescription).addClass(classShowBtn);
        $(listDropdownComponent).addClass(classShowList);
      }
    }

    /* Unchecked Eyes And Remove Disable Some Field Box */

  }, {
    key: 'nonCheckedEyes',
    value: function nonCheckedEyes(arrBoxRight) {
      var boxesRight = window.prescriptionS3B.boxesRight;

      arrBoxRight.forEach(function (box) {
        box.attr('disabled', false);
        switch (true) {
          case firstLoadPage:
          case !state:
            $(box.siblings()[0]).attr('disabled', false);
            break;
          default:
            box === boxesRight ? $(box.siblings()[0]).attr('disabled', false) : '';
            break;
        }
      });
    }
  }, {
    key: 'calculateExistingPrescription',
    value: function calculateExistingPrescription() {
      var _that = this;
      var prescriptions = [];
      $(".existing-prescription").each(function () {
        var prescription = {};
        var $this = $(this);
        prescription.id = $this.find("input[name=presNumber]").val();
        var title = $this.find("input[name=optomName]").val();
        if (title === "") {
          title = "Prescription";
        }
        prescription.title = title;
        prescription.expired = $this.find("input[name=expired]").val();
        prescription.issueDate = $this.find("input[name=issueDate]").val();
        prescription.expiryDate = $this.find("input[name=expiryDate]").val();
        prescription.boxes = [$this.find("input[name=leftLensQuantity]").val(), $this.find("input[name=rightLensQuantity]").val()];
        prescription.power = [$this.find("input[name=leftLensPower]").val(), $this.find("input[name=rightLensPower]").val()];
        //power format '-2.00' or '2.00'
        prescription.power.forEach(function (value, index, arr) {
          value = value.replace(/[+\s]/g, '');
          if (value.endsWith('.0')) {
            value = value.padEnd(value.length + 1, '0');
          }
          arr[index] = value;
        });
        prescription.baseCurve = [$this.find("input[name=leftLensBaseCurve]").val(), $this.find("input[name=rightLensBaseCurve]").val()];
        //baseCurve format '8.7'
        prescription.baseCurve.forEach(function (value, index, arr) {
          value = value.replace(/[+\s]/g, '');
          if (/^[^\.]+\.\d0$/.exec(value)) {
            value = value.slice(0, -1);
          }
          arr[index] = value;
        });
        prescription.dia = [$this.find("input[name=leftLensDiameter]").val(), $this.find("input[name=rightLensDiameter]").val()];
        //dia format '14.0' '14.2'
        prescription.dia.forEach(function (value, index, arr) {
          value = value.replace(/[+\s]/g, '');
          if (/^[^\.]+\.\d0$/.exec(value)) {
            value = value.slice(0, -1);
          }
          arr[index] = value;
        });
        prescription.cyl = [$this.find("input[name=leftLensCylinder]").val(), $this.find("input[name=rightLensCylinder]").val()];
        //cyl format '-0.75', positives not detected
        prescription.cyl.forEach(function (value, index, arr) {
          value = value.replace(/[\s]/g, '');
          arr[index] = value;
        });
        prescription.axis = [$this.find("input[name=leftLensAxis]").val(), $this.find("input[name=rightLensAxis]").val()];
        //axis format '20'
        prescription.axis.forEach(function (value, index, arr) {
          value = value.replace(/[+\s]/g, '');
          arr[index] = value;
        });
        prescription.add = [$this.find("input[name=leftLensAdd]").val(), $this.find("input[name=rightLensAdd]").val()];
        //add format 'HIGH' 'LOW' 'MED' | '1.00 D' '1.50 N' | '2.50' '1.25'
        prescription.add.forEach(function (value, index, arr) {
          value = value.replace(/[+]/g, '').replace(/(^\s+)|(\s+$)/g, '');
          arr[index] = value;
        });
        prescription.color = [$this.find("input[name=leftLensColor]").val(), $this.find("input[name=rightLensColor]").val()];
        //color format 'LIGHT BLUE' 'Light Blue'
        if (_that.skipUnmatchedPresc && !checkApplyData(prescription, _that)) {
          _that.discardPrescription($this);
        } else {
          prescriptions.push(prescription);
        }
      });
      return prescriptions;
    }
  }, {
    key: 'discardPrescription',
    value: function discardPrescription($presc) {

      if (typeof $presc != 'undefined' && $($presc).length) {
        //this section is for PDP
        if ($presc.closest('.slick-initialized').length) {
          var $slider = $presc.closest('.slick-initialized');
          var $slide = $presc.closest('.slick-slide');
          if (!isNaN($slide.attr('data-slick-index'))) {
            $slider.slick('slickRemove', parseInt($slide.attr('data-slick-index')));
          }
        } else if ($presc.closest('[data-prescription-id]').length) {
          $presc.closest('[data-prescription-id]').remove();
        }
      }
    }

    /* Get API When Reload Page With User Loggined */

  }, {
    key: 'initialLoad',
    value: function initialLoad() {
      var _this2 = this;

      /* works with '.existing-prescription'
       * expected in favourite page and PDP for CL
       */
      dataPrescriptions = this.calculateExistingPrescription();

      //PDP UI init slick custom only if user prescriptions >1 
      if ($("#user-prescr-wrapper .prescription-list [data-prescription-id]").length > 1 && $("#user-prescr-wrapper .prescription-list.js-gr-slide-cust").length) {
        $("#user-prescr-wrapper .prescription-list-wrapper").addClass("slick-mode");
        $("#user-prescr-wrapper .prescription-list").removeClass("d-grid col-2-grid").slick({
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
          dots: true,
          arrows: false
        });
      }

      //pdp use direct output from server
      if (this.isFavPage) {
        //inject html template
        this.buildListExistingPrescription(dataPrescriptions);
        /* Create Dropdown For Mobile */
        var btnDropdownPrescription = $('.dropdown--prescription-btn');
        var listDropdownComponent = $('.dropdown--prescription-list');
        $(btnDropdownPrescription).on('click', function (e) {
          e.stopPropagation();
          _this2.handleClass(btnDropdownPrescription, listDropdownComponent);
        }).stop();

        $('body').click(function (e) {
          var $target = $(e.target);
          if (!$target.parents().is('.dropdown-prescription') && $(listDropdownComponent).hasClass(classShowList)) {
            $(btnDropdownPrescription).removeClass(classShowBtn);
            $(listDropdownComponent).removeClass(classShowList);
          }
        });
      }

      /* old prescription tab slider for CL
      if(!this.isFavPage){
      	this.tabSlider();
      }
      */

      //OPSMD-3930
      var elementGroup = [this.powerLeft, this.powerRight];
      elementGroup.forEach(function (elm) {
        if (elm.data('wrapper-class') && elm.data('wrapper-class').indexOf('native-select') != -1) {
          Utils.moveDefaultOptionBefore(elm, '0.00');
          Utils.scrollToSelectedOptionOnOpen(elm);
        }
      }, this);
      this.showSelectOrDropdownOnly();
    }
  }, {
    key: 'showSelectOrDropdownOnly',
    value: function showSelectOrDropdownOnly() {
      var _window3 = window,
          prescriptionS3B = _window3.prescriptionS3B;
      var boxesLeft = this.boxesLeft,
          powerLeft = this.powerLeft,
          bcLeft = this.bcLeft,
          diaLeft = this.diaLeft,
          cylLeft = this.cylLeft,
          axisLeft = this.axisLeft,
          addLeft = this.addLeft,
          colorLeft = this.colorLeft,
          boxesRight = this.boxesRight,
          powerRight = this.powerRight,
          bcRight = this.bcRight,
          diaRight = this.diaRight,
          cylRight = this.cylRight,
          axisRight = this.axisRight,
          addRight = this.addRight,
          colorRight = this.colorRight;


      var boxLeftRight = [boxesLeft, powerLeft, bcLeft, diaLeft, cylLeft, axisLeft, addLeft, colorLeft, boxesRight, powerRight, bcRight, diaRight, cylRight, axisRight, addRight, colorRight];
      if (Utils.isNotDesktopDevice()) {
        //only native select options should be visible (not using diplay:none for validator to work)
        $(document).ready(function () {
          boxLeftRight.forEach(function (box) {
            if (box.is('select')) $(box.siblings('.dropdown-menu')).css('visibility', 'hidden');
          });
        });

        boxLeftRight.forEach(function (box) {
          $(box.siblings("button[data-toggle='dropdown']")).children('.icon').click(false);
        });
      } else {
        //only hybridSelect dropdown menu should be visible
        //        	boxLeftRight.forEach(box => {
        //        	    if (box.is('select')) box.css('visibility', 'hidden');
        //        	});
      }
    }

    /* Create DOM For Prescription Boxs And Append User Data In Boxs */

  }, {
    key: 'buildListExistingPrescription',
    value: function buildListExistingPrescription(data) {
      var prescriptionExisting = $('.product--prescription-existing');
      if (Array.isArray(data) && data.length > 0) {
        var templateDeskBox = '';
        var templateMobileBox = '';
        data.forEach(function (item) {
          var id = item.id,
              title = item.title,
              issueDate = item.issueDate,
              expiryDate = item.expiryDate,
              baseCurve = item.baseCurve,
              power = item.power;

          var baseCurveRow = '';
          if (baseCurve[0] !== '' && baseCurve[1] !== '') {
            baseCurveRow = '<li>Base Curve: ' + baseCurve[0] + ', ' + baseCurve[1] + '</li>';
          }
          var powerRow = '';
          if (power[0] !== '' && power[1] !== '') {
            powerRow = '<li>Power: ' + power[0] + ', ' + power[1] + '</li>';
          }
          var issueRow = '<small class="ml-0 product--prescription--existing-issue">Issued ' + issueDate + '</small>';
          var issueRowMobile = '<span class="dropdown--component-issue">Issued ' + issueDate + '</span>';
          var expired = "";
          if (item.expired === "true") {
            expired = 'disabled="disabled"';
            issueRow = '<small class="ml-0 product--prescription--existing-issue">Expired ' + expiryDate + '</small>';
            issueRowMobile = '<span class="dropdown--component-issue">Expired ' + expiryDate + '</span>';
          }

          templateDeskBox += '\n              <div class="item product--prescription-slider-nav-item" ' + expired + '>\n                <div class="product--prescription-slider-item">\n                    <h5 class="product--prescription-slider-item-title" data-prescription-id="' + id + '">' + title + '</h5>\n                    ' + issueRow + '\n                    <ul class="list-unstyled m-0 prescription--existing-info">\n                        ' + baseCurveRow + '\n                        ' + powerRow + '\n                    </ul>\n                </div>\n            </div>\n           ';

          templateMobileBox += '\n            <li class="dropdown--component" ' + expired + '>\n                <h4 class="dropdown--component-title" data-prescription-id="' + id + '">' + title + '</h4>\n                ' + issueRowMobile + '\n                <div class="dropdown--component-info"><span>Base Curve:</span><span>' + baseCurve[0] + ', ' + baseCurve[1] + '</span></div>\n                <div class="dropdown--component-info"><span>Power:</span><span>' + power[0] + ', ' + power[1] + '</span></div>\n            </li>\n          ';
        });

        var templateDeskBoxs = '<div class="product--prescription-exist-box-tb dropdown-prescription">\n        <button class="dropdown--prescription-btn">Enter new prescription</button>\n        <ul class="dropdown--prescription-list">\n        \t<li class="dropdown--prescription-name dropdown--component"> Enter new prescription</li>\n            ' + templateMobileBox + '\n        </ul>\n     </div>\n    <div class="product--prescription-exist-box mt-4">\n        <div class="product--prescription-slider-nav-wrapper">\n        \t<div class="product--prescription-slider-nav">\n\t\t\t    <div class="item product--prescription-slider-nav-item">\n\t\t\t        <div class="product--prescription-slider-item product--prescription-slider-item-selected text-center">\n\t\t\t\t        <div class="product--prescription-add-item mt-4">+</div>\n\t\t\t\t        <h5 class="product--prescription-slider-item-title m-auto">Enter new prescription</h5>\n\t\t\t\t     </div>\n\t\t\t\t</div>\n                ' + templateDeskBox + '\n            </div>\n        </div>\n    </div>\n    <div id="prescription-not-valid-msg" class="cannot-apply-existing-prescription" style="margin-top: 15px; display: none;">Cannot apply prescription: values don\'t match</div>';

        return $(prescriptionExisting).append(templateDeskBoxs);
      }
      var templateNoExisting = '\n        <div class="prescription--no-existing">You do not have any existing prescriptions from our OPSM stores.</div>\n      ';
      return $(prescriptionExisting).append(templateNoExisting);
    }

    /* Prescription Slider */

  }, {
    key: 'tabSlider',
    value: function tabSlider() {
      var tabSliderNavEle = $('.product--prescription-slider-nav');

      /* vertical slider for FAV page must be triggered on opening modal to avoid issues*/
      if (!this.isFavPage) {
        if (!tabSliderNavEle.data('slick')) {
          tabSliderNavEle.not('.slick-initialized').slick({
            arrows: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: false,
            responsive: [{
              breakpoint: 1140,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }, {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }, {
              breakpoint: 576,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }]
          });
        }
      }
    }
  }, {
    key: 'findFirstError',
    value: function findFirstError() {
      if ($('#left-boxes').length && !$('#left-boxes').valid()) return $('#left-boxes');
      if ($('#left-power').length && !$('#left-power').valid()) return $('#left-power');
      if ($('#left-bc').length && !$('#left-bc').valid()) return $('#left-bc');
      if ($('#left-dia').length && !$('#left-dia').valid()) return $('#left-dia');
      if ($('#left-cyl').length && !$('#left-cyl').valid()) return $('#left-cyl');
      if ($('#left-axis').length && !$('#left-axis').valid()) return $('#left-axis');
      if ($('#left-add').length && !$('#left-add').valid()) return $('#left-add');
      if ($('#left-color').length && !$('#left-color').valid()) return $('#left-color');
      if ($('#right-boxes').length && !$('#right-boxes').valid()) return $('#right-boxes');
      if ($('#right-power').length && !$('#right-power').valid()) return $('#right-power');
      if ($('#right-bc').length && !$('#right-bc').valid()) return $('#right-bc');
      if ($('#right-dia').length && !$('#right-dia').valid()) return $('#right-dia');
      if ($('#right-cyl').length && !$('#right-cyl').valid()) return $('#right-cyl');
      if ($('#right-axis').length && !$('#right-axis').valid()) return $('#right-axis');
      if ($('#right-add').length && !$('#right-add').valid()) return $('#right-add');
      if ($('#right-color').length && !$('#right-color').valid()) return $('#right-color');
      if ($('#start-date').length && !$('#start-date').valid()) return $('#start-date');
      if ($('#expiry-date').length && !$('#expiry-date').valid()) return $('#expiry-date');
      if ($('#prescription-valid').length && !$('#prescription-valid').valid()) return $('#prescription-valid');
      return null;
    }
  }, {
    key: 'scrollToError',
    value: function scrollToError() {
      var _this3 = this;

      var productPrescriptionLogin = $('.product--prescription');
      if (productPrescriptionLogin.length) {
        var timeoutSticky = void 0;
        $('#prescr-sel-pdp').click(function () {
          timeoutSticky ? clearTimeout(timeoutSticky) : '';
          var firstErrorElement = _this3.findFirstError();
          if (firstErrorElement !== undefined && firstErrorElement != null) {
            //        	 $('html,body').animate({
            //        		 scrollTop: $(firstErrorElement).parent().offset().top-200
            //        	 }, 500);
            var centerScrollPos = $(firstErrorElement).parent().offset().top - $(window).height() / 2;
            $([document.documentElement, document.body]).animate({
              //scrollTop: $(".product--prescription").offset().top
              scrollTop: centerScrollPos
            }, 200);

            $('.product--sidebar-col').getNiceScroll()
            //             	.doScrollPos(0, $('.product--prescription').position().top);
            .doScrollPos(0, $(firstErrorElement).parent().position().top);
          } else {
            //        	  $('html,body').animate({ scrollTop: $(productPrescriptionLogin).offset().top }, 500);
            $([document.documentElement, document.body]).animate({
              scrollTop: $(".product--prescription").offset().top
            }, 200);

            $('.product--sidebar-col').getNiceScroll().doScrollPos(0, $('.product--prescription').position().top);
          }
          timeoutSticky = setTimeout(function () {
            var header = $('.header--sticky');
            $(header).addClass('temp-hidden').attr('data-aos', 'fade-up');
          }, 550);
        }).stop();
      }
    }
  }]);

  return PrescriptionS3B;
}();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  var clCombinationValidationFunc = function clCombinationValidationFunc(lensEye) {
    var _lensEye = "select#" + lensEye;
    var _notSelectableLensEye = "input#" + lensEye;
    var _boxes = $(_lensEye + "-boxes").val();
    var boxes = parseInt(_boxes);
    if (isNaN(boxes) || boxes < 1) return true; //first step: check quantity

    var isValid = true;
    var selectSelector = ".prescription-" + lensEye + " select";
    $(selectSelector).each(function () {
      if ($(this).val() === null) {
        isValid = false;
      }
    });
    if (!isValid) {
      return false;
    }

    var ajaxGetData = {
      productId: $("#parentCatentryIdforLens").val(),
      storeId: WCParamJS.storeId,
      langId: WCParamJS.langId
    };

    var power = $(_lensEye + "-power").val() || $(_notSelectableLensEye + "-power").val();
    var bc = $(_lensEye + "-bc").val() || $(_notSelectableLensEye + "-bc").val();
    var dia = $(_lensEye + "-dia").val() || $(_notSelectableLensEye + "-dia").val();
    var cyl = $(_lensEye + "-cyl").val() || $(_notSelectableLensEye + "-cyl").val();
    var axis = $(_lensEye + "-axis").val() || $(_notSelectableLensEye + "-axis").val();
    var add = $(_lensEye + "-add").val() || $(_notSelectableLensEye + "-add").val();
    var color = $(_lensEye + "-color").val() || $(_notSelectableLensEye + "-color").val();

    if (typeof power !== "undefined") {
      ajaxGetData["spherePower"] = power;
    } else {
      ajaxGetData["spherePower"] = null;
    }
    if (typeof bc !== "undefined") {
      ajaxGetData["baseCurve"] = bc;
    } else {
      ajaxGetData["baseCurve"] = null;
    }
    if (typeof dia !== "undefined") {
      ajaxGetData["diameter"] = dia;
    } else {
      ajaxGetData["diameter"] = null;
    }
    if (typeof cyl !== "undefined") {
      ajaxGetData["cylinder"] = cyl;
    } else {
      ajaxGetData["cylinder"] = null;
    }
    if (typeof axis !== "undefined") {
      ajaxGetData["axis"] = axis;
    } else {
      ajaxGetData["axis"] = null;
    }
    if (typeof add !== "undefined") {
      ajaxGetData["addPower"] = add;
    } else {
      ajaxGetData["addPower"] = null;
    }
    if (typeof color !== "undefined") {
      ajaxGetData["tintColor"] = color;
    } else {
      ajaxGetData["tintColor"] = null;
    }

    /*var clProduct = SKUs_MAP.getSkusByAttributes(power, bc, dia, cyl, axis, add, color);
    if (clProduct)
    {
    return true;
    }
    return false;*/
    var count = 0;
    $.ajax({
      url: "/AjaxPrescriptionValidator",
      data: ajaxGetData,
      cache: true,
      async: false,
      dataType: "json",
      success: function success(results) {
        isValid = "true" === results["isValidPrescription"];
        if (isValid) {
          count = parseInt(results["count"]);
          if (count !== 1) {
            isValid = false;
          }
        }
      },
      error: function error() {
        isValid = false;
        return false;
      }
    });
    return isValid;
  };
  $.validator.addMethod("sameClCombination", function (val, element) {
    return clCombinationValidationFunc("right");
  }, $.validator.format("Unfortunately both products are not available in the prescription that you have entered. Please check your prescription again or visit your local OPSM store."));
  $.validator.addMethod("leftClCombination", function () {
    return clCombinationValidationFunc("left");
  }, $.validator.format("Unfortunately the left-eye product is not available in the prescription that you have entered. Please check your prescription again or visit your local OPSM store"));
  $.validator.addMethod("rightClCombination", function () {
    return clCombinationValidationFunc("right");
  }, $.validator.format("Unfortunately the right-eye product is not available in the prescription that you have entered. Please check your prescription again or visit your local OPSM store"));
})();

//OPSMD-15501
window.addEventListener("load", function () {
  var initialized = false;
  var retryCount = 0;
  var maxRetries = 10;

  var getSpan = function getSpan(id) {
    var el = document.querySelector("#" + id);
    if (!el) return null;

    var wrapper = el.closest(".hybrid-select");
    if (!wrapper) return null;

    return wrapper.querySelector("button #selected_text_dropdown");
  };

  var checkNegativeDiffWarning = function checkNegativeDiffWarning() {
    var warningDiv = document.querySelector(".cl-combination-error-placement");
    if (!warningDiv) return;

    var getText = function getText(span) {
      return span ? span.textContent.trim() : null;
    };

    var leftSpanPower = getSpan("left-power");
    var rightSpanPower = getSpan("right-power");
    var leftSpanCyl = getSpan("left-cyl");
    var rightSpanCyl = getSpan("right-cyl");
    var leftSpanBc = getSpan("left-bc");
    var rightSpanBc = getSpan("right-bc");

    var leftRawPower = getText(leftSpanPower);
    var rightRawPower = getText(rightSpanPower);
    var leftRawCyl = getText(leftSpanCyl);
    var rightRawCyl = getText(rightSpanCyl);
    var leftRawBc = getText(leftSpanBc);
    var rightRawBc = getText(rightSpanBc);

    var isValid = function isValid(v) {
      return v && v !== "-";
    };

    if ((!isValid(leftRawPower) || !isValid(rightRawPower)) && (!isValid(leftRawCyl) || !isValid(rightRawCyl)) && (!isValid(leftRawBc) || !isValid(rightRawBc))) {
      warningDiv.style.display = "none";
      warningDiv.innerHTML = "";
      return;
    }

    var leftValPower = parseFloat(leftRawPower);
    var rightValPower = parseFloat(rightRawPower);
    var leftValCyl = parseFloat(leftRawCyl);
    var rightValCyl = parseFloat(rightRawCyl);
    var leftValBc = parseFloat(leftRawBc);
    var rightValBc = parseFloat(rightRawBc);

    if (leftValPower && rightValPower && leftValPower * rightValPower < 0 || leftValCyl && rightValCyl && rightValCyl * leftValCyl < 0) {
      warningDiv.style.display = "block";
      warningDiv.innerHTML = "<p class='warning-diff'>You've inserted 1 positive and 1 negative value, which is very rare. We suggest double checking your prescription. If this is correct, you can proceed.</p>";
    } else if (!isNaN(leftValPower) && !isNaN(rightValPower) && Math.abs(leftValPower - rightValPower) >= 3 || !isNaN(leftValCyl) && !isNaN(rightValCyl) && Math.abs(leftValCyl - rightValCyl) >= 3) {
      warningDiv.style.display = "block";
      warningDiv.innerHTML = "<p class='warning-diff'>You've inserted values that are notably different, which is very rare. We suggest double checking your prescription. If this is correct, you can proceed.</p>";
    } else if (leftValBc && rightValBc && rightValBc !== leftValBc) {
      warningDiv.style.display = "block";
      warningDiv.innerHTML = "<p class='warning-diff'>You've different base curve values, which is very rare. We suggest double checking your prescription. If this is correct, you can proceed</p>";
    } else {
      warningDiv.style.display = "none";
      warningDiv.innerHTML = "";
    }
  };

  var initializeObservers = function initializeObservers() {
    var step = document.querySelector("#prescription-step-1");
    var warningDiv = document.querySelector(".cl-combination-error-placement");

    if (!step || !warningDiv) {
      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(initializeObservers, 100);
      }
      return false;
    }

    var leftSpanPower = getSpan("left-power");
    var rightSpanPower = getSpan("right-power");
    var leftSpanCyl = getSpan("left-cyl");
    var rightSpanCyl = getSpan("right-cyl");
    var leftSpanBc = getSpan("left-bc");
    var rightSpanBc = getSpan("right-bc");

    var availableSpans = [leftSpanPower, rightSpanPower, leftSpanCyl, rightSpanCyl, leftSpanBc, rightSpanBc].filter(Boolean);

    if (availableSpans.length === 0) {
      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(initializeObservers, 100);
      }
      return false;
    }

    var config = { characterData: true, childList: true, subtree: true };

    availableSpans.forEach(function (span) {
      if (span) {
        new MutationObserver(checkNegativeDiffWarning).observe(span, config);
      }
    });

    var dropdownContainers = document.querySelectorAll('.hybrid-select');
    dropdownContainers.forEach(function (container) {
      new MutationObserver(function () {
        setTimeout(checkNegativeDiffWarning, 100);
      }).observe(container, config);

      container.addEventListener('click', function () {
        setTimeout(checkNegativeDiffWarning, 150);
      });

      var buttons = container.querySelectorAll('button, li, [role="option"]');
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          setTimeout(checkNegativeDiffWarning, 150);
        });
      });
    });

    var inputs = document.querySelectorAll('#left-power, #right-power, #left-cyl, #right-cyl, #left-bc, #right-bc');
    inputs.forEach(function (input) {
      input.addEventListener('change', checkNegativeDiffWarning);
      input.addEventListener('input', checkNegativeDiffWarning);
    });

    var pollCount = 0;
    var pollInterval = setInterval(function () {
      checkNegativeDiffWarning();
      pollCount++;
      if (pollCount >= 20) {
        clearInterval(pollInterval);
      }
    }, 100);

    checkNegativeDiffWarning();

    initialized = true;
    return true;
  };

  if (!initializeObservers()) {
    var mainObserver = new MutationObserver(function (mutations, obs) {
      if (!initialized && initializeObservers()) {
        obs.disconnect();
      }
    });

    mainObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!initialized) {
      setTimeout(function () {
        return initializeObservers();
      }, 50);
    }
  });

  setTimeout(function () {
    if (!initialized) {
      initializeObservers();
    }
  }, 1000);

  setTimeout(function () {
    if (initialized) {
      checkNegativeDiffWarning();
    }
  }, 1500);

  var globalPollCount = 0;
  var globalPoll = setInterval(function () {
    if (initialized) {
      checkNegativeDiffWarning();
    }
    globalPollCount++;
    if (globalPollCount >= 30) {
      clearInterval(globalPoll);
    }
  }, 100);
});

var Prescription = function () {
  function Prescription() {
    var _this2 = this;

    _classCallCheck(this, Prescription);

    this.prescription = $(".product--prescription");

    if (typeof isFavoritePage !== "undefined" && isFavoritePage === true) {
      this.isFavPage = true;
      this.prescription = $(".product--modal-prescription");
    }
    if (this.prescription.length === 0) {
      return;
    }

    /* PDP only */
    //this.subscribeCheckbox = $('#subscribe-desktop');
    this.purchaseTypeRadio = $('input[name="purchase-type"');
    this.subscribeRadio = $("input#subscribe-now");
    this.singlePurchaseRadio = $("input#one-off");

    /* PDP and FAV pages */
    this.modalPrescription = $("#modal-prescription"); //same of prescription in FAV page
    this.loggedInWrapper = this.prescription.find(".prescription--loggedin");
    this.loggedInNotWrapper = this.prescription.find(".prescription--not-loggedin");
    this.startDate = this.prescription.find("#start-date");
    this.expiryDate = this.prescription.find("#expiry-date");
    this.chbSameOnBoth = this.prescription.find(".prescription--same-on-both");
    this.formStep1 = this.prescription.find("#prescription-step-1");
    this.step1 = this.prescription.find(".prescription--step-1");
    this.step2 = this.prescription.find(".prescription--step-2");
    this.btnBackStep1 = this.prescription.find("#back-step-1");
    this.existPresDropdownArea = this.prescription.find(".prescription--existing-pres-dropdown");
    this.msgNoExistingPres = this.prescription.find(".prescription--no-existing");

    this.prescrValidCheckbox = $("#prescription-valid");
    if (this.isFavPage) {
      this.btnAddToCart = this.prescription.find("#add-to-cart-pdp"); //.prescription--add-to-cart
      this.btnAddPrescr = this.prescription.find(".prescription--add-prescription");
    } else {
      this.btnAddToCart = $(".prescription--add-to-cart"); //.prescription--add-to-cart
      this.btnAddPrescr = $(".prescription--add-prescription");
    }
    /* non matching */
    this.existPrescriptionListMobile = this.prescription.find("#prescription-existing");
    this.existPrescriptionListDesktop = this.prescription.find(".prescription--existing-pres-list");

    // ---------------------------------------------
    this.bindInput();
    this.bindSelectionHandler();
    $("#right-boxes, #left-boxes").on("change", Subscription.updateLensOrderFrequency);

    // render slider in modals after modal first opens to avoid issues
    this.modalPrescription.on("show.bs.modal", function (e) {
      if (_this2.isFavPage) {
        var tabSliderNavEle = $(".product--prescription-slider-nav");
        if (!tabSliderNavEle.data("slick")) {
          tabSliderNavEle.not(".slick-initialized").one("firstShown", function (e) {
            $(this).on("init", function () {
              $(".product--prescription-slider-nav").on("wheel", { tabSliderNavEle: tabSliderNavEle }, function (event) {
                event.preventDefault();
                var $slider = event.data.tabSliderNavEle;
                var delta = event.originalEvent.deltaY;
                if (delta > 0) {
                  $slider.slick("slickNext");
                } else {
                  $slider.slick("slickPrev");
                }
              });
            }).slick({
              arrows: false,
              dots: true,
              speed: 300,
              slidesToShow: 3,
              slidesToScroll: 1,
              vertical: true,
              verticalSwiping: true,
              verticalScrolling: true,
              infinite: false,
              responsive: [{
                breakpoint: 1140,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              }, {
                breakpoint: 992,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              }, {
                breakpoint: 576,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }, {
                breakpoint: 368,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }]
            });
          });
        }
        tabSliderNavEle.trigger("firstShown");
      } else {
        if (window.user) {
          _this2.loggedInNotWrapper.addClass("d-none");
        } else {
          _this2.loggedInWrapper.addClass("d-none");
        }
      }
      _this2.step1.removeClass("d-none");
      _this2.step2.addClass("d-none");
    });
    //handle data to show in modal for FAV page having more than 1 CL items
    if (this.isFavPage && $("input#singleCLProduct").length && "false" === $("input#singleCLProduct").val()) {
      var _this = this;
      $(".opsm-modal-link.prescription-btn").off().on("click", window, function (e) {
        e.stopImmediatePropagation();
        var pid = $(this).data("prdid");
        var pn = $(this).data("prdpn");
        var url = $(this).data("url");
        $("#contactLensPrice").remove();
        $("#subscriptionPrice").remove();
        _this.prescription.append('<input type="hidden" id="subscriptionPrice" value="' + $(this).siblings("input#offerPriceString-" + $(this).data("id")).val() + '" />');
        _this.prescription.append('<input type="hidden" id="contactLensPrice" value="' + $(this).siblings("input#listPriceString-" + $(this).data("id")).val() + '" />');
        $.ajax({
          url: url,
          data: {
            productId: pid,
            partNumber: pn,
            storeId: WCParamJS.storeId,
            langId: WCParamJS.langId,
            catalogId: WCParamJS.catalogId
          },
          success: _this.handleAjaxModal,
          error: function error(XMLHttpRequest, textStatus, errorThrown) {
            $(".product--modal-prescription:visible").modal("hide");
            opsm.utils.showAlertError("Sorry some error occurred, try again later");
          }
        });
      });
    }

    /**
     * expiry date time picker
     */
    // this.expiryDate.datetimepicker({
    //     format: 'MM/YYYY'
    // });

    /**
     * form step 1 validation rules
     */
    this.formStep1.validate({
      ignore: [],
      rules: {
        "left-boxes": {
          notBothZero: "#right-boxes"
        },
        "left-power": {
          leftEyeSelected: true
        },
        "left-bc": {
          leftEyeSelected: true
        },
        "left-dia": {
          leftEyeSelected: true
        },
        "left-cyl": {
          leftEyeSelected: true
        },
        "left-axis": {
          leftEyeSelected: true
        },
        "left-color": {
          leftEyeSelected: true
        },
        "left-add": {
          leftEyeSelected: true
        },
        "right-boxes": {
          notBothZero: "#left-boxes"
        },
        "right-power": {
          rightEyeSelected: true
        },
        "right-bc": {
          rightEyeSelected: true
        },
        "right-dia": {
          rightEyeSelected: true
        },
        "right-cyl": {
          rightEyeSelected: true
        },
        "right-axis": {
          rightEyeSelected: true
        },
        "right-color": {
          rightEyeSelected: true
        },
        "right-add": {
          rightEyeSelected: true
        },
        "start-date": {
          required: function required() {
            return $("#left-boxes").val() > 0 || $("#right-boxes").val() > 0;
          },
          DateFormatByMYIssueDate: true,
          DateFormatMonthValidation: $("#month-valid-config").val() || 12
        },
        "expiry-date": {
          DateFormatByMYExpiryDate: true
        },
        bevalid: {
          sameClCombination: {
            depends: function depends(element) {
              return $(".prescription--same-on-both").is(":checked");
            }
          },
          rightClCombination: {
            depends: function depends(element) {
              return !$(".prescription--same-on-both").is(":checked");
            }
          },
          leftClCombination: {
            depends: function depends(element) {
              return !$(".prescription--same-on-both").is(":checked");
            }
          }
        },
        "prescription-valid": {
          required: function required() {
            return $("#left-boxes").val() > 0 || $("#right-boxes").val() > 0;
          }
        }
      },
      messages: {
        "left-boxes": {
          required: "Required field"
        },
        "left-power": {
          required: "Required field"
        },
        "left-bc": {
          required: "Required field"
        },
        "left-dia": {
          required: "Required field"
        },
        "left-cyl": {
          required: "Required field"
        },
        "left-axis": {
          required: "Required field"
        },
        "left-color": {
          required: "Required field"
        },
        "left-add": {
          required: "Required field"
        },
        "right-boxes": {
          required: "Required field"
        },
        "right-power": {
          required: "Required field"
        },
        "right-bc": {
          required: "Required field"
        },
        "right-dia": {
          required: "Required field"
        },
        "right-cyl": {
          required: "Required field"
        },
        "right-axis": {
          required: "Required field"
        },
        "right-color": {
          required: "Required field"
        },
        "right-add": {
          required: "Required field"
        },
        "start-date": {
          required: "Required field"
        },
        "prescription-valid": {
          required: "Please confirm your prescription is valid"
        }
      },
      errorPlacement: function errorPlacement(error, element) {
        if (element.attr("name") == "bevalid") {
          error.appendTo($(".cl-combination-error-placement"));
          $(".cl-combination-error-placement").show();
        } else if (element.attr("name") == "prescription-valid") {
          error.addClass("red");
          error.appendTo(element.closest(".form-group"));
        } else {
          //do not show error
        }
      },
      highlight: function highlight(element, errorClass, validClass) {
        $(element).closest(".form-group").addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function unhighlight(element, errorClass, validClass) {
        $(element).closest(".form-group").removeClass(errorClass).addClass(validClass);
      },
      submitHandler: function submitHandler(form, ev) {
        opsm.product.addToCartContactLensAndTorics(form, ev);
      }
    });

    /**
     * trigger existing prescription
     */
    this.existPrescriptionListMobile.on("change", function () {
      var value = _this2.existPrescriptionListMobile.val();
      if (value) {
        _this2.existPrescriptionListDesktop.find("input[type=\"radio\"][value=\"" + value + "\"]").prop("checked", true);
      } else {
        _this2.existPrescriptionListDesktop.find('input[type="radio"]').prop("checked", false);
      }

      _this2.selectPrescription(value);
    });

    /**
     * trigger existing prescription
     */
    this.existPrescriptionListDesktop.on("change", 'input[type="radio"]', function (e) {
      var value = $(e.target).val();
      _this2.existPrescriptionListMobile.val(value).trigger("change");

      _this2.selectPrescription(value);
    });

    /**
     * back to step 1
     */

    this.btnBackStep1.on("click", function () {
      _this2.step1.removeClass("d-none");
      _this2.step2.addClass("d-none");
    });

    if (this.isFavPage) {
      var _this3 = this;
      this.btnAddPrescr.off().on("click", function (e) {
        if (!$(this).hasClass("disabled")) {
          var rows = _this3.step2.find("table>tbody>tr");
          rows.each(function () {
            var _row = $(this);
            if (_row.find("td a[id]").text() === "-") {
              if (!_row.hasClass("hide")) {
                _row.addClass("hide");
              }
            } else {
              _row.removeClass("hide");
            }
          });
          _this3.step1.toggleClass("d-none");
          _this3.step2.toggleClass("d-none");
        }
      });
    }

    /**
     * subscribe
     */
    this.purchaseTypeRadio.on("change", function (e) {
      if ($("#" + e.target.id).attr("id") == "subscribe-now") {
        $(".product--after-pay").toggleClass("d-none", e.target.checked);
        $("#js-sub-price-div").toggleClass("d-none", !e.target.checked);
        $("#js-nosub-price-div").toggleClass("d-none", e.target.checked);
        $("input#subscribe-now").prop("checked", $("input#subscribe-now").is(":checked"));
        // if (this.subscribeRadio.is(":checked")) {
        //     $(".prescription--subscribe-desc").removeClass("d-none");
        // } else {
        //     $(".prescription--subscribe-desc").addClass("d-none");
        // }
        _this2.updateBtnCartValue();
      } else {
        $(".product--after-pay").toggleClass("d-none", !e.target.checked);
        $("#js-sub-price-div").toggleClass("d-none", e.target.checked);
        $("#js-nosub-price-div").toggleClass("d-none", !e.target.checked);
        $("input#one-off").prop("checked", $("input#one-off").is(":checked"));
        // if (this.subscribeRadio.is(":checked")) {
        //     $(".prescription--subscribe-desc").removeClass("d-none");
        // } else {
        //     $(".prescription--subscribe-desc").addClass("d-none");
        // }
        _this2.updateBtnCartValue();
      }
    });

    if ($(".product--modal-prescription:visible").length) {
      this.btnAddToCart.on("click", function () {
        $(".product--modal-prescription:visible").modal("hide");
      });
    }
    this.prescrValidCheckbox.on("change", function (e) {
      _this2.updateBtnCartValue();
    });
    /*OPSMD-6803 handle back button case: all values are filled in, add-to cart has to show up*/
    this.updateBtnCartValue();
  }

  _createClass(Prescription, [{
    key: "handleAjaxModal",
    value: function handleAjaxModal(data) {
      //check for expected
      if ($(data).find("form#prescription-step-1 .row.prescription-eye.prescription-left").length > 0 && $(data).find("form#prescription-step-1 .row.prescription-eye.prescription-right").length > 0) {
        $(".product--modal-prescription").find("form#prescription-step-1 .row.prescription-eye.prescription-left").replaceWith($(data).find("form#prescription-step-1 .row.prescription-eye.prescription-left"));
        $(".product--modal-prescription").find("form#prescription-step-1 .row.prescription-eye.prescription-right").replaceWith($(data).find("form#prescription-step-1 .row.prescription-eye.prescription-right"));

        $(".product--prescription-existing.prescription--loggedin").find(".product--prescription-exist-box-tb.dropdown-prescription, .product--prescription-exist-box, .prescription--no-existing, #prescription-not-valid-msg").remove();

        $('[data-toggle="hybridSelect"]').hybridSelect();

        //    		window.formSubscription = new FormSubscription();
        //    		window.plp = new PLP();
        //    		window.pdp = new PDP();
        //    		window.sizingAndFit = new SizingAndFit();
        window.prescription = new Prescription();
        window.prescriptionS3B = new PrescriptionS3B();
        $(".product--modal-prescription:hidden").modal();
      } else {
        $(".product--modal-prescription:visible").modal("hide");
        opsm.utils.showAlertError("Sorry some error occurred, try again later");
      }
    }

    /**
     * bind unique value input
     */

  }, {
    key: "bindInput",
    value: function bindInput() {
      $(".prescription .prescription--step-1 .opsm-form-group input.form-control-plaintext").each(function () {
        var $this = $(this);
        $(".prescription .prescription--step-2 td+td#" + $this.attr("id") + "-value").text($this.val());
      });
    }

    /**
     * bind events to select boxes
     */

  }, {
    key: "bindSelectionHandler",
    value: function bindSelectionHandler() {
      var _this = this;
      //updated to include FAV page modal use case
      $(_this.prescription.find(".prescription--step-1 .opsm-form-control select")).add($(_this.startDate)).add($(_this.expiryDate))
      //$(".product--prescription .prescription--step-1 .prescription-eye .opsm-form-group .opsm-form-control select, .product--prescription .prescription--step-1 #start-date, .product--prescription .prescription--step-1 #expiry-date")
      .each(function () {
        var $this = $(this);
        $($this.attr("id") + "-value");
        $this.on("change", function () {
          $this.closest(".opsm-form-group").removeClass("blue");
          $this.closest("form").attr("data-activated", true);
          var step2Id = "#" + $this.attr("id");
          $(step2Id + "-value").text($this.val());
          if (_this.chbSameOnBoth.is(":checked") && step2Id.indexOf("right") > -1) {
            $(step2Id.replace("right", "left") + "-value").val($(step2Id + "-value").val()).trigger("change");
            $(step2Id.replace("right", "left")).val($(step2Id).val()).trigger("change");
          }
          if (!step2Id.endsWith("-boxes")) {
            $(".cl-combination-error-placement").hide().empty(); //reset external container for "unavailable prescription combination"
          } else {
            var boxCounterR = parseInt($("#right-boxes").val());
            var boxCounterL = parseInt($("#left-boxes").val());
            var counterSum = boxCounterR + boxCounterL;

            if (!isNaN(counterSum)) {
              if ($(".box-counter-label").length) {
                if (counterSum == 1) {
                  $(".box-counter-label").text("Box");
                }
                $(".box-counter").text(counterSum);
              } else {
                if (counterSum == 1) {
                  $(".box-counter").text("1 Box");
                } else {
                  $(".box-counter").text(counterSum + " Boxes");
                }
              }
            }
          }
          _this.updateBtnCartValue();
          //is needed in FAV?
          //    Subscription.updateLensOrderFrequency();
        });
      });

      var selectedExpiryDate = this.prescription.find("#selected-expiry-value");
      this.expiryDate.on("change.datetimepicker", function (e) {
        //selectedExpiryDate.text(e.date ? e.date.format('MM/YYYY') : '-');
        selectedExpiryDate.text(e.currentTarget.value);
      });

      this.chbSameOnBoth.on("change", function (e) {
        if (e.target.checked) {
          $(_this.prescription).find(".prescription--step-1 .opsm-form-control select[id*='left']").each(function () {
            var selectId = "#" + $(this).attr("id");
            if (!selectId.endsWith("-boxes")) {
              $(selectId).val($(selectId.replace("left", "right")).val()).trigger("change").hybridSelect("select").hybridSelect("disable");
            }
          });
          $(_this.prescription).find(".prescription--step-1 input[id*='left']").each(function () {
            var selectId = "#" + $(this).attr("id");
            var siblingSelector = $(selectId).next();
            if (!selectId.endsWith("-boxes")) {
              $(siblingSelector).attr("disabled", "");
            }
          });
          $(_this.prescription).find(".prescription--step-1 .left-title").addClass("disabled");
        } else {
          $(_this.prescription).find(".prescription--step-1 .opsm-form-control select[id*='left']").each(function () {
            var selectId = "#" + $(this).attr("id");
            var rightSelDis = $(selectId.replace("left", "right")).attr("disabled");
            if (typeof rightSelDis === "undefined" || rightSelDis === false) {
              /*OPSMD-7730*/
              var skipValidation = true;
              $(this).hybridSelect("enable", skipValidation);
            }
          });
          $(_this.prescription).find(".prescription--step-1 input[id*='left']").each(function () {
            var selectId = "#" + $(this).attr("id");
            var siblingSelector = $(selectId).next();
            if (!selectId.endsWith("-boxes")) {
              $(siblingSelector).removeAttr("disabled", "");
            }
          });
          $(_this.prescription).find(".prescription--step-1 .left-title").removeClass("disabled");
        }
      });
    }

    /**
     * update RED button with total value
     */

  }, {
    key: "updateBtnCartValue",
    value: function updateBtnCartValue() {
      var leftBoxes = this.prescription.find("#left-boxes");
      var rightBoxes = this.prescription.find("#right-boxes");
      var totalPriceSpan = this.prescription.find("#total-value");

      // this should be set on page
      var unitPrice = parseFloat($("#contactLensPrice").val());
      var subUnitPrice = parseFloat($("#subscriptionPrice").val());
      var afterpayNumInst = parseFloat($("#afterPayInstallm").val());

      if ($("#xSimDiscPrice").val() === "true") {
        unitPrice = parseFloat($("#contactLensFullPrice").val());
        if ($("input#one-off").is(":checked")) {
          subUnitPrice = parseFloat($("#contactLensPrice").val());
        }
      }

      var count = 0;
      if (leftBoxes.length) {
        if (leftBoxes.val()) {
          count += parseInt(leftBoxes.val(), 10);
        }
      }
      if (rightBoxes.length) {
        if (rightBoxes.val()) {
          count += parseInt(rightBoxes.val(), 10);
        }
      }

      var totalPrice = unitPrice * count;
      var subscriptionTotalPrice = subUnitPrice * count;
      var afterPayInstPrice = totalPrice / afterpayNumInst;
      var afterPayInstPriceSub = subscriptionTotalPrice / afterpayNumInst;

      if (!isNaN(totalPrice)) {
        totalPriceSpan.text("$" + totalPrice.toFixed(2));
      }
      if (!isNaN(subscriptionTotalPrice) && !this.isFavPage) {
        if (this.subscribeRadio.prop("checked") == true) {
          //this.btnAddToCart.find('.button--label').text(`Add to cart ($${subscriptionTotalPrice.toFixed(2)})`)
          $("span#js-afterpayPrice").text(afterPayInstPriceSub.toFixed(2));
        } else {
          //this.btnAddToCart.find('.button--label').text(`Add to cart ($${totalPrice.toFixed(2)})`)
          $("span#js-afterpayPrice").text(afterPayInstPrice.toFixed(2));
        }
        $(".js-listPrice").text("$" + totalPrice.toFixed(2));
        $(".js-offerPrice").text("$" + subscriptionTotalPrice.toFixed(2));
      } else if (!isNaN(subscriptionTotalPrice) && this.isFavPage && this.subscribeRadio.prop("checked") == true) {
        totalPriceSpan.text("$" + subscriptionTotalPrice.toFixed(2));
      }
      var prescriptionComplete = true;

      if (count == 0) prescriptionComplete = false;

      if (leftBoxes.val() > 0) {
        $(this.prescription).find(".prescription--step-1 .prescription-eye.prescription-left .opsm-form-group .opsm-form-control select").each(function () {
          var currentValue = $(this).val();
          if (typeof currentValue === "undefined" || currentValue === null) {
            prescriptionComplete = false;
          }
        });
      }

      if (rightBoxes.val() > 0) {
        $(this.prescription).find(".prescription--step-1 .prescription-eye.prescription-right .opsm-form-group .opsm-form-control select").each(function () {
          var currentValue = $(this).val();
          if (typeof currentValue === "undefined" || currentValue === null) {
            prescriptionComplete = false;
          }
        });
      }

      /* update to include FAV page */
      //        const startDateValue = $(".product--prescription .prescription--step-1 #start-date").val();
      //        const expiryDateValue = $(".product--prescription .prescription--step-1 #expiry-date").val();

      var startDateValue = $(this.startDate).val();
      var expiryDateValue = $(this.expiryDate).val();

      if (startDateValue.match(/^(0[1-9]|1[012])[/]\d{4}$/) === null || expiryDateValue !== "" && startDateValue.match(/^(0[1-9]|1[012])[/]\d{4}$/) === null) {
        prescriptionComplete = false;
      }

      if (!this.prescription.find("#prescription-valid").is(":checked")) {
        prescriptionComplete = false;
      }

      if (this.isFavPage) {
        if (prescriptionComplete) {
          this.btnAddPrescr.removeClass("disabled");
        } else {
          this.btnAddPrescr.addClass("disabled");
        }
      } else {
        // OPSMD-8324 - check if prescription form is valid in order to show the add to cart button
        // TODO DISABILITATO VALIDAZIONE PER LUNGHI TEMPI DI RISPOSTA
        //if (prescriptionComplete && $('form#prescription-step-1').valid()) {
        if (prescriptionComplete) {
          this.btnAddToCart.removeClass("hide");
          this.btnAddPrescr.addClass("hide");
        } else {
          this.btnAddToCart.addClass("hide");
          this.btnAddPrescr.removeClass("hide");
        }
      }
    }
  }, {
    key: "selectPrescription",
    value: function selectPrescription(presId) {
      var preses = window.existingPrescription.filter(function (item) {
        return item.id === presId;
      });
      if (preses.length) {
        var pres = preses[0];

        var leftBC = this.prescription.find("#left-bc");
        var leftBCValue = this.prescription.find("#left-bc-value");
        var leftPower = this.prescription.find("#left-power");
        var leftPowerValue = this.prescription.find("#left-power-value");

        var rightBC = this.prescription.find("#right-bc");
        var rightBCValue = this.prescription.find("#right-bc-value");
        var rightPower = this.prescription.find("#right-power");
        var rightPowerValue = this.prescription.find("#right-power-value");

        if (leftBC.length) {
          leftBC.val(pres.baseCurve);
          leftBC.trigger("change");
        }
        if (leftBCValue.length) {
          leftBCValue.text(pres.baseCurve);
        }
        if (leftPower.length) {
          leftPower.val(pres.power[0]);
          leftPower.trigger("change");
        }
        if (leftPowerValue.length) {
          leftPowerValue.text(pres.power[0]);
        }

        if (rightBC.length) {
          rightBC.val(pres.baseCurve);
          rightBC.trigger("change");
        }
        if (rightBCValue.length) {
          rightBCValue.text(pres.baseCurve);
        }
        if (rightPower.length) {
          rightPower.val(pres.power[1]);
          rightPower.trigger("change");
        }
        if (rightPowerValue.length) {
          rightPowerValue.text(pres.power[1]);
        }
      }
    }
  }]);

  return Prescription;
}();

var AllSKUsMap = function () {
  function AllSKUsMap() {
    _classCallCheck(this, AllSKUsMap);

    this.skusMap = {};
  }

  _createClass(AllSKUsMap, [{
    key: "addSku",
    value: function addSku(clproduct) {
      this.skusMap[clproduct.attributesString()] = clproduct;
    }
  }, {
    key: "getSkuByCLProduct",
    value: function getSkuByCLProduct(clproduct) {
      return this.skusMap[clproduct.attributesString()];
    }
  }, {
    key: "getSkusByAttributes",
    value: function getSkusByAttributes(spherePower, baseCurve, diameter, cylinder, axis, addPower, tintColor) {
      return this.getSkuByCLProduct(new CLProduct(null, null, spherePower, baseCurve, diameter, cylinder, axis, addPower, tintColor));
    }
  }]);

  return AllSKUsMap;
}();

var CLProduct = function () {
  function CLProduct(catentryId, partnumber, spherePower, baseCurve, diameter, cylinder, axis, addPower, tintColor) {
    _classCallCheck(this, CLProduct);

    this.catentryId = catentryId;
    this.partnumber = partnumber;

    this.setSpherePower(spherePower);
    this.setBaseCurve(baseCurve);
    this.setDiameter(diameter);
    this.setCylinder(cylinder);
    this.setAxis(axis);
    this.setAddPower(addPower);
    this.setTintColor(tintColor);
  }

  _createClass(CLProduct, [{
    key: "getSpherePower",
    value: function getSpherePower() {
      return this.spherePower;
    }
  }, {
    key: "setSpherePower",
    value: function setSpherePower(spherePower) {
      this.spherePower = this.normalizeNumber(spherePower);
    }
  }, {
    key: "getBaseCurve",
    value: function getBaseCurve() {
      return this.baseCurve;
    }
  }, {
    key: "setBaseCurve",
    value: function setBaseCurve(baseCurve) {
      this.baseCurve = this.normalizeNumber(baseCurve);
    }
  }, {
    key: "getDiameter",
    value: function getDiameter() {
      return this.diameter;
    }
  }, {
    key: "setDiameter",
    value: function setDiameter(diameter) {
      this.diameter = this.normalizeNumber(diameter);
    }
  }, {
    key: "getCylinder",
    value: function getCylinder() {
      return this.cylinder;
    }
  }, {
    key: "setCylinder",
    value: function setCylinder(cylinder) {
      this.cylinder = this.normalizeNumber(cylinder);
    }
  }, {
    key: "getAxis",
    value: function getAxis() {
      return this.axis;
    }
  }, {
    key: "setAxis",
    value: function setAxis(axis) {
      this.axis = this.normalizeNumber(axis);
    }
  }, {
    key: "getAddPower",
    value: function getAddPower() {
      return this.addPower;
    }
  }, {
    key: "setAddPower",
    value: function setAddPower(addPower) {
      this.addPower = this.normalizeNumber(addPower);
    }
  }, {
    key: "getTintColor",
    value: function getTintColor() {
      return this.tintColor;
    }
  }, {
    key: "setTintColor",
    value: function setTintColor(tintColor) {
      this.tintColor = this.normalizeString(tintColor);
    }
  }, {
    key: "getCatentryId",
    value: function getCatentryId() {
      return this.catentryId;
    }
  }, {
    key: "setCatentryId",
    value: function setCatentryId(catentryId) {
      this.catentryId = catentryId;
    }
  }, {
    key: "getPartnumber",
    value: function getPartnumber() {
      return this.partnumber;
    }
  }, {
    key: "setPartnumber",
    value: function setPartnumber(partnumber) {
      this.partnumber = partnumber;
    }
  }, {
    key: "normalizeNumber",
    value: function normalizeNumber(n) {
      if (!n) return "";
      var _n = parseFloat(n);
      if (isNaN(_n)) return "x";
      return _n;
    }
  }, {
    key: "normalizeString",
    value: function normalizeString(s) {
      if (!s) return "";
      return s.toLowerCase();
    }
  }, {
    key: "attributesString",
    value: function attributesString() {
      return [this.spherePower, this.baseCurve, this.diameter, this.cylinder, this.axis, this.addPower, this.tintColor].join("|");
    }
  }, {
    key: "identifierString",
    value: function identifierString() {
      return [this.catentryId, this.partnumber].join("_");
    }
  }]);

  return CLProduct;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Product = function () {
    function Product() {
        _classCallCheck(this, Product);
    }

    // Added to alreadyInOpsmFunctions.js
    // static toggleFavourite(event, productID) {
    //     event.preventDefault();
    //     event.stopPropagation();
    //     const link = $(event.target).closest('.product--favourite');
    //     const product = link.closest('.product');
    //
    //     /**
    //      * @todo: send real request here to change favourite status
    //      */
    //
    //     link.toggleClass('product--favourite--yes')
    //         .find('.icon').toggleClass('icon-star-outline icon-star');
    // }

    _createClass(Product, null, [{
        key: 'changeProductColor',
        value: function changeProductColor(currentEl) {
            var colorBtn = $(currentEl).find('.product--color-item');
            colorBtn.addClass('product--color-item--default').siblings('.product--color-item').removeClass('product--color-item--default');

            var product = $(currentEl).closest('.product');
            var primaryImage = product.find('.product--primary-img');
            var secondaryImage = product.find('.product--secondary-img');

            var dataPrimaryImage = colorBtn.data('product-primary-image');
            var dataSecondaryImage = colorBtn.data('product-secondary-image');
            var dataIsPolarized = colorBtn.data('product-is-polarized');
            var dataDiscountPerc = colorBtn.data('product-disc-perc') || '';
            var dataPriceParsed = parseFloat(colorBtn.data('product-price'));
            var dataListPriceParsed = parseFloat(colorBtn.data('product-listprice'));
            var dataPartNumber = colorBtn.data('product-partnumber');
            var dataUniqueId = colorBtn.data('product-unique-id');

            // OPSMD-15618
            try {
                var dataParentUniqueId = colorBtn.data('product-parent-id');
                var dataParentIsRoxable = colorBtn.data('product-is-parent-roxable');
                var dataParentLensCount = colorBtn.data('product-parent-lens-count');
                console.log("badge optical fit", 'partnum:', dataPartNumber, 'parent-id:', dataParentUniqueId, 'isroxable:', dataParentIsRoxable, 'lenscount:', dataParentLensCount);

                var badgeOpticalFit = product.find(".product--badge--opticalfit");
                if (dataParentIsRoxable && dataParentLensCount && dataParentLensCount > 0) {
                    if (badgeOpticalFit.length === 0) {
                        var $existingBadges = product.find('.product--badge');
                        if ($existingBadges.length < 3) {
                            var newBadgeHTML = '<div class="product--badge product--badge--features product--badge--opticalfit">Optical fit</div>';
                            if ($existingBadges.length > 0) {
                                $existingBadges.last().after(newBadgeHTML);
                            } else {
                                var badgeContainer = product.find('.product--top');
                                if (badgeContainer.length) {
                                    badgeContainer.prepend(newBadgeHTML);
                                }
                            }
                        }
                    }
                } else {
                    if (badgeOpticalFit.length) {
                        badgeOpticalFit.detach();
                    }
                }
            } catch (e) {
                console.err(e);
            }

            primaryImage.find('img').attr({
                'src': dataPrimaryImage.src
            });

            if (secondaryImage.length) {
                secondaryImage.find('img').attr({
                    'src': dataSecondaryImage.src
                });
            }

            var isPolarizedEl = product.find(".product--polarised");
            if (dataIsPolarized === "Y") {
                isPolarizedEl.removeClass("d-none");
            } else {
                isPolarizedEl.addClass("d-none");
            }

            if (!isNaN(dataListPriceParsed)) {
                if (dataPriceParsed !== dataListPriceParsed) {
                    if (product.find(".product--price--full").length) {
                        product.find(".product--price--full").detach();
                        product.find(".price-title").append('<span class="product--price product--price--old">$' + dataListPriceParsed.toFixed(2) + '</span>');
                        product.find(".price-title").append('<span class="product--price product--price--new">$' + dataPriceParsed.toFixed(2) + '</span>');
                        product.find(".price-title").append('<div class="product--badge product--badge--discount ct_badge--discount">-' + dataDiscountPerc + '</div>');
                    } else {
                        product.find(".product--price--old").html('$' + dataListPriceParsed.toFixed(2));
                        product.find(".product--price--new").html('$' + dataPriceParsed.toFixed(2));
                        product.find("product--badge--discount").html("-" + dataDiscountPerc);
                    }
                    product.find(".analyticsProductPriceFull").html(dataListPriceParsed.toFixed(2));
                    product.find(".analyticsProductPrice").html(dataPriceParsed.toFixed(2));
                } else {
                    if (product.find(".product--price--full").length) {
                        product.find(".product--price--full").html('$' + dataListPriceParsed.toFixed(2));
                    } else {
                        product.find(".product--price--old").detach();
                        product.find(".product--price--new").detach();
                        product.find(".product--badge--discount").detach();
                        product.find(".price-title").append('<span class="product--price--full">$' + dataListPriceParsed.toFixed(2) + '</span>');
                    }
                    product.find(".analyticsProductPriceFull").html(dataListPriceParsed.toFixed(2));
                    product.find(".analyticsProductPrice").html(dataListPriceParsed.toFixed(2));
                }
            }

            var hrefProduct = product.find('a').attr("href");
            var hrefSlide = $(currentEl).find('a').attr("href");
            product.find(".product--color-item").each(function () {
                var productPartNumber = $(this).data('product-partnumber');
                hrefProduct = hrefProduct.split(productPartNumber).join(dataPartNumber);
                hrefSlide = hrefSlide.split(productPartNumber).join(dataPartNumber);
            });
            product.find('a').attr("href", hrefProduct);
            $(currentEl).find('a').attr("href", hrefSlide);
            product.find(".product--favourite").attr("rel", dataUniqueId);
            if (!isNaN(dataListPriceParsed)) {
                product.find(".product--favourite").attr("data-analytics-listprice", "" + dataListPriceParsed);
            }
            if (!isNaN(dataPriceParsed)) {
                product.find(".product--favourite").attr("data-analytics-discprice", "" + dataPriceParsed);
            }
            if (OPSMHeader.getFavList().indexOf(dataUniqueId) > -1) {
                product.find(".product--favourite").addClass('product--favourite--yes').find('.icon').addClass('icon-heart');
                product.find(".product--favourite").removeClass('product--favourite--yes').find('.icon').removeClass('icon-heart-outline');
            } else {
                product.find(".product--favourite").removeClass('product--favourite--yes').find('.icon').removeClass('icon-heart').addClass('icon-heart-outline');
            }

            document.dispatchEvent(new CustomEvent('plp:tilesUpdated', { detail: { tile: product[0] } }));
        }
    }, {
        key: 'addToCart',
        value: function addToCart(quantity, event, productID) {
            $(".header--sticky.aos-init.aos-animate").removeClass("temp-hidden");
            var btnAddToCart = $(event.target).closest('a, button');

            var badge = $('#btn-cart').find('.badge');
            var badgeCurrentValue = badge.text() ? parseInt(badge.text(), 10) : 0;
            var buttonLabel = btnAddToCart.find('.button--label');

            if (btnAddToCart.is('.added') === false) {
                badge.text(badgeCurrentValue + quantity);

                // if (buttonLabel.length) {
                //     const buttonLabelClone = buttonLabel.clone();
                //     buttonLabel.addClass('d-none');
                //     buttonLabelClone.insertAfter(buttonLabel);
                // } 

                //            btnAddToCart.addClass('added');
            } else {
                badge.text(badgeCurrentValue - 1);

                // if (buttonLabel.length) {
                //     // buttonLabel.html('Add to cart');
                //     buttonLabel.filter(':not(.d-none)').remove();
                //     buttonLabel.removeClass('d-none');
                // } else {
                //     btnAddToCart.html('Add to cart');
                // }

                //            btnAddToCart.removeClass('added');
            }
        }
    }]);

    return Product;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollSpalla = function () {
	function ScrollSpalla(binarioSelector, contenutoSelector, margins) {
		_classCallCheck(this, ScrollSpalla);

		var _this = this;
		this.binarioSelector = binarioSelector;
		this.contenutoSelector = contenutoSelector;
		this.margins = margins;

		this.$binario = $(binarioSelector);
		this.$contenuto = $(contenutoSelector);

		function checkElement($el) {
			return $el.length > 0 && !$el.hasClass("nofix");
		}

		if (!checkElement(this.$binario) || !checkElement(this.$contenuto)) return;

		setTimeout(function () {
			_this.init();
		}, 100);
	}

	_createClass(ScrollSpalla, [{
		key: 'init',
		value: function init() {
			var _this = this;
			_this.$binario.trigger('detach.ScrollToFixed');
			var end = _this.$contenuto.offset().top + _this.$contenuto.height() - _this.$binario.height() - _this.margins.top;
			if (end > 0) {
				initializeScrollToFixedRail(_this.$binario, _this.margins.marginTop, end - _this.margins.bottom);
			}

			function initializeScrollToFixedRail(rail, start, end) {
				rail.scrollToFixed({
					marginTop: start,
					limit: end,
					zIndex: 1,
					postFixed: function postFixed() {
						rail.addClass('resetLeft');
					},
					preFixed: function preFixed() {
						rail.removeClass('resetLeft');
					}
				});
			}
		}
	}]);

	return ScrollSpalla;
}();
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchOverlay = function () {
  function SearchOverlay() {
    var _this = this;

    _classCallCheck(this, SearchOverlay);

    this.articlesBlog = [];
    this.productListing;
    this.topSearches = [];
    this.storeId = $("#storeId").val();
    this.catalogId = $("#catalogId").val();
    this.langId = $("#langId").val();
    this.waitTime = 1000;
    // OPSMD-13504: extra settle window for the search-run analytics event, so a
    // pending push is cancelled if the user keeps typing (see trackSearchRun).
    this.trackWaitTime = 1000;
    this.mapViewRequested = {};
    this.showType = 2;
    // showType:
    //   0: Popular Search
    //   1: Keyword Search
    //   2: Products Search

    // on init overlay, populate top searches
    //this.requestTopSearches();

    this.btnOpenSearch = $('#btn-search,#btn-search-mob');
    this.searchOverlay = $('#search-overlay');
    this.bodyHomePage = $('#body-home-page');
    this.btnCloseSearch = this.searchOverlay.find('#search-overlay-close');
    this.searchInput = this.searchOverlay.find('#search-input');
    this.divPopularSearches = this.searchOverlay.find('#searches-found');
    // Submit search result
    this.btnSearchSubmit = this.searchOverlay.find('#search-submit');
    // this.searchSubmit.unbind('click');
    this.searchForm = this.searchOverlay.find('#searchForm');
    this.formAction = this.searchOverlay.find('form#searchForm[action]').attr('action');
    // Search articles found
    this.divSearchArticlesFound = this.searchOverlay.find('#search-result-article-blog');
    // Search found content
    this.labelSearchResult = this.searchOverlay.find('#search-result-label');
    this.divPopularResults = this.searchOverlay.find('#popular-results-espot');
    this.divSuggestedKeywords = this.searchOverlay.find('#suggested-keywords');

    this.divSuggestedProductsLabel = this.searchOverlay.find('#search-result-label-products');
    this.divSuggestedProducts = this.searchOverlay.find('#suggested-products-views');
    // Search Result Found
    this.divPopularResults.find("a").each(function (index, elem) {
      _this.topSearches.push($(elem).text());
    });
    // this.divSearchResultFound = this.searchOverlay.find('.search--result-found');
    this.searchForm.on('submit', function (e) {
      e.preventDefault();
      $(this).children(':input#search-input').attr("disabled", "disabled");
      $(this).unbind('submit').submit();
    });

    /**
     * Open Search Overlay
     */
    this.btnOpenSearch.on('click', function () {
      _this.searchOverlay.fadeIn();
      _this.searchInput.focus();
      _this.bodyHomePage.css("overflow", "hidden");
      _this.divPopularSearches.show(function () {
        _this.showTopSearch();
      });
    });

    /**
     * Close Search Overlay
     */
    this.btnCloseSearch.on('click', function () {
      _this.bodyHomePage.css("overflow", "");
      _this.closeSearchOvl();
    });

    /**
     * Search Input events handler
     */

    this.searchInput.on('input', function () {
      clearTimeout(_this.currentWait);
      // OPSMD-13504: cancel a pending search-run analytics push while the user
      // keeps typing, so only the term they settle on is tracked.
      clearTimeout(_this.trackWait);
      _this.updateAction();
      _this.currentWait = setTimeout(function () {
        _this.startRequestSearching();
      }, _this.waitTime);
    });

    // search tabs navigator
    this.productNav = $('#search-result-product-nav');
    this.articleNav = $('#search-result-article-nav');
    this.productTab = $('#search-result-products');
    this.articleTab = $('#search-result-articles');
    this.articleTab.addClass('search--result-tab--disabled');

    this.productNav.on('click', function () {
      _this.articleNav.removeClass('search--result-sub-header--active');
      _this.productNav.addClass('search--result-sub-header--active');
      _this.articleTab.removeClass('search--result-tab--active').addClass('search--result-tab--inactive');
      _this.productTab.removeClass('search--result-tab--inactive').addClass('search--result-tab--active');
    });

    this.articleNav.on('click', function () {
      _this.productNav.removeClass('search--result-sub-header--active');
      _this.articleNav.addClass('search--result-sub-header--active');
      _this.articleTab.removeClass('search--result-tab--inactive').addClass('search--result-tab--active');
      _this.productTab.removeClass('search--result-tab--active').addClass('search--result-tab--inactive');
    });
    this.handleIE();
  }

  _createClass(SearchOverlay, [{
    key: "updateAction",
    // end constructor

    value: function updateAction() {
      var updateAction = this.searchInput.val().replace(/-/g, " ").trim().replace(/\./g, "").replace(/&/g, " ").replace(/ +/g, " ").replace(/ /g, "+");
      this.searchForm.attr('action', this.formAction + updateAction);
    }
  }, {
    key: "startRequestSearching",
    value: function startRequestSearching() {
      var _this2 = this;

      var pattern = "" + this.searchInput.val().replace(/-/g, " ").trim().replace(/\./g, "").replace(/&/g, " ").replace(/ +/g, " ");
      var srchpat = pattern && pattern.length > 1 ? new RegExp(pattern, 'ig') : null;

      if (pattern.indexOf("contact") != -1) {
        pattern = "contact";
      }
      if (pattern == 'lense' || pattern == 'lens') {
        pattern = "contact";
      }

      if (this.searchInput.val()) {
        this.btnSearchSubmit.removeClass('search--submit--disabled');
        this.btnSearchSubmit.addClass('search--submit--enabled');
      } else {
        this.btnSearchSubmit.removeClass('search--submit--enabled');
        this.btnSearchSubmit.addClass('search--submit--disabled');
      }
      // make a search request
      if (pattern !== "") {
        this.requestSearching(pattern, function () {
          return _this2.renderResults();
        },
        /*
        // success callback 
        let listProducts = [];
        let listArticles = [];
             
        // @todo: you can remove regex match logic
         
        this.productListing.forEach((prod) => {
          listProducts.push(prod.term);
        });
             this.articlesBlog.forEach((article) => {
          listArticles.push(article.name);
        });
             
        //then show the results
        
        this.divPopularResults.show();
        this.divSuggestedKeywords.hide();
        this.divSuggestedProductsLabel.hide();
        this.divSuggestedProducts.hide();
        if (listProducts.length > 0 && listArticles.length > 0) {
          this.showProductResults(listProducts);
          this.showArticleResults(listArticles, 'Suggested articles');
        } else if (listProducts.length > 0) {
          this.showProductResults(listProducts);
        } else if (listArticles.length > 0) {
          this.showArticleResults(listArticles, 'Suggested articles');
        } else {
          this.showTopSearch();
        }
        opsm.search.loadListeners();*/
        function () {
          return _this2.showTopSearch;
        }); // end this.requestSearching
      } else {
        this.showTopSearch();
      }
    }
  }, {
    key: "requestSearching",
    value: function requestSearching(keyword, callback, failCallback) {
      var _this3 = this;

      this.keyword = keyword;
      this.startedReqKeywords = true;
      this.startedReqProducts = true;
      // Set showtype popular search (do not render now, but with no result render populars)
      this.showType = 2;
      $.ajax({
        url: "SearchAutoSuggestKeywordsJson",
        dataType: "json",
        aysnc: false,
        data: {
          searchTerm: keyword,
          storeId: this.storeId,
          langId: this.langId,
          catalogId: this.catalogId
        },
        success: function success(data) {
          // Set showtype suggested search (render if products has ended)
          _this3.showType = _this3.showType / 2;
          _this3.articlesBlog = data;
          _this3.startedReqKeywords = false;
          if (typeof callback === 'function' && !_this3.startedReqProducts) {
            callback.call(_this3);
          }
        },
        error: function error() {
          try {
            analyticsFramework.asyncSendErrorEvolvedDetails('Unable to search for pages', null, 'Client', 'Search');
          } catch (e) {}
          if (typeof failCallback === 'function') {
            failCallback.call(_this3);
          }
        }
      });
      if (typeof this.mapViewRequested[keyword] === "undefined" || this.mapViewRequested[keyword] === null || !this.mapViewRequested[keyword]) {
        // check if products has already been loaded
        this.mapViewRequested[keyword] = true;
        $.ajax({
          url: "SearchAutoSuggestProductsView",
          data: {
            searchTerm: keyword,
            storeId: this.storeId,
            langId: this.langId,
            catalogId: this.catalogId,
            reqType: 'ajax',
            customExpr: $("#searchForm .customExpr").val()
          },
          type: "GET",
          success: function success(data) {
            _this3.showType = 0;
            _this3.createViewWithProducts(keyword, data);
            _this3.startedReqProducts = false;
            /* OPSMD-4639*/
            try {
              if ($(data).filter("title").text() && $(data).filter("title").text().toLowerCase().indexOf('error') != -1) {
                analyticsFramework.asyncSendErrorEvolvedDetails('Unable to search for products', null, 'Client', 'Search');
              }
            } catch (e) {}
            if (typeof callback === 'function' && !_this3.startedReqKeywords) {
              callback.call(_this3);
            }
          },
          error: function error() {
            try {
              analyticsFramework.asyncSendErrorEvolvedDetails('Unable to search for products', null, 'Client', 'Search');
            } catch (e) {}
            _this3.mapViewRequested[keyword] = false;
            if (typeof failCallback === 'function') {
              failCallback.call(_this3);
            }
          }
        });
      } else {
        var view = void 0;
        $(".suggested-products-view").each(function () {
          if ($(this).data("suggested-products-term") === keyword) {
            view = $(this);
          }
        });
        if (typeof view !== "undefined" && view.find(".product.card").length !== 0) {
          this.showType = 0;
          callback.call(this);
        } else {
          this.startedReqProducts = false;
        }
      }
    }
  }, {
    key: "renderResults",
    value: function renderResults() {
      // OPSMD-13504: fire the NO-SERP "search run" analytics event for the
      // auto-suggest overlay (the SERP page fires its own Events_SearchRun).
      this.trackSearchRun();
      switch (this.showType) {
        case 0:
          this.showProductResults();
          break;
        case 1:
          this.showArticleResults();
          break;
        case 2:
          this.showTopSearch();
          break;
        default:
          this.showTopSearch();
      }
    }

    /**
     * OPSMD-13504: push the NO-SERP "search run" event (Events_SearchRun = 1)
     * once per searched term while the user types in the auto-suggest overlay.
     * The data layer payload is built by analyticsFramework.eventSearchRun().
     */

  }, {
    key: "trackSearchRun",
    value: function trackSearchRun() {
      var _this4 = this;

      // OPSMD-13504: debounce the push so only the term the user settles on is
      // tracked. Keyword AND result count are read when the timeout fires (not at
      // schedule time): requestSearching uses shared instance state that
      // overlapping/slow searches mutate, so reading at settle time avoids
      // reporting a stale keyword or a result set that is not rendered yet.
      clearTimeout(this.trackWait);
      this.trackWait = setTimeout(function () {
        var keyword = _this4.keyword;
        // Skip empty terms and avoid re-firing for the same settled term.
        if (!keyword || keyword === _this4.lastSearchRunTracked) {
          return;
        }

        // Count the product cards in the suggested-products view of this term,
        // reusing the same selector the overlay uses to detect loaded products.
        var resultItemsQnt = 0;
        _this4.divSuggestedProducts.find(".suggested-products-view").each(function () {
          if ($(this).data("suggested-products-term") == keyword) {
            resultItemsQnt = $(this).find(".product.card").length;
          }
        });

        _this4.lastSearchRunTracked = keyword;
        try {
          // "text": the overlay only handles typed search. Barcode/image search
          // come from other entry points and set their own Search_Type.
          analyticsFramework.eventSearchRun(keyword, "text", resultItemsQnt);
        } catch (e) {}
      }, this.trackWaitTime);
    }

    /**
     * request for popular searches
     * @todo: replace with your real request URL to get popular searches
     */
    // requestTopSearches() {
    //   $.getJSON('topSearches.json', (data) => {
    //     this.topSearches = data;
    //   });
    // }

  }, {
    key: "createViewWithProducts",
    value: function createViewWithProducts(keyword, data) {
      // try bad formatting
      var views = this.divSuggestedProducts.find(".suggested-products-view"),
          currentView = void 0;
      views.each(function () {
        if ($(this).data("search-keyword") === keyword) {
          currentView = $(this);
        }
      });
      if (typeof currentView === "undefined" || currentView === null) {
        $("#suggested-products-views").append(data);
        if ($(data).filter(".row").find(".product.card").length === 0) {
          this.showType = 2;
        }
        $(".ghost-thumbnail").parent().addClass("d-none");
      }
    }

    /**
     * search for products
     * @param {*} listProducts 
     */

  }, {
    key: "showProductResults",
    value: function showProductResults(listProducts) {
      this.labelSearchResult.hide();
      this.divPopularResults.hide();
      this.divSuggestedKeywords.hide();
      this.divSuggestedProductsLabel.show();
      this.divSuggestedProducts.show();
      this.divSuggestedProducts.find(".suggested-products-view").hide();
      var currentKeyword = this.keyword;
      this.divSuggestedProducts.find(".suggested-products-view").each(function () {
        if ($(this).data("suggested-products-term") == currentKeyword) {
          $(this).show();
        }
      });
    }

    /**
     * Search for other things
     * @param {*} keywords 
     * @param {*} label 
     */

  }, {
    key: "showArticleResults",
    value: function showArticleResults() {
      if (this.articlesBlog.length > 0) {
        var listArticles = [];
        this.articlesBlog.forEach(function (article) {
          listArticles.push(article.name);
        });
        this.labelSearchResult.text("Suggested Articles");
        this.labelSearchResult.show();
        this.divPopularResults.hide();
        this.divSuggestedKeywords.show();
        this.divSuggestedKeywords.empty();
        this.divSuggestedProductsLabel.hide();
        this.divSuggestedProducts.hide();
        var suggestedKeywords = $('<div></div>');
        if (listArticles.length > 0) {
          var fiveKeys = listArticles.slice(0, 5);
          fiveKeys.forEach(function (result) {
            if (typeof result === "string") {
              suggestedKeywords.append("<a href=\"#\" class=\"list-group-item search--searches-found\" data-search-term=\"" + result + "\">" + result + "</a>");
            } else {
              suggestedKeywords.append("<a href=\"#\" class=\"list-group-item search--searches-found\" data-search-term=\"" + result.title + "\">" + result.title + "</a>");
            }
          });
          this.divSuggestedKeywords.append(suggestedKeywords);
        }
      } else {
        this.showTopSearch();
      }
    }
  }, {
    key: "showTopSearch",
    value: function showTopSearch() {
      this.labelSearchResult.text("Popular searches");
      this.labelSearchResult.show();
      this.divPopularResults.show();
      this.divSuggestedKeywords.hide();
      this.divSuggestedProductsLabel.hide();
      this.divSuggestedProducts.hide();
    }

    /**
     * get host / domain
     */

  }, {
    key: "getUrlOrigin",
    value: function getUrlOrigin() {
      return window.location.origin;
    }

    /**
     * close search overlay
     */

  }, {
    key: "closeSearchOvl",
    value: function closeSearchOvl() {
      this.searchInput.val('');
      this.searchOverlay.fadeOut();
    }
  }, {
    key: "handleIE",
    value: function handleIE() {
      /*
       * OPSMD Bug - 3631 : Hot Fix for IE Browser 11 - Not support
       * placeholder in text for search TODO - Temporary Fix
       */
      if (!Modernizr || !Modernizr.input || !Modernizr.input.placeholder) {
        var $inputEl = this.searchInput;

        var renderPlaceHolder = function renderPlaceHolder(inputSelectorStr) {
          var $inputEl = $(inputSelectorStr);
          if (!$inputEl.length) return;
          var origColor = $inputEl.css('color');
          if ($inputEl.val() == "" && $inputEl.attr("placeholder") != "") {
            $inputEl.val($inputEl.attr("placeholder"));
            $inputEl[0].setSelectionRange(0, 0);
            $inputEl.css('color', 'rgb(85, 85, 85)');
          }
          $(document).one('keydown blur click', inputSelectorStr, function () {
            if ($(this).val() == $(this).attr("placeholder")) {
              $(this).val("");
              $(this).css('color', origColor);
            }
          });
        };

        if ($('#btn-search').length) {
          $('#btn-search').on('click', function () {
            if ($inputEl.length) {
              renderPlaceHolder("input#search-input");
            }
          });
        }
      }
    }
  }]);

  return SearchOverlay;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Sidemenu = function () {
    function Sidemenu() {
        var _this = this;

        _classCallCheck(this, Sidemenu);

        var self = this;
        this.BODY_SHOW_SIDEMENU_CLASS = 'open-sidemenu';
        this.SIDEMENU_ACTIVE_CLASS = 'sidemenu--active';
        this.SIDEMENU_INNER_CLASS = 'sidemenu--inner';
        this.SIDEMENU_ENTER_EFFECT = 'slideInLeft';
        this.SIDEMENU_EXIT_EFFECT = 'slideOutLeft';
        this.SIDEMENU_HASCHILD_CLASS = 'sidemenu--item--has-child';
        this.SIDEMENU_MAINNAV_CLASS = 'sidemenu--main';
        this.SIDEMENU_SUBNAV_CLASS = 'sidemenu--subnav';
        this.SIDEMENU_SUBNAV_BTNBACK_CLASS = 'sidemenu--subnav-back-btn';
        this.SIDEMENU_OVERLAY_CLASS = 'sidemenu--overlay';
        this.SIDEMENU_FIRSTLEVEL_CLASS = 'sidemenu--subnav-first-level';

        this.menuEle = $('#sidemenu');
        // this.btnClose = $('#btn-close-sidemenu');
        this.btnCloseOpen = $('#btn-toggle-sidemenu');
        this.body = $('html, body');

        // this.btnClose.on('click', () => {
        //         this.closeMenu();
        // });
        this.btnCloseOpen.off("click").on('click', function () {
            if ($('#btn-toggle-sidemenu').hasClass('sidemenu--btn-close')) {
                _this.closeMenu();
            } else {
                _this.openMenu();
            }
        });

        $('.' + this.SIDEMENU_HASCHILD_CLASS).on('click', '> a', function (e) {
            e.preventDefault();
            var toLevel = $(this).attr("to-level");
            self.openSubMenu($(this).parent(), toLevel);
        });

        $('.' + this.SIDEMENU_SUBNAV_BTNBACK_CLASS).on('click', function () {
            var toLevel = $(this).attr("to-level");
            self.closeSubMenu($(this).closest('.' + self.SIDEMENU_SUBNAV_CLASS), toLevel);
        });

        // @todo: remove this line
        // this.openMenu();

        $('.' + this.SIDEMENU_OVERLAY_CLASS).on('click', function () {
            _this.closeMenu();
        });
    }

    /**
     * open sidemenu
     */


    _createClass(Sidemenu, [{
        key: 'openMenu',
        value: function openMenu() {
            var _this2 = this;

            if (this.menuEle.is(':hidden') && !this.btnCloseOpen.hasClass("sidemenu--btn-close")) {
                // disable body overflow
                this.body.addClass(this.BODY_SHOW_SIDEMENU_CLASS);
                document.documentElement.style.setProperty('--win-height', $(window).height() + 'px');

                // active / display the menu -> run effect
                this.menuEle.addClass(this.SIDEMENU_ACTIVE_CLASS).find('.' + this.SIDEMENU_INNER_CLASS).animateCss(this.SIDEMENU_ENTER_EFFECT);

                // show overlay
                this.menuEle.find('.' + this.SIDEMENU_OVERLAY_CLASS).animateCss('fadeIn', function () {
                    _this2.menuEle.find('.' + _this2.SIDEMENU_OVERLAY_CLASS).addClass('show');
                });
                this.btnCloseOpen.addClass("sidemenu--btn-close");
            }
        }

        /**
         * close sidemenu
         */

    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            var _this3 = this;

            if (this.menuEle.is(':hidden') && !this.btnCloseOpen.hasClass("sidemenu--btn-close")) {
                return;
            }

            // enable body overflow
            this.body.removeClass(this.BODY_SHOW_SIDEMENU_CLASS);

            // hide overlay
            this.menuEle.find('.' + this.SIDEMENU_OVERLAY_CLASS).animateCss('fadeOut', function () {
                _this3.menuEle.find('.' + _this3.SIDEMENU_OVERLAY_CLASS).removeClass('show');
            });

            // at the same time, slide out menu content, then hide whole sidebar
            this.menuEle.find('.' + this.SIDEMENU_INNER_CLASS).animateCss(this.SIDEMENU_EXIT_EFFECT, function () {
                _this3.menuEle.removeClass(_this3.SIDEMENU_ACTIVE_CLASS);

                // close any opening sub menu
                _this3.menuEle.find('.' + _this3.SIDEMENU_SUBNAV_CLASS).not('.' + _this3.SIDEMENU_FIRSTLEVEL_CLASS).removeClass(_this3.SIDEMENU_SUBNAV_CLASS + '--active');
            });
            this.btnCloseOpen.removeClass("sidemenu--btn-close");
        }
    }, {
        key: 'mobileLinklistVisibility',
        value: function mobileLinklistVisibility(level) {
            if (typeof level != 'undefined') {
                $(".placeholder-content-mobile").css('display', 'none');
                $(".placeholder-sidebar-mobile").css('display', 'none');

                $(".level-" + level).css('display', 'block');
            } else {
                console.log("Level unknown for mobile menu");
            }
        }
    }, {
        key: 'openSubMenu',
        value: function openSubMenu(menuItemEle, toLevel) {
            // push sub menu into view
            //console.log("tolevel -> "+toLevel);
            this.mobileLinklistVisibility(toLevel);
            $(menuItemEle).children('.' + this.SIDEMENU_SUBNAV_CLASS).addClass(this.SIDEMENU_SUBNAV_CLASS + '--active').animateCss('slideInRight');
        }
    }, {
        key: 'closeSubMenu',
        value: function closeSubMenu(subMenu, toLevel) {
            var _this4 = this;

            //console.log("tolevel -> " + toLevel);
            this.mobileLinklistVisibility(toLevel);
            $(subMenu).animateCss('slideOutRight', function () {
                $(subMenu).removeClass(_this4.SIDEMENU_SUBNAV_CLASS + '--active');
            });
        }
    }]);

    return Sidemenu;
}();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// usermenu in mobile
var SidemenuUser = function () {
    function SidemenuUser() {
        _classCallCheck(this, SidemenuUser);

        var _this = this;
        this.BODY_SHOW_SIDEMENU_CLASS = 'open-sidemenu';
        this.SIDEMENU_ACTIVE_CLASS = 'sidemenu--active';
        this.SIDEMENU_INNER_CLASS = 'sidemenu--inner';
        this.SIDEMENU_ENTER_EFFECT = 'slideInLeft';
        this.SIDEMENU_EXIT_EFFECT = 'slideOutLeft';
        this.SIDEMENU_HASCHILD_CLASS = 'sidemenu--item--has-child';
        this.SIDEMENU_MAINNAV_CLASS = 'sidemenu--main';
        this.SIDEMENU_SUBNAV_CLASS = 'sidemenu--subnav';
        this.SIDEMENU_SUBNAV_BTNBACK_CLASS = 'sidemenu--subnav-back-btn';
        this.SIDEMENU_OVERLAY_CLASS = 'sidemenu--overlay';

        this.menuEle = $('#sidemenuaccount');
        this.btnClose = $('.sidemenu--btn-close');
        this.body = $('html, body');

        if (this.menuEle.length === 0) {
            return;
        }

        this.btnClose.on('click', function () {
            _this.closeMenu();
        });

        $('.' + this.SIDEMENU_OVERLAY_CLASS).on('click', function () {
            _this.closeMenu();
        });
    }

    /**
     * open sidemenu
     */

    _createClass(SidemenuUser, [{
        key: 'openMenu',
        value: function openMenu() {
            var _this2 = this;

            if (this.menuEle.is(':hidden')) {
                // disable body overflow
                this.body.addClass(this.BODY_SHOW_SIDEMENU_CLASS);
                document.documentElement.style.setProperty('--win-height', $(window).height() + 'px');

                // active / display the menu -> run effect
                this.menuEle.addClass(this.SIDEMENU_ACTIVE_CLASS).find('.' + this.SIDEMENU_INNER_CLASS).animateCss(this.SIDEMENU_ENTER_EFFECT);

                // show overlay
                this.menuEle.find('.' + this.SIDEMENU_OVERLAY_CLASS).animateCss('fadeIn', function () {
                    _this2.menuEle.find('.' + _this2.SIDEMENU_OVERLAY_CLASS).addClass('show');
                });
            }
        }

        /**
         * close sidemenu
         */

    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            var _this3 = this;

            if (this.menuEle.is(':hidden')) {
                return;
            }

            // enable body overflow
            this.body.removeClass(this.BODY_SHOW_SIDEMENU_CLASS);

            // hide overlay
            this.menuEle.find('.' + this.SIDEMENU_OVERLAY_CLASS).animateCss('fadeOut', function () {
                _this3.menuEle.find('.' + _this3.SIDEMENU_OVERLAY_CLASS).removeClass('show');
            });

            // at the same time, slide out menu content, then hide whole sidebar
            this.menuEle.find('.' + this.SIDEMENU_INNER_CLASS).animateCss(this.SIDEMENU_EXIT_EFFECT, function () {
                _this3.menuEle.removeClass(_this3.SIDEMENU_ACTIVE_CLASS);

                // close any opening sub menu
                _this3.menuEle.find('.' + _this3.SIDEMENU_SUBNAV_CLASS).removeClass(_this3.SIDEMENU_SUBNAV_CLASS + '--active');
            });
        }
    }]);

    return SidemenuUser;
}();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SizingAndFit = function SizingAndFit() {
        _classCallCheck(this, SizingAndFit);

        var sizeMap = { 'S': '#small', 'STD': '#standard', 'L': '#wide' };
        var modal = $('#modal-sizing-fit');
        if (modal.length === 0) {
                return;
        }

        modal.find('.lens-width').text($("#lens-width").val());
        modal.find('.bridge-width').text($("#bridge-width").val());

        var sizeBriefSelect = modal.find('.product--size-brief-select');
        var sizeBriefContent = modal.find('.product--size-brief-content');

        /*
         *		OPSMD - 2209 Bug - items -  #small #wide  #standard and event for individually data, 
         */
        this.tabClick = modal.find('.btn');
        //        this.tabClick.on('click', (event) => {
        //            const target = $(event.target).data('target');
        //            modal.find('.btn').removeClass("active");
        //            modal.find('.item').removeClass("active");
        //            $(event.target).addClass("active");
        //            $(target).addClass("active");
        //        
        //        });

        var $skuSize = $('input#display-size');
        modal.find('.btn').addClass("active");
        if ($skuSize.val() && sizeMap[$skuSize.val()]) {
                modal.find('.btn').removeClass("active");
                //        	modal.find(".btn[data-target='${sizeMap[$skuSize.val()]}']").click();
                modal.find(".btn[data-target='" + sizeMap[$skuSize.val()] + "']").addClass("active");
        }
        //        sizeBriefSelect.on('click', '.btn', (event) => {
        //            const btn = $(event.target);
        //            sizeBriefSelect.find('.btn').removeClass('active');
        //            btn.addClass('active');
        //     lensWidth.text(btn.data('lens-width'));
        //     bridgeWidth.text(btn.data('bridge-width'));

        //            const target = btn.data('target');
        //            sizeBriefContent.find('.item').removeClass('active');
        //            sizeBriefContent.find('.item' + target).addClass('active');
        //        });
};
'use strict';

/**
 * Init SlideShow grid
 */
;(function ($) {
    $(function () {
        var slideshowGrid = $('.opsm-slideshow--slide[data-slide-type="grid-area"]');
        slideshowGrid.not('.slick-initialized').slick({
            dots: false,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }]
        });
    });
})(jQuery);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SortBy = function () {
    function SortBy(elementId) {
        var _this = this;

        _classCallCheck(this, SortBy);

        this.ele = $(elementId);

        if (this.ele.length === 0) {
            return;
        }

        this.nativeSelect = this.ele.find('select');
        this.dropdown = this.ele.find('.dropdown');
        this.setText();

        this.nativeSelect.on('change', function () {
            _this.setText();
        });

        this.dropdown.find('.dropdown-item').on('click', function (event) {
            var link = $(event.target);
            var value = link.data('value');
            _this.dropdown.find('.dropdown-item').removeClass("selected");
            $(link).addClass("selected");
            _this.nativeSelect.val(value);
            _this.setText();
        });
    }

    _createClass(SortBy, [{
        key: 'setText',
        value: function setText() {
            var selectedOption = this.nativeSelect.find('option:selected');
            this.ele.find('.sort-by--selected-text').html(selectedOption.html());
        }
    }]);

    return SortBy;
}();

$(document).ready(function () {
    new SortBy('#product-sort-by');
});
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StickyBookingSummary = function StickyBookingSummary() {
    var _this = this;

    _classCallCheck(this, StickyBookingSummary);

    this.booking = $('#booking-summary');

    if (this.booking.length === 0) {
        return;
    }

    if (!Modernizr.csspositionsticky) {
        this.booking.affix({
            offset: {
                top: function top() {
                    return this.top = $('.header').outerHeight() + $('.baet-step').outerHeight() + $('.baet-step--back-nav').outerHeight();
                },
                bottom: function bottom() {
                    return this.bottom = $('.footer').outerHeight() + 210;
                }
            }
        }).on('affixed.bs.affix', function () {
            var wrapper = $('.booking--ie-wrapper');
            _this.booking.css({
                'width': wrapper.width(),
                'left': ''
            });
        }).on('affixed-bottom.bs.affix', function () {
            var wrapper = $('.booking--ie-wrapper');
            _this.booking.css({
                'width': wrapper.width(),
                'left': 15
            });
        }).parent().addClass('booking--ie-wrapper');
    }
};

;

(function ($) {
    $(document).ready(function () {
        if ($('#booking-summary').length) {
            new StickyBookingSummary();
        }
    });
})(jQuery);
//import mapStore.js | autocomplete.js
/* Doesn't work, line 5 broken. Imported MapStoreLocator
class StoreLocator {
    constructor(isNotAutoInit,favoriteMap) {
      _classCallCheck(this, MapStoreLocator);
         this.elmMap = $('#map');
         if (this.elmMap.length === 0) {
           return;
         }
         this.searchStore = $('#searchStore-find');
         this.btnShowMore = $('#btn-show-more');
         this.storeList = $('.select-store--list-inner');
         this.spinner = $('#load-more-product-spinner');
         this.showMoreWrap = $('.select-store--showmore');
         this.mapWrap = $('.select-store--maps');
         this.mapSticky = $('.select-store--maps--sticky');
         this.btnSelectMap = $('#select-map');
         this.btnBackListMap = $('#back-list-view');
         this.mapInstance = {};
         this.listMarket = [];
         this.storeItem = $('.select-store--item');
         this.btnUseMyLocation = $('#use-my-location');
         this.dataStore = [];
         this.newDataStore = [];

         if(!favoriteMap){

           this.btnUseMyLocation.on('click', function () {
             _this.btnUseMyLocation.find('.loading').removeClass('d-none');
             if (navigator.geolocation) {
               try {
                 navigator.geolocation.getCurrentPosition(_this.showPosition.bind(_this));
               } catch (ex) {
                 _this.useGoogleApiToGetLocation();
               }
             } else {
               _this.useGoogleApiToGetLocation();
             }
           });

         }

         if (!isNotAutoInit) {
           this.init();
         }

         if(!favoriteMap){

           this.searchStore.on('submit', function (e) {
             var val = $('#field-booking').val();
             e.preventDefault();
             _this.handleSearchStore(val);
           });

           this.btnShowMore.on('click', function () {
             _this.btnShowMore.addClass('d-none');
             _this.spinner.removeClass('d-none');

             _this.showMoreStore(function () {
               _this.btnShowMore.removeClass('d-none');
               _this.spinner.addClass('d-none');
             });
           });
         }else{
             this.handleFavoriteStore();
         }


         this.btnSelectMap.on('click', function () {
           _this.mapSticky.addClass('open');
           _this.storeList.addClass('openMobile');
           $('html').addClass('openMaps');
         });

         this.btnBackListMap.on('click', function () {
           _this.mapSticky.removeClass('open');
           _this.storeList.removeClass('openMobile');
           $('html').removeClass('openMaps');
         });

         if (!Modernizr.csspositionsticky) {

           $('.select-store--maps--sticky').affix({
             offset: {
               top: function top() {
                 return this.top = $('.baet-step').outerHeight() + $('.select-store--header').outerHeight();
               },
               bottom: function bottom() {
                 return this.bottom = $('.footer').outerHeight();
               }
             }
           }).on('affixed.bs.affix', function () {
             var wrapper = $('.filters--ie-wrapper');
             $('.select-store--maps--sticky').css({
               'width': wrapper.width(),
               'left': wrapper.offset().left,
               'top': $('.header').outerHeight()
             });
           }).on('affixed-top.bs.affix, affixed-bottom.bs.affix', function () {
             $('.select-store--maps--sticky').css({
               'width': '',
               'left': '',
               'top': ''
             });
           }).parent().addClass('filters--ie-wrapper');
         }

         $(window).scroll(function () {
           if (!UtilsOmnys.isSmallDesktopAndAbove()) {
             return;
           }

           if (!$('html').is('.csspositionsticky')) {
             return;
           }

           var scrollTop = $(window).scrollTop();
           var storeContent = $('.select-store--content').position().top;
           var headerStickyHeight = $('.header').is('.sticky-ing') ? $('#opsm-header-sticky').height() : 0;
           var isStickyHeaderHidden = $('#opsm-header-sticky').is('.temp-hidden');
           if (scrollTop >= storeContent - headerStickyHeight && !isStickyHeaderHidden) {
             _this.mapSticky.css('top', headerStickyHeight);
           } else {
             _this.mapSticky.css('top', '');
           }
         });

    }

    openDetailStore(e,id){
     $.getJSON('search-store.json', function (data) {
       var dataShow = data;
       dataShow.forEach(function (store, index) {
         if(store.id == id){
           $("#store-name").html(store.nameStreet);
           $("#store-address").html(store.address);
           $("#store-tel .value").html(store.tel);
           $("#store-fax .value").html(store.fax);
           $("#store-openGmap,#store-openGmapMob").attr("href","https://www.google.com/maps/search/?api=1&query="+ store.nameStreet+"+"+ store.address);
           var hours = store.openingHours.map(function (hour) {
             return '<li><span class="label">' + hour.day + '</span><span class="value">' + hour.time + '</span></li>';
           });
           var slides = store.slidesStore.map(function (slide) {
             return '<div class="opsm-slideshow--slide-item"><img src="' + slide.pic + '"/></div>';
           });
           $("#store-openinghours").html(hours);
           $("#store-screenmap img").attr("src","https://maps.googleapis.com/maps/api/staticmap?center="+ store.lat +","+ store.lng +"&zoom=15&size=640x300&key=" + window.googleApiKey + "&maptype=roadmap&format=jpg&visual_refresh=true&markers=icon:http://static.omnys.com/opsm/newdesign/assets/images/icons/icon_marker.png|"+ store.lat +","+ store.lng +"");
           $("#store-slideshow .opsm-slideshow--slide").html(slides);
           var slideshowSingle = $('.opsm-slideshow--slide[data-slide-type="storedetail"]');
           slideshowSingle.slick({
               slidesToShow: 1,
               slidesToScroll: 1,
               infinite: true,
               dots: true
           });
           $("#opsm-modal-detailstore").modal();
           $("#opsm-modal-detailstore").on("hidden.bs.modal",function(){
             slideshowSingle.slick("unslick");
           });
         }
       });
     });
   }
   showStore(store, index, favorite) {
      var hours = store.openingHours.map(function (hour) {
        return '<li><span class="day">' + hour.day + '</span><span>' + hour.time + '</span></li>';
      });
        // Matteo - aggiungere il controllo se sono loggato e se lo store è già presente tra i miei preferiti
        var favoritelink = '';
        var favoritelink_d = '';
        var logged = true; // qui serve una chiamata per sapere se l'utente è loggato

        if(favorite && logged){
          favoritelink = '<a href="" class="visible-mobile underline mt-2"><strong>Add to My Stores</strong></a>';
          favoritelink_d = '<a href="" class="visible-desktop underline mt-2"><strong>Add to My Stores</strong></a>';
        }

        var item = $('\n    <div class="select-store--item" data-index="' + index + '" data-lat="' + store.lat + '" data-lng="' + store.lng + '">\n      <div class="select-store--item--marker">\n        <span class="icon"><img src="assets/images/icons/icon_marker.png"></span>\n        <span class="number">' + store.id + '</span>\n      </div>\n      <div class="select-store--item--info">\n        <div class="select-store--item--inner">\n          <h6 class="select-store--item--street">' + store.nameStreet + '</h6>\n          <p class="select-store--item--add">' + store.address + '<br/>'+ favoritelink +'</p>\n          <div class="select-store--item--openhours">\n            <a class="btn btn-link collapsed" data-toggle="collapse" href="#tab' + store.id + '" role="button" aria-expanded="false" aria-controls="tab' + store.id + '">\n              <span class="text">Opening hours</span>\n              <span class="icon icon-chevron-left"></span>\n            </a>\n            <div class="collapse" id="tab' + store.id + '" data-parent="#accordion">\n              <ul class="list-unstyled select-store--item--hour">\n                ' + hours.join('') + '\n              </ul>\n            </div>\n          </div>\n        </div>\n     <div>   <a id="openstoredetail-'+ store.id +'" onclick="UtilsOmnys.openDetailStore(event, '+ store.id +')" class="button button--primary button--primary--dark" style="padding:13px 15px;"><span class="button--label">store details</span></a> <br/> \n  '+ favoritelink_d +' </div>\n</div>\n    </div>\n    ');

     return item;
    }
    showStoreFavorite(store, index) {
      var hours = store.openingHours.map(function (hour) {
        return '<li><span class="day">' + hour.day + '</span><span>' + hour.time + '</span></li>';
      });

      var item = $('\n    <div class="select-store--item opsm-bordered-fluid-div mb-4" style="padding:0;display:block" data-index="' + index + '" data-lat="' + store.lat + '" data-lng="' + store.lng + '">\n <div class="opsm-bordered-header">\n<div class="div-flex w-100"><p><strong><span class="number">' + store.id + '.</span> ' + store.nameStreet + '</strong></p>\n</div></div>\n <div class="opsm-bordered-body py-0">\n<p class="visible-mobile"><img src="https://maps.googleapis.com/maps/api/staticmap?center='+ store.lat +', '+ store.lng +'&zoom=15&size=640x300&key=' + window.googleApiKey+'&maptype=roadmap&format=jpg&visual_refresh=true&markers=icon:http://static.omnys.com/opsm/newdesign/assets/images/icons/icon_marker.png|'+ store.lat +','+ store.lng+'" /></p><p class="select-store--item--add">' + store.address + '</p>\n<p><a class="strong underline" target="_blank" href="https://www.google.com/maps/search/?api=1&query='+ store.nameStreet+'+'+ store.address+'" >Get directions</a></p>\n<p>Tel: <strong>'+store.tel+'</strong></p><p>Open today: <strong>'+store.today+'</strong></p>\n<hr/>\n<div class="select-store--item--openhours">\n<a class="btn btn-link collapsed" data-toggle="collapse" href="#tab' + store.id + '" role="button" aria-expanded="false" aria-controls="tab' + store.id + '">\n<span class="text">Opening hours</span>\n<span class="icon icon-chevron-left"></span>\n </a>\n<div class="collapse" id="tab' + store.id + '" data-parent="#accordion">\n<ul class="list-unstyled select-store--item--hour">\n' + hours.join('') + '\n</ul>\n</div>\n<p class="pt-3 pb-2"><a href="#" class="strong underline">Book an eye test</a></p><a id="openstoredetail-'+ store.id +'" onclick="UtilsOmnys.openDetailStore(event, '+ store.id +')" class="button button--primary button--primary--dark" style="padding:13px 15px;width:auto"><span class="button--label">store details</span></a> <br/><p class="text-right pt-5"><a onClick="removeFavoriteStore"><span class="fa icon-close pr-2" style="font-size:.8rem"></span><span class="underline">Remove</span></a></p> \n</div>\n</div>\n');

     return item;
    }
}
*/
"use strict";
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Subscription = function () {
	function Subscription() {
		_classCallCheck(this, Subscription);
	}

	_createClass(Subscription, null, [{
		key: 'updateLensOrderFrequency',
		value: function updateLensOrderFrequency() {
			var leftValNum = parseInt($('#left-boxes').val());
			var rightValNum = parseInt($('#right-boxes').val());
			var freq = parseFloat($("#refill").attr("attr-freq"));
			//var freqUOM = $("#refill-uom").attr("attr-freq-uom"));
			if (isNaN(freq)) return;
			if (isNaN(leftValNum)) leftValNum = 0;
			if (isNaN(rightValNum)) rightValNum = 0;
			if (0 == leftValNum + rightValNum) return;
			var refillPeriodDays = 0;
			if (0 < leftValNum) {
				refillPeriodDays = leftValNum * freq;
			}
			if (0 < rightValNum) {
				refillPeriodDays = rightValNum * freq < refillPeriodDays || refillPeriodDays < 1 ? rightValNum * freq : refillPeriodDays;
			}
			if (refillPeriodDays < 1) {
				console.error("Bad value for refillPeriodDays " + refillPeriodDays);
				return;
			}
			var months = Math.floor(refillPeriodDays / 30);
			var days = refillPeriodDays % 30;
			var html = months + " months";
			if (days != 0) {
				html += " and " + days + " days";
			}
			$(".the-period").html(html);
			var optionVal = refillPeriodDays + "_DAY";
			var recommendedText = " (Recommended)";
			var currentText = "";
			if ($("#freq-selection option.recommended").length) {
				currentText = $("#freq-selection option.recommended").html();
				if (-1 != currentText.indexOf(recommendedText)) {
					currentText = currentText.slice(0, currentText.indexOf(recommendedText));
					$("#freq-selection option.recommended").html(currentText);
				}
				$("#freq-selection option.recommended").removeClass("recommended");
			}
			if (!$("#freq-selection option[value='" + optionVal + "']").length) {
				$('<option class="recommended" value="' + optionVal + '">Every ' + html + recommendedText + '</option>').appendTo($("#freq-selection"));
				var $optionList = $("#freq-selection").find('option');
				var sortList = Array.prototype.sort.bind($optionList);
				sortList(function (a, b) {
					try {
						var aVal = parseInt($(a).attr('value').split("_")[0]);
						var bVal = parseInt($(b).attr('value').split("_")[0]);
						// Returning -1 will place element `a` before element `b`
						if (aVal < bVal) {
							return -1;
						} else if (aVal > bVal) {
							return 1;
						} else return 0;
					} catch (e) {
						return 0;
					}
				});
				$("#freq-selection").append($optionList);
				try {
					$("#freq-selection").hybridSelect('buildDropdownMenu');
				} catch (e) {}
			} else {
				currentText = $("#freq-selection option[value='" + optionVal + "']").html();
				if (-1 != currentText.indexOf(recommendedText)) {
					currentText = currentText.slice(0, currentText.indexOf(recommendedText));
				}
				$("#freq-selection option[value='" + optionVal + "']").html(currentText + recommendedText).addClass("recommended");
			}
			$("#freq-selection").val(optionVal).trigger('change');
			try {
				$("#freq-selection").hybridSelect('select');
			} catch (e) {}
		}
	}, {
		key: 'checkAddRecommOptionCart',
		value: function checkAddRecommOptionCart($el) {
			if ('undefined' !== typeof $el && $el.length) {
				if ($el.is('select') && $el.find('option.recommended').length < 1) {
					var origiVal = $el.val();
					//add the option
					//var leftValNum = parseInt($el.closest('.prod-info-wrapper').find('#left-boxes').val());
					//var rightValNum = parseInt($el.closest('.prod-info-wrapper').find('#right-boxes').val());
					//var freq = parseFloat($el.closest('.freq-wrapper').find('').attr("attr-freq"));
					////var freqUOM = $el.closest('.freq-wrapper').find('').attr("attr-freq-uom"));
					//if(isNaN(freq)) return;
					//if(isNaN(leftValNum)) leftValNum = 0;
					//if(isNaN(rightValNum)) rightValNum = 0;
					//if(0 == leftValNum + rightValNum) return;
					//var refillPeriodDays = 0;
					//				if(0 < leftValNum){
					//					refillPeriodDays = leftValNum * freq;
					//				}
					//				if(0 < rightValNum){
					//					refillPeriodDays = rightValNum * freq < refillPeriodDays ? rightValNum * freq : refillPeriodDays;
					//				}
					var refillPeriodDays = parseFloat($el.closest('.freq-wrapper').find('input.refill-calc').attr("attr-freq"));
					if (isNaN(refillPeriodDays)) return;
					var months = Math.floor(refillPeriodDays / 30);
					var days = refillPeriodDays % 30;
					var html = months + " months";
					if (days != 0) {
						html += " and " + days + " days";
					}
					//				$(".the-period").html(html);
					var optionVal = refillPeriodDays + "_DAY";
					var recommendedText = " (Recommended)";
					var currentText = "";
					//				if($("#freq-selection option.recommended").length){
					//					currentText = $("#freq-selection option.recommended").html();
					//					if(-1 != currentText.indexOf(recommendedText)){
					//						currentText = currentText.slice(0, currentText.indexOf(recommendedText));
					//						$("#freq-selection option.recommended").html(currentText);
					//					}
					//					$("#freq-selection option.recommended").removeClass("recommended");
					//				}
					if (!$el.find('option.recommended').length && !$el.find("option[value='" + optionVal + "']").length) {
						$('<option class="recommended" value="' + optionVal + '">Every ' + html + recommendedText + '</option>').appendTo($el);
						var $optionList = $el.find('option');
						var sortList = Array.prototype.sort.bind($optionList);
						sortList(function (a, b) {
							try {
								var aVal = parseInt($(a).attr('value').split("_")[0]);
								var bVal = parseInt($(b).attr('value').split("_")[0]);
								// Returning -1 will place element `a` before element `b`
								if (aVal < bVal) {
									return -1;
								} else if (aVal > bVal) {
									return 1;
								} else return 0;
							} catch (e) {
								return 0;
							}
						});
						$el.append($optionList);
						$el.val(origiVal);
						try {
							$el.hybridSelect('buildDropdownMenu');
							$el.hybridSelect('select');
						} catch (e) {}
					}
					//				else  {
					//					currentText = $("#freq-selection option[value='"+ optionVal +"']").html();
					//					if(-1 != currentText.indexOf(recommendedText)){
					//						currentText = currentText.slice(0, currentText.indexOf(recommendedText));
					//					}
					//					$("#freq-selection option[value='"+ optionVal +"']").html(currentText + recommendedText)
					//						.addClass("recommended");
					//				}
					//				$("#freq-selection")
					//					.val(optionVal)
					//					.trigger('change');
					//				try{$("#freq-selection").hybridSelect('select');}catch(e){}
				}
			}
			/////////////////////////////////////
			var valueToSet = $('#ord-attr-refill-str').val();
			if (!valueToSet || valueToSet.length < 1) {
				var freqNum = parseFloat($el.closest('.freq-wrapper').find('input.refill-calc').attr("attr-freq"));
				var freqUOM = $el.closest('.freq-wrapper').find('input.refill-uom-calc').attr("attr-freq-uom");
				valueToSet = freqUOM && freqUOM.length && !isNaN(freqNum) ? freqNum + "_" + freqUOM : "notExistingValue";
			}

			if ('notExistingValue' !== valueToSet && 'undefined' !== typeof $el && $el.length) {
				if ($el.is('select') && $el.find('option[value="' + valueToSet + '"]').length < 1) {
					var refillPeriod = parseFloat($('#ord-attr-refill').attr("attr-freq"));
					if (isNaN(refillPeriod)) return;
					var mth = Math.floor(refillPeriod / 30);
					var day = refillPeriod % 30;
					var label = mth + " months";
					if (day != 0) {
						label += " and " + day + " days";
					}
					$('<option selected value="' + valueToSet + '">Every ' + label + '</option>').appendTo($el);
					var $optionList = $el.find('option');
					var sortList = Array.prototype.sort.bind($optionList);
					sortList(function (a, b) {
						try {
							var aVal = parseInt($(a).attr('value').split("_")[0]);
							var bVal = parseInt($(b).attr('value').split("_")[0]);
							// Returning -1 will place element `a` before element `b`
							if (aVal < bVal) {
								return -1;
							} else if (aVal > bVal) {
								return 1;
							} else return 0;
						} catch (e) {
							return 0;
						}
					});
					$el.append($optionList);
				}
				$el.val(valueToSet);
				try {
					$el.hybridSelect('select');
				} catch (e) {}
			}
		}
	}]);

	return Subscription;
}();
"use strict";

function addMonths(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + +months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}
;(function ($) {
  /* OPSMD-3163 skip validation of eye with 0 boxes */
  $.validator.addMethod("leftEyeSelected", function (value, element) {
    var leftBoxes = $("#left-boxes").val();
    if ($("#same-on-both:checked").length) {
      return true;
    } else if (typeof leftBoxes === "undefined" || leftBoxes === null || leftBoxes === "0") {
      // eye not selected -> no check, ok
      return true;
    } else if (typeof $(element).val() === "undefined" || $(element).val() === null) {
      // parameter not selected -> check failed
      return false;
    } else {
      // eye selected and parameter selected  -> ok
      return true;
    }
  }, "Required Field");

  $.validator.addMethod("rightEyeSelected", function (value, element) {
    var rightBoxes = $("#right-boxes").val();
    if (typeof rightBoxes === "undefined" || rightBoxes === null || rightBoxes === "0") {
      // eye not selected -> no check, ok
      return true;
    } else if (typeof $(element).val() === "undefined" || $(element).val() === null) {
      // parameter not selected -> check failed
      return false;
    } else {
      // eye selected and parameter selected  -> ok
      return true;
    }
  }, "Required Field");

  /* OPSMD-2725 avoid both boxes 0 at checkout */
  $.validator.addMethod("notBothZero", function (value, element, compareElem) {
    if (value == 0 && $(compareElem).val() == 0) {
      return false;
    }
    return true;
  }, "Please select at least 1 box");
  /* OPSMD-2725 end*/
  //validate future date, current month not included
  $.validator.addMethod("DateFormatByMY", function (value, element) {
    if (value.match(/^(0[1-9]|1[012])[/]\d{4}$/)) {
      var splitDate = value.split("/");
      var prDate = new Date(parseInt(splitDate[1]), parseInt(splitDate[0]) - 1);
      return prDate.getTime() < new Date().getTime();
    }
    //immediately return true if the element is blank AND it is not required
    return this.optional(element);
  }, "Please enter a date in the format MM/YYYY");
  $.validator.addMethod("DateFormatByMYIssueDate", function (value, element) {
    if (value === "") return true;
    if (value.match(/^(0[1-9]|1[012])[/]\d{4}$/)) {
      var splitDate = value.split("/");
      var prDate = new Date(parseInt(splitDate[1]), parseInt(splitDate[0]) - 1);
      return prDate.getTime() < new Date().getTime();
    }
    return false;
  }, "Please enter a valid date in the format MM/YYYY");
  $.validator.addMethod("DateFormatMonthValidation", function (value, element, months) {
    if (value === "") return true;
    var validityMonths = isNaN(months) ? 12 : parseInt(months);

    if (value.match(/^(0[1-9]|1[012])[/]\d{4}$/)) {
      var splitDate = value.split("/");
      var isValidate = true;
      var expDate = new Date(parseInt(splitDate[1]), parseInt(splitDate[0]) - 1);
      expDate = addMonths(expDate, validityMonths);
      //get the day before at EOD
      //expDate.setMilliseconds(expDate.getMilliseconds() - 1);
      var todayEOD = new Date();
      todayEOD = new Date(todayEOD.getFullYear(), todayEOD.getMonth(), todayEOD.getDate() + 1);
      todayEOD.setMilliseconds(todayEOD.getMilliseconds() - 1);

      isValidate = expDate > todayEOD;
    }
    return isValidate;
  }, 'Your prescription start date is more than 18 months before today\'s date. This means your prescription has expired. Please check that your prescription details are correct.');

  $.validator.addMethod("DateFormatByMYExpiryDate", function (value, element) {
    if (value.match(/^(0[1-9]|1[012])[/]\d{4}$/)) {
      var splitDate = value.split("/");
      var prDate = new Date(parseInt(splitDate[1]), parseInt(splitDate[0]));
      return prDate.getTime() > new Date().getTime();
    }
    //immediately return true if the element is blank AND it is not required
    return this.optional(element);
  }, "Please enter a valid date in the format MM/YYYY");
  $.validator.addMethod("DateFormat", function (value, element) {
    return value.match(/^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/]\d{4}$/);
  }, "Please enter a date in the format DD/MM/YYYY");
  $.validator.addMethod("MobilePhoneAU", function (value, element) {
    return value.match(/^\({0,1}((0|\+?61)(4))\){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/);
  }, "Please enter a valid phone number");
  $.validator.addMethod("pwdPolicyCompliant", function (value, element, params) {
    function checkAllPwdRules(value) {
      var regexPasswordOneUpper = document.getElementById("REGEX_PASSWORD_ONE_UPPER").value; // at least
      var regexPasswordOneLower = document.getElementById("REGEX_PASSWORD_ONE_LOWER").value; // at least
      var regexPasswordOneNumber = document.getElementById("REGEX_PASSWORD_ONE_NUMBER").value; // at least
      var regexPasswordOneSpecial = document.getElementById("REGEX_PASSWORD_ONE_SPECIAL").value; // at least
      //var regexPasswordLegalChars = document.getElementById("REGEX_PASSWORD_LEGAL_CHARS").value; // always check
      var regexPasswordMinLength = document.getElementById("REGEX_PASSWORD_MIN_LENGTH").value; // always check

      var allRules = ['atLeastOneUpperCase', 'atLeastOneLowerCase', 'atLeastOneNumber', 'atLeastOneSpecial', 'minLength'];

      var checkAndUpdateClass = true;
      checkAndUpdateClass = checkAndUpdateClass && checkRules(value, new RegExp(regexPasswordOneUpper), 'atLeastOneUpperCase', "checked");
      checkAndUpdateClass = checkAndUpdateClass && checkRules(value, new RegExp(regexPasswordOneLower), 'atLeastOneLowerCase', "checked");
      checkAndUpdateClass = checkAndUpdateClass && checkRules(value, new RegExp(regexPasswordOneNumber), 'atLeastOneNumber', "checked");
      checkAndUpdateClass = checkAndUpdateClass && checkRules(value, new RegExp(regexPasswordOneSpecial), 'atLeastOneSpecial', "checked");
      checkAndUpdateClass = checkAndUpdateClass && checkRules(value, new RegExp(regexPasswordMinLength), 'minLength', "checked");
      return checkAndUpdateClass;
    }
    function checkRules(newPassword, regex, divId, classToAdd) {
      function matchWithRegex(text, regex) {
        var match = regex.exec(text);
        return match != null && match[0].length >= 1;
      }
      function addClass(idDiv, classCheck) {
        var element = document.getElementById(idDiv);
        if ((classCheck || false) && (idDiv || false) && null != element) {
          element.classList.add(classCheck);
        }
      }
      function removeClass(idDiv, classUnCheck) {
        var element = document.getElementById(idDiv);
        if ((classUnCheck || false) && (idDiv || false) && null != element) {
          element.classList.remove(classUnCheck);
        }
      }
      if (matchWithRegex(newPassword, new RegExp(regex))) {
        addClass(divId, classToAdd);
        return true;
      } else {
        removeClass(divId, classToAdd);
        return false;
      }
    }
    return this.optional(element) || checkAllPwdRules(value);
  }, "");
})(jQuery);
'use strict';

/**
 * Special stuff for OPSM video
 */
/**
 * Register component
 * Example: http://jsbin.com/vobacas/edit?html,css,js,output
 */
var Component = videojs.getComponent('Component');
var OptionalHeading = videojs.extend(Component, {
    constructor: function constructor(player, options) {
        Component.apply(this, arguments);
        if (options.heading) {
            this.updateTextContent(options.heading);
        }
    },
    createEl: function createEl() {
        return videojs.createEl('div', {
            className: 'opsm-video--heading'
        });
    },
    updateTextContent: function updateTextContent(text) {
        if (typeof text !== 'string') {
            text = '';
        }
        videojs.emptyEl(this.el());
        videojs.appendContent(this.el(), text);
    }
});

videojs.registerComponent('OptionalHeading', OptionalHeading);

$(function () {
    $('.opsm-video').each(function (i, it) {
        var videoWrapper = $(it);
        var video = videoWrapper.find('.video-js')[0];
        var button = videoWrapper.find('.vjs-big-play-button')[0];
        var videoPlayer = videojs(video);

        if (videoWrapper.data('heading')) {
            videoPlayer.addChild('OptionalHeading', {
                heading: videoWrapper.data('heading')
            });
        }
        $(button).attr('tabindex', '-1');
    });
});
'use strict';

var opsm = window.opsm || {};

(function (window, document, $, opsm) {
	opsm.VirtualMirrorManager = function () {

		var vmapp;
		var jsLoaded = false;

		$(document).on('click', '#try-on-btn', function (e) {
			var checkScript = $('script[src="' + $("#VMMV_API_URL").val() + '"]');
			console.log("VMMV script " + checkScript.length);

			//Moved https://vmmv.luxottica.com/v/4.16/index.umd.js / ${VMMV_API_URL} to HEAD of HTML in ProductDisplay.jsp
			/*
   if (!jsLoaded || checkScript.length===0) {
   	//loadJS("https://bit.ly/2zSvqEu");
   	loadJS($("#VMMV_API_URL").val());
   	jsLoaded = true;
   } else {
   	startVMMV();
   }
   */
			jsLoaded = true;
			startVMMV();
		});

		var startVMMV = function startVMMV() {

			var wishlistedUpcList = [];
			var productData = getProductData();

			$.ajax({
				url: '/AjaxUserFavouriteListItems',
				dataType: 'json',
				async: false,
				success: function success(interestItemsLists) {
					if (interestItemsLists.length > 0 && interestItemsLists[0].items.length > 0) {
						for (var ind = 0; ind < productData.length; ind++) {
							if (productData[ind].code === "" + interestItemsLists[0].items) {
								wishlistedUpcList.push(productData[ind].upc);
							}
						}
					}
				},
				error: function error(XMLHttpRequest, textStatus, errorThrown) {
					console.error("VMMV wishlist AjaxUserFavouriteListItems " + textStatus);
				}
			});
			console.log("VMMV wishlist " + JSON.stringify(wishlistedUpcList));

			var configData = {
				selector: '#vmmv-container',
				locale: $('#try-on-btn').data('localevm'),
				prices: getPrices(),
				products: productData,
				store: {
					id: '',
					storeId: '',
					type: '',
					name: '',
					address: '',
					standAlone: true,
					logo: '',
					region: 'AU'
				},
				analytics: {
					adobeSessionId: '',
					sourcePosition: '',
					pageEnvironment: '',
					storeGlobalId: '',
					style: '',
					pagePlatform: '',
					pageBrand: '',
					storeId: '',
					storeRegion: '',
					storeCompany: '',
					source: ''
				},
				style: '',
				fromStore: true,
				termsAndConditions: location.origin + "/terms-of-use",
				vmInit: {
					source: 'VMMV_OPSM',
					key: '99749c5d-616c-42b2-acb0-73925faea4ae',
					channel: 'ecommerce',
					brand: 'OPSM'
				},
				onClose: function onClose() {
					$('#vm-modal').modal('hide');
					if (vmapp != null) {
						vmapp.unmount();
					}
				},
				onAddPrescriptionLenses: function onAddPrescriptionLenses(product) {
					console.log("VMMV onAddPrescriptionLenses " + product.code + " " + JSON.stringify(product));
					if (!getOos(product.upc)) {
						var _productData = getProductData();
						for (var ind = 0; ind < _productData.length; ind++) {
							console.log("VMMV onAddPrescriptionLenses data " + _productData[ind].code);
							if (_productData[ind].code === product.code) {
								var rxlink = _productData[ind].link + (_productData[ind].link.includes('?') ? "&openlenspanel=true" : "?openlenspanel=true");
								console.log("VMMV onAddPrescriptionLenses redirect " + rxlink);
								document.location.href = rxlink;
							}
						}
					} else {
						console.log("VMMV onAddPrescriptionLenses OOS " + product.upc);
						$(".vmmv-add-prescription-modal-close-modal-button").click();
						$("#vm-modal-oos").modal();
					}
				},
				onAddToBag: function onAddToBag(pr) {
					console.log("VMMV onAddToBag " + pr.code + " " + JSON.stringify(pr));
					if (!getOos(pr.upc)) {
						return opsm.product.addToCart(null, pr.code);
					} else {
						console.log("VMMV onAddToBag OOS " + pr.upc);
						$(".vmmv-add-prescription-modal-close-modal-button").click();
						$("#vm-modal-oos").modal();
					}
				},
				wishlistedUpcs: wishlistedUpcList,
				onToggleWishlist: function onToggleWishlist(pr) {
					console.log("VMMV onToggleWishlist " + pr.code + " " + JSON.stringify(pr));
					var params = {
						catEntryId: pr.code,
						storeId: $('#storeId').val(),
						quantity: "1",
						updatable: "0"
					};
					Utils.addToFav("/FavouritesAddCmd", params, successAddFav, errorAddFav);

					return Promise.resolve();
				},
				onShare: function onShare(img, product) {
					return fetch(img).then(function (img) {
						return img.blob();
					}).then(function (blob) {
						var file = new File([blob], product.upc + '.jpg', { type: blob.type });
						var shareOptions = {
							title: product.brand,
							text: product.name,
							files: [file]
						};
						return Promise.resolve(shareOptions);
					});
				},
				isPictureModeEnabled: true,
				isTryOnEnabled: true,
				isVideoModeEnabled: true,
				isUploadPictureEnabled: true,
				isTakePictureEnabled: true,
				isTakeScreenshotEnabled: true
				//vmapp = new vmmv.VMWidgetApp(configData);
				//vmapp = new vmmv.VMWidgetApp().setConfig(configData);
				//vmapp.setConfig(configData);
				// const wmapp = new vmmv.VMWidgetApp();
				// console.log("devug as: " + vmapp);
				// setTimeout(function () {
				// 	console.log("This message is shown after 3 seconds.");
				// 	wmapp.setConfig(configData).then(function () {
				// 		wmapp.init();
				// 	}).catch(function (e) {
				// 		console.log("something went wrong on wmapp invocation", e);
				// 	});
				// }, 3000);

			};vmapp = new vmmv.VMWidgetApp();
			vmapp.setConfig(configData).then(function () {
				$("#vm-modal").modal();
				$('#vm-modal').one('shown.bs.modal', function () {
					$("#vmmv-container").css("height", $("#vm-modal .modal-body").height() + "px");
					vmapp.init();
				});
			}).catch(function (e) {
				console.error(e);
			});
			// $('#vm-modal').on('shown.bs.modal', function () {
			// 	$("#vmmv-container").css("height", $("#vm-modal .modal-body").height() + "px");
			// 	vmapp.init();
			// });
			// $('#vm-modal').on('hidden.bs.modal', function () {
			// 	if (vmapp != null) {
			// 		vmapp.unmount();
			// 	}
			// });
		};

		function errorAddFav(xhr, textStatus, thrownError) {
			console.error("VMMV errorAddFav: " + textStatus + '\n' + thrownError);
		}
		function successAddFav(result) {
			console.log("VMMV successAddFav " + result.itemAddStatus);
			if (result.itemAddStatus == 'ALREADY_FAV') {
				var params = {
					catEntryId: result.catEntryId[0],
					storeId: result.storeId,
					quantity: "1"
				};
				return Utils.removeFromFav("/FavouritesDeleteCmd", params);
			} else if (result.itemAddStatus == 'limitExceeded') {
				opsm.utils.showAlertError("Only 20 or less items can be saved");
			}
		}

		function getOos(upc) {
			var itemoos = false;
			$('.list-inline.product--thumbnail-color-selectors').find('.list-inline-item.product--thumbnail-color-selector ').each(function (idx, item) {
				var curupc = "" + $(item).children('a').data('upc');
				var curoos = "" + $(item).children('a').data('oos');
				if (upc === curupc && curoos === 'true') {
					itemoos = true;
				}
			});
			return itemoos;
		}

		function getPrices() {
			var pricesData = [];
			$('.list-inline.product--thumbnail-color-selectors').find('.list-inline-item.product--thumbnail-color-selector ').each(function (idx, item) {
				var data = {
					upc: "" + $(item).children('a').data('upc'),
					current: { text: "" + $(item).children('a').data('offer-price-string'), value: parseInt($(item).children('a').data('offer-price')) },
					currency: "" + $(item).children('a').data('currency')
				};
				if ($(item).children('a').data('list-price') !== "") {
					data.previous = { text: "" + $(item).children('a').data('list-price-string'), value: "" + $(item).children('a').data('list-price') };
				}
				pricesData.push(data);
			});
			console.log("VMMV prices " + JSON.stringify(pricesData));
			return pricesData;
		}
		function getProductData() {
			var productsData = [];
			var upcCurrent = "" + $('.list-inline.product--thumbnail-color-selectors').find('.list-inline-item.product--thumbnail-color-selector.active').children('a').data('upc');
			$('.list-inline.product--thumbnail-color-selectors').find('.list-inline-item.product--thumbnail-color-selector ').each(function (idx, item) {
				var data = {
					upc: "" + $(item).children('a').data('upc'),
					code: "" + $(item).children('a').data('code'),
					name: "" + $(item).children('a').data('name'),
					styleName: "" + $(item).children('a').data('name'),
					colorCode: "" + $(item).children('a').data('color'),
					thumbnailUrl: "" + $(item).children('a').data('img-thumb-vto'),
					brand: { name: "OPSM", logoUrl: "https://media.opsm.com/DDM/brand.png?differentUrl=true" },
					frameColorLabel: "" + $(item).children('a').data('color'),
					lensColorLabel: "" + $(item).children('a').data('lens-color'),
					rxAvailable: $(item).children('a').data('roxable'),
					link: $(item).children('a')[0].href
				};
				if (data.upc === upcCurrent) {
					productsData.unshift(data);
				} else {
					productsData.push(data);
				}
			});

			console.log("VMMV data " + JSON.stringify(productsData));
			return productsData;
		}
		function loadJS(urlJS) {
			console.log("VMMV load start " + urlJS);
			var script = document.createElement("script");
			script.setAttribute("type", "text/javascript");
			//script.setAttribute("vmmv-script-id", "vmmv-script");
			script.src = urlJS;
			script.crossOrigin = "anonymous";
			script.onload = function () {
				console.log("VMMV load end " + urlJS);
				startVMMV();
			};
			script.onerror = function () {
				console.log("VMMV error loading " + urlJS);
			};
			document.head.appendChild(script);
		}
	}();
})(window, document, jQuery, opsm);
"use strict";

var ZOOM_MIN = 1.0;
var ZOOM_MAX;
if (window.matchMedia('(min-width: 768px)').matches) {
    ZOOM_MAX = 3.0;
} else {
    ZOOM_MAX = 6.0;
}

var PINCH_FRICTION = 0.04;

function ZoomNode(node) {
    var _this = this;

    var x = 0;
    var y = 0;
    var pageX = 0;
    var pageY = 0;
    var rectTop = 0;
    var rectLeft = 0;
    var offsetX = 0;
    var offsetY = 0;
    var scale = 1.0;
    var ongoingEvents = [];
    var prevDistance = -1;
    var wasPinchToZoom = false;
    var scalingSum = 0;
    node.classList.add("zooming");

    // API

    /* Set zoom to given factor, clamped.
    */
    _this.zoom = function (value, transition) {
        scale = Math.min(Math.max(value, ZOOM_MIN), ZOOM_MAX);
        node.style.transition = transition ? transition : "";
        transform(x, y, scale);
    };

    /* Set zoom factor to 1.0 and put back element to initial position.
    */
    _this.reset = function () {
        x = 0;
        y = 0;
        scale = 1.0;
        node.style.transition = "";
        node.classList.remove("zooming");
        clearTransformation();
    };

    _this.bindEvents = function () {
        //node.addEventListener("wheel", wheel);
        node.addEventListener("pointerdown", pointerDown);
        node.addEventListener("pointermove", pointerMove);
        node.addEventListener("pointerup", pointerUp);
        node.addEventListener("pointerout", pointerUp);
        node.addEventListener("pointercancel", pointerUp);
    };

    _this.unbindEvents = function () {
        //node.addEventListener("wheel", wheel);
        node.removeEventListener("pointerdown", pointerDown);
        node.removeEventListener("pointermove", pointerMove);
        node.removeEventListener("pointerup", pointerUp);
        node.removeEventListener("pointerout", pointerUp);
        node.removeEventListener("pointercancel", pointerUp);
    };

    _this.destroy = function () {
        _this.unbindEvents();
        _this.reset();
    };

    // Events handlers

    // function wheel(event) {
    //     if (!event.ctrlKey) {
    //         return;
    //     }        
    //     event.preventDefault();
    //     offsetX = event.offsetX;
    //     offsetY = event.offsetY;
    //     x = event.pageX - offsetX - event.target.x;
    //     y = event.pageY - offsetY - event.target.y;        
    //     node.style.transition = "";
    //     _this.zoom(2.0);
    // }

    function pointerDown(event) {
        // DEBUG && log("pointerDown.", event);
        ongoingEvents.push(event);
        // Save pointer offset from node top left corner
        offsetX = event.offsetX;
        offsetY = event.offsetY;
        node.style.transition = "";

        // Don't allow DOM dragging while zooming
        event.preventDefault();
        // showEventData();        
    }

    function pointerMove(event) {
        //DEBUG && log("pointerMove.", event);
        if (ongoingEvents.length == 0) {
            // Nothing happening
            return;
        }

        updateEvent(event);
        // showEventData();
        // If two pointers are down, check for pinch gestures
        if (ongoingEvents.length == 2) {

            // Calculate the distance between the two pointers
            var distance = getDistance(ongoingEvents[0], ongoingEvents[1]);

            if (prevDistance > 0) {
                var newScale = distance / prevDistance * PINCH_FRICTION;

                if (distance > prevDistance) {
                    // Distance increased, zoom in

                    scalingSum = scale + newScale;

                    if (scalingSum < ZOOM_MAX) {
                        _this.zoom(scalingSum);
                    } else {
                        scalingSum = ZOOM_MAX;
                    }
                }
                if (distance < prevDistance) {
                    // Distance decreased, zoom out

                    scalingSum = scale - newScale;
                    if (scalingSum > ZOOM_MIN) {
                        _this.zoom(scalingSum);
                    } else {
                        scalingSum = ZOOM_MIN;
                    }
                }
                window.pdp.scale = scalingSum;
                window.pdp.updateZoomButtons();
            }

            // Store distance for the next move event
            prevDistance = distance;
            // If one pointer is down do a pan, also check if we was in the middle of a pinch
        } else if (ongoingEvents.length == 1 && prevDistance == -1 && !wasPinchToZoom) {

            // Get computed rect after CSS transformation
            var rect = node.getBoundingClientRect();
            //DEBUG && log("rect.left", rect.left);
            //DEBUG && log("target.x", event.target.x);
            //DEBUG && log("target.y", event.target.y);
            pageX = event.pageX;
            pageY = event.pageY;
            // Figure out movement keeping scale into account
            x = x + event.pageX - offsetX * scale - rect.left;
            y = y + event.pageY - offsetY * scale - rect.top;

            // OPSMD-7859
            //  Here we are calculating the soils in order to avoid to let the image get completely out of viewport 
            //  (we're doing so by calculating half of the transformed img plus half of the viewport width, 
            //  but keeping only the 80% of this because of the transparent padding included in every product image)
            var rightSoil = (event.target.getBoundingClientRect().width / 2 + window.innerWidth / 2) * 80 / 100;
            var leftSoil = rightSoil * -1;

            // OPSMD-7859
            // if the movement is bigger than the soil, we bring the node (img) back to 0,  
            // in order to have it always in viewport, as requested in the ticket.
            if (x > rightSoil || x < leftSoil) {
                x = 0;
            }

            transform(x, y, scale);
        }
        // showEventData();
    }

    function pointerUp(event) {
        // DEBUG && log("pointerUp.", event);
        // Remove this pointer from the cache
        removeEvent(event);
        // If the number of pointers down is less than two then reset distance tracker
        if (ongoingEvents.length < 2) {
            prevDistance = -1;
            wasPinchToZoom = false;
        }
        if (ongoingEvents.length == 1) {
            wasPinchToZoom = true;
        }
        event.preventDefault();
    }

    /* Remove this event from the target's cache
    */
    function removeEvent(event) {
        for (var i = 0; i < ongoingEvents.length; i++) {
            if (ongoingEvents[i].pointerId == event.pointerId) {
                ongoingEvents.splice(i, 1);
                break;
            }
        }
    }

    /* Find this event in the cache and update its record
    */
    function updateEvent(event) {
        for (var i = 0; i < ongoingEvents.length; i++) {
            if (event.pointerId == ongoingEvents[i].pointerId) {
                ongoingEvents[i] = event;
                break;
            }
        }
    }

    _this.bindEvents();

    // CSS transformation 

    function transform(x, y, scale) {
        node.style.transform = "matrix(" + scale + ", 0, 0, " + scale + ", " + x + ", " + y + ")";
    }

    function clearTransformation() {
        transform(0, 0, 1.0);
    }

    function getDistance(a, b) {
        var x = a.x - b.x;
        var y = a.y - b.y;
        return Math.hypot(x, y);
    }

    function showEventData() {
        // Quick and dirty to show some events data on screen        
        var stats = document.querySelector(".stats");
        if (stats) {
            stats.querySelector(".pageX").innerHTML = "pageX: " + pageX + "px";
            stats.querySelector(".x").innerHTML = "x: " + x + "px";
            stats.querySelector(".rectLeft").innerHTML = "rectLeft: " + rectLeft + "px";
            stats.querySelector(".pageY").innerHTML = "pageY: " + pageY + "px";
            stats.querySelector(".y").innerHTML = "y: " + y + "px";
            stats.querySelector(".rectTop").innerHTML = "rectTop: " + rectTop + "px";
            stats.querySelector(".offX").innerHTML = "offX: " + offsetX + "px";
            stats.querySelector(".offY").innerHTML = "offY: " + offsetY + "px";
            stats.querySelector(".scale").innerHTML = "scale: " + scale;
            stats.querySelector(".prevDistance").innerHTML = "prevDistance: " + prevDistance;
        }
    }
}
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * OPSM Hybrid Select
 */
(function ($) {
    var pluginName = 'hybridSelect';

    function Plugin(element, options) {
        var el = element;
        var $el = $(element);
        var $wrapper = null;
        var $menu = null;

        options = $.extend({}, $.fn[pluginName].defaults, options);

        function init() {
            // Add any initialization logic here...
            $el.wrap('<div class="dropdown hybrid-select"></div>');
            $wrapper = $el.parent();
            if (options.wrapperClass) {
                $wrapper.addClass(options.wrapperClass);
            }
            if ($el.data('wrapper-class')) {
                $wrapper.addClass($el.data('wrapper-class'));
            }

            var selected_text_dropdown_html = String(getSelectedOption().html());
            var selected_text_dropdown_text = getSelectedOption().text();
            var selected_badge = "";
            if (selected_text_dropdown_html.includes('<span class="opt--badge">')) {
                selected_text_dropdown_text = selected_text_dropdown_html.replace(/<span class="opt--badge">.*?<\/span>/g, '').trim();
                selected_badge = selected_text_dropdown_html.match(/<span class="opt--badge">.*?<\/span>/);
            }

            $wrapper.append('\n                <button type="button" class="btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n                    <span class="selected-text" id="selected_text_dropdown">' + selected_text_dropdown_text + '</span>\n                    ' + selected_badge + '\n                    <span class="warn-icon-wrapper flex-grow-1 d-none"><span class="invalid-feedback ml-auto mr-2 my-0 warn-icon"></span></span>\n                    <span class="icon icon-chevron-thin-right"></span>\n                </button>\n                <div class="dropdown-menu">\n                </div>\n            ');

            $menu = $wrapper.find('.dropdown-menu');

            if (options.dropdownMenuDirection === 'right' || $el.data('dropdown-menu-direction') === 'right') {
                $menu.addClass('dropdown-menu-right');
            }

            if (options.noNative === true || $el.data('no-native') === true) {
                $wrapper.addClass('hybrid-select--no-native');
            }

            buildDropdownMenu();

            $menu.on('click', 'a', function () {
                $wrapper.find('.selected-text').text($(this).text());
                $menu.find('.active').removeClass('active');
                $(this).addClass('active');
                $el.val($(this).data('value'));
                $el.trigger('change');
                triggerValidate();
            });

            $el.on('change.' + pluginName, function () {
                select();
            });

            hook('onInit');
        }

        function buildDropdownMenu() {
            $menu.empty();
            $el.children().each(function (i, it) {
                if ($(it).is('optgroup')) {
                    $menu.append('<h6 class="dropdown-header">' + $(it).attr('label') + '</h6>');
                    $(it).children().each(function (z, opt) {
                        $menu.append('<a tabindex="0" class="pointer dropdown-item ' + ($(opt).attr('hidden') ? 'hidden' : '') + '\n                            ' + ($(opt).is(':disabled') ? 'disabled' : '') + ' ' + ($(opt).is(':selected') ? 'active' : '') + '"\n                            data-value="' + $(opt).attr('value') + '" ' + ($(opt).attr('ajax-href') ? 'href="' + $(opt).attr('ajax-href') + '"' : '') + '>\n                                ' + ($(opt).data('template') || $(opt).text()) + ' </a>');
                    });
                } else {
                    $menu.append('<a tabindex="0" class="pointer dropdown-item ' + ($(it).attr('hidden') ? 'hidden' : '') + '\n                        ' + ($(it).is(':disabled') ? 'disabled' : '') + ' ' + ($(it).is(':selected') ? 'active' : '') + '"\n                        data-value="' + $(it).attr('value') + '" ' + ($(it).attr('ajax-href') ? 'href="' + $(it).attr('ajax-href') + '"' : '') + '>\n                             ' + ($(it).data('template') || $(it).text()) + '\n                        </a>');
                }
            });

            var $btn = $wrapper.find('.btn');
            if ($el.is(':disabled')) {
                $btn.attr('disabled', true);
            } else {
                $btn.attr('disabled', false);
            }
            if ($(".product--info-area.contact-lenses").length > 0) {
                $(".hybrid-select .dropdown-menu").niceScroll({
                    cursorcolor: "#2D2A26",
                    autohidemode: false,
                    cursorwidth: "2px",
                    // cursorfixedheight: "44px",
                    cursorborder: "0px solid #2D2A26",
                    railpadding: { top: 20, right: 20, left: 0, bottom: 20 },
                    railoffset: { top: 40, right: 20, left: 0, bottom: 40 }
                });
            } else {
                $(".hybrid-select .dropdown-menu").niceScroll({
                    cursorcolor: "#ccc",
                    autohidemode: false,
                    cursorwidth: "10px",
                    railpadding: { top: 0, right: 12, left: 0, bottom: 0 }
                });
            }
            select();
        }

        function select() {
            var $btn = $wrapper.find('.btn');
            var $selectedOpt = getSelectedOption();

            var optoToInsert = $selectedOpt.html();
            var optoSelectedArr = $("#selected_text_dropdown").html().replaceAll("\n", "").trim().split(" ").filter(function (val) {
                return val !== "";
            });
            if (optoSelectedArr.includes("Remote") || optoSelectedArr.includes("Kids") || optoSelectedArr.includes("Audio")) {

                var lastElement = optoSelectedArr.pop();
                var newString = optoSelectedArr.join(" ");

                var badgeToInsert = "";
                if (lastElement === "Kids") {
                    badgeToInsert = 'opt--badge-kids"';
                } else if (lastElement === "Remote") {
                    badgeToInsert = 'opt--badge-remote"';
                } else if (lastElement === "Audio") {
                    badgeToInsert = 'opt--badge-audio"';
                }

                optoToInsert = newString + ' <span class="opt--badge ' + badgeToInsert + '> ' + lastElement + '</span>';
            }

            $btn.find('.selected-text').html(optoToInsert);

            var $menu = $wrapper.find('.dropdown-menu');
            $menu.find('.dropdown-item').removeClass('active').filter('[data-value="' + $selectedOpt.val() + '"]').addClass('active');

            $el.find('option').removeAttr('selected').filter('[value="' + $selectedOpt.val() + '"]').attr('selected', 'true');

            triggerValidate();
        }

        function getSelectedOption() {
            return $el.find('option:selected');
        }

        function option(key, val) {
            if (val) {
                options[key] = val;
            } else {
                return options[key];
            }
        }

        function destroy() {
            $el.each(function () {
                var el = this;
                var $el = $(this);

                // Add code to restore the element to its original state...

                hook('onDestroy');
                $el.removeData('plugin_' + pluginName);
            });
        }

        function enable(skipValidation) {
            var $btn = $wrapper.find('.btn');
            $btn.removeAttr('disabled');
            $el.removeAttr('disabled');
            if (skipValidation !== true) {
                triggerValidate();
            }
        }

        function disable() {
            var $btn = $wrapper.find('.btn');
            $btn.attr('disabled', true);
            $el.attr('disabled', true);
            triggerValidate();
        }

        function hook(hookName) {
            if (options[hookName] !== undefined) {
                options[hookName].call(el);
            }
        }

        function triggerValidate() {
            try {
                var form = $el.closest('form');
                if (form.data('validator')) {
                    form.data('validator').element($el);
                }
            } catch (ex) {
                console.error('Could not call valid() method on element', $el, ex);
            }
        }

        init();

        return {
            option: option,
            destroy: destroy,
            buildDropdownMenu: buildDropdownMenu,
            refresh: buildDropdownMenu,
            enable: enable,
            disable: disable,
            select: select
        };
    }

    $.fn[pluginName] = function (options) {
        if (typeof arguments[0] === 'string') {
            var methodName = arguments[0];
            var args = Array.prototype.slice.call(arguments, 1);
            var returnVal;
            this.each(function () {
                if ($.data(this, 'plugin_' + pluginName) && typeof $.data(this, 'plugin_' + pluginName)[methodName] === 'function') {
                    returnVal = $.data(this, 'plugin_' + pluginName)[methodName].apply(this, args);
                } else {
                    throw new Error('Method ' + methodName + ' does not exist on jQuery.' + pluginName);
                }
            });
            if (returnVal !== undefined) {
                return returnVal;
            } else {
                return this;
            }
        } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object' || !options) {
            return this.each(function () {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
                }
            });
        }
    };

    $.fn[pluginName].defaults = {
        onInit: function onInit() {},
        onDestroy: function onDestroy() {},
        dropdownMenuDirection: '',
        noNative: false
    };
})(jQuery);

;(function ($) {
    $(document).ready(function () {
        $('[data-toggle="hybridSelect"]').hybridSelect();
    });
})(jQuery);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function Affix(element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options);

    this.$target = $(this.options.target).on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this)).on('click.bs.affix.data-api', $.proxy(this.checkPositionWithEventLoop, this));

    this.$element = $(element);
    this.affixed = null;
    this.unpin = null;
    this.pinnedOffset = null;

    this.checkPosition();
  };

  Affix.VERSION = '3.3.7';

  Affix.RESET = 'affix affix-top affix-bottom';

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  };

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop = this.$target.scrollTop();
    var position = this.$element.offset();
    var targetHeight = this.$target.height();

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false;

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return scrollTop + this.unpin <= position.top ? false : 'bottom';
      return scrollTop + targetHeight <= scrollHeight - offsetBottom ? false : 'bottom';
    }

    var initializing = this.affixed == null;
    var colliderTop = initializing ? scrollTop : position.top;
    var colliderHeight = initializing ? targetHeight : height;

    if (offsetTop != null && scrollTop <= offsetTop) return 'top';
    if (offsetBottom != null && colliderTop + colliderHeight >= scrollHeight - offsetBottom) return 'bottom';

    return false;
  };

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset;
    this.$element.removeClass(Affix.RESET).addClass('affix');
    var scrollTop = this.$target.scrollTop();
    var position = this.$element.offset();
    return this.pinnedOffset = position.top - scrollTop;
  };

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1);
  };

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return;

    var height = this.$element.height();
    var offset = this.options.offset;
    var offsetTop = offset.top;
    var offsetBottom = offset.bottom;
    var scrollHeight = Math.max($(document).height(), $(document.body).height());

    if ((typeof offset === 'undefined' ? 'undefined' : _typeof(offset)) != 'object') offsetBottom = offsetTop = offset;
    if (typeof offsetTop == 'function') offsetTop = offset.top(this.$element);
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element);

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom);

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '');

      var affixType = 'affix' + (affix ? '-' + affix : '');
      var e = $.Event(affixType + '.bs.affix');

      this.$element.trigger(e);

      if (e.isDefaultPrevented()) return;

      this.affixed = affix;
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null;

      this.$element.removeClass(Affix.RESET).addClass(affixType).trigger(affixType.replace('affix', 'affixed') + '.bs.affix');
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      });
    }
  };

  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.affix');
      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;

      if (!data) $this.data('bs.affix', data = new Affix(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.affix;

  $.fn.affix = Plugin;
  $.fn.affix.Constructor = Affix;

  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old;
    return this;
  };

  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this);
      var data = $spy.data();

      data.offset = data.offset || {};

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom;
      if (data.offsetTop != null) data.offset.top = data.offsetTop;

      Plugin.call($spy, data);
    });
  });
}(jQuery);
'use strict';

$.fn.extend({
    animateCss: function animateCss(animationName, callback) {
        var animationEnd = function (el) {
            var animations = {
                animation: 'animationend',
                OAnimation: 'oAnimationEnd',
                MozAnimation: 'mozAnimationEnd',
                WebkitAnimation: 'webkitAnimationEnd'
            };

            for (var t in animations) {
                if (el.style[t] !== undefined) {
                    return animations[t];
                }
            }
        }(document.createElement('div'));

        this.addClass('animated ' + animationName).one(animationEnd, function () {
            $(this).removeClass('animated ' + animationName);

            if (typeof callback === 'function') callback();
        });

        return this;
    }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * OPSM Utilities to build Product HTML block
 */
var Utils = function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }

  _createClass(Utils, null, [{
    key: 'string_of_enum',
    value: function string_of_enum(enumerator, value) {
      for (var k in enumerator) {
        if (enumerator[k] == value) return k;
      }return null;
    }
  }, {
    key: 'showAppointment',
    value: function showAppointment(item, index) {
      var active = false;
      var appointment = void 0;
      var hours = void 0;

      if (index == 0) active = true;

      appointment = $('\n      <div class="card baet-step-2--card">\n        <div class="card-header baet-step-2--card-header">\n          <a tabindex="0" data-toggle="collapse" class="baet-step-2--card-title pointer" data-target="#collapse-' + index + '" aria-expanded="' + active + '" aria-controls="collapse-' + index + '">' + item.name + '\n            <span class="baet-step-2--card-subtitle">(' + item.items.length + ' available)</span>\n          </a>\n          <a tabindex="0" data-toggle="collapse" class="tab-accordion--sign baet-step-2--card-sign ' + (active ? '' : 'collapsed') + '" data-target="#collapse-' + index + '" aria-expanded="' + active + '" aria-controls="collapse-' + index + '"></a>\n        </div>\n        <div class="collapse baet-step-2--card-body ' + (active ? 'show' : '') + '" id="collapse-' + index + '">\n        </div>\n      </div>\n    ');

      hours = this.showHours(item.items);
      appointment.find('.baet-step-2--card-body').append(hours);

      return appointment;
    }
  }, {
    key: 'showHours',
    value: function showHours(items) {
      var hoursList = $('<ul class="list-unstyled baet-step-2--card-list"></ul>');

      items.forEach(function (data, index) {
        var item = $('\n        <li class="baet-step-2--card-item">\n          <div class="article-card--item">\n            <div class="article-card--item-inner">\n              <span class="article-card--time">' + data.time + '</span>\n            </div>\n          </div>\n        </li>  \n      ');

        if (data.booking) {
          item = $('\n          <li class="baet-step-2--card-item baet-step-2--card-booked">\n            <div class="article-card--item">\n              <div class="article-card--item-inner">\n                <span class="article-card--time">' + data.time + '</span>\n                <span class="article-card--booked">Existing booking</span>\n              </div>\n            </div>\n          </li>  \n        ');
        }
        hoursList.append(item);
      });

      return hoursList;
    }
  }, {
    key: 'showStore',
    value: function showStore(store, index) {
      var hours = store.openingHours.map(function (hour) {
        return '<li><span class="day">' + hour.day + '</span><span>' + hour.time + '</span></li>';
      });
      var item = $('\n    <div class="select-store--item" data-index="' + index + '" data-lat="' + store.lat + '" data-lng="' + store.lng + '">\n      <div class="select-store--item--marker">\n        <span class="icon"><img src="' + imageDirectoryPath + 'images/icons/marker_default.svg"></span>\n        <span class="number">' + store.id + '</span>\n      </div>\n      <div class="select-store--item--info">\n        <div class="select-store--item--inner">\n          <h6 class="select-store--item--street">' + store.nameStreet + '</h6>\n          <p class="select-store--item--add">' + store.address + '</p>\n          <div class="select-store--item--openhours">\n            <a class="btn btn-link collapsed" data-toggle="collapse" href="#tab' + store.id + '" role="button" aria-expanded="false" aria-controls="tab' + store.id + '">\n              <span class="text">Opening hours</span>\n              <span class="icon icon-chevron-left"></span>\n            </a>\n            <div class="collapse" id="tab' + store.id + '" data-parent="#accordion">\n              <ul class="list-unstyled select-store--item--hour">\n                ' + hours.join('') + '\n              </ul>\n            </div>\n          </div>\n        </div>\n        <a href="baet-step-2.html" class="button button--primary button--primary--dark"><span class="button--label">select store</span></a>\n      </div>\n    </div>\n    ');
      return item;
    }
  }, {
    key: 'showArticle',
    value: function showArticle(article) {
      var post = $('\n      <div class="card search--result-articles--card">\n        <div class="card-body search--result-article-card">\n          <h4 class="card-title"><a href="' + article.link + '">' + article.title + '</a></h5>\n          <p class="card-text">' + article.content + '</p>\n          <a class="card-link search--result-article-card-link" href="' + article.link + '">Read more</a>\n        </div>\n      </div>\n    ');
      return post;
    }
  }, {
    key: 'showStoreFavorite',
    value: function showStoreFavorite(store, index) {
      var hours = store.openingHours.map(function (hour) {
        return '<li><span class="day">' + hour.day + '</span><span>' + hour.time + '</span></li>';
      });

      var item = $('\n    <div class="select-store--item opsm-bordered-fluid-div mb-4 ' + (store.isPref ? 'select-store--item--selected' : '') + '" ' + (store.isPref ? 'disabled' : '') + ' style="padding:0;display:block" data-index="' + index + '" data-lat="' + store.lat + '" data-lng="' + store.lng + '">\n      <div class="opsm-bordered-header">\n        <div class="div-flex w-100">\n          <p><strong><span class="number">' + store.id + '.</span> ' + store.nameStreet + '</strong></p>\n        </div>\n      </div>\n      <div class="opsm-bordered-body py-0">\n        <p class="visible-mobile"><img src="//maps.googleapis.com/maps/api/staticmap?center=' + store.lat + ', ' + store.lng + '&zoom=15&size=640x300&key=' + opsm.core.getGoogleMapsApiKey() + '&maptype=roadmap&format=jpg&visual_refresh=true&markers=icon:' + imageDirectoryPath + 'images/icons/marker_default.svg|' + store.lat + ',' + store.lng + '" /></p>\n          <p class="select-store--item--add">' + store.address + '</p>\n        <p><a class="strong underline" target="_blank" href="https://www.google.com/maps/search/?api=1&query=' + store.nameStreet + '+' + store.address + '" >Get directions</a></p>\n        <p>Tel: <strong>' + store.tel + '</strong></p>\n        <p>Open today: <strong>' + store.today + '</strong></p>\n        <hr/>\n        <div class="select-store--item--openhours">\n          <a class="btn btn-link collapsed" data-toggle="collapse" href="#tab' + store.id + '" role="button" aria-expanded="false" aria-controls="tab' + store.id + '">\n            <span class="text">Opening hours</span>\n            <span class="icon icon-chevron-left"></span>\n          </a>\n        <div class="collapse" id="tab' + store.id + '" data-parent="#accordion">\n          <ul class="list-unstyled select-store--item--hour">\n            ' + hours.join('') + '\n          </ul>\n        </div>\n        <p class="pt-3 pb-2"><a href="' + store.url + '" class="strong underline">Book an eye test</a></p>\n        <a id="openstoredetail-' + store.id + '" class="button button--primary button--primary--dark" style="padding:13px 15px;width:auto"><span class="button--label">store details</span></a>\n        <br/>\n        <p class="text-right pt-5"><a href="' + store.deleteUrl + '" class="fav-store-remove"><span class="fa icon-close pr-2" style="font-size:.8rem"></span><span class="underline">Remove</span></a></p> \n      </div>\n    </div>');
      return item;
    }
  }, {
    key: 'openDetailStore',
    value: function openDetailStore(ev, id) {
      $.getJSON('search-store.json', function (data) {
        var dataShow = data;
        dataShow.forEach(function (store, index) {
          if (store.id === id) {
            $("#store-name").html(store.nameStreet);
            $("#store-address").html(store.address);
            $("#store-tel .value").html(store.tel);
            $("#store-fax .value").html(store.fax);
            $("#store-openGmap,#store-openGmapMob").attr("href", 'https://www.google.com/maps/search/?api=1&query=' + store.nameStreet + '+' + store.address);
            var hours = store.openingHours.map(function (hour) {
              return '<li><span class="label">' + hour.day + '</span><span class="value">' + hour.time + '</span></li>';
            });
            var slides = store.slidesStore.map(function (slide) {
              return '<div class="opsm-slideshow--slide-item"><img src="' + slide.pic + '"/></div>';
            });
            $("#store-openinghours").html(hours);
            $("#store-screenmap img").attr("src", '//maps.googleapis.com/maps/api/staticmap?center=' + store.lat + ',' + store.lng + '&zoom=15&size=640x300&key=' + opsm.core.getGoogleMapsApiKey() + '&maptype=roadmap&format=jpg&visual_refresh=true&markers=icon:' + imageDirectoryPath + 'images/icons/marker_default.svg|' + store.lat + ',' + store.lng);
            $("#store-slideshow .opsm-slideshow--slide").html(slides);
            var slideshowSingle = $('.opsm-slideshow--slide[data-slide-type="storedetail"]');
            slideshowSingle.not('.slick-initialized').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            });
            $("#opsm-modal-detailstore").modal();
            $("#opsm-modal-detailstore").on("hidden.bs.modal", function () {
              slideshowSingle.slick("unslick");
            });
          }
        });
      });
    }
    /**
     * @param type string search/none, if type === 'search' then the product description will not be rendered.
     */

  }, {
    key: 'showProduct',
    value: function showProduct(prod, type) {
      var product = $('<div class="col-12 col-sm-6 col-xl-4"></div>');
      var prodCard = $('<a href="pdp-frames.html" class="product card"></a>');
      var prodImages = $('<div class="product--img"></div>');
      prodCard.append(this.productBadge(prod.badge));
      prodImages.append(this.productImage(prod.name, prod.images, 'primary'));
      if (prod.imagesHover) {
        prodImages.addClass('product--img--dual');
        prodImages.append(this.productImage(prod.name, prod.imagesHover, 'secondary'));
      }
      prodCard.append(prodImages);
      if (type === 'search') {
        prodCard.append(this.productContent(prod.name, '', prod.price, prod.colors));
      } else {
        prodCard.append(this.productContent(prod.name, prod.desc, prod.price, prod.colors));
      }
      product.append(prodCard);
      return product;
    }
  }, {
    key: 'productImage',
    value: function productImage(name, images, type) {
      var prodImage = $('<div class="product--' + type + '-img"></div>');
      prodImage.append('<img class="card-img-top" src="images/' + (images.src ? images.src : '') + '" srcset="images/' + (images.src2x ? images.src2x : '') + ' 2x, images/' + (images.src3x ? images.src3x : '') + ' 3x" alt="' + (name ? name : '') + '"/>');
      return prodImage;
    }
  }, {
    key: 'productBadge',
    value: function productBadge(badge) {
      var prodBadge = $('<div class="product--top d-flex align-items-center"></div>');
      if (badge.text) {
        prodBadge.append('<div class="product--badge text-uppercase product--badge--' + badge.color + '">' + badge.text + '</div>');
      }
      prodBadge.append('<button class="product--favourite btn btn-link ml-auto" onclick="Product.toggleFavourite(event, 111)" title="Favourite"><span class="icon icon-star-outline"></span></button>');
      return prodBadge;
    }
  }, {
    key: 'productContent',
    value: function productContent(name, desc, price, colors) {
      var commonClasses = "d-flex align-items-center justify-content-center";
      var content = $('<div class="product--content card-body"></div>');
      var prodDes = $('<div class="product--description">' + desc + '</div>');
      var colorList = $('<ul class="list-unstyled product--colors ' + commonClasses + '"></ul>');
      colors.forEach(function (color, index) {
        var item = $('<li  class="product--color-item ' + (index === 0 ? 'product--color-item--default' : '') + '" \n              onmouseover="Product.changeProductColor(event)" \n              data-product-primary-image=""\n              data-product-secondary-image="">\n          <span class="catalogue-color catalogue-color--lg catalogue-color--frames--' + color.name + '"></span>\n        </li>');
        if (color.primaryImage) {
          item.attr('data-product-primary-image', JSON.stringify(color.primaryImage));
        }
        if (color.secondaryImage) {
          item.attr('data-product-secondary-image', JSON.stringify(color.secondaryImage));
        }
        colorList.append(item);
      });
      content.append('<h5 class="product--name">' + name + '</h5>');
      if (desc) {
        content.append(prodDes);
      }
      if (typeof price === 'string') {
        content.append('<h6 class="price-title product--price ' + commonClasses + '">' + price + '</h6>');
      } else {
        content.append('<h6 class="price-title product--price ' + commonClasses + '">\n          <span class="product--price product--price--old">' + price.old + '</span>\n          <span class="product--price product--price--new">' + price.new + '</span>\n        </h6>');
      }
      colorList.append('<li class="product--color-more">+2</li>');
      content.append(colorList);
      return content;
    }
  }, {
    key: 'isNotDesktopDevice',
    value: function isNotDesktopDevice() {
      return typeof window.orientation !== "undefined" || /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent);
    }

    /**
     * Detect mobile screen 320px -> 767.98px
     */

  }, {
    key: 'isMobile',
    value: function isMobile() {
      return !Modernizr.mq('(min-width: 768px)');
    }

    /**
     * Detect tablet screen and above 768px -> inf
     */

  }, {
    key: 'isTabletAndAbove',
    value: function isTabletAndAbove() {
      return Modernizr.mq('(min-width: 768px)');
    }

    /**
     * Detect tablet screen only 768px -> 991.98px
     */

  }, {
    key: 'isTablet',
    value: function isTablet() {
      return Modernizr.mq('(min-width: 768px)') && !Modernizr.mq('(min-width: 992px)');
    }

    /**
     * Detect small desktop and above 992px -> inf
     */

  }, {
    key: 'isSmallDesktopAndAbove',
    value: function isSmallDesktopAndAbove() {
      return Modernizr.mq('(min-width: 992px)');
    }

    /**
     * Detect small desktop only 992px -> 1199.98px
     */

  }, {
    key: 'isSmallDesktop',
    value: function isSmallDesktop() {
      return Modernizr.mq('(min-width: 992px)') && !Modernizr.mq('(min-width: 1200px)');
    }

    /**
     * Detect large desktop 1200px -> inf
     */

  }, {
    key: 'isLargeDesktop',
    value: function isLargeDesktop() {
      return Modernizr.mq('(min-width: 1200px)');
    }

    /**
     * Select / dropdowns enhancement
     * scrollTo/show the selected option 
     */

  }, {
    key: 'scrollToSelectedOptionOnOpen',
    value: function scrollToSelectedOptionOnOpen($selectEl) {
      if (typeof $selectEl === 'undefined' || $selectEl === null) {
        return;
      }
      if (!$selectEl.is("select") && !$selectEl.is(".dropdown-menu")) {
        return;
      }
      if ($selectEl.data('wrapper-class') != 'native-select') {
        $selectEl.parent().on('click', "button[data-toggle='dropdown']", function () {
          var $dropdownMenu = $(this).siblings(".dropdown-menu").first();
          var $itemToShow = $dropdownMenu.children('.dropdown-item.active');

          if ($itemToShow.length) {
            setTimeout(function () {
              var topPosition = $dropdownMenu.scrollTop() + $itemToShow.offset().top - $dropdownMenu.offset().top;
              var centerPosition = topPosition - ($dropdownMenu.height() / 2 - $itemToShow.height() / 2);
              $dropdownMenu.scrollTop(centerPosition);
            }, 60);
          }
        });
      }
      // not scrolling in mobile native select
    }
  }, {
    key: 'findSelectOptionByNerbyValue',
    value: function findSelectOptionByNerbyValue($selectEl, value) {
      if (typeof value === 'undefined' || typeof $selectEl === 'undefined' || $selectEl === null) {
        return;
      }
      if (!$selectEl.is("select") && !$selectEl.is(".dropdown-menu")) {
        return;
      }
      if (!isNaN(value)) {
        var intValue = parseFloat(value).toFixed();
        var doubleValue = parseFloat(value).toFixed(2);

        if ($selectEl.is("select")) {
          var $targetItem = $selectEl.find("option[value='" + doubleValue + "']").first();
          if (!$targetItem.length) {
            $targetItem = $selectEl.find("option[value='" + intValue + "']").first();
          }
          for (var i = 0, j = intValue; !$targetItem.length && i < 5; i++, j++) {
            $targetItem = $selectEl.find("option[value^='-" + j + "']").first();
          }
          return $targetItem;
        } else if ($selectEl.is(".dropdown-menu")) {
          var _$targetItem = $selectEl.find(".dropdown-item[data-value='" + doubleValue + "']").first();
          if (!_$targetItem.length) {
            _$targetItem = $selectEl.find(".dropdown-item[data-value='" + intValue + "']").first();
          }
          for (var _i = 0, _j = intValue; !_$targetItem.length && _i < 5; _i++, _j++) {
            _$targetItem = $selectEl.find(".dropdown-item[data-value^='-" + _j + "']").first();
          }
          return _$targetItem;
        }
      }
    }

    /**
     * Select / dropdowns enhancement
     * move an option near to another option by value
     * Use case: when creating options on server page with iteration
     * the default starting value is prepended or appended
     * but you need to show in other position 
     */

  }, {
    key: 'moveDefaultOptionBefore',
    value: function moveDefaultOptionBefore($selectEl, value, $default) {
      var $targetItem = Utils.findSelectOptionByNerbyValue($selectEl, value);
      if (typeof $targetItem !== 'undefined' && $targetItem.length) {
        var defaultOption = $default;
        if (typeof defaultOption === 'undefined' || defaultOption === null) {
          defaultOption = $selectEl.find('option:disabled');
        }
        if (!defaultOption.length) {
          defaultOption = $selectEl.find('option:selected');
        }
        if (defaultOption.length) {
          defaultOption.remove();
          $targetItem.before(defaultOption);
          $selectEl.hybridSelect('buildDropdownMenu');
        }
      }
    }
  }, {
    key: 'onSliderWheel',
    value: function onSliderWheel(e) {
      var deltaY = e.originalEvent.deltaY,
          $currentSlider = $(e.currentTarget),
          currentSlickIndex = $currentSlider.slick('slickCurrentSlide'),
          $slickInitialized = $currentSlider.closest('.slick-initialized');

      if (!$slickInitialized.length || $("body.contactlenses .modal-zoom:not(.show)").length > 0 ||
      // check when you scroll up
      deltaY < 0 && currentSlickIndex == 0 ||
      // check when you scroll down
      deltaY > 0 && currentSlickIndex == $currentSlider.data('slider-length') - 1) {
        return;
      }

      e.preventDefault();

      if (deltaY <= 0) {
        $currentSlider.slick('slickPrev');
      } else {
        $currentSlider.slick('slickNext');
      }
    }
  }, {
    key: 'blockPageScroll',
    value: function blockPageScroll(blocked) {
      var html = document.querySelector("html");
      if (blocked) {
        html.classList.add("no-scroll");
      } else {
        html.classList.remove("no-scroll");
      }
    }
  }, {
    key: 'scrollToTarget',
    value: function scrollToTarget(elTarget) {
      var targetTopPos = $(elTarget).offset().top;
      window.scrollTo({
        top: targetTopPos,
        left: 0,
        behavior: 'smooth'
      });
    }

    /**
     * Add a catentryId to favourites list and updates UI
     */

  }, {
    key: 'addToFav',
    value: function addToFav(endpoint, params, success, error) {
      var url = endpoint || '/FavouritesAddCmd';
      //var addedProducts = OPSMHeader.getFavList();
      return Utils.interestItemsOperation(url, params, success, error);
    }

    /**
     * remove a catentryId to favourites list and updates UI
     */

  }, {
    key: 'removeFromFav',
    value: function removeFromFav(endpoint, params, success, error) {
      var url = endpoint || '/FavouritesDeleteCmd';
      return Utils.interestItemsOperation(url, params, success, error);
    }

    /**
     * Add a catentryId to favourites list and updates UI
     */

  }, {
    key: 'interestItemsOperation',
    value: function interestItemsOperation(url, params, _success, _error) {
      if (OPSMHeader.isPendingFavReq() === "true") {
        console.log('interestItemsOperation: waiting operation to complete.');
        return Promise.resolve();
      } else {
        OPSMHeader.setPendingFavReq(true);
        var url = url || '/FavouritesAddCmd',
            params = params || {};
        return $.ajax({
          dataType: 'json',
          url: url,
          data: params,
          success: function success(result, textStatus, jqXHR) {
            OPSMHeader.setPendingFavReq(false);
            OPSMHeader.favItemListServerResp(result);
            //				  if(result != null && result.itemAddStatus != undefined && result.itemAddStatus == 'limitExceeded'){
            //				  }  
            if (typeof _success === 'function') {
              _success(result);
            }
          },
          error: function error(xhr, textStatus, thrownError) {
            OPSMHeader.setPendingFavReq(false);
            if (typeof _error === 'function') {
              _error(xhr, textStatus, thrownError);
            }
          }
        });
      }
    }
  }, {
    key: 'updateCartBadge',
    value: function updateCartBadge(cartCount) {
      var cartCount = cartCount || $("#cartCount").val() || $("#order-items-quantity").val() || "";
      if (typeof cartCount !== 'undefined') {
        if (cartCount == '0') {
          $("#btn-cart .badge").text("");
        } else {
          $("#btn-cart .badge").text(cartCount);
        }
      }
    }
  }, {
    key: 'setCookie',
    value: function setCookie(name, value, expiration) {
      var dateExpires = void 0;
      if (Object.prototype.toString.call(expiration) === "[object Date]") {
        dateExpires = expiration;
      } else {
        dateExpires = new Date();
        dateExpires.setTime(dateExpires.getTime() + 24 * 60 * 60 * 1000 * expiration);
      }

      document.cookie = name + "=" + value + ";path=/;expires=" + dateExpires.toGMTString();
    }
  }, {
    key: 'getCookie',
    value: function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + encodeURIComponent(name) + '=([^;]*)(;|$)');
      return v ? decodeURIComponent(v[2]) : null;
    }
  }]);

  return Utils;
}();
'use strict';

//settings to make ajax calls work for IE

$.ajaxSetup({ cache: false });

$(document).ready(function () {
  /* OPSMD-8092 OPSMD-8089 */
  $('iframe').each(function () {
    if (!$(this).attr('title')) {
      $(this).attr('title', 'OPSM');
    }
  });
  /**
   * Init all components
   */

  window.sidemenu = new Sidemenu();
  window.opsmheader = new OPSMHeader();
  window.searchoverlay = new SearchOverlay();
  var btnSidemenuToggle = $('#btn-toggle-sidemenu');
  // btnSidemenuToggle.on('click', () => {
  //     window.sidemenu.openMenu();
  // });
  window.footerStickyBanner = new StickFooterBanner();
  window.formSubscription = new FormSubscription();
  window.plp = new PLP();
  window.pdp = new PDP();
  window.sizingAndFit = new SizingAndFit();
  window.prescription = new Prescription();
  window.prescriptionS3B = new PrescriptionS3B();
  window.prescriptionLeadTime = new PrescriptionLeadTime();
  window.homeCarousel = new HomeCarousel();
  window.homepage = new Home();
  var mapStoreLocal = new MapStore(true);
  window.mapStore = mapStoreLocal;
  window.autoCompleteGoogleMaps = new AutoCompleteGoogleMaps(function () {
    mapStoreLocal.init();
  });
  window.eyeTestBooking = new EyeTestBooking();
  window.eyeTestStep2 = new BaetStepTwo();

  // ADDENDUM MATTEO

  window.deliveryAddress = new DeliveryAddress('logged-address', 'saved-address', 'myaccount-area', '.only-new-address-shipping', 'New address', 'deliveryAddress');
  window.billingAddress = new DeliveryAddress('logged-address-billing', 'saved-address-billing', 'myaccount-area', '.only-new-address-billing', 'New address', 'billingAddress');
  //Using old-style autocomplete for suburb
  /*window.autoCompleteSuburbShipping = new AutoCompleteSuburb(
  'addressSuggest-bet',
  'addressSuggest_state',
  'addressSuggest_postcode',
  'hiddenStatePostcode',
  opsm.core.getGoogleMapsApiKey(),
  opsm.core.getCountryCode()
  );
  window.autoCompleteSuburbBilling = new AutoCompleteSuburb(
  'billingAddressSuggest',
  'billingAddress_state',
  'billingAddress_postcode',
  'hiddenStatePostcode-billing',
  opsm.core.getGoogleMapsApiKey(),
  opsm.core.getCountryCode()
  );*/

  /*OPSMD-2951
   * Google api to autocomplete on checkout
   * on street address field
  */
  if ($('div#checkout').length) {

    /*configuration for G-maps autocomplete;
    * also use as classes on element fields in order to
    * autocomplete without implementing callback
    */
    var componentForm = {
      subpremise: 'short_name',
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name', /* City */
      colloquial_area: 'long_name', //for city in some cases
      administrative_area_level_1: 'short_name', /*suburb*/
      country: 'short_name',
      postal_code: 'short_name'
    };
    var componentRestrictions = {
      'country': opsm.core.getCountryCode()
    };
    var types = ['address'];

    //ui business logic on the returned results, let the component work and trigger his events 
    var placeChangedCallback = function placeChangedCallback(place, addrTypeSfx, selectedPrediction) {
      addrTypeSfx = addrTypeSfx || '';
      var componentForm = this.componentForm;
      var colloquial_area_for_city = '';
      //administrative_area_level_2 ???
      var street_number = '';
      var subpremise = '';
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
          var val = place.address_components[i][componentForm[addressType]];

          if (addressType === 'colloquial_area') {
            colloquial_area_for_city = val;
          }

          if (addressType === 'subpremise') {
            subpremise = val;
          }

          //not in UI, prepend to street address
          if (addressType === 'street_number') {
            street_number = val;
          }
          if ($('.' + addressType + addrTypeSfx).length) {
            opsm.utils.setContent($('.' + addressType + addrTypeSfx), val);
          }
        }
        //different countries may have different mappings
        if (addressType === 'administrative_area_level_2') {
          var aaLev2 = place.address_components[i]['short_name'];
        }
        if (addressType === 'administrative_area_level_3') {
          var aaLev3 = place.address_components[i]['short_name'];
        }
        /* OPSMD-4695 ADDON for NZ Suburb */
        if (opsm.core.getCountryCode() === 'nz' && addressType === 'sublocality_level_1') {
          var subLocLev1 = place.address_components[i]['short_name'];
        }
      }
      if (opsm.core.getCountryCode() === 'nz') {
        subLocLev1 = subLocLev1 || false;
        if (subLocLev1) {
          opsm.utils.setContent($('.locality' + addrTypeSfx), subLocLev1);
        }
      }
      /* END OPSMD-4695 ADDON for NZ Suburb */

      if (opsm.utils.getContent($('.locality' + addrTypeSfx)) === '') {
        opsm.utils.setContent($('.locality' + addrTypeSfx), colloquial_area_for_city);
      }
      if (street_number.length) {

        if (subpremise.length) {
          street_number = subpremise + "/" + street_number;
        }

        opsm.utils.setContent($('.route' + addrTypeSfx), street_number + ', ' + opsm.utils.getContent($('.route' + addrTypeSfx)));
      }

      //different countries may have different mappings
      if (addrTypeSfx == '-billing' && $('#checkout-billing-country').val() && $('#checkout-billing-country').val() !== 'AU' && $('#checkout-billing-country').val() !== 'NZ') {
        //	    		if(opsm.utils.getContent($('.administrative_area_level_1'+addrTypeSfx)) === ''){
        opsm.utils.setContent($('.administrative_area_level_1' + addrTypeSfx), aaLev3 && aaLev3 !== opsm.utils.getContent($('.locality' + addrTypeSfx)) ? aaLev3 : null || aaLev2 && aaLev2 !== opsm.utils.getContent($('.locality' + addrTypeSfx)) ? aaLev2 : null || opsm.utils.getContent($('.administrative_area_level_1' + addrTypeSfx)) ? opsm.utils.getContent($('.administrative_area_level_1' + addrTypeSfx)) : opsm.utils.getContent($('.locality' + addrTypeSfx)));
        //	    		}
      }
      opsm.utils.changeGmapPlaceApiResults($('.administrative_area_level_1' + addrTypeSfx), 'administrative_area_level_1');

      /* OPSMD-4013 street number not fully returned by place api */
      if (selectedPrediction) {
        try {
          var selectedAddrParts = selectedPrediction.split(',');
          if (selectedAddrParts.length > 1) {
            for (var part = 0; part < selectedAddrParts.length; part++) {
              if (part > 0 && selectedAddrParts[part].indexOf(opsm.utils.getContent($('.locality' + addrTypeSfx)).trim()) !== -1) {
                /* the street number + street address is all before this part */
                opsm.utils.setContent($('.route' + addrTypeSfx), selectedAddrParts.slice(0, part).join(',').trim());
                break;
              }
            }
          }
        } catch (e) {
          console.log('placeChangedCallback: selectedPrediction parsing error');
        }
      }
      /* END OPSMD-4013 */
    };

    // Handles events by gmap api autocomplete on streetaddress field
    var onStreetAddressNotif = function onStreetAddressNotif(e) {
      $('#checkout-shipping-street-address_1').valid();

      /* OPSMD-3715 trigger event to handle validation at opsm.checkout.attachevents()*/
      $('#checkout-shipping-street-address_1').trigger('paste');
      if ($('#addressSuggest-bet').length) {
        //change only if gmap api is working
        // FYI: commented in order to avoid any overlap with the label "suburb" in checkout validation (especially error case when the div is empty)
        //$('#addressSuggest-bet').attr('placeholder', 'Select address with suburb');
        //show any completed fields to user, needed also to activate validation on it
        if ($('#addressSuggest-bet').parent().length) {
          $('#addressSuggest-bet').parent().show();
        } else {
          $('#addressSuggest-bet').show();
        }

        if ($('#hiddenStatePostcode').length) {
          $('#hiddenStatePostcode').show();
        }
        $('#addressSuggest-bet').attr('contenteditable', ''); //needed to activate validation on it

        /*
         * $.validator is lazy, let's activate validation
         */
        if ($('#addressSuggest-bet').closest('form#checkout-form').data("validator")) {
          $('#addressSuggest-bet').closest('form#checkout-form').data("validator").checkForm();
        }

        if (opsm.utils.getContent($('#addressSuggest-bet')).trim().length) {
          $('#addressSuggest-bet').parent().addClass("not-empty");
          //check also state/postcode
          if (opsm.utils.getContent($('#addressSuggest_state')).trim().length && opsm.utils.getContent($('#addressSuggest_postcode')).trim().length) {
            //set as valid and validate
            $('#addressSuggest-bet').data('selected', 'true').valid();
          } else {
            $('#addressSuggest-bet').data('selected', 'false').valid();
            opsm.utils.setContent($('#addressSuggest-bet-error'), 'The selected address is incomplete');
          }
        } else {
          $('#addressSuggest-bet').parent().removeClass("not-empty");
          $('#addressSuggest-bet').data('selected', 'false').valid();
          opsm.utils.setContent($('#addressSuggest-bet-error'), 'The selected address is incomplete');
        }
        $('#addressSuggest-bet').blur();
        $('#addressSuggest-bet').removeAttr("contenteditable")
        //cannot set readonly for validator to work
        .css("background-color", $('input.form-control[readonly]').css("background-color"));
      }
    };

    // Handles events by gmap api autocomplete on streetaddress field for billing address
    var onStreetAddressNotifBilling = function onStreetAddressNotifBilling(e) {
      $('#checkout-billing-street-address_1').valid();

      /* OPSMD-3715 trigger event to handle validation at opsm.checkout.attachevents()*/
      $('#checkout-billing-street-address_1').trigger('paste');
      if ($('#billingAddressSuggest').length) {
        //change only if gmap api is working
        // FYI: commented in order to avoid any overlap with the label "suburb" in checkout validation (especially error case when the div is empty)
        // $('#billingAddressSuggest').attr('placeholder', 'Select address with suburb');
        //show any completed fields to user, needed also to activate validation on it
        if ($('#billingAddressSuggest').parent().length) {
          $('#billingAddressSuggest').parent().show();
        } else {
          $('#billingAddressSuggest').show();
        }

        if ($('#hiddenStatePostcode-billing').length) {
          $('#hiddenStatePostcode-billing').show();
        }
        $('#billingAddressSuggest').attr('contenteditable', ''); //needed to activate validation on it

        /*
         * $.validator is lazy, let's activate validation
         */
        if ($('#billingAddressSuggest').closest('form#checkout-form').data("validator")) {
          $('#billingAddressSuggest').closest('form#checkout-form').data("validator").checkForm();
        }

        if (opsm.utils.getContent($('#billingAddressSuggest')).trim().length) {
          $('#billingAddressSuggest').parent().addClass("not-empty");
          //check also state/postcode
          if (opsm.utils.getContent($('#billingAddress_state')).trim().length && opsm.utils.getContent($('#billingAddress_postcode')).trim().length) {
            //set as valid and validate
            $('#billingAddressSuggest').data('selected', 'true').valid();
          } else {
            $('#billingAddressSuggest').data('selected', 'false').valid();
            opsm.utils.setContent($('#billingAddressSuggest-error'), 'The selected address is incomplete');
          }
        } else {
          $('#billingAddressSuggest').parent().removeClass("not-empty");
          $('#billingAddressSuggest').data('selected', 'false').valid();
          opsm.utils.setContent($('#billingAddressSuggest-error'), 'The selected address is incomplete');
        }
        $('#billingAddressSuggest').blur();
        $('#billingAddressSuggest').removeAttr("contenteditable")
        //cannot set readonly for validator to work
        .css("background-color", $('input.form-control[readonly]').css("background-color"));
      }
    };

    var gApiError = false;

    var gApiErrorHappened = function gApiErrorHappened() {
      gApiError = true;
    };

    $(document).on('gmapApi:detached', gApiErrorHappened);

    /* this method handles autocomplete on 
     * streetaddress only
     * hiding suburb input
     */
    var handleSuburbHide = function handleSuburbHide() {
      /* values from cookies will be filled-in on a latter time
       * one per one, so street address will be reset
       * due to missing suburb-state-postcode
       * Do intercept and restore value
       */
      var onSuburbStateZipComplete = function onSuburbStateZipComplete() {
        if (opsm.utils.getContent($('#addressSuggest-bet')) && opsm.utils.getContent($('#addressSuggest_state')) && opsm.utils.getContent($('#addressSuggest_postcode'))) {
          //    				if(opsm.utils.getContent($('#checkout-shipping-street-address_1')) !== ''){
          opsm.utils.setContent($('#checkout-shipping-street-address_1'), $.cookie("checkout-shipping-street-address_1_" + $('#storeId').val()));
          //    	    		}
          $('#addressSuggest-bet').data('selected', 'true');
          if ($('#hiddenStatePostcode').length) {
            $('#hiddenStatePostcode').show();
          }
          if ($('#addressSuggest-bet').parent().length) {
            $('#addressSuggest-bet').parent().show();
          } else {
            $('#addressSuggest-bet').show();
          }
        } else {
          $('#addressSuggest-bet').data('selected', 'false');
          opsm.utils.setContent($('#addressSuggest-bet-error'), 'The selected address is incomplete');
        }
        $('#addressSuggest-bet').attr('contenteditable', '');
        if ($('#addressSuggest-bet').closest('form#checkout-form').data("validator")) {
          $('#addressSuggest-bet').closest('form#checkout-form').data("validator").checkForm();
        }
        $('#addressSuggest-bet').blur();
        //revalidate
        handleSuburbHide();
      };

      //handle address changes for logged user
      $('#checkout-order-billing-shipping').one('change', '#logged-address', handleSuburbHide);

      //handle autofill from cookies
      $('#checkout-order-billing-shipping').off('restoreCookie:shippingAddressComplete', '#addressSuggest-bet');
      $('#checkout-order-billing-shipping').one('restoreCookie:shippingAddressComplete', '#addressSuggest-bet', onSuburbStateZipComplete);

      $('#checkout-order-billing-shipping').off('restoreCookie:shippingAddressPartial', '#addressSuggest-bet');
      $('#checkout-order-billing-shipping').one('restoreCookie:shippingAddressPartial', '#addressSuggest-bet', onSuburbStateZipComplete);

      if (!gApiError && $('#addressSuggest-bet').length) {
        //hide only if not already filled in
        // while restoring from cookies they will not be set at once
        if (!opsm.utils.getContent($('#addressSuggest-bet')) && !opsm.utils.getContent($('#addressSuggest_state')) && !opsm.utils.getContent($('#addressSuggest_postcode'))) {
          opsm.utils.setContent($('#checkout-shipping-street-address_1'), '');
          if ($('#addressSuggest-bet').parent().length) {
            $('#addressSuggest-bet').parent().hide();
          } else {
            $('#addressSuggest-bet').hide();
          }
        } else {
          if ($('#hiddenStatePostcode').length) {
            $('#hiddenStatePostcode').show();
          }
          $('#addressSuggest-bet').removeAttr("contenteditable")
          //cannot set readonly for validator to work
          .css("background-color", $('input.form-control[readonly]').css("background-color"));
          if ($('#addressSuggest-bet').parent().length) {
            $('#addressSuggest-bet').parent().show();
          } else {
            $('#addressSuggest-bet').show();
          }
        }
        $('.delivery-address-wrapper').off('gmapApi:placeEdited gmapApi:placeSelected', '#checkout-shipping-street-address_1', onStreetAddressNotif);
        $('.delivery-address-wrapper').on('gmapApi:placeEdited gmapApi:placeSelected', '#checkout-shipping-street-address_1', onStreetAddressNotif);
      }
    };

    var handleSuburbHideBilling = function handleSuburbHideBilling() {
      /* values from cookies will be filled-in on a latter time
       * one per one, so street address will be reset
       * due to missing suburb-state-postcode
       * Do intercept and restore value
       */
      var onSuburbStateZipCountryComplete = function onSuburbStateZipCountryComplete() {
        if (opsm.utils.getContent($('#billingAddressSuggest')) && opsm.utils.getContent($('#billingAddress_state')) && opsm.utils.getContent($('#billingAddress_postcode'))
        //  					&& opsm.utils.getContent($('#checkout-billing-country'))
        ) {
            //  				if(opsm.utils.getContent($('#checkout-billing-street-address_1')) !== ''){
            opsm.utils.setContent($('#checkout-billing-street-address_1'), $.cookie("checkout-billing-street-address_1_" + $('#storeId').val()));
            //  				}
            $('#billingAddressSuggest').data('selected', 'true');
            if ($('#hiddenStatePostcode-billing').length) {
              $('#hiddenStatePostcode-billing').show();
            }
            if ($('#billingAddressSuggest').parent().length) {
              $('#billingAddressSuggest').parent().show();
            } else {
              $('#billingAddressSuggest').show();
            }
          } else {
          $('#billingAddressSuggest').data('selected', 'false');
          opsm.utils.setContent($('#billingAddressSuggest-error'), 'The selected address is incomplete');
        }
        $('#billingAddressSuggest').attr('contenteditable', '');
        if ($('#billingAddressSuggest').closest('form#checkout-form').data("validator")) {
          $('#billingAddressSuggest').closest('form#checkout-form').data("validator").checkForm();
        }
        $('#billingAddressSuggest').blur();
        //revalidate
        handleSuburbHideBilling();
      };

      //handle address changes for logged user
      $('#checkout-order-billing-shipping').one('change', '#logged-address-billing', handleSuburbHideBilling);

      //handle autofill from cookies
      $('#checkout-order-billing-shipping').off('restoreCookie:billingAddressComplete', '#billingAddressSuggest');
      $('#checkout-order-billing-shipping').one('restoreCookie:billingAddressComplete', '#billingAddressSuggest', onSuburbStateZipCountryComplete);

      $('#checkout-order-billing-shipping').off('restoreCookie:billingAddressPartial', '#billingAddressSuggest');
      $('#checkout-order-billing-shipping').one('restoreCookie:billingAddressPartial', '#billingAddressSuggest', onSuburbStateZipCountryComplete);

      if (!gApiError && $('#billingAddressSuggest').length) {
        //hide only if not already filled in
        // while restoring from cookies they will not be set at once
        if (!opsm.utils.getContent($('#billingAddressSuggest')) && !opsm.utils.getContent($('#billingAddress_state')) && !opsm.utils.getContent($('#billingAddress_postcode'))
        //    					&& !opsm.utils.getContent($('#checkout-billing-country')
        ) {
            opsm.utils.setContent($('#checkout-billing-street-address_1'), '');
            if ($('#billingAddressSuggest').parent().length) {
              $('#billingAddressSuggest').parent().hide();
            } else {
              $('#billingAddressSuggest').hide();
            }
          } else {
          if ($('#hiddenStatePostcode-billing').length) {
            $('#hiddenStatePostcode-billing').show();
          }
          $('#billingAddressSuggest').removeAttr("contenteditable")
          //cannot set readonly for validator to work
          .css("background-color", $('input.form-control[readonly]').css("background-color"));
          if ($('#billingAddressSuggest').parent().length) {
            $('#billingAddressSuggest').parent().show();
          } else {
            $('#billingAddressSuggest').show();
          }
        } //TODO
        $('.delivery-address-wrapper').off('gmapApi:placeEdited gmapApi:placeSelected', '#checkout-billing-street-address_1', onStreetAddressNotifBilling);
        $('.delivery-address-wrapper').on('gmapApi:placeEdited gmapApi:placeSelected', '#checkout-billing-street-address_1', onStreetAddressNotifBilling);
      }
    };

    var gApiErrorCallback = function gApiErrorCallback() {
      console.log("gApiErrorCallback called for shipping address");
      //detach google.maps listeners
      if (typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.event !== 'undefined') {
        google.maps.event.clearInstanceListeners($('#checkout-shipping-street-address_1'));
      }
      //detach listenters on streetaddr input
      $('.delivery-address-wrapper').off('gmapApi:placeEdited gmapApi:placeSelected', '#checkout-shipping-street-address_1', onStreetAddressNotif);

      $('#addressSuggest-bet').attr('contenteditable', '').css("background-color", $('input#checkout-shipping-street-address_1').css("background-color"));
      //init old validation on suburb
      var shippingAddressValidationsUrl = $('#addressValidationResults').val();
      window.autoCompleteSuburbShipping = new OPSMAutoCompleteSuburb('addressSuggest-bet', 'addressSuggest_state', 'addressSuggest_postcode', 'hiddenStatePostcode', shippingAddressValidationsUrl, opsm.core.getCountryCode());
      if ($('#addressSuggest-bet').length) {
        if ($('#addressSuggest-bet').parent().length) {
          $('#addressSuggest-bet').parent().show();
        } else {
          $('#addressSuggest-bet').show();
        }
      }
      $("#hiddenStatePostcode").show();
    };

    var gApiErrorCallbackBilling = function gApiErrorCallbackBilling() {
      console.log("gApiErrorCallback called for billing address");
      if (typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.event !== 'undefined') {
        google.maps.event.clearInstanceListeners($('#checkout-billing-street-address_1'));
      }
      //detach listenters on streetaddr input
      $('.delivery-address-wrapper').off('gmapApi:placeEdited gmapApi:placeSelected', '#checkout-billing-street-address_1', onStreetAddressNotifBilling);

      $('#billingAddressSuggest').attr('contenteditable', '').css("background-color", $('input#checkout-billing-street-address_1').css("background-color"));

      //init old validation on suburb for AU or NZ only
      $('.delivery-address-wrapper').off('change', '#checkout-billing-country');
      var $select = $('#checkout-billing-country');
      var option1 = $select.find("option[value='AU']");
      var option2 = $select.find("option[value='NZ']");
      $select.empty();
      $select.append(option1);
      $select.append(option2);
      $select.hybridSelect('buildDropdownMenu');
      $select.val(countryCode || 'AU').trigger('change');

      var billingAddressValidationsUrl = $('#addressValidationResults').val();
      billingAddressValidationsUrl = billingAddressValidationsUrl + '&selectedCountryCode=' + ($('#checkout-billing-country').val() || countryCodee);

      window.autoCompleteSuburbBilling = new OPSMAutoCompleteSuburb('billingAddressSuggest', 'billingAddress_state', 'billingAddress_postcode', 'hiddenStatePostcode-billing', billingAddressValidationsUrl, $('#checkout-billing-country').val() || countryCode);

      $('.delivery-address-wrapper').on('change', '#checkout-billing-country', function () {
        window.autoCompleteSuburbBilling.urlToCall = $('#addressValidationResults').val() + '&selectedCountryCode=' + $(this).val();
        opsm.utils.setContent($('#billingAddressSuggest'), '');
        opsm.utils.setContent($('#billingAddress_state'), '');
        opsm.utils.setContent($('#billingAddress_postcode'), '');
      });

      if ($('#billingAddressSuggest').length) {
        if ($('#billingAddressSuggest').parent().length) {
          $('#billingAddressSuggest').parent().show();
        } else {
          $('#billingAddressSuggest').show();
        }
      }
      $("#hiddenStatePostcode-billing").show();
    };

    $("#hiddenStatePostcode").hide();
    handleSuburbHide();
    //init the autocomplete if not a BOSS shipToStore checkout
    if (!($('#ship-to-store-id').length && $('#ship-to-store-id').val())) {
      var gautocomplete = new AutoCompleteGoogleMapsPlace($('#checkout-shipping-street-address_1'), componentForm, '-shipping', types, componentRestrictions, placeChangedCallback, /* we need to handle custom address number */
      gApiErrorCallback);
    }
    $("#hiddenStatePostcode-billing").hide();
    handleSuburbHideBilling();
    //    	var selectedCountryCodeBilling =$('#checkout-billing-country').val();

    var gautocompleteBilling = new AutoCompleteGoogleMapsPlace($('#checkout-billing-street-address_1'), componentForm, '-billing', types, $('#checkout-billing-country').val() ? { 'country': [String($('#checkout-billing-country').val())] } : { 'country': [] }, placeChangedCallback, /* we need to handle custom address number */
    gApiErrorCallbackBilling);

    $('.delivery-address-wrapper').on('change', '#checkout-billing-country', function () {
      gautocompleteBilling.setCompRestrictions($('#checkout-billing-country').val() ? { 'country': [String($('#checkout-billing-country').val())] } : { 'country': [] });
    });

    $('#checkout-billing-country').closest('.dropdown.hybrid-select').find('.dropdown-menu').on('click', '.dropdown-item', function () {
      $('.delivery-address-wrapper').one('change', '#checkout-billing-country', function () {
        opsm.utils.setContent($('#billingAddressSuggest'), '');
        opsm.utils.setContent($('#billingAddress_state'), '');
        opsm.utils.setContent($('#billingAddress_postcode'), '');
      });
    });

    /* OPSMD-4470 */
    $('div#checkout').on('click', '.gmap-detach-streetaddress', function (e) {
      e.preventDefault();
      $(this).hide();
      var tgt = $(this).data('address');
      var custEv = 'gmapApi:detach-' + tgt;
      $('div#checkout').trigger(custEv);
    });
  } else {
    var shippingAddressValidationsUrl = $('#addressValidationResults').val();
    window.autoCompleteSuburbShipping = new OPSMAutoCompleteSuburb('addressSuggest-bet', 'addressSuggest_state', 'addressSuggest_postcode', 'hiddenStatePostcode', shippingAddressValidationsUrl, selectedCountryCode);

    var billingAddressValidationsUrl = $('#addressValidationResults').val();
    var selectedCountryCode = $('#countryAddressSuggest').val();
    if (selectedCountryCode == 'AU' || selectedCountryCode == 'NZ') {
      billingAddressValidationsUrl = billingAddressValidationsUrl + '&selectedCountryCode=' + selectedCountryCode;
    }
    window.autoCompleteSuburbBilling = new OPSMAutoCompleteSuburb('billingAddressSuggest', 'billingAddress_state', 'billingAddress_postcode', 'hiddenStatePostcode-billing', billingAddressValidationsUrl, selectedCountryCode);
  }

  window.checkout = new Checkout();

  if ($('#map').hasClass('storepage')) {
    var _mapStoreLocal = new MapStoreLocator(true, false);
    window.mapStore = _mapStoreLocal;
    window.autoCompleteGoogleMaps = new AutoCompleteGoogleMapsOmnys(function () {
      _mapStoreLocal.init();
    });
  }

  if ($('#map').hasClass('favstorepage') && (typeof google === 'undefined' || google === null)) {
    $.getScript('https://maps.google.com/maps/api/js?sensor=false&key=' + opsm.core.getGoogleMapsApiKey() + '&language=en&region=' + opsm.core.getCountryCode(), function () {
      var mapStoreLocal = new MapStoreLocator(false, true);
      window.mapStore = mapStoreLocal;
    });
  }

  window.sidemenuAccount = new SidemenuUser();
  var btnSidemenuToggleAccount = $('#btn-login-mobile .visible-mobile');
  btnSidemenuToggleAccount.on('click', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    window.sidemenuAccount.openMenu();
  });

  window.paymentMethod = new PaymentMethod();
  $('#dob').inputmask('99/99/9999', { "placeholder": "DD/MM/YYYY" });
  /*
  if($(window).width()>800){
    window.scrollSpalla = new InitializeScrollSpalla();
  }
  */
  $('.opsm-modal-link').each(function (i, modalContent) {
    var $modalContent = $(modalContent);
    var $modalTarget = $modalContent.data('target');
    $modalContent.on('click', function (e) {
      $($modalTarget).modal({
        backdrop: 'static'
      });
    });
  });
  $('.qty-set').each(function (i, qtydiv) {
    var $qtydiv = $(qtydiv);
    var $val = parseInt($qtydiv.find('input').val());
    if ($val == 1) {
      $qtydiv.find('.less-qty').addClass("disabled");
    }
    $qtydiv.on('click', '.less-qty', function () {
      if ($val > 1) {
        $val--;
        $qtydiv.find('input').val($val);
        if ($val == 1) {
          $qtydiv.find('.less-qty').addClass("disabled");
        }
      }
    });
    $qtydiv.on('click', '.more-qty', function () {
      $val++;
      $qtydiv.find('input').val($val);
      $qtydiv.find('.less-qty').removeClass("disabled");
    });
  });

  $(".greybox").on("click", function () {
    if ($(this).find(".summary-title").length > 0) {
      var summaryBox = $(this).find(".summary-title");
      if ($(summaryBox).hasClass("collapsed")) {
        $(this).addClass("whitebox");
      } else {
        $(this).removeClass("whitebox");
      }
    }
  });

  if ($("input[type='email']").length > 0) {
    $("input[type='email']").each(function () {
      $(this).keyup(function () {
        $(this).val($(this).val().toLowerCase());
      });
    });
  }

  if ($(".pg-product-detail").length > 0) {

    $('.popular-products--inner').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      refresh: true,
      arrows: false,
      responsive: [{
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          variableWidth: true
        }
      }]
    });
  }

  $('.opsm-scrollpane').each(function (i, modalContent) {
    var $modalContent = $(modalContent);
    $modalContent.niceScroll({
      cursorcolor: "#ccc"
    });
  });

  $('.check-gift input[type="checkbox"]').on("change", function () {
    var $row = $(this).attr("id");
    var $par = $(this).parent('.check-gift');
    var $form = $par.next('.form-gift');

    $form.find('.price-message').hide();
    $par.toggleClass('checked');
    if ($('.check-gift input[type="checkbox"]').is(':checked')) {
      $form.on('click', '.cancel-btn', function () {
        $form.find('input, textarea').val('');
      });
      $form.on('click', '.add-btn', function () {

        $form.find('a').hide();
        $form.find('input, textarea').attr('readonly', true);
        $form.find('a.re-edit').show();
        $(".row[data-check=" + $row + "]").find('.price-message').show();
      });
      $form.on('click', '.re-edit', function () {
        $form.find('a').show();
        $form.find('input, textarea').attr('readonly', false);
        $form.find('a.re-edit').hide();
        $(".row[data-check=" + $row + "]").find('.price-message').hide();
      });
    } else {
      $(".row[data-check=" + $row + "]").find('.price-message').hide();
    }
  });

  $('#promoinput form').on('click', '#verify-code', function () {
    // ajax callout
    var code = $('#promo-field').val();
    $.getJSON("promocode.json", function (data) {
      if (data.verify == "OK") {
        $('.promo-code-insert').hide();
        $('.promo-code-ok').show();
        $('#promocode-insert').html(code);
        $('#price-discount').html(data.discount);
      } else {

        $('.promo-code-ok').hide();
        $('.promo-code-insert').show();
        $('#promocode-insert').empty();
        $('#price-discount').empty();
      }
    });
  });

  $('textarea.limit-charapter').on('blur', function (e) {
    var tval = $(this).val(),
        tlength = tval.length,
        set = $(this).data('limit'),
        remain = parseInt(set - tlength);
    $(this).next('.counter-charapter').find('span').text(remain);
    if (remain <= 0 && e.which !== 0 && e.charCode !== 0) {
      $(this).val(tval.substring(0, tlength - 1));
      return false;
    }
  });
  $('textarea.limit-charapter').keypress(function (e) {
    var tval = $(this).val(),
        tlength = tval.length,
        set = $(this).data('limit'),
        remain = parseInt(set - tlength);
    $(this).next('.counter-charapter').find('span').text(remain);
    if (remain <= 0 && e.which !== 0 && e.charCode !== 0) {
      $(this).val(tval.substring(0, tlength - 1));
      return false;
    }
  });

  $('.select-all').click(function () {
    $('.contact-option-input').prop('checked', true);
    $('#no-promo').prop('checked', false);
  });
  $('#no-promo').click(function () {
    $('.contact-option-input').prop('checked', false);
  });

  if ($('[name="leaveornotcc"]').length > 0) {
    $('[name="leaveornotcc"]').on('change', function () {
      if ($("#radioinsertcc").is(":checked")) {
        $(".reentryDiv").show();
      } else {
        $(".reentryDiv").hide();
      }
    });
  }

  $(window).scroll(function () {
    if ($("#loginpage").length > 0 && $(window).width() <= 768) {
      $("#opsm-header-sticky").css("position", "static");
      $(".header--notibar").css("position", "static");
    }
  });

  // OPSMD-7100
  $("#frameadv-ui .card").on("click", function () {
    $(window).scrollTop(0);
  });

  $('.material-input').each(function () {
    materialInputEmptyCheck(this);
  });

  // OPSMD-9145
  $("#security-code-body").on("shown.bs.collapse", function () {
    $("body").on("click", function (e) {
      if ($(e.target).parents("#security-code-body").length == 0 && $(e.target).attr('id') != "security-code-body") {
        $("#security-code-body").collapse('hide');
        $("body").off("click");
      }
    });
  });
  // FINE
  $(document).on('change, blur', '.material-input', materialInputEmptyCheck);

  // OPSMD-10252
  $("#pupillary-distance-box .hybrid-select button").on("click", function (el) {
    var currentBtn = el.target;
    var thisDropdownMenu = $(currentBtn).next();
    // checking if it doesn't have this class because the other script that adds the class comes after this one,
    // I've decided to use the not operator in order to avoid timeout
    if (!$(thisDropdownMenu).hasClass("show")) {
      $(thisDropdownMenu).on("mouseenter", function () {
        $('body, html').addClass('modal-open');
      });
      $(thisDropdownMenu).on("mouseleave", function () {
        $('body, html').removeClass('modal-open');
      });
    }
  });

  $(".purchase-selection .custom-control-input").on("click", function () {
    if ($(this).attr("id") == "subscribe-now") {
      if ($(".subscription-box").hasClass("d-none")) {
        $(".subscription-box").removeClass("d-none");
      }
      //$(".product-purchase-hf").addClass("d-none").removeClass("d-flex");
    } else {
      if (!$(".subscription-box").hasClass("d-none")) {
        $(".subscription-box").addClass("d-none");
      }
      //$(".product-purchase-hf").addClass("d-flex").removeClass("d-none");
    }
  });
  /*
  $("#booking-salutation").on("change", function() {
  	if(!$("#booking-salutation").parents('.rounded-select').hasClass('filled-select')){
  		$("#booking-salutation").parents('.rounded-select').addClass('filled-select');
  	}
  });
  */
  $("#booking-gender").on("change", function () {
    if (!$("#booking-gender").parents('.rounded-select').hasClass('filled-select')) {
      $("#booking-gender").parents('.rounded-select').addClass('filled-select');
    }
  });

  if ($("#tooltip-payment-summary").length > 0) {
    var tooltipHtml = $("#tooltip-payment-summary").html();
    $("#tooltip-payment-summary").detach();
    $("#show-payment-summary").tooltip({
      html: true,
      placement: "top",
      title: tooltipHtml,
      template: '<div class="tooltip payment-tooltip-wrapper" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
      trigger: 'hover focus click',
      offset: "4px"
    });
  }
});

function resizeInput(el) {
  $(el).each(function () {
    $(this).css("width", $(this).val().length + "ch");
  });
}

function toggleCollapse(elToToggle, commonSelector) {
  if ($(elToToggle).hasClass('show')) {
    $(commonSelector).removeClass('show');
  } else {
    $(commonSelector).removeClass('show');
    $(elToToggle).addClass('show');
  }
}

function subsDetailsModalsResetForm(formToReset, formToShow) {
  $(formToReset)[0].reset();
  $(formToReset).find('.not-empty').removeClass('not-empty');
  $(formToReset).addClass('d-none');
  $(formToReset).find('.input-major-error').hide();
  $(formToShow).removeClass('d-none');
}

function toggleConfirmationBtn(parentSelector) {
  var elToCheck = $(parentSelector).find('#prescription-valid');
  var btnToToggle = $(parentSelector).find('.save-changes');
  if ($(elToCheck).prop("checked") == true) {
    $(btnToToggle).removeAttr('disabled').removeClass('disabled');
  } else {
    $(btnToToggle).attr('disabled', true).addClass('disabled');
  }
}

function materialInputEmptyCheck(el) {
  var that;
  var elToCheck = "";

  if ($(this).length > 0) {
    that = $(this);
  } else {
    that = $(el);
  }

  if ($(that).find('input').length > 0) {
    elToCheck = that.find('input').val();
  } else if (that.find('textarea').length > 0) {
    elToCheck = that.find('textarea').val();
  } else if (that.find('div.opsm-form-control').length > 0) {
    elToCheck = that.find('div.opsm-form-control').text();
  }

  if (elToCheck != "") {
    that.addClass('not-empty');
  } else {
    that.removeClass('not-empty');
  }
}

function openModal(target) {
  if ($(".modal.show").length > 0) {
    $(".modal.show").modal('hide');
  }
  setTimeout(function () {
    $(target).modal('show');
  }, 500);
}

function betRecaptchaCallback() {
  $('#deleteAppointmentForm button').removeAttr('disabled');
  $('#rescheduleBtn').removeClass('pointer-none disabled');
};

function betRecaptchaExpiredCallback() {
  $('#deleteAppointmentForm button').attr('disabled', 'true');
  $('#rescheduleBtn').addClass('pointer-none disabled');
};

function betFormRecaptchaCallback() {
  $(".g-recaptcha-wrapper").addClass("valid").removeClass("error");
  $(".g-recaptcha-wrapper .invalid-feedback").removeClass("d-block");
};

function betFormRecaptchaExpiredCallback() {
  $(".g-recaptcha-wrapper").removeClass("valid").addClass("error");
  $(".g-recaptcha-wrapper .invalid-feedback").addClass("d-block");
};

// PAFF FIX WCAG PER FRAME DA YOUTUBE E FRAME DA GMAPS
//!! Some pages call this file multiple times !!
//added check to not loop (not working)
//if (typeof hookedWindowOnLoad === "undefined" || hookedWindowOnload === null || !hookedWindowOnLoad) {
//
//	var oldWindowOnload = window.onload;
//	window.onload = () => {
//		//$("iframe").removeAttr("height").removeAttr("width").removeAttr("frameborder");
//		$(".select-store--maps iframe").attr("title", "Map iframe").removeAttr("frameborder");
//		if (typeof oldWindowOnload !== "undefined" && oldWindowOnload !== null) {
//			oldWindowOnload();
//		}
//	};
//	window["hookedWindowOnLoad"] = true;
//}

// ADDENDUM FUNC MATTEO


//https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length > targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}

function openOrderSummary() {
  var parentSelector;
  if ($("#checkout_presc_step").length <= 0 || $("#checkout_presc_step").hasClass('d-none')) {
    parentSelector = $("#checkout_no_presc_step");
  } else {
    parentSelector = $("#checkout_presc_step");
  }
  var currentSummary = $(parentSelector).find("#orderSummary");
  var currentSideCol = $(parentSelector).find(".side-col");
  $(currentSummary).collapse('show');

  $(currentSummary).on('shown.bs.collapse', function () {
    var scrollableSecHeight = $("#header-checkout").height() + $(currentSideCol).height() + $(currentSummary).height();
    $("#main").css('height', scrollableSecHeight + 'px').addClass('overflow-hidden');
    $(".open-btn.order-summary-trigger").addClass('d-none');
    $(".close-btn.order-summary-trigger").removeClass('d-none');
  });
}

function closeOrderSummary() {
  if ($("#checkout_presc_step").length <= 0 || $("#checkout_presc_step").hasClass('d-none')) {
    $("#checkout_no_presc_step #orderSummary").collapse('hide');
  } else {
    $("#checkout_presc_step #orderSummary").collapse('hide');
  }
  $("#main").removeAttr('style').removeClass('overflow-hidden');
  $(".close-btn.order-summary-trigger").addClass('d-none');
  $(".open-btn.order-summary-trigger").removeClass('d-none');
}

function toggleClassCtrl(b, c, div) {
  var t = $(b);
  t.closest(div).toggleClass(c);
}

function feValidationClasses(currentInput) {
  $(currentInput).valid();
  if ($(currentInput).val() == "") {
    $(currentInput).parent().addClass('empty');
  } else {
    $(currentInput).parent().removeClass('empty');
  }
}

/*
function InitializeScrollSpalla() {
 new ScrollSpalla("#cartpage .colsxfixed", '#cartpage .main-columnrow', {top: 295, bottom: 0, marginTop: 0});
 new ScrollSpalla('#checkout .checkout-sidebar .float-div', '#checkout .main-columnrow', {top: 260, bottom: 13, marginTop: 30});
}
*/
'use strict';

/**
 * OPSM Tab Accordion animation
 */

$(document).ready(function () {
    $('[data-toggle="tab-accordion"]').each(function (i, tabAcc) {
        var $tabAcc = $(tabAcc);
        var tabPart = $tabAcc.find('.tab-accordion--tab-part');
        var accordionPart = $(tabAcc).find('.tab-accordion--accordion-part');
        var underline = $(tabAcc).find('.tab-accordion--underline');

        tabPart.find('a').on('click', function (event) {
            var tab = $(event.currentTarget);
            var parent = $(event.currentTarget).data('target');
            var parentEle = $(parent);

            tabPart.find('a').removeClass('tab-accordion--bold');

            if (!tab.hasClass('collapsed')) {
                event.stopPropagation();
                $(parentEle).addClass('tab-accordion--show');
                tab.addClass('tab-accordion--bold');
            } else {
                accordionPart.find('.collapse').removeClass('tab-accordion--show');
                tab.removeClass('tab-accordion--bold');
            }
        });

        accordionPart.find('.collapse').on('show.bs.collapse', function (event) {
            var id = event.target.id;
            var tabPartItem = tabPart.find('[data-target="#' + id + '"]');
            moveUnderlineTabAccordion(tabPartItem.parent(), underline);
        });

        function moveLineForCurrentTab() {
            var currentActiveTabPartItem = tabPart.find('a').not('.collapsed').first();
            moveUnderlineTabAccordion(currentActiveTabPartItem.parent(), underline);
        }

        moveLineForCurrentTab();

        var bouncing = false;
        $(window).on('resize', function () {
            if (bouncing) {
                clearTimeout(bouncing);
                bouncing = false;
            }

            bouncing = setTimeout(function () {
                moveLineForCurrentTab();
            }, 100);
        });
    });

    function moveUnderlineTabAccordion(tabPartItem, underline) {
        var position = tabPartItem.position();
        underline.css({
            left: position.left,
            width: tabPartItem.width()
        });
    }

    /**
     * OPSM Tab Content
     */
    $('.opsm-tab-content').each(function (i, tabContent) {
        var $tabContent = $(tabContent);
        var underline = $tabContent.find('.opsm-tab-content--underline');
        var tabPart = $tabContent.find('.opsm-tab-content--nav');

        $tabContent.find('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            moveUnderlineTabAccordion($(e.target), underline);
        });

        function moveLineForCurrentTab() {
            var currentActiveTabPartItem = tabPart.find('.nav-link.active');
            moveUnderlineTabAccordion(currentActiveTabPartItem, underline);
        }

        setTimeout(function () {
            moveLineForCurrentTab();
        }, 200);

        var bouncing = false;
        $(window).on('resize', function () {
            if (bouncing) {
                clearTimeout(bouncing);
                bouncing = false;
            }

            bouncing = setTimeout(function () {
                moveLineForCurrentTab();
            }, 100);
        });
    });
});